webpackJsonp([0],{

/***/ 1041:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1042:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ravenJs = __webpack_require__(489);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactHotLoader = __webpack_require__(2416);

var _root = __webpack_require__(1415);

var _root2 = _interopRequireDefault(_root);

var _firebaseConfig = __webpack_require__(1210);

var _user = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Start Sentry logger
// https://docs.sentry.io/clients/javascript/config/
var sentryDSN = "https://16a4b33290c44b89979957634c3ff3e3@sentry.io/1014205";
var sentryDebug = "false" === 'true';
var sentryEnableAutoBreadcrumbs = "true" === 'true';
try {
  _ravenJs2.default.config(sentryDSN, {
    environment: "production",
    debug: sentryDebug,
    // https://github.com/getsentry/raven-js/issues/723
    // https://docs.sentry.io/clients/javascript/config/
    autoBreadcrumbs: sentryEnableAutoBreadcrumbs,
    // Only log errors that originate in our JS files.
    whitelistUrls: [/tab\.gladly\.io\/newtab\/static/, /prod-tab2017\.gladly\.io\/newtab\/static/, /dev-tab2017\.gladly\.io\/newtab\/static/]
  }).install();
} catch (e) {
  console.error(e);
}

// Add context to Sentry logs
// https://docs.sentry.io/clients/javascript/usage/#tracking-users
try {
  var username = (0, _user.getUsername)();
  if (username) {
    _ravenJs2.default.setUserContext({
      username: username
    });
  }
} catch (e) {
  console.error(e);
}

var initApp = function initApp() {
  // Init Firebase
  (0, _firebaseConfig.initializeFirebase)();

  __webpack_require__(2641);

  var rootNode = document.createElement('div');
  document.body.appendChild(rootNode);

  var render = function render(Component) {
    _reactDom2.default.render(_react2.default.createElement(
      _reactHotLoader.AppContainer,
      null,
      _react2.default.createElement(Component, null)
    ), rootNode);
  };

  render(_root2.default);

  // Hot Module Replacement API
  if (false) {
    module.hot.accept('js/root', function () {
      render(_root2.default);
    });
  }
};

try {
  _ravenJs2.default.context(function () {
    if (sentryDebug) {
      console.log('Initialized Raven for Sentry DSN ' + sentryDSN);
    }
    initApp();
  });
} catch (e) {
  console.error('Failed to wrap app in Raven.context', e);
  initApp();
}

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Snackbar = __webpack_require__(772);

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorMessage = function (_React$Component) {
  _inherits(ErrorMessage, _React$Component);

  function ErrorMessage() {
    _classCallCheck(this, ErrorMessage);

    return _possibleConstructorReturn(this, (ErrorMessage.__proto__ || Object.getPrototypeOf(ErrorMessage)).apply(this, arguments));
  }

  _createClass(ErrorMessage, [{
    key: 'render',
    value: function render() {
      var message = this.props.message;
      // TODO: set theme color.

      return _react2.default.createElement(_Snackbar2.default, _extends({
        contentStyle: { textAlign: 'center' }
      }, this.props, {
        'data-test-id': 'error-message',
        message: message,
        open: true,
        autoHideDuration: 4000
      }));
    }
  }]);

  return ErrorMessage;
}(_react2.default.Component);

ErrorMessage.propTypes = {
  message: _propTypes2.default.string,
  style: _propTypes2.default.object
};

ErrorMessage.defaultProps = {
  message: null,
  style: {}
};

exports.default = ErrorMessage;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasUserDismissedAdExplanation = exports.setUserDismissedAdExplanation = exports.getBrowserExtensionInstallTime = exports.setBrowserExtensionInstallTime = exports.getBrowserExtensionInstallId = exports.setBrowserExtensionInstallId = exports.incrementTabsOpenedToday = exports.getTabsOpenedToday = undefined;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _v = __webpack_require__(537);

var _v2 = _interopRequireDefault(_v);

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

var _constants = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the count of tabs opened today (UTC day) from localStorage. If no
 * value exists in storage, return zero.
 * @returns {number} The user's tab count
 */
var getTabsOpenedTodayFromStorage = function getTabsOpenedTodayFromStorage() {
  var tabCountStr = _localstorageMgr2.default.getItem(_constants.STORAGE_TABS_RECENT_DAY_COUNT);
  var tabCountParsed = parseInt(tabCountStr, 10);
  var tabCount = isNaN(tabCountParsed) ? 0 : tabCountParsed;
  return tabCount;
};

/**
 * Get whether the user has opened a tab today, according to the tab
 * count in localStorage.
 * @returns {boolean} Whether the user has opened a tab today
 */
var hasUserOpenedTabToday = function hasUserOpenedTabToday() {
  // An ISO timestamp
  var tabCountDate = _localstorageMgr2.default.getItem(_constants.STORAGE_TABS_LAST_TAB_OPENED_DATE);

  // If no current date, assume no tabs have been opened today.
  if (!tabCountDate) {
    return 0;
  }

  // If the current date is the same as the most recent date a
  // tab was opened, it is not the first tab today.
  var hasOpenedTabToday = (0, _moment2.default)(tabCountDate).utc().format('LL') === (0, _moment2.default)().utc().format('LL');
  return hasOpenedTabToday;
};

/**
 * Get the count of tabs opened today (UTC day) from localStorage. If no
 * value exists in storage, return zero.
 * @returns {number} The user's tab count
 */
var getTabsOpenedToday = exports.getTabsOpenedToday = function getTabsOpenedToday() {
  if (!hasUserOpenedTabToday()) {
    return 0;
  }
  return getTabsOpenedTodayFromStorage();
};

/**
 * Sets the localStorage value for the date of the last tab opened
 * to an ISO timestamp of the current time.
 * @returns {undefined}
 */
var setLastTabOpenedDateInLocalStorage = function setLastTabOpenedDateInLocalStorage() {
  _localstorageMgr2.default.setItem(_constants.STORAGE_TABS_LAST_TAB_OPENED_DATE, _moment2.default.utc().toISOString());
};

/**
 * Sets the localStorage value for today's tab count to the value
 * of `tabCount`.
 * @param {number} tabCount - The number of tabs today
 * @returns {undefined}
 */
var setTabCountInLocalStorage = function setTabCountInLocalStorage(tabCount) {
  _localstorageMgr2.default.setItem(_constants.STORAGE_TABS_RECENT_DAY_COUNT, tabCount);
};

/**
 * Increment the count of tabs opened today (UTC day) in localStorage.
 * If the most recent day of a tab opening is prior to today, reset
 * the tab counter. If no values exist in localStorage, set them.
 * @returns {undefined}
 */
var incrementTabsOpenedToday = exports.incrementTabsOpenedToday = function incrementTabsOpenedToday() {
  if (hasUserOpenedTabToday()) {
    // Increment the tab count
    var currentTabCount = getTabsOpenedTodayFromStorage();
    setTabCountInLocalStorage(currentTabCount + 1);
  } else {
    // Reset the date and tab count
    setLastTabOpenedDateInLocalStorage();
    setTabCountInLocalStorage(1);
  }
};

/**
 * Saves a UUID to localStorage as the "extension install ID",
 * which may be helpful in determining if multiple anonymous
 * users belong to the same user.
 * @returns {undefined}
 */
var setBrowserExtensionInstallId = exports.setBrowserExtensionInstallId = function setBrowserExtensionInstallId() {
  _localstorageMgr2.default.setItem(_constants.STORAGE_EXTENSION_INSTALL_ID, (0, _v2.default)());
};

/**
 * Gets the extension install ID from localStorage if it exists.
 * extension (from localStorage).
 * @returns {String|null} A UUID string, or null if it does not
 *   exist.
 */
var getBrowserExtensionInstallId = exports.getBrowserExtensionInstallId = function getBrowserExtensionInstallId() {
  var installId = _localstorageMgr2.default.getItem(_constants.STORAGE_EXTENSION_INSTALL_ID);
  if (!installId) {
    return null;
  }
  return installId;
};

/**
 * Saves now as the approximate time the user installed the
 * browser extension (saving to localStorage). This helps us
 * distinguish truly new users from returning users who had
 * cleared their local data: if it exists and is recent, we
 * know the user is brand new.
 * @returns {undefined}
 */
var setBrowserExtensionInstallTime = exports.setBrowserExtensionInstallTime = function setBrowserExtensionInstallTime() {
  _localstorageMgr2.default.setItem(_constants.STORAGE_APPROX_EXTENSION_INSTALL_TIME, _moment2.default.utc().toISOString());
};

/**
 * Gets the approximate time the user installed the browser
 * extension (from localStorage). The value may not exist;
 * e.g. if a user cleared their local data.
 * @returns {Object|null} The approximate local MomentJS
 *   datetime the user installed the Tab for a Cause browser
 *   extension on this device.
 */
var getBrowserExtensionInstallTime = exports.getBrowserExtensionInstallTime = function getBrowserExtensionInstallTime() {
  var timeISOString = _localstorageMgr2.default.getItem(_constants.STORAGE_APPROX_EXTENSION_INSTALL_TIME);
  var time = (0, _moment2.default)(timeISOString);
  if (!timeISOString || !time.isValid()) {
    return null;
  }
  return time;
};

/**
 * Marks that the user has dismissed the ad explanation.
 * @returns {undefined}
 */
var setUserDismissedAdExplanation = exports.setUserDismissedAdExplanation = function setUserDismissedAdExplanation() {
  _localstorageMgr2.default.setItem(_constants.STORAGE_DISMISSED_AD_EXPLANATION, 'true');
};

/**
 * Gets whether the user has dismissed the ad explanation.
 * @returns {Boolean} Whether the user has dismissed the ad
 *   explanation.
 */
var hasUserDismissedAdExplanation = exports.hasUserDismissedAdExplanation = function hasUserDismissedAdExplanation() {
  return _localstorageMgr2.default.getItem(_constants.STORAGE_DISMISSED_AD_EXPLANATION) === 'true';
};

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adsEnabledStatus = __webpack_require__(378);

var _adsEnabledStatus2 = _interopRequireDefault(_adsEnabledStatus);

var _googleDisplayAd = __webpack_require__(1200);

var _googleDisplayAd2 = _interopRequireDefault(_googleDisplayAd);

var _mockDisplayAd = __webpack_require__(1203);

var _mockDisplayAd2 = _interopRequireDefault(_mockDisplayAd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (adId) {
  if ((0, _adsEnabledStatus2.default)()) {
    (0, _googleDisplayAd2.default)(adId);
  } else {
    (0, _mockDisplayAd2.default)(adId);
  }
};

/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (adId) {
  var googletag = (0, _getGoogleTag2.default)();
  googletag.cmd.push(function () {
    googletag.display(adId);
  });
};

var _getGoogleTag = __webpack_require__(184);

var _getGoogleTag2 = _interopRequireDefault(_getGoogleTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (adId) {
  var _mapDOMIdToHeight;

  var mockNetworkDelayMs = 0;
  var useMockDelay = false;
  if (useMockDelay) {
    mockNetworkDelayMs = Math.random() * (1500 - 900) + 900;
  }
  var mapDOMIdToHeight = (_mapDOMIdToHeight = {}, _defineProperty(_mapDOMIdToHeight, _adSettings.VERTICAL_AD_SLOT_DOM_ID, 250), _defineProperty(_mapDOMIdToHeight, _adSettings.SECOND_VERTICAL_AD_SLOT_DOM_ID, 250), _defineProperty(_mapDOMIdToHeight, _adSettings.HORIZONTAL_AD_SLOT_DOM_ID, 90), _mapDOMIdToHeight);
  var height = mapDOMIdToHeight[adId];

  // Mock returning an ad.
  setTimeout(function () {
    var elem = document.getElementById(adId);
    if (!elem) {
      return;
    }
    elem.setAttribute('style', '\n      color: white;\n      background: repeating-linear-gradient(\n        -55deg,\n        #222,\n        #222 20px,\n        #333 20px,\n        #333 40px\n      );\n      width: 100%;\n      height: ' + height + 'px;\n    ');
  }, mockNetworkDelayMs);
};

var _adSettings = __webpack_require__(148);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _this = undefined;

var DEBUG = false;

var fbq = window.fbq;
if (!fbq) {
  console.error('Facebook analytics are not available on `window.fbq`.');
}

var facebookAnalytics = function facebookAnalytics() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  try {
    if (DEBUG) {
      console.log('Logging Facebook event with args:', args);
    }
    fbq.apply(_this, args);
  } catch (e) {
    console.error('Failed to track Facebook Analytics event.', e);
  }
};

exports.default = facebookAnalytics;

/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// https://github.com/react-ga/react-ga


var _reactGa = __webpack_require__(2407);

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEBUG = false;
var debugLogger = function debugLogger() {
  if (DEBUG) {
    var _console;

    (_console = console).log.apply(_console, arguments);
  }
};

try {
  // TODO: env var for app ID
  _reactGa2.default.initialize('UA-24159386-1');
} catch (e) {
  console.error('Failed to initialize Google Analytics.', e);
}

// Wraps ReactGA methods in try/catch.

var ReactGAWrapper = function () {
  function ReactGAWrapper() {
    _classCallCheck(this, ReactGAWrapper);
  }

  _createClass(ReactGAWrapper, null, [{
    key: 'pageview',
    value: function pageview() {
      try {
        var url = '' + window.location.pathname + window.location.search;
        debugLogger('Logging GA pageview with url: ' + url);
        _reactGa2.default.pageview(url);
      } catch (e) {
        console.error('Failed to track Google Analytics pageview.', e);
      }
    }
  }, {
    key: 'event',
    value: function event(gaEvent) {
      try {
        debugLogger('Logging GA event:', JSON.stringify(gaEvent));
        _reactGa2.default.event(gaEvent);
      } catch (e) {
        console.error('Failed to track Google Analytics event.', e);
      }
    }
  }, {
    key: 'ga',
    value: function ga(gaAction, gaEvent) {
      try {
        debugLogger('Logging GA event:', gaAction, JSON.stringify(gaEvent));
        _reactGa2.default.ga(gaAction, gaEvent);
      } catch (e) {
        console.error('Failed to track Google Analytics event.', e);
      }
    }
  }]);

  return ReactGAWrapper;
}();

exports.default = ReactGAWrapper;

/***/ }),

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* globals Image */

var redditAccountCreationEvent = exports.redditAccountCreationEvent = function redditAccountCreationEvent() {
  var i = new Image();
  i.src = 'https://alb.reddit.com/snoo.gif?q=CAAHAAABAAoACQAAAAAA7xUOAA==&s=RGC2UDUA43GMsxM-RWyC1n_k5kkF8YB_CfcyBdhIMtw=';
};

/***/ }),

/***/ 1209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _logEvent = __webpack_require__(279);

var _navigation = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// A higher-order component that logs a pageview analytics
// event when the React Router location changes.
// https://github.com/react-ga/react-ga/issues/122#issuecomment-299692833
var withPageviewTracking = function withPageviewTracking(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var trackPageview = function trackPageview(pathname) {
    // Do not track a regular pageview for the new tab page.
    // This prevents us from going over our Google Analytics
    // event limit.
    if (pathname === _navigation.dashboardURL) {
      (0, _logEvent.newTabView)();
    } else {
      (0, _logEvent.pageview)();
    }
  };

  var Wrapper = function (_React$Component) {
    _inherits(Wrapper, _React$Component);

    function Wrapper() {
      _classCallCheck(this, Wrapper);

      return _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).apply(this, arguments));
    }

    _createClass(Wrapper, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var pathname = this.props.location.pathname;
        trackPageview(pathname);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var currentPage = this.props.location.pathname;
        var nextPage = nextProps.location.pathname;

        if (currentPage !== nextPage) {
          trackPageview(nextPage);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return Wrapper;
  }(_react2.default.Component);

  return Wrapper;
};

exports.default = withPageviewTracking;

/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeFirebase = undefined;

var _app = __webpack_require__(246);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(247);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  apiKey: "AIzaSyDZKbk3DzJwA9nWLlpt6hjqhTm6WY-WOnk",
  authDomain: "tab-for-a-cause.firebaseapp.com",
  databaseURL: "https://tab-for-a-cause.firebaseio.com",
  projectId: "tab-for-a-cause"
};

var initializeFirebase = exports.initializeFirebase = function initializeFirebase() {
  _app2.default.initializeApp(config);
};

/***/ }),

/***/ 1211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _displayAd = __webpack_require__(1199);

var _displayAd2 = _interopRequireDefault(_displayAd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Suggestions on React component using DFP:
// https://stackoverflow.com/q/25435066/1332513
var Ad = function (_React$Component) {
  _inherits(Ad, _React$Component);

  function Ad() {
    _classCallCheck(this, Ad);

    return _possibleConstructorReturn(this, (Ad.__proto__ || Object.getPrototypeOf(Ad)).apply(this, arguments));
  }

  _createClass(Ad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _displayAd2.default)(this.props.adId);
    }

    // Never update. This prevents unexpected unmounting or
    // rerendering of third-party ad content.

  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var adStyle = Object.assign({}, this.props.style);
      var adContainerStyle = Object.assign({}, this.props.adWrapperStyle);
      return _react2.default.createElement(
        'div',
        { style: adStyle },
        _react2.default.createElement('div', { id: this.props.adId, style: adContainerStyle })
      );
    }
  }]);

  return Ad;
}(_react2.default.Component);

Ad.propTypes = {
  adId: _propTypes2.default.string,
  style: _propTypes2.default.object,
  adWrapperStyle: _propTypes2.default.object
};

Ad.defaultProps = {
  style: {},
  adWrapperStyle: {}
};

exports.default = Ad;

/***/ }),

/***/ 1212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _withPageviewTracking = __webpack_require__(1209);

var _withPageviewTracking2 = _interopRequireDefault(_withPageviewTracking);

var _clientLocation = __webpack_require__(232);

var _consentManagement = __webpack_require__(379);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this2 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this2.consentChangeCallback = null;
    return _this2;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var isEU;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _clientLocation.isInEuropeanUnion)();

              case 3:
                isEU = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                isEU = false;

              case 9:
                if (isEU) {
                  _this.consentChangeCallback = _this.handleDataConsentDecision.bind(_this);
                  (0, _consentManagement.registerConsentCallback)(_this.consentChangeCallback);
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 6]]);
      }))();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.consentChangeCallback) {
        (0, _consentManagement.unregisterConsentCallback)(this.consentChangeCallback);
      }
    }
  }, {
    key: 'handleDataConsentDecision',
    value: function handleDataConsentDecision() {
      var _this4 = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Store the consent data. We'll log it to the server with
                // the user's ID after the user authenticates.
                (0, _consentManagement.saveConsentUpdateEventToLocalStorage)();

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }, {
    key: 'render',
    value: function render() {
      var root = {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        margin: 0,
        padding: 0,
        border: 'none'
      };

      return _react2.default.createElement(
        'div',
        { style: root },
        this.props.children
      );
    }
  }]);

  return App;
}(_react2.default.Component);

exports.default = (0, _withPageviewTracking2.default)(App);

/***/ }),

/***/ 1213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(111);

var _Paper2 = _interopRequireDefault(_Paper);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _lang = __webpack_require__(107);

var _user = __webpack_require__(64);

var _helpers = __webpack_require__(185);

var _navigation = __webpack_require__(50);

var _LogoWithText = __webpack_require__(571);

var _LogoWithText2 = _interopRequireDefault(_LogoWithText);

var _utils = __webpack_require__(81);

var _AssignExperimentGroupsContainer = __webpack_require__(566);

var _AssignExperimentGroupsContainer2 = _interopRequireDefault(_AssignExperimentGroupsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Handle the authentication flow:
//   check if current user is fully authenticated and redirect
//     to the app if they are; otherwise: ->
//   authenticate with Firebase ->
//   receive onSignInSuccess callback (called for both new
//     and existing users) ->
//   idempotently create a new user in our database ->
//   check if user's email is verified. If not, send a
//     verification email and ask the user to check their email;
//     otherwise: ->
//   fetch the user from our database and ensure they have a
//     username. If not, ask the user to enter a username;
//     otherwise, set the username in localStorage so we know it
//     exists in other views without needing to fetch it from the
//     database. Then, redirect to the app.
// This is somewhat convoluted for a few reasons:
//  * we're using Firebase UI for most authentication views, and it
//    does not support mandatory email verification or extra fields
//    (such as a username)
//  * we're making the username mandatory but can't rely on a field
//    from the authentication user token to store this info
var Authentication = function (_React$Component) {
  _inherits(Authentication, _React$Component);

  function Authentication(props) {
    _classCallCheck(this, Authentication);

    var _this3 = _possibleConstructorReturn(this, (Authentication.__proto__ || Object.getPrototypeOf(Authentication)).call(this, props));

    _this3.state = {
      loadChildren: false,
      // Whether we are requiring the anonymous user to sign in.
      isMandatoryAnonymousSignIn: (0, _utils.getUrlParameters)()['mandatory'] === 'true'
    };
    return _this3;
  }

  _createClass(Authentication, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.mounted = true;

                _context.next = 3;
                return _this.navigateToAuthStep();

              case 3:

                // Don't render any children until after checking the user's
                // authed state. Otherwise, immediate unmounting of
                // FirebaseAuthenticationUI can cause errors.
                // We check `this.mounted` to make sure we don't set state after
                // the component has unmounted. This is hacky; it would be
                // better to cancel the async call on unmount or use a flux-like
                // data flow. See:
                // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
                if (_this.mounted) {
                  _this.setState({
                    loadChildren: true
                  });
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lang.isEqual)(nextProps.user, this.props.user)) {
        this.navigateToAuthStep();
      }
    }

    // Whether this is rendering an /auth/action/ page, which include
    // email confirmation links and password reset links.

  }, {
    key: 'isAuthActionURL',
    value: function isAuthActionURL() {
      return this.props.location.pathname.indexOf('/auth/action/') !== -1;
    }
  }, {
    key: 'navigateToAuthStep',
    value: function navigateToAuthStep() {
      var _this5 = this;

      var _this2 = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
        var authTokenUser, usernameFromServer, redirected, stayOnAuthPage;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.isAuthActionURL()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return (0, _user.getCurrentUser)();

              case 4:
                authTokenUser = _context2.sent;


                // Redirect to the appropriate authentication view if the
                // user is not fully authenticated.
                usernameFromServer = _this2.props.user ? _this2.props.user.username : null;
                _context2.prev = 6;
                _context2.next = 9;
                return (0, _helpers.checkAuthStateAndRedirectIfNeeded)(authTokenUser, usernameFromServer);

              case 9:
                redirected = _context2.sent;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);
                throw _context2.t0;

              case 15:

                // When anonymous users choose to sign in, do not go back to the
                // dashboard.
                stayOnAuthPage = (0, _utils.getUrlParameters)()['noredirect'] === 'true';

                // The user is fully authed, so go to the dashboard.

                if (!redirected && !stayOnAuthPage) {
                  (0, _navigation.goToDashboard)();
                }

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[6, 12]]);
      }))();
    }

    /**
     * Called when the user signs in (for both new and existing users).
     * At this point, the user may or may not have a verified email
     * or a username.
     * @param {object} currentUser - A Firebase user instance
     * @returns {Promise<boolean>}  A promise that resolves into a boolean,
     *   whether or not the email was sent successfully.
     */

  }, {
    key: 'onSignInSuccess',
    value: function onSignInSuccess(currentUser) {
      var _this6 = this;

      // Check that the user has an email address.
      // An email address may be missing if the user signs in
      // with a social provider that does not share their
      // email address. In this case, ask the user to sign in
      // via another method.
      if (!currentUser.email) {
        (0, _navigation.goTo)(_navigation.missingEmailMessageURL);
        return;
      }

      // Get or create the user.
      // Important: we expect to call this on every sign-in event,
      // even for anonymous users who already have a user in our
      // database, because this is when we add their email address
      // and email verification status to their profile.
      return (0, _helpers.createNewUser)().then(function (createdOrFetchedUser) {
        // Check if the user has verified their email.
        // Note: later versions of firebaseui-web might support mandatory
        // email verification:
        // https://github.com/firebase/firebaseui-web/issues/21
        if (!currentUser.emailVerified) {
          // Ask the user to verify their email.
          (0, _user.sendVerificationEmail)().then(function (emailSent) {
            (0, _navigation.goTo)(_navigation.verifyEmailURL);
          }).catch(function (err) {
            // TODO: show error message to the user
            console.error(err);
          });
        } else {
          // Fetch the user from our database. This will update the `user`
          // prop, which will let us navigate to the appropriate step in
          // authentication.
          _this6.props.fetchUser();
        }
      }).catch(function (err) {
        // TODO: show error message to the user
        console.error(err);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props = this.props,
          user = _props.user,
          location = _props.location;

      var showRequiredSignInExplanation = this.state.isMandatoryAnonymousSignIn &&
      // Don't display the message on the iframe auth message page, because
      // it will have its own message.
      location.pathname.indexOf(_navigation.authMessageURL) === -1;
      return _react2.default.createElement(
        'span',
        {
          'data-test-id': 'authentication-page',
          style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            backgroundColor: '#FAFAFA'
          }
        },
        _react2.default.createElement(
          'div',
          { style: { padding: '20px 40px', position: 'absolute', top: 0, left: 0 } },
          _react2.default.createElement(_LogoWithText2.default, { style: { height: 40 } })
        ),
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              alignSelf: 'stretch',
              justifyContent: 'center',
              alignItems: 'center'
            }
          },
          _react2.default.createElement(
            'span',
            {
              style: {
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                padding: 20
              }
            },
            this.state.loadChildren ? _react2.default.Children.map(this.props.children, function (child) {
              return _react2.default.cloneElement(child, {
                onSignInSuccess: _this7.onSignInSuccess.bind(_this7),
                user: user
              });
            }) : null
          ),
          !showRequiredSignInExplanation ?
          // Using same style as homepage
          _react2.default.createElement(
            'span',
            {
              'data-test-id': 'endorsement-quote',
              style: {
                color: 'rgba(33, 33, 33, 0.82)',
                fontFamily: "'Helvetica Neue','Helvetica','Arial',sans-serif",
                fontWeight: '500',
                lineHeight: '1.1',
                textAlign: 'center',
                padding: 10
              }
            },
            _react2.default.createElement(
              'h1',
              null,
              '"One of the simplest ways to raise money"'
            ),
            _react2.default.createElement(
              'p',
              { style: { color: '#838383', fontWeight: '400' } },
              '- USA Today'
            )
          ) : null
        ),
        showRequiredSignInExplanation ? _react2.default.createElement(
          'div',
          {
            'data-test-id': 'anon-sign-in-fyi',
            style: {
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              bottom: 24
            }
          },
          _react2.default.createElement(
            _Paper2.default,
            null,
            _react2.default.createElement(
              'div',
              {
                style: {
                  padding: '14px 18px',
                  maxWidth: 600
                }
              },
              _react2.default.createElement(
                _Typography2.default,
                { variant: 'body2', style: { fontWeight: 'bold' } },
                'Hey there!'
              ),
              _react2.default.createElement(
                _Typography2.default,
                { variant: 'body2' },
                'We ask you to sign in after a while so you don\'t lose access to your notes, bookmarks, and Hearts (even if you drop your computer in a puddle). Signing in also lets you sync your tab between browsers \u2013 nice!'
              )
            )
          )
        ) : null,
        user ? _react2.default.createElement(_AssignExperimentGroupsContainer2.default, { user: user, isNewUser: true }) : null
      );
    }
  }]);

  return Authentication;
}(_react2.default.Component);

Authentication.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }),
  // User fetched from our database (not the auth service user).
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    username: _propTypes2.default.string
  }),
  fetchUser: _propTypes2.default.func.isRequired
};

exports.default = Authentication;

/***/ }),

/***/ 1214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _Authentication = __webpack_require__(1213);

var _Authentication2 = _interopRequireDefault(_Authentication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_Authentication2.default, {
  user: function user() {
    return __webpack_require__(1222);
  }
});

/***/ }),

/***/ 1215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _graphql;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(16);

var _object = __webpack_require__(212);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _AuthenticationContainer = __webpack_require__(1214);

var _AuthenticationContainer2 = _interopRequireDefault(_AuthenticationContainer);

var _user = __webpack_require__(64);

var _helpers = __webpack_require__(185);

var _constants = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* global graphql */

// Fetch the user from our database if the user is
// authenticated.
var AuthenticationView = function (_React$Component) {
  _inherits(AuthenticationView, _React$Component);

  function AuthenticationView(props) {
    _classCallCheck(this, AuthenticationView);

    var _this3 = _possibleConstructorReturn(this, (AuthenticationView.__proto__ || Object.getPrototypeOf(AuthenticationView)).call(this, props));

    _this3.state = {
      relayVariables: {
        userId: null,
        refetchCounter: 0
      }
    };
    _this3.createNewUserAttempts = 0;
    return _this3;
  }

  _createClass(AuthenticationView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchUser();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }

    // If we have an authed user with a user ID, fetch the
    // user from our database.
    // This will force Relay to refetch by modifying the
    // variables object. We could also use the `retry`
    // QueryRenderer function instead.
    // Pass this to children to allow a forced refetch after
    // we create a new user in our database.

  }, {
    key: 'fetchUser',
    value: function fetchUser() {
      var _this5 = this;

      var _this2 = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
        var user;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _user.getCurrentUser)();

              case 2:
                user = _context2.sent;

                if (user && user.id) {
                  _this2.setState({
                    relayVariables: Object.assign({}, _this2.state.relayVariables, {
                      userId: user.id,
                      refetchCounter: _this2.state.relayVariables.refetchCounter + 1
                    })
                  });
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var query;
      if (this.state.relayVariables.userId) {
        query = _graphql || (_graphql = function _graphql() {
          return __webpack_require__(1223);
        });
      }
      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _relayEnv2.default,
        query: query,
        variables: this.state.relayVariables,
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props;

          if (error && (0, _object.get)(error, 'source.errors')) {
            // If any of the errors is because the user does not exist
            // on the server side, create the user and re-query if
            // possible.
            var userDoesNotExistError = error.source.errors.some(function (err) {
              return err.code === _constants.ERROR_USER_DOES_NOT_EXIST;
            });

            // Limit the number of times we try to refetch a user after
            // trying to create the user to prevent a loop in case of
            // any bugs.
            if (userDoesNotExistError && _this6.createNewUserAttempts < 3) {
              _this6.createNewUserAttempts = _this6.createNewUserAttempts + 1;
              (0, _helpers.createNewUser)().then(function (user) {
                _this6.fetchUser();
              }).catch(function (e) {
                throw e;
              });
            } else {
              console.error(error);
            }
          }
          if (!props) {
            props = {};
          }
          var user = props.user || null;
          return _react2.default.createElement(_AuthenticationContainer2.default, _extends({
            user: user,
            fetchUser: _this6.fetchUser.bind(_this6)
          }, _this6.props));
        } });
    }
  }]);

  return AuthenticationView;
}(_react2.default.Component);

exports.default = AuthenticationView;

/***/ }),

/***/ 1216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__(120);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _UsernameField = __webpack_require__(1280);

var _UsernameField2 = _interopRequireDefault(_UsernameField);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _SetUsernameMutation = __webpack_require__(1396);

var _SetUsernameMutation2 = _interopRequireDefault(_SetUsernameMutation);

var _user = __webpack_require__(64);

var _helpers = __webpack_require__(185);

var _navigation = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EnterUsernameForm = function (_React$Component) {
  _inherits(EnterUsernameForm, _React$Component);

  function EnterUsernameForm(props) {
    _classCallCheck(this, EnterUsernameForm);

    var _this = _possibleConstructorReturn(this, (EnterUsernameForm.__proto__ || Object.getPrototypeOf(EnterUsernameForm)).call(this, props));

    _this.state = {
      usernameDuplicate: false,
      otherError: false,
      savingUsernameInProgress: false
    };
    return _this;
  }

  _createClass(EnterUsernameForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // See if the user verified their email address so that we can
      // log the verification. It would be better to user a cloud
      // function for this, or at least an official callback from the
      // Firebase SDK, but Firebase does not yet support one. See:
      // https://stackoverflow.com/q/43503377
      // We also do this on the email verification screen, but it
      // may fail if Firebase is slow to update, so we're adding it
      // here to reduce the frequency that we fail to log the
      // verification.
      (0, _helpers.checkIfEmailVerified)();
    }
  }, {
    key: 'submit',
    value: function submit(e) {
      var usernameValid = this.username.validate();
      var username = this.username.getValue();
      this.setState({
        usernameDuplicate: false,
        otherError: false
      });
      if (usernameValid) {
        this.setState({
          savingUsernameInProgress: true
        });
        (0, _SetUsernameMutation2.default)(_relayEnv2.default, this.props.user.id, username, this.onMutationCompleted.bind(this), this.onMutationError.bind(this));
      }
    }
  }, {
    key: 'onMutationCompleted',
    value: function onMutationCompleted(response) {
      var _this2 = this;

      this.setState({
        savingUsernameInProgress: false
      });
      var data = response.setUsername;

      // Handle server-side validation errors.
      if (!data.user) {
        data.errors.forEach(function (err) {
          // Username already exists
          if (err.code === 'USERNAME_DUPLICATE') {
            _this2.setState({
              usernameDuplicate: true
            });
            // Some other error
          } else {
            _this2.setState({
              otherError: true
            });
          }
        });
        return;
      }

      // Username saved successfully. Set the username in localStorage
      // and redirect to the app.
      (0, _user.setUsernameInLocalStorage)(data.user.username);
      (0, _navigation.goToDashboard)();
    }
  }, {
    key: 'onMutationError',
    value: function onMutationError(response) {
      // TODO: show better error message to the user
      console.error('Error saving username:', response);
      this.setState({
        savingUsernameInProgress: false,
        otherError: true
      });
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(e) {
      if (this.state.savingUsernameInProgress) {
        return;
      }

      if (e.key === 'Enter') {
        this.submit();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        _materialUi.Paper,
        {
          zDepth: 1,
          style: {
            padding: 24,
            backgroundColor: '#FFF'
          }
        },
        _react2.default.createElement(
          'span',
          {
            style: {
              fontSize: 20,
              fontWeight: 500
            }
          },
          'Choose a username'
        ),
        _react2.default.createElement(_UsernameField2.default, {
          usernameDuplicate: this.state.usernameDuplicate,
          otherError: this.state.otherError,
          onKeyPress: this.handleKeyPress.bind(this),
          ref: function ref(elem) {
            _this3.username = elem;
          },
          style: {
            display: 'block'
          },
          'data-test-id': 'enter-username-form-username-field'
        }),
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 30
            },
            'data-test-id': 'enter-username-form-button-container'
          },
          _react2.default.createElement(_RaisedButton2.default, {
            label: this.state.savingUsernameInProgress ? 'SAVING...' : 'NEXT',
            primary: true,
            disabled: this.state.savingUsernameInProgress,
            onClick: this.submit.bind(this)
          })
        )
      );
    }
  }]);

  return EnterUsernameForm;
}(_react2.default.Component);

EnterUsernameForm.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string
  })
};

exports.default = EnterUsernameForm;

/***/ }),

/***/ 1217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _app = __webpack_require__(246);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(247);

var _reactFirebaseui = __webpack_require__(2405);

var _navigation = __webpack_require__(50);

var _logEvent = __webpack_require__(279);

var _logger = __webpack_require__(187);

var _logger2 = _interopRequireDefault(_logger);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _MergeIntoExistingUserMutation = __webpack_require__(1391);

var _MergeIntoExistingUserMutation2 = _interopRequireDefault(_MergeIntoExistingUserMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var FirebaseAuthenticationUI = function (_React$Component) {
  _inherits(FirebaseAuthenticationUI, _React$Component);

  function FirebaseAuthenticationUI(props) {
    _classCallCheck(this, FirebaseAuthenticationUI);

    var _this3 = _possibleConstructorReturn(this, (FirebaseAuthenticationUI.__proto__ || Object.getPrototypeOf(FirebaseAuthenticationUI)).call(this, props));

    _this3.configureFirebaseUI();
    return _this3;
  }

  _createClass(FirebaseAuthenticationUI, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeButtonClickListeners();
    }
  }, {
    key: 'socialButtonClicked',
    value: function socialButtonClicked(e) {
      (0, _logEvent.signupPageButtonClick)();
      (0, _logEvent.signupPageSocialButtonClick)();
    }
  }, {
    key: 'emailButtonClicked',
    value: function emailButtonClicked(e) {
      (0, _logEvent.signupPageButtonClick)();
      (0, _logEvent.signupPageEmailButtonClick)();
    }

    // Poll a few times for an element by classnames

  }, {
    key: 'getElementByClassNamePolling',
    value: function getElementByClassNamePolling(classnames) {
      var _this4 = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var getElems, timeout, elems, timesToPoll, pollIntervalMs, times;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                timeout = function timeout(ms) {
                  return new Promise(function (resolve) {
                    return setTimeout(resolve, ms);
                  });
                };

                getElems = function getElems() {
                  return document.getElementsByClassName(classnames);
                };

                elems = [];
                timesToPoll = 10;
                pollIntervalMs = 100;
                times = 0;

              case 6:
                if (!(times < timesToPoll)) {
                  _context.next = 15;
                  break;
                }

                elems = getElems();

                if (!elems.length) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', elems[0]);

              case 10:
                // If could not find the elem, continue polling
                times += 1;
                _context.next = 13;
                return timeout(pollIntervalMs);

              case 13:
                _context.next = 6;
                break;

              case 15:
                return _context.abrupt('return', null);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }

    // TODO: fix this hack after replacing/updating firebaseweb-ui.
    // This callback is called before the sign-in buttons are
    // rendered, so poll for the elements.

  }, {
    key: 'addButtonClickListeners',
    value: function addButtonClickListeners() {
      var _this5 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
        var facebookButton, googleButton, emailButton;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.getElementByClassNamePolling('firebaseui-idp-button firebaseui-idp-facebook');

              case 2:
                facebookButton = _context2.sent;

                if (facebookButton) {
                  facebookButton.addEventListener('click', _this.socialButtonClicked);
                }

                // Google
                _context2.next = 6;
                return _this.getElementByClassNamePolling('firebaseui-idp-button firebaseui-idp-google');

              case 6:
                googleButton = _context2.sent;

                if (googleButton) {
                  googleButton.addEventListener('click', _this.socialButtonClicked);
                }

                // // Twitter
                // const twitterButton = await this.getElementByClassNamePolling(
                //   'firebaseui-idp-button firebaseui-idp-twitter')
                // if (twitterButton) {
                //   twitterButton.addEventListener('click', this.socialButtonClicked)
                // }

                // Email & password
                _context2.next = 10;
                return _this.getElementByClassNamePolling('firebaseui-idp-button firebaseui-idp-password');

              case 10:
                emailButton = _context2.sent;

                if (emailButton) {
                  emailButton.addEventListener('click', _this.emailButtonClicked);
                }

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    }
  }, {
    key: 'removeButtonClickListeners',
    value: function removeButtonClickListeners() {
      var _this6 = this;

      var _this2 = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
        var facebookButton, googleButton, emailButton;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.getElementByClassNamePolling('firebaseui-idp-button firebaseui-idp-facebook');

              case 2:
                facebookButton = _context3.sent;

                if (facebookButton) {
                  facebookButton.removeEventListener('click', _this2.socialButtonClicked);
                }

                // Google
                _context3.next = 6;
                return _this2.getElementByClassNamePolling('firebaseui-idp-button firebaseui-idp-google');

              case 6:
                googleButton = _context3.sent;

                if (googleButton) {
                  googleButton.removeEventListener('click', _this2.socialButtonClicked);
                }

                // // Twitter
                // const twitterButton = await this.getElementByClassNamePolling(
                //   'firebaseui-idp-button firebaseui-idp-twitter')
                // if (twitterButton) {
                //   twitterButton.removeEventListener('click', this.socialButtonClicked)
                // }

                // Email & password
                _context3.next = 10;
                return _this2.getElementByClassNamePolling('firebaseui-idp-button firebaseui-idp-password');

              case 10:
                emailButton = _context3.sent;

                if (emailButton) {
                  emailButton.removeEventListener('click', _this2.emailButtonClicked);
                }

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    }
  }, {
    key: 'configureFirebaseUI',
    value: function configureFirebaseUI() {
      var _this7 = this;

      // Configure FirebaseUI.
      // https://github.com/firebase/firebaseui-web#example-with-all-parameters-used
      this.uiConfig = {
        // Either 'popup' or 'redirect'
        signInFlow: 'popup',
        // Redirect path after successful sign in, or a callbacks.signInSuccess function
        signInSuccessUrl: _navigation.dashboardURL,
        // Auth providers
        // https://github.com/firebase/firebaseui-web#configure-oauth-providers
        signInOptions: [{
          provider: _app2.default.auth.GoogleAuthProvider.PROVIDER_ID,
          scopes: ['https://www.googleapis.com/auth/userinfo.email']
        }, {
          provider: _app2.default.auth.FacebookAuthProvider.PROVIDER_ID,
          scopes: ['email']
        }, {
          provider: _app2.default.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: false
        }],
        // Allow anonymous users to sign in.
        autoUpgradeAnonymousUsers: true,
        callbacks: {
          signInSuccessWithAuthResult: function signInSuccessWithAuthResult(authResult, redirectUrl) {
            // Note: we can check if it's a new user with
            // `authResult.additionalUserInfo.isNewUser`.
            _this7.props.onSignInSuccess(authResult.user);

            // Do not automatically redirect to the signInSuccessUrl.
            return false;
          },
          uiShown: function uiShown() {
            _this7.addButtonClickListeners();
          },
          // The signInFailure callback must be provided to handle merge conflicts which
          // occur when an existing credential is linked to an anonymous user.
          // https://firebase.google.com/docs/auth/web/firebaseui?authuser=0#handling_anonymous_user_upgrade_merge_conflicts
          // https://github.com/firebase/firebaseui-web#handling-anonymous-user-upgrade-merge-conflicts
          signInFailure: function signInFailure(error) {
            // For merge conflicts, the error.code will be
            // 'firebaseui/anonymous-upgrade-merge-conflict'.
            if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
              var user = _app2.default.auth().currentUser;
              _this7.props.onSignInSuccess(user);
              return Promise.resolve();
            }

            var anonymousUser = _app2.default.auth().currentUser;

            // The existing credential the user tried to sign in with.
            var cred = error.credential;

            return new Promise(function (resolve, reject) {
              // Mark the anonymous user as merged in our database (a duplicate).
              // Here, we could also merge the anonymous user's data with the
              // existing user but we don't do that currently.
              (0, _MergeIntoExistingUserMutation2.default)(_relayEnv2.default, anonymousUser.uid,
              // onCompleted
              function () {
                resolve();
              },
              // onError
              function (err) {
                // Log the error but don't throw (it's a non-critical error).
                _logger2.default.error(err);
                resolve();
              });
            }).then(function () {
              // Sign in as the existing user.
              return _app2.default.auth().signInAndRetrieveDataWithCredential(cred);
            }).then(function (authResult) {
              var authedUser = authResult.user;

              // Delete the anonymous user in Firebase.
              return anonymousUser.delete().catch(function (e) {
                _logger2.default.error(e);
              }).finally(function () {
                // Proceed with sign-in as usual.
                _this7.props.onSignInSuccess(authedUser);
              });
            }).catch(function (e) {
              _logger2.default.error(e);
            });
          }
        },
        // Just using the constant rather than importing firebaseui
        // https://github.com/firebase/firebaseui-web#credential-helper
        // https://github.com/firebase/firebaseui-web/blob/bd710448caa34c4a47a2fd578d76be8506d392d8/javascript/widgets/config.js#L83
        credentialHelper: 'none',
        // Terms of service URL
        tosUrl: _navigation.termsOfServiceURL,
        // Privacy policy URL
        privacyPolicyUrl: _navigation.privacyPolicyURL
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_reactFirebaseui.FirebaseAuth, {
          uiConfig: this.uiConfig,
          firebaseAuth: _app2.default.auth()
        }),
        this.props.children
      );
    }
  }]);

  return FirebaseAuthenticationUI;
}(_react2.default.Component);

FirebaseAuthenticationUI.propTypes = {
  onSignInSuccess: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.element

  // https://github.com/facebook/react/issues/6653
};FirebaseAuthenticationUI.defaultProps = {
  onSignInSuccess: function onSignInSuccess() {}
};

exports.default = FirebaseAuthenticationUI;

/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _helpers = __webpack_require__(185);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FirebaseAuthenticationUIAction = function (_React$Component) {
  _inherits(FirebaseAuthenticationUIAction, _React$Component);

  function FirebaseAuthenticationUIAction() {
    _classCallCheck(this, FirebaseAuthenticationUIAction);

    return _possibleConstructorReturn(this, (FirebaseAuthenticationUIAction.__proto__ || Object.getPrototypeOf(FirebaseAuthenticationUIAction)).apply(this, arguments));
  }

  _createClass(FirebaseAuthenticationUIAction, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // See if the user verified their email address so that we can
      // log the verification. It would be better to user a cloud
      // function for this, or at least an official callback from the
      // Firebase SDK, but Firebase does not yet support one. See:
      // https://stackoverflow.com/q/43503377
      (0, _helpers.checkIfEmailVerified)();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return FirebaseAuthenticationUIAction;
}(_react2.default.Component);

FirebaseAuthenticationUIAction.propTypes = {};
FirebaseAuthenticationUIAction.defaultProps = {};

exports.default = FirebaseAuthenticationUIAction;

/***/ }),

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(120);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _user = __webpack_require__(64);

var _navigation = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var MissingEmailMessage = function (_React$Component) {
  _inherits(MissingEmailMessage, _React$Component);

  function MissingEmailMessage() {
    _classCallCheck(this, MissingEmailMessage);

    return _possibleConstructorReturn(this, (MissingEmailMessage.__proto__ || Object.getPrototypeOf(MissingEmailMessage)).apply(this, arguments));
  }

  _createClass(MissingEmailMessage, [{
    key: 'restartAuthFlow',
    value: function restartAuthFlow() {
      var _this2 = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _user.logout)();

              case 2:
                (0, _navigation.goTo)(_navigation.loginURL);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }, {
    key: 'render',
    value: function render() {
      var buttonLabel = 'SIGN IN USING ANOTHER METHOD';
      return _react2.default.createElement(
        _materialUi.Paper,
        {
          zDepth: 1,
          style: {
            padding: 24,
            maxWidth: 400,
            backgroundColor: '#FFF'
          }
        },
        _react2.default.createElement(
          'h3',
          null,
          'We couldn\'t sign you in'
        ),
        _react2.default.createElement(
          'p',
          null,
          'This can happen when Facebook or Google doesn\'t have your email address on file, which we use to create your account. Please try signing in with another method, such as an email and password.'
        ),
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 24
            },
            'data-test-id': 'missing-email-message-button-container'
          },
          _react2.default.createElement(_RaisedButton2.default, {
            label: buttonLabel,
            primary: true,
            onClick: this.restartAuthFlow.bind(this)
          })
        )
      );
    }
  }]);

  return MissingEmailMessage;
}(_react2.default.Component);

exports.default = MissingEmailMessage;

/***/ }),

/***/ 1220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(120);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _navigation = __webpack_require__(50);

var _utils = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This view primarily exists as an intermediary to open
// the authentication page outside of an iframe, because
// authentication may not work properly within an iframe.
// E.g., see: https://github.com/gladly-team/tab/issues/188
// Most often, users will see this if they are not authenticated
// and open a new tab; our browser extensions currently iframe
// the page.
var SignInIframeMessage = function (_React$Component) {
  _inherits(SignInIframeMessage, _React$Component);

  function SignInIframeMessage(props) {
    _classCallCheck(this, SignInIframeMessage);

    var _this = _possibleConstructorReturn(this, (SignInIframeMessage.__proto__ || Object.getPrototypeOf(SignInIframeMessage)).call(this, props));

    _this.state = {
      // Whether we are requiring the anonymous user to sign in.
      isMandatoryAnonymousSignIn: (0, _utils.getUrlParameters)()['mandatory'] === 'true'
    };
    return _this;
  }

  _createClass(SignInIframeMessage, [{
    key: 'openAuthOutsideIframe',
    value: function openAuthOutsideIframe() {
      window.open((0, _navigation.absoluteUrl)(_navigation.loginURL), '_top');
    }
  }, {
    key: 'render',
    value: function render() {
      var showRequiredSignInExplanation = this.state.isMandatoryAnonymousSignIn;
      var buttonLabel = 'SIGN IN';
      return _react2.default.createElement(
        _materialUi.Paper,
        {
          zDepth: 1,
          style: {
            padding: 24,
            maxWidth: 400,
            backgroundColor: '#FFF',
            marginBottom: 60
          }
        },
        _react2.default.createElement(
          _Typography2.default,
          { variant: 'h6' },
          showRequiredSignInExplanation ? 'Great job so far!' : 'Let\'s get started!'
        ),
        showRequiredSignInExplanation ? _react2.default.createElement(
          _Typography2.default,
          { variant: 'body2' },
          'You\'ve already made a positive impact! Let\'s keep this progress safe: we ask you to sign in after a while so you don\'t lose access to your notes, bookmarks, and Hearts (even if you drop your computer in a puddle).'
        ) : _react2.default.createElement(
          _Typography2.default,
          { variant: 'body2' },
          'Sign in to customize your new tab page and raise money for your favorite causes.'
        ),
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 24
            }
          },
          _react2.default.createElement(_RaisedButton2.default, {
            'data-test-id': 'sign-in-iframe-message-button',
            label: buttonLabel,
            primary: true,
            onClick: this.openAuthOutsideIframe.bind(this)
          })
        )
      );
    }
  }]);

  return SignInIframeMessage;
}(_react2.default.Component);

exports.default = SignInIframeMessage;

/***/ }),

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__(120);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _user = __webpack_require__(64);

var _navigation = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var VerifyEmailMessage = function (_React$Component) {
  _inherits(VerifyEmailMessage, _React$Component);

  function VerifyEmailMessage(props) {
    _classCallCheck(this, VerifyEmailMessage);

    var _this2 = _possibleConstructorReturn(this, (VerifyEmailMessage.__proto__ || Object.getPrototypeOf(VerifyEmailMessage)).call(this, props));

    _this2.state = {
      emailResent: false,
      emailResendingInProgress: false,
      emailResendingError: false
    };
    return _this2;
  }

  _createClass(VerifyEmailMessage, [{
    key: 'resendEmailClick',
    value: function resendEmailClick(e) {
      var _this3 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var emailSent;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  emailResendingInProgress: true,
                  emailResendingError: false
                });
                _context.next = 3;
                return (0, _user.sendVerificationEmail)();

              case 3:
                emailSent = _context.sent;

                if (emailSent) {
                  _this.setState({
                    emailResent: true,
                    emailResendingInProgress: false
                  });
                } else {
                  _this.setState({
                    emailResent: false,
                    emailResendingError: true,
                    emailResendingInProgress: false
                  });
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  }, {
    key: 'restartAuthFlow',
    value: function restartAuthFlow() {
      var _this4 = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _user.logout)();

              case 2:
                (0, _navigation.goTo)(_navigation.loginURL);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }, {
    key: 'render',
    value: function render() {
      var buttonLabel = 'RESEND EMAIL';
      var buttonDisabled = false;
      if (this.state.emailResendingInProgress) {
        buttonLabel = 'SENDING EMAIL...';
        buttonDisabled = true;
      } else if (this.state.emailResent) {
        buttonLabel = 'EMAIL RESENT';
        buttonDisabled = true;
      } else if (this.state.emailResendingError) {
        buttonLabel = 'ERROR SENDING EMAIL';
        buttonDisabled = true;
      }

      var cancelButtonLabel = 'CANCEL';

      return _react2.default.createElement(
        _materialUi.Paper,
        {
          zDepth: 1,
          style: {
            padding: 24,
            maxWidth: 400,
            backgroundColor: '#FFF'
          }
        },
        _react2.default.createElement(
          'p',
          null,
          'Please check your email to verify your account.'
        ),
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 24
            },
            'data-test-id': 'verify-email-message-button-container'
          },
          _react2.default.createElement(_RaisedButton2.default, {
            label: cancelButtonLabel,
            disabled: buttonDisabled,
            onClick: this.restartAuthFlow.bind(this),
            style: {
              marginRight: 8
            }
          }),
          _react2.default.createElement(_RaisedButton2.default, {
            label: buttonLabel,
            primary: true,
            disabled: buttonDisabled,
            onClick: this.resendEmailClick.bind(this)
          })
        )
      );
    }
  }]);

  return VerifyEmailMessage;
}(_react2.default.Component);

exports.default = VerifyEmailMessage;

/***/ }),

/***/ 1222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AssignExperimentGroupsContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AuthenticationContainer_user$ref: FragmentReference;
export type AuthenticationContainer_user = {|
  +id: string,
  +email: ?string,
  +username: ?string,
  +$fragmentRefs: AssignExperimentGroupsContainer_user$ref,
  +$refType: AuthenticationContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "AuthenticationContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "username",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "AssignExperimentGroupsContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '57598014cbc7780de40eeb6ab67baff2';
module.exports = node;

/***/ }),

/***/ 1223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b5d1bfdd856c0b98fca1294446458d19
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type AuthenticationContainer_user$ref = any;
export type AuthenticationViewQueryVariables = {|
  userId: string
|};
export type AuthenticationViewQueryResponse = {|
  +user: ?{|
    +$fragmentRefs: AuthenticationContainer_user$ref
  |}
|};
export type AuthenticationViewQuery = {|
  variables: AuthenticationViewQueryVariables,
  response: AuthenticationViewQueryResponse,
|};
*/

/*
query AuthenticationViewQuery(
  $userId: String!
) {
  user(userId: $userId) {
    ...AuthenticationContainer_user
    id
  }
}

fragment AuthenticationContainer_user on User {
  id
  email
  username
  ...AssignExperimentGroupsContainer_user
}

fragment AssignExperimentGroupsContainer_user on User {
  id
  joined
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "AuthenticationViewQuery",
    "id": null,
    "text": "query AuthenticationViewQuery(\n  $userId: String!\n) {\n  user(userId: $userId) {\n    ...AuthenticationContainer_user\n    id\n  }\n}\n\nfragment AuthenticationContainer_user on User {\n  id\n  email\n  username\n  ...AssignExperimentGroupsContainer_user\n}\n\nfragment AssignExperimentGroupsContainer_user on User {\n  id\n  joined\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AuthenticationViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "AuthenticationContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AuthenticationViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "username",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "joined",
          "args": null,
          "storageKey": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '8eb1f773649b756f546ceeeb231c6536';
module.exports = node;

/***/ }),

/***/ 1224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactColor = __webpack_require__(941);

var _Paper = __webpack_require__(60);

var _Paper2 = _interopRequireDefault(_Paper);

var _Subheader = __webpack_require__(215);

var _Subheader2 = _interopRequireDefault(_Subheader);

var _Divider = __webpack_require__(258);

var _Divider2 = _interopRequireDefault(_Divider);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _default = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundColorPicker = function (_React$Component) {
  _inherits(BackgroundColorPicker, _React$Component);

  function BackgroundColorPicker(props) {
    _classCallCheck(this, BackgroundColorPicker);

    var _this = _possibleConstructorReturn(this, (BackgroundColorPicker.__proto__ || Object.getPrototypeOf(BackgroundColorPicker)).call(this, props));

    _this.state = {
      selectedColor: '#000'
    };
    return _this;
  }

  _createClass(BackgroundColorPicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var user = this.props.user;

      var selectedColor = user.backgroundColor || this.state.selectedColor;
      this.onColorChanged({ hex: selectedColor });
    }
  }, {
    key: 'onColorChanged',
    value: function onColorChanged(color) {
      this.setState({
        selectedColor: color.hex
      });
      this.props.onBackgroundColorSelection(color.hex);
    }
  }, {
    key: 'render',
    value: function render() {
      var root = {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
      };

      var gridList = {
        display: 'flex',
        width: '100%'
      };

      var previewContainer = {
        width: '100%',
        padding: 10,
        paddingTop: 0
      };

      var preview = {
        width: '100%',
        height: '60%',
        backgroundColor: this.state.selectedColor
      };

      var header = Object.assign({}, _default.cardHeaderSubtitleStyle, {
        paddingLeft: 0
      });

      var divider = {
        marginBottom: 10
      };

      return _react2.default.createElement(
        'div',
        { style: root },
        _react2.default.createElement(
          _Subheader2.default,
          { style: header },
          'Select your color'
        ),
        _react2.default.createElement(_Divider2.default, { style: divider }),
        _react2.default.createElement(
          'div',
          {
            style: gridList },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactColor.SketchPicker, {
              color: this.state.selectedColor,
              disableAlpha: true,
              onChangeComplete: this.onColorChanged.bind(this)
            })
          ),
          _react2.default.createElement(
            'div',
            { style: previewContainer },
            _react2.default.createElement(_Paper2.default, { style: preview })
          )
        )
      );
    }
  }]);

  return BackgroundColorPicker;
}(_react2.default.Component);

BackgroundColorPicker.propTypes = {
  user: _propTypes2.default.shape({
    backgroundColor: _propTypes2.default.string.isRequired
  }),
  onBackgroundColorSelection: _propTypes2.default.func.isRequired
};

exports.default = BackgroundColorPicker;

/***/ }),

/***/ 1225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _BackgroundColorPickerComponent = __webpack_require__(1224);

var _BackgroundColorPickerComponent2 = _interopRequireDefault(_BackgroundColorPickerComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_BackgroundColorPickerComponent2.default, {
  user: function user() {
    return __webpack_require__(1231);
  }
});

/***/ }),

/***/ 1226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Subheader = __webpack_require__(215);

var _Subheader2 = _interopRequireDefault(_Subheader);

var _TextField = __webpack_require__(95);

var _TextField2 = _interopRequireDefault(_TextField);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _default = __webpack_require__(44);

var _nopicture = __webpack_require__(2651);

var _nopicture2 = _interopRequireDefault(_nopicture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundCustomeImagePicker = function (_React$Component) {
  _inherits(BackgroundCustomeImagePicker, _React$Component);

  function BackgroundCustomeImagePicker(props) {
    _classCallCheck(this, BackgroundCustomeImagePicker);

    var _this = _possibleConstructorReturn(this, (BackgroundCustomeImagePicker.__proto__ || Object.getPrototypeOf(BackgroundCustomeImagePicker)).call(this, props));

    _this.state = {
      image: null
    };
    return _this;
  }

  _createClass(BackgroundCustomeImagePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var user = this.props.user;

      if (user.customImage) {
        this.setState({
          image: user.customImage
        });
        this.updateUserCustomImg(user.customImage);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(event, newValue) {
      // May want to validate URI and have separate error message
      // if it's invalid.
      this.setState({
        image: newValue
      });
    }
  }, {
    key: 'updateUserCustomImg',
    value: function updateUserCustomImg(imgURL) {
      this.props.onCustomImageSelection(imgURL);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.imgLink.input.value = '';
      this.setState({
        image: null
      });
    }
  }, {
    key: 'onImgLoaded',
    value: function onImgLoaded() {
      var user = this.props.user;

      if (this.state.image && this.state.image !== user.customImage) {
        this.updateUserCustomImg(this.state.image);
      }
    }
  }, {
    key: 'onErrorLoadingImg',
    value: function onErrorLoadingImg() {
      this.props.showError('Could not load that image.');
      this.setState({
        image: null
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var image = this.state.image || _nopicture2.default;

      var root = {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start'
      };

      var textInput = {
        fontSize: 14,
        width: '100%'
      };

      var column1 = {
        flex: 1,
        paddingRight: 30
      };

      var column2 = {
        flex: 1
      };

      var header = Object.assign({}, _default.cardHeaderSubtitleStyle, {
        paddingLeft: 0
      });

      var preview = {
        height: 'auto',
        transform: 'translateY(-0%)',
        position: 'relative',
        left: 0,
        width: '100%',
        top: 0
      };

      var clear = {
        margin: 5,
        marginLeft: 0
      };

      return _react2.default.createElement(
        'div',
        { style: root },
        _react2.default.createElement(
          'div',
          {
            style: column1 },
          _react2.default.createElement(
            _Subheader2.default,
            { style: header },
            'Enter an image URL'
          ),
          _react2.default.createElement(_TextField2.default, {
            ref: function ref(input) {
              _this2.imgLink = input;
            },
            style: textInput,
            value: this.state.image || '',
            hintText: 'Image URL',
            onChange: this.onChange.bind(this) }),
          _react2.default.createElement(_RaisedButton2.default, {
            label: 'CLEAR',
            onClick: this.clear.bind(this),
            'default': true,
            style: clear })
        ),
        _react2.default.createElement(
          'div',
          { style: column2 },
          _react2.default.createElement('img', {
            alt: 'Preview of your custom background',
            onLoad: this.onImgLoaded.bind(this),
            onError: this.onErrorLoadingImg.bind(this),
            style: preview,
            src: image })
        )
      );
    }
  }]);

  return BackgroundCustomeImagePicker;
}(_react2.default.Component);

BackgroundCustomeImagePicker.propTypes = {
  user: _propTypes2.default.shape({
    customImage: _propTypes2.default.string.isRequired
  }),
  showError: _propTypes2.default.func.isRequired,
  onCustomImageSelection: _propTypes2.default.func.isRequired
};

exports.default = BackgroundCustomeImagePicker;

/***/ }),

/***/ 1227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _BackgroundCustomImagePickerComponent = __webpack_require__(1226);

var _BackgroundCustomImagePickerComponent2 = _interopRequireDefault(_BackgroundCustomImagePickerComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_BackgroundCustomImagePickerComponent2.default, {
  user: function user() {
    return __webpack_require__(1232);
  }
});

/***/ }),

/***/ 1228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _object = __webpack_require__(212);

var _GridList = __webpack_require__(768);

var _IconButton = __webpack_require__(119);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _checkCircle = __webpack_require__(337);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _radioButtonUnchecked = __webpack_require__(798);

var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);

var _Subheader = __webpack_require__(215);

var _Subheader2 = _interopRequireDefault(_Subheader);

var _default = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundImagePicker = function (_React$Component) {
  _inherits(BackgroundImagePicker, _React$Component);

  function BackgroundImagePicker(props) {
    _classCallCheck(this, BackgroundImagePicker);

    var _this = _possibleConstructorReturn(this, (BackgroundImagePicker.__proto__ || Object.getPrototypeOf(BackgroundImagePicker)).call(this, props));

    var app = props.app,
        user = props.user;

    var selectedImage = user.backgroundImage;
    if (selectedImage) {
      var image;
      for (var index in app.backgroundImages.edges) {
        var bkgImage = app.backgroundImages.edges[index].node;
        if (selectedImage.imageURL === bkgImage.imageURL) {
          image = bkgImage;
          break;
        }
      }
    } else {
      // If the user's photo does not exist, select the first
      // photo we display.
      image = (0, _object.get)(app, 'backgroundImages.edges[0].node') || null;
    }

    _this.state = {
      selectedImage: image || null
    };
    return _this;
  }

  _createClass(BackgroundImagePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Call the image selection on mount so the parent component
      // can save the background settings.
      if (this.state.selectedImage) {
        this.props.onBackgroundImageSelection(this.state.selectedImage);
      }
    }
  }, {
    key: 'onImageSelected',
    value: function onImageSelected(image) {
      if (!image || !image.id) {
        return;
      }
      this.setState({
        selectedImage: image
      });

      this.props.onBackgroundImageSelection(image);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var app = this.props.app;

      var root = {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
      };

      var gridList = {
        width: '100%',
        overflowY: 'auto'
      };

      var header = Object.assign({}, _default.cardHeaderSubtitleStyle, {
        paddingLeft: 0
      });
      return _react2.default.createElement(
        'div',
        { style: root },
        _react2.default.createElement(
          _Subheader2.default,
          { style: header },
          'Select your photo'
        ),
        _react2.default.createElement(
          _GridList.GridList,
          {
            cols: 3,
            cellHeight: 170,
            style: gridList },
          app.backgroundImages.edges.map(function (edge) {
            var checked = _this2.state.selectedImage && _this2.state.selectedImage.id === edge.node.id;
            return _react2.default.createElement(
              _GridList.GridTile,
              {
                key: edge.node.id,
                title: edge.node.name,
                style: { cursor: 'pointer' },
                onClick: _this2.onImageSelected.bind(_this2, edge.node),
                actionIcon: _react2.default.createElement(
                  _IconButton2.default,
                  {
                    onClick: _this2.onImageSelected.bind(_this2, edge.node) },
                  checked ? _react2.default.createElement(_checkCircle2.default, { color: 'white' }) : _react2.default.createElement(_radioButtonUnchecked2.default, { color: 'white' })
                ) },
              _react2.default.createElement('img', { alt: edge.node.name, src: edge.node.thumbnailURL })
            );
          })
        )
      );
    }
  }]);

  return BackgroundImagePicker;
}(_react2.default.Component);

BackgroundImagePicker.propTypes = {
  app: _propTypes2.default.shape({
    backgroundImages: _propTypes2.default.shape({
      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.string,
        name: _propTypes2.default.string,
        imageURL: _propTypes2.default.string,
        thumbnailURL: _propTypes2.default.string
      })).isRequired
    }).isRequired
  }),
  user: _propTypes2.default.shape({
    backgroundImage: _propTypes2.default.shape({
      id: _propTypes2.default.string.isRequired,
      imageURL: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  onBackgroundImageSelection: _propTypes2.default.func.isRequired
};

exports.default = BackgroundImagePicker;

/***/ }),

/***/ 1229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _BackgroundImagePickerComponent = __webpack_require__(1228);

var _BackgroundImagePickerComponent2 = _interopRequireDefault(_BackgroundImagePickerComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_BackgroundImagePickerComponent2.default, {
  user: function user() {
    return __webpack_require__(1234);
  },
  app: function app() {
    return __webpack_require__(1233);
  }
});

/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FadeBackgroundAnimation = function (_React$Component) {
  _inherits(FadeBackgroundAnimation, _React$Component);

  function FadeBackgroundAnimation() {
    _classCallCheck(this, FadeBackgroundAnimation);

    return _possibleConstructorReturn(this, (FadeBackgroundAnimation.__proto__ || Object.getPrototypeOf(FadeBackgroundAnimation)).apply(this, arguments));
  }

  _createClass(FadeBackgroundAnimation, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        null,
        _react2.default.Children.map(this.props.children, function (item, i) {
          return _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
              key: i,
              classNames: 'fade-background',
              appear: true,
              timeout: {
                enter: 500,
                exit: 2200
              } },
            item
          );
        })
      );
    }
  }]);

  return FadeBackgroundAnimation;
}(_react2.default.Component);

FadeBackgroundAnimation.propTypes = {
  children: _propTypes2.default.element
};

FadeBackgroundAnimation.defaultProps = {};

exports.default = FadeBackgroundAnimation;

/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundColorPickerContainer_user$ref: FragmentReference;
export type BackgroundColorPickerContainer_user = {|
  +backgroundColor: ?string,
  +$refType: BackgroundColorPickerContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundColorPickerContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundColor",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '0b3763d486015259bac7483f15964188';
module.exports = node;

/***/ }),

/***/ 1232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundCustomImagePickerContainer_user$ref: FragmentReference;
export type BackgroundCustomImagePickerContainer_user = {|
  +customImage: ?string,
  +$refType: BackgroundCustomImagePickerContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundCustomImagePickerContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "customImage",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '4270efb7d9046bccc1fcf2bf736f70cd';
module.exports = node;

/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundImagePickerContainer_app$ref: FragmentReference;
export type BackgroundImagePickerContainer_app = {|
  +backgroundImages: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +imageURL: ?string,
        +thumbnailURL: ?string,
      |}
    |}>
  |},
  +$refType: BackgroundImagePickerContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundImagePickerContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "backgroundImages",
    "storageKey": "backgroundImages(first:50)",
    "args": [{
      "kind": "Literal",
      "name": "first",
      "value": 50,
      "type": "Int"
    }],
    "concreteType": "BackgroundImageConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BackgroundImageEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "BackgroundImage",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageURL",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "thumbnailURL",
          "args": null,
          "storageKey": null
        }]
      }]
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '702fc4e01067b75c080186e696ad7441';
module.exports = node;

/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundImagePickerContainer_user$ref: FragmentReference;
export type BackgroundImagePickerContainer_user = {|
  +backgroundImage: ?{|
    +id: string,
    +imageURL: ?string,
  |},
  +$refType: BackgroundImagePickerContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundImagePickerContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "backgroundImage",
    "storageKey": null,
    "args": null,
    "concreteType": "BackgroundImage",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageURL",
      "args": null,
      "storageKey": null
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '943a2513955f178bd4109a26f96224f2';
module.exports = node;

/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql; /* global graphql */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__(16);

var _styles = __webpack_require__(79);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _FadeInDashboardAnimation = __webpack_require__(380);

var _FadeInDashboardAnimation2 = _interopRequireDefault(_FadeInDashboardAnimation);

var _Paper = __webpack_require__(111);

var _Paper2 = _interopRequireDefault(_Paper);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _withUserId = __webpack_require__(570);

var _withUserId2 = _interopRequireDefault(_withUserId);

var _HeartDonationCampaignContainer = __webpack_require__(1238);

var _HeartDonationCampaignContainer2 = _interopRequireDefault(_HeartDonationCampaignContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CampaignBase = function (_React$Component) {
  _inherits(CampaignBase, _React$Component);

  function CampaignBase() {
    _classCallCheck(this, CampaignBase);

    return _possibleConstructorReturn(this, (CampaignBase.__proto__ || Object.getPrototypeOf(CampaignBase)).apply(this, arguments));
  }

  _createClass(CampaignBase, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          userId = _props.userId,
          theme = _props.theme;

      var anchorStyle = {
        color: theme.palette.primary.main,
        textDecoration: 'none'
      };
      var CAMPAIGN_START_TIME_ISO = '2018-11-26T16:00:00.000Z';
      var CAMPAIGN_END_TIME_ISO = '2018-11-30T22:00:00.000Z';
      var heartsGoal = 18e6;

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _relayEnv2.default
        // Hardcode campaign-specific data requirements here, and remove
        // after the campaign is no longer live.
        , query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__(1239);
        }),
        variables: {
          userId: userId,
          charityId: '77ee7208-62d7-41ad-a6e1-60f8d1dcfd9a',
          startTime: CAMPAIGN_START_TIME_ISO,
          endTime: CAMPAIGN_END_TIME_ISO
        },
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props,
              retry = _ref.retry;

          if (error) {
            console.error(error);
          }
          if (!props) {
            return null;
          }
          var app = props.app,
              user = props.user;

          // Hardcode campaign component here when running one.

          var currentCampaign = _react2.default.createElement(
            _HeartDonationCampaignContainer2.default,
            {
              app: app,
              user: user,
              campaign: {
                time: {
                  start: (0, _moment2.default)(CAMPAIGN_START_TIME_ISO),
                  end: (0, _moment2.default)(CAMPAIGN_END_TIME_ISO)
                },
                heartsGoal: heartsGoal,
                endContent: _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _Typography2.default,
                    {
                      variant: 'h6',
                      style: {
                        textAlign: 'center',
                        marginTop: 4
                      }
                    },
                    'Thank You for Giving Directly!'
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      style: {
                        margin: '14px 10px 20px',
                        textAlign: 'left'
                      }
                    },
                    _react2.default.createElement(
                      _Typography2.default,
                      {
                        variant: 'body2',
                        gutterBottom: true
                      },
                      'Thanks for welcoming',
                      ' ',
                      _react2.default.createElement(
                        'a',
                        { href: 'https://www.givedirectly.org/', target: '_blank', rel: 'noopener noreferrer', style: anchorStyle },
                        'GiveDirectly'
                      ),
                      ' ',
                      'to Tab for a Cause this week! Your tabs will put cash into the hands of people',
                      ' ',
                      'who need it most.'
                    ),
                    _react2.default.createElement(
                      _Typography2.default,
                      {
                        variant: 'body2',
                        gutterBottom: true
                      },
                      _react2.default.createElement(
                        'span',
                        { style: { fontWeight: 'bold' } },
                        'Your tabs, more causes:'
                      ),
                      ' ',
                      'Each month in 2019, we\'ll be highlighting the work of different charities in a',
                      ' ',
                      _react2.default.createElement(
                        'a',
                        { href: 'https://www.facebook.com/notes/tab-for-a-cause/introducing-monthly-charity-spotlight/2071986076177802/', target: '_blank', rel: 'noopener noreferrer', style: anchorStyle },
                        '"Charity Spotlight"'
                      ),
                      '. You\'ll be able to donate Hearts to a wider variety of causes,',
                      ' ',
                      'and best of all, you\'ll get to vote for which new non-profits we',
                      ' ',
                      'should feature! Learn more and nominate your favorite charity',
                      ' ',
                      _react2.default.createElement(
                        'a',
                        { href: 'https://www.facebook.com/notes/tab-for-a-cause/introducing-monthly-charity-spotlight/2071986076177802/', target: '_blank', rel: 'noopener noreferrer', style: anchorStyle },
                        'here'
                      ),
                      '.'
                    )
                  )
                )
              },
              showError: _this2.props.showError
            },
            _react2.default.createElement(
              _Typography2.default,
              {
                variant: 'h6',
                style: {
                  textAlign: 'center',
                  marginTop: 4
                }
              },
              'This Giving Tuesday, Give Directly'
            ),
            _react2.default.createElement(
              'div',
              {
                style: {
                  margin: '14px 10px 20px',
                  textAlign: 'left'
                }
              },
              _react2.default.createElement(
                _Typography2.default,
                {
                  variant: 'body2',
                  gutterBottom: true
                },
                'We\u2019re very excited to introduce a new charity partner,',
                ' ',
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.givedirectly.org/', target: '_blank', rel: 'noopener noreferrer', style: anchorStyle },
                  'GiveDirectly'
                ),
                '!'
              ),
              _react2.default.createElement(
                _Typography2.default,
                {
                  variant: 'body2',
                  gutterBottom: true
                },
                'GiveDirectly offers a simple approach to addressing poverty: cut out',
                ' ',
                'intermediaries and allow poor families to decide for themselves what they',
                ' ',
                'need most. They consistently',
                ' ',
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.givedirectly.org/operating-model', target: '_blank', rel: 'noopener noreferrer', style: anchorStyle },
                  'measure their impact'
                ),
                ',',
                ' ',
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.givedirectly.org/research-at-give-directly', target: '_blank', rel: 'noopener noreferrer', style: anchorStyle },
                  'show impressive results'
                ),
                ',',
                ' ',
                'and are one of only nine top-rated charities on',
                ' ',
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.givewell.org/charities/give-directly', target: '_blank', rel: 'noopener noreferrer', style: anchorStyle },
                  'GiveWell'
                ),
                '.'
              ),
              _react2.default.createElement(
                _Typography2.default,
                {
                  variant: 'body2',
                  gutterBottom: true
                },
                'Join us in welcoming GiveDirectly to Tab for a Cause with a cornucopia of Hearts!'
              ),
              _react2.default.createElement(
                _Typography2.default,
                {
                  variant: 'body2',
                  gutterBottom: true
                },
                _react2.default.createElement(
                  'span',
                  { style: { fontWeight: 'bold' } },
                  'Update: '
                ),
                'congrats, we passed our original',
                ' ',
                'goal of 10M Hearts! Let\'s see if we can hit 18M!'
              )
            )
          );

          return _react2.default.createElement(
            'div',
            {
              style: {
                zIndex: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                boxSizing: 'border-box',
                pointerEvents: 'none'
              }
            },
            _react2.default.createElement(
              _FadeInDashboardAnimation2.default,
              null,
              _react2.default.createElement(
                _Paper2.default,
                {
                  elevation: 1,
                  style: {
                    pointerEvents: 'all',
                    minWidth: 400,
                    margin: 0,
                    marginBottom: 100,
                    padding: 0,
                    background: '#FFF',
                    border: 'none'
                  }
                },
                _react2.default.createElement('div', {
                  style: {
                    width: '100%',
                    height: 3,
                    borderTopLeftRadius: 2,
                    borderTopRightRadius: 2,
                    backgroundColor: theme.palette.secondary.main
                  } }),
                currentCampaign
              )
            )
          );
        }
      });
    }
  }]);

  return CampaignBase;
}(_react2.default.Component);

CampaignBase.propTypes = {
  userId: _propTypes2.default.string.isRequired,
  showError: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.object.isRequired
};

CampaignBase.defaultProps = {};

exports.default = (0, _styles.withTheme)()((0, _withUserId2.default)()(CampaignBase));

/***/ }),

/***/ 1236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CountdownClock = function (_React$Component) {
  _inherits(CountdownClock, _React$Component);

  function CountdownClock(props) {
    _classCallCheck(this, CountdownClock);

    var _this = _possibleConstructorReturn(this, (CountdownClock.__proto__ || Object.getPrototypeOf(CountdownClock)).call(this, props));

    _this.state = {
      countdownClock: _this.getCountdownClockText()
    };
    return _this;
  }

  _createClass(CountdownClock, [{
    key: 'getCountdownClockText',
    value: function getCountdownClockText() {
      var campaignEndDatetime = (0, _moment2.default)(this.props.campaignEndDatetime);
      var timeRemaining = campaignEndDatetime.diff(_moment2.default.utc(), 'milliseconds');
      if (timeRemaining < 0) {
        timeRemaining = 0;
      }
      var duration = _moment2.default.duration(timeRemaining, 'milliseconds');
      return duration.days() + 'd ' + duration.hours() + 'h\n      ' + duration.minutes() + 'm ' + duration.seconds() + 's';
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var self = this;

      // Every second, update the countdown clock
      this.timeRemainingInterval = setInterval(function () {
        self.setState({
          countdownClock: self.getCountdownClockText()
        });
      }, 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timeRemainingInterval);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        this.state.countdownClock
      );
    }
  }]);

  return CountdownClock;
}(_react2.default.Component);

CountdownClock.propTypes = {
  campaignStartDatetime: _propTypes2.default.instanceOf(_moment2.default),
  campaignEndDatetime: _propTypes2.default.instanceOf(_moment2.default).isRequired
};

exports.default = CountdownClock;

/***/ }),

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _LinearProgress = __webpack_require__(1096);

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

var _CountdownClockComponent = __webpack_require__(1236);

var _CountdownClockComponent2 = _interopRequireDefault(_CountdownClockComponent);

var _DonateHeartsControlsContainer = __webpack_require__(569);

var _DonateHeartsControlsContainer2 = _interopRequireDefault(_DonateHeartsControlsContainer);

var _utils = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeartDonationCampaign = function (_React$Component) {
  _inherits(HeartDonationCampaign, _React$Component);

  function HeartDonationCampaign() {
    _classCallCheck(this, HeartDonationCampaign);

    return _possibleConstructorReturn(this, (HeartDonationCampaign.__proto__ || Object.getPrototypeOf(HeartDonationCampaign)).apply(this, arguments));
  }

  _createClass(HeartDonationCampaign, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          app = _props.app,
          user = _props.user,
          campaign = _props.campaign,
          children = _props.children,
          showError = _props.showError;
      var time = campaign.time,
          heartsGoal = campaign.heartsGoal,
          endContent = campaign.endContent;

      var hasCampaignEnded = (0, _moment2.default)().isAfter(time.end);
      var heartsDonatedAbbreviated = (0, _utils.abbreviateNumber)(app.charity.vcReceived);
      var heartsGoalAbbreviated = (0, _utils.abbreviateNumber)(heartsGoal);
      var progress = 100 * app.charity.vcReceived / heartsGoal;
      return _react2.default.createElement(
        'div',
        {
          style: {
            width: 480,
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 12,
            paddingRight: 12
          }
        },
        ' ',
        hasCampaignEnded && endContent ? endContent : children,
        hasCampaignEnded ? null : _react2.default.createElement(_DonateHeartsControlsContainer2.default, {
          charity: app.charity,
          user: user,
          heartDonationCampaign: {
            time: {
              start: time.start,
              end: time.end
            }
          },
          showError: showError
        }),
        _react2.default.createElement(
          'div',
          {
            style: {
              marginTop: 8,
              marginBottom: 8,
              textAlign: 'center'
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                marginLeft: 10,
                marginRight: 10
              }
            },
            hasCampaignEnded ? _react2.default.createElement(
              _Typography2.default,
              { variant: 'caption', gutterBottom: true },
              'Great job! Together, we donated ',
              heartsDonatedAbbreviated,
              ' Hearts of our',
              ' ',
              heartsGoalAbbreviated,
              ' goal.'
            ) : null,
            hasCampaignEnded ? null : _react2.default.createElement(
              'span',
              {
                style: {
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between'
                }
              },
              _react2.default.createElement(
                _Typography2.default,
                { variant: 'caption' },
                heartsDonatedAbbreviated,
                ' Hearts donated'
              ),
              _react2.default.createElement(
                _Typography2.default,
                { variant: 'caption' },
                'Goal: ',
                heartsGoalAbbreviated
              )
            ),
            _react2.default.createElement(_LinearProgress2.default, { variant: 'determinate', value: progress })
          ),
          _react2.default.createElement(
            _Typography2.default,
            { variant: 'caption' },
            _react2.default.createElement(_CountdownClockComponent2.default, {
              campaignStartDatetime: time.start,
              campaignEndDatetime: time.end
            }),
            ' ',
            'remaining'
          )
        )
      );
    }
  }]);

  return HeartDonationCampaign;
}(_react2.default.Component);

HeartDonationCampaign.propTypes = {
  app: _propTypes2.default.shape({
    charity: _propTypes2.default.shape({
      vcReceived: _propTypes2.default.number.isRequired
    }).isRequired
  }),
  user: _propTypes2.default.shape({
    vcCurrent: _propTypes2.default.number.isRequired
  }).isRequired,
  campaign: _propTypes2.default.shape({
    time: _propTypes2.default.shape({
      start: _propTypes2.default.instanceOf(_moment2.default).isRequired,
      end: _propTypes2.default.instanceOf(_moment2.default).isRequired
    }),
    heartsGoal: _propTypes2.default.number.isRequired,
    endContent: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
  }).isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  showError: _propTypes2.default.func.isRequired
};

exports.default = HeartDonationCampaign;

/***/ }),

/***/ 1238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _HeartDonationCampaignComponent = __webpack_require__(1237);

var _HeartDonationCampaignComponent2 = _interopRequireDefault(_HeartDonationCampaignComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_HeartDonationCampaignComponent2.default, {
  app: function app() {
    return __webpack_require__(1240);
  },
  user: function user() {
    return __webpack_require__(1241);
  }
});

/***/ }),

/***/ 1239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ef97d9713fa6649221d8891ffac3f023
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type HeartDonationCampaignContainer_app$ref = any;
type HeartDonationCampaignContainer_user$ref = any;
export type CampaignBaseQueryVariables = {|
  userId: string,
  charityId: string,
  startTime: string,
  endTime: string,
|};
export type CampaignBaseQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: HeartDonationCampaignContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: HeartDonationCampaignContainer_user$ref
  |},
|};
export type CampaignBaseQuery = {|
  variables: CampaignBaseQueryVariables,
  response: CampaignBaseQueryResponse,
|};
*/

/*
query CampaignBaseQuery(
  $userId: String!
  $charityId: String!
  $startTime: String!
  $endTime: String!
) {
  app {
    ...HeartDonationCampaignContainer_app_3uKjWt
    id
  }
  user(userId: $userId) {
    ...HeartDonationCampaignContainer_user
    id
  }
}

fragment HeartDonationCampaignContainer_app_3uKjWt on App {
  charity(charityId: $charityId) {
    id
    name
    vcReceived(startTime: $startTime, endTime: $endTime)
    ...DonateHeartsControlsContainer_charity
  }
}

fragment HeartDonationCampaignContainer_user on User {
  vcCurrent
  ...DonateHeartsControlsContainer_user
}

fragment DonateHeartsControlsContainer_user on User {
  id
  vcCurrent
}

fragment DonateHeartsControlsContainer_charity on Charity {
  id
  image
  imageCaption
  impact
  name
  website
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "charityId",
    "type": "String!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "startTime",
    "type": "String!",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "endTime",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "CampaignBaseQuery",
    "id": null,
    "text": "query CampaignBaseQuery(\n  $userId: String!\n  $charityId: String!\n  $startTime: String!\n  $endTime: String!\n) {\n  app {\n    ...HeartDonationCampaignContainer_app_3uKjWt\n    id\n  }\n  user(userId: $userId) {\n    ...HeartDonationCampaignContainer_user\n    id\n  }\n}\n\nfragment HeartDonationCampaignContainer_app_3uKjWt on App {\n  charity(charityId: $charityId) {\n    id\n    name\n    vcReceived(startTime: $startTime, endTime: $endTime)\n    ...DonateHeartsControlsContainer_charity\n  }\n}\n\nfragment HeartDonationCampaignContainer_user on User {\n  vcCurrent\n  ...DonateHeartsControlsContainer_user\n}\n\nfragment DonateHeartsControlsContainer_user on User {\n  id\n  vcCurrent\n}\n\nfragment DonateHeartsControlsContainer_charity on Charity {\n  id\n  image\n  imageCaption\n  impact\n  name\n  website\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "CampaignBaseQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "HeartDonationCampaignContainer_app",
          "args": [{
            "kind": "Variable",
            "name": "endTime",
            "variableName": "endTime",
            "type": null
          }, {
            "kind": "Variable",
            "name": "startTime",
            "variableName": "startTime",
            "type": null
          }]
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "HeartDonationCampaignContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "CampaignBaseQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "charity",
          "storageKey": null,
          "args": [{
            "kind": "Variable",
            "name": "charityId",
            "variableName": "charityId",
            "type": "String!"
          }],
          "concreteType": "Charity",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "vcReceived",
            "args": [{
              "kind": "Variable",
              "name": "endTime",
              "variableName": "endTime",
              "type": "String"
            }, {
              "kind": "Variable",
              "name": "startTime",
              "variableName": "startTime",
              "type": "String"
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "image",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "imageCaption",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "impact",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "website",
            "args": null,
            "storageKey": null
          }]
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "vcCurrent",
          "args": null,
          "storageKey": null
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6bdad5779a2fa23ae7c07d54d7e496dc';
module.exports = node;

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type DonateHeartsControlsContainer_charity$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type HeartDonationCampaignContainer_app$ref: FragmentReference;
export type HeartDonationCampaignContainer_app = {|
  +charity: ?{|
    +id: string,
    +name: ?string,
    +vcReceived: ?number,
    +$fragmentRefs: DonateHeartsControlsContainer_charity$ref,
  |},
  +$refType: HeartDonationCampaignContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "HeartDonationCampaignContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "startTime",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "LocalArgument",
    "name": "endTime",
    "type": "String",
    "defaultValue": null
  }, {
    "kind": "RootArgument",
    "name": "charityId",
    "type": "String!"
  }],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "charity",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "charityId",
      "variableName": "charityId",
      "type": "String!"
    }],
    "concreteType": "Charity",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "vcReceived",
      "args": [{
        "kind": "Variable",
        "name": "endTime",
        "variableName": "endTime",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "startTime",
        "variableName": "startTime",
        "type": "String"
      }],
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "DonateHeartsControlsContainer_charity",
      "args": null
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '633bc8aa6fc32418057c1c824115c69c';
module.exports = node;

/***/ }),

/***/ 1241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type DonateHeartsControlsContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type HeartDonationCampaignContainer_user$ref: FragmentReference;
export type HeartDonationCampaignContainer_user = {|
  +vcCurrent: ?number,
  +$fragmentRefs: DonateHeartsControlsContainer_user$ref,
  +$refType: HeartDonationCampaignContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "HeartDonationCampaignContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "vcCurrent",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "DonateHeartsControlsContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '3a487f1ceef9986af1b7092d32e9cd10';
module.exports = node;

/***/ }),

/***/ 1242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _experiments = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignExperimentGroups = function (_React$Component) {
  _inherits(AssignExperimentGroups, _React$Component);

  function AssignExperimentGroups() {
    _classCallCheck(this, AssignExperimentGroups);

    return _possibleConstructorReturn(this, (AssignExperimentGroups.__proto__ || Object.getPrototypeOf(AssignExperimentGroups)).apply(this, arguments));
  }

  _createClass(AssignExperimentGroups, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var user = this.props.user;

      // Assign the user to experiment groups. We do this every
      // page load because the user may have become eligble for
      // an experimeng (e.g. by having joined X days ago) or we
      // may have added new experiments.

      (0, _experiments.assignUserToTestGroups)({
        id: user.id,
        joined: user.joined,
        isNewUser: this.props.isNewUser
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return AssignExperimentGroups;
}(_react2.default.Component);

AssignExperimentGroups.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    joined: _propTypes2.default.string.isRequired
  }).isRequired,
  isNewUser: _propTypes2.default.bool.isRequired
};

AssignExperimentGroups.defaultProps = {
  isNewUser: false
};

exports.default = AssignExperimentGroups;

/***/ }),

/***/ 1243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _v = __webpack_require__(537);

var _v2 = _interopRequireDefault(_v);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _Paper = __webpack_require__(111);

var _Paper2 = _interopRequireDefault(_Paper);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _Button = __webpack_require__(227);

var _Button2 = _interopRequireDefault(_Button);

var _MoneyRaisedContainer = __webpack_require__(1283);

var _MoneyRaisedContainer2 = _interopRequireDefault(_MoneyRaisedContainer);

var _UserBackgroundImageContainer = __webpack_require__(1338);

var _UserBackgroundImageContainer2 = _interopRequireDefault(_UserBackgroundImageContainer);

var _UserMenuContainer = __webpack_require__(1340);

var _UserMenuContainer2 = _interopRequireDefault(_UserMenuContainer);

var _WidgetsContainer = __webpack_require__(1379);

var _WidgetsContainer2 = _interopRequireDefault(_WidgetsContainer);

var _CampaignBase = __webpack_require__(1235);

var _CampaignBase2 = _interopRequireDefault(_CampaignBase);

var _Ad = __webpack_require__(1211);

var _Ad2 = _interopRequireDefault(_Ad);

var _LogTabContainer = __webpack_require__(1253);

var _LogTabContainer2 = _interopRequireDefault(_LogTabContainer);

var _LogRevenueContainer = __webpack_require__(1251);

var _LogRevenueContainer2 = _interopRequireDefault(_LogRevenueContainer);

var _LogConsentDataContainer = __webpack_require__(568);

var _LogConsentDataContainer2 = _interopRequireDefault(_LogConsentDataContainer);

var _LogAccountCreationContainer = __webpack_require__(1248);

var _LogAccountCreationContainer2 = _interopRequireDefault(_LogAccountCreationContainer);

var _AssignExperimentGroupsContainer = __webpack_require__(566);

var _AssignExperimentGroupsContainer2 = _interopRequireDefault(_AssignExperimentGroupsContainer);

var _lens = __webpack_require__(2192);

var _lens2 = _interopRequireDefault(_lens);

var _favorite = __webpack_require__(485);

var _favorite2 = _interopRequireDefault(_favorite);

var _default = __webpack_require__(44);

var _FadeInDashboardAnimation = __webpack_require__(380);

var _FadeInDashboardAnimation2 = _interopRequireDefault(_FadeInDashboardAnimation);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _fireworksReact = __webpack_require__(1419);

var _fireworksReact2 = _interopRequireDefault(_fireworksReact);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _close = __webpack_require__(797);

var _close2 = _interopRequireDefault(_close);

var _NewUserTourContainer = __webpack_require__(1255);

var _NewUserTourContainer2 = _interopRequireDefault(_NewUserTourContainer);

var _user = __webpack_require__(64);

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

var _localUserDataMgr = __webpack_require__(113);

var _constants = __webpack_require__(46);

var _navigation = __webpack_require__(50);

var _adSettings = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable jsx-a11y/href-no-hash */


var Dashboard = function (_React$Component) {
  _inherits(Dashboard, _React$Component);

  function Dashboard(props) {
    _classCallCheck(this, Dashboard);

    var _this2 = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));

    _this2.state = {
      errorMessage: null,
      tabId: (0, _v2.default)(),
      showFireworks: false,
      isUserAnonymous: false, // Set after mount if true
      // This may be false if the user cleared their storage,
      // which is why we only show the tour to recently-joined
      // users.
      userAlreadyViewedNewUserTour: _localstorageMgr2.default.getItem(_constants.STORAGE_NEW_USER_HAS_COMPLETED_TOUR) === 'true',
      numAdsToShow: (0, _adSettings.getNumberOfAdsToShow)(),
      showAdExplanation: (0, _adSettings.shouldShowAdExplanation)()
    };
    return _this2;
  }

  _createClass(Dashboard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.determineAnonymousStatus();
    }

    /**
     * Check if the user is anonymous and update state with the
     * anonymous status.
     * @return {Promise<undefined>} A Promise that resolves after
     *   the state has been updated.
     */

  }, {
    key: 'determineAnonymousStatus',
    value: function determineAnonymousStatus() {
      var _this3 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var currentUser, isAnon;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _user.getCurrentUser)();

              case 2:
                currentUser = _context.sent;
                isAnon = currentUser && currentUser.isAnonymous;
                return _context.abrupt('return', new Promise(function (resolve, reject) {
                  _this.setState({
                    isUserAnonymous: isAnon
                  }, function () {
                    resolve();
                  });
                }));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  }, {
    key: 'showError',
    value: function showError(msg) {
      this.setState({
        errorMessage: msg
      });
    }
  }, {
    key: 'clearError',
    value: function clearError() {
      this.showError(null);
    }
  }, {
    key: 'launchFireworks',
    value: function launchFireworks(show) {
      this.setState({
        showFireworks: show
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      // Props will be null on first render.
      var _props = this.props,
          user = _props.user,
          app = _props.app;
      var tabId = this.state.tabId;

      var errorMessage = this.state.errorMessage;

      var menuStyle = {
        position: 'fixed',
        zIndex: 10,
        top: 14,
        right: 16,
        display: 'flex',
        justifyItems: 'flex-end',
        alignItems: 'center'
      };
      var menuTextStyle = {
        fontSize: 24
      };
      var moneyRaisedStyle = Object.assign({}, menuTextStyle);
      var bulletPointStyle = {
        alignSelf: 'center',
        width: 5,
        height: 5,
        marginTop: 2,
        marginLeft: 12,
        marginRight: 12
      };
      var userMenuStyle = Object.assign({}, menuTextStyle);

      // Whether or not a campaign should show on the dashboard
      // TODO: also make sure the user hasn't dismissed the campaign (`isCampaignShown` var)
      var isGlobalCampaignLive = !!(app && app.isGlobalCampaignLive);

      // Show the tour if the user joined recently and localStorage
      // does not have a flag marking the tour as already viewed.
      var showNewUserTour = user && (0, _moment2.default)().utc().diff((0, _moment2.default)(user.joined), 'hours') < 2 && !this.state.userAlreadyViewedNewUserTour;

      return _react2.default.createElement(
        'div',
        {
          style: {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            overflowY: 'hidden',
            overflowX: 'auto',
            // Otherwise, campaigns can cover up bookmarks.
            minWidth: 1080
          },
          'data-test-id': 'app-dashboard',
          key: 'dashboard-key' },
        _react2.default.createElement(_UserBackgroundImageContainer2.default, { user: user, showError: this.showError.bind(this) }),
        user ? _react2.default.createElement(
          _FadeInDashboardAnimation2.default,
          null,
          _react2.default.createElement(
            'div',
            { style: menuStyle },
            _react2.default.createElement(_MoneyRaisedContainer2.default, {
              app: app,
              style: moneyRaisedStyle,
              launchFireworks: this.launchFireworks.bind(this)
            }),
            _react2.default.createElement(_lens2.default, {
              color: _default.dashboardIconInactiveColor,
              hoverColor: _default.dashboardIconActiveColor,
              style: bulletPointStyle
            }),
            _react2.default.createElement(_UserMenuContainer2.default, {
              app: app,
              user: user,
              style: userMenuStyle,
              isUserAnonymous: this.state.isUserAnonymous
            })
          )
        ) : null,
        this.state.isUserAnonymous && user ? _react2.default.createElement(
          _FadeInDashboardAnimation2.default,
          null,
          _react2.default.createElement(
            'div',
            {
              'data-test-id': 'anon-sign-in-prompt-dashboard',
              style: {
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                top: 14
              }
            },
            _react2.default.createElement(
              _Paper2.default,
              null,
              _react2.default.createElement(
                'div',
                {
                  style: {
                    padding: '6px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    background: _default.dashboardIconInactiveColor
                  }
                },
                _react2.default.createElement(
                  _Typography2.default,
                  { variant: 'body2' },
                  'Sign in to save your progress!'
                ),
                _react2.default.createElement(
                  _Button2.default,
                  {
                    color: 'primary',
                    style: {
                      marginLeft: 10,
                      marginRight: 10
                    },
                    onClick: function onClick() {
                      (0, _navigation.goTo)(_navigation.loginURL, { noredirect: 'true' });
                    }
                  },
                  'Sign In'
                )
              )
            )
          )
        ) : null,
        _react2.default.createElement(_WidgetsContainer2.default, {
          user: user,
          isCampaignLive: isGlobalCampaignLive,
          showError: this.showError.bind(this)
        }),
        isGlobalCampaignLive ? _react2.default.createElement(
          _FadeInDashboardAnimation2.default,
          null,
          _react2.default.createElement(_CampaignBase2.default, {
            showError: this.showError.bind(this)
          })
        ) : null,
        this.state.showFireworks ? _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            _FadeInDashboardAnimation2.default,
            null,
            _react2.default.createElement(_close2.default, {
              style: {
                position: 'absolute',
                top: 14,
                right: 14,
                zIndex: 22,
                height: 32,
                width: 32,
                color: '#FFF',
                cursor: 'pointer'
              },
              onClick: function onClick() {
                _this4.launchFireworks(false);
              }
            })
          ),
          _react2.default.createElement(
            _FadeInDashboardAnimation2.default,
            null,
            _react2.default.createElement(
              'span',
              {
                style: {
                  position: 'absolute',
                  zIndex: 21,
                  color: '#FFF',
                  top: 14,
                  left: 14,
                  width: 240,
                  fontSize: 18,
                  lineHeight: '110%'
                }
              },
              _react2.default.createElement(
                'div',
                null,
                'Tabbers, together we\'ve raised over half a million dollars for charity. Congrats, and thank you!'
              ),
              _react2.default.createElement(
                'a',
                {
                  href: 'https://www.facebook.com/notes/tab-for-a-cause/500000-raised-for-charity/1752143718162041/',
                  target: '_top'
                },
                _react2.default.createElement(_RaisedButton2.default, {
                  label: 'Share This Milestone',
                  style: {
                    marginTop: 8
                  },
                  primary: true
                })
              )
            )
          ),
          _react2.default.createElement(_fireworksReact2.default, {
            width: window.innerWidth,
            height: window.innerHeight,
            background: 'rgba(0, 0, 0, 0.01)',
            style: {
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 20
            }
          })
        ) : null,
        showNewUserTour ? _react2.default.createElement(_NewUserTourContainer2.default, { user: user }) : null,
        _react2.default.createElement(
          'div',
          {
            style: {
              position: 'absolute',
              overflow: 'visible',
              display: 'flex',
              alignItems: 'flex-end',
              flexDirection: 'row-reverse',
              bottom: 10,
              right: 10
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                display: 'flex',
                flexDirection: 'column',
                overflow: 'visible'
              }
            },
            this.state.numAdsToShow > 2 ? _react2.default.createElement(_Ad2.default, {
              adId: _adSettings.SECOND_VERTICAL_AD_SLOT_DOM_ID,
              style: {
                display: 'flex',
                minWidth: 300,
                overflow: 'visible'
              }
            }) : null,
            this.state.numAdsToShow > 1 ? _react2.default.createElement(_Ad2.default, {
              adId: _adSettings.VERTICAL_AD_SLOT_DOM_ID,
              style: {
                display: 'flex',
                minWidth: 300,
                overflow: 'visible',
                marginTop: 10
              }
            }) : null
          ),
          this.state.numAdsToShow > 0 ? _react2.default.createElement(
            'div',
            {
              style: {
                display: 'flex',
                flexDirection: 'column',
                overflow: 'visible',
                marginRight: 10
              }
            },
            this.state.showAdExplanation && user ? _react2.default.createElement(
              _FadeInDashboardAnimation2.default,
              null,
              _react2.default.createElement(
                'div',
                {
                  'data-test-id': 'ad-explanation',
                  style: {
                    display: 'inline-block',
                    float: 'right'
                  }
                },
                _react2.default.createElement(
                  _Paper2.default,
                  null,
                  _react2.default.createElement(
                    'div',
                    {
                      style: {
                        display: 'flex',
                        padding: '6px 14px',
                        marginBottom: 10,
                        alignItems: 'center',
                        background: _default.dashboardIconInactiveColor
                      }
                    },
                    _react2.default.createElement(_favorite2.default, {
                      color: _default.primaryColor,
                      style: {
                        width: 24,
                        height: 24,
                        marginRight: 14
                      }
                    }),
                    _react2.default.createElement(
                      _Typography2.default,
                      { variant: 'body2' },
                      'Did you know? The ads here are raising money for charity.'
                    ),
                    _react2.default.createElement(
                      _Button2.default,
                      {
                        color: 'primary',
                        style: {
                          marginLeft: 20,
                          marginRight: 10
                        },
                        onClick: function onClick() {
                          (0, _localUserDataMgr.setUserDismissedAdExplanation)();
                          _this4.setState({
                            showAdExplanation: false
                          });
                        }
                      },
                      'Got it'
                    )
                  )
                )
              )
            ) : null,
            _react2.default.createElement(_Ad2.default, {
              adId: _adSettings.HORIZONTAL_AD_SLOT_DOM_ID,
              style: {
                overflow: 'visible',
                minWidth: 728
              }
            })
          ) : null
        ),
        user && tabId ? _react2.default.createElement(_LogTabContainer2.default, { user: user, tabId: tabId }) : null,
        user && tabId ? _react2.default.createElement(_LogRevenueContainer2.default, { user: user, tabId: tabId }) : null,
        user ? _react2.default.createElement(_LogConsentDataContainer2.default, { user: user }) : null,
        user ? _react2.default.createElement(_LogAccountCreationContainer2.default, { user: user }) : null,
        user ? _react2.default.createElement(_AssignExperimentGroupsContainer2.default, { user: user, isNewUser: false }) : null,
        errorMessage ? _react2.default.createElement(_ErrorMessage2.default, { message: errorMessage,
          onRequestClose: this.clearError.bind(this) }) : null
      );
    }
  }]);

  return Dashboard;
}(_react2.default.Component);

Dashboard.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    joined: _propTypes2.default.string.isRequired
  }),
  app: _propTypes2.default.shape({
    isGlobalCampaignLive: _propTypes2.default.bool
  })
};

Dashboard.defaultProps = {
  app: {
    isGlobalCampaignLive: false
  }
};

exports.default = Dashboard;

/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _DashboardComponent = __webpack_require__(1243);

var _DashboardComponent2 = _interopRequireDefault(_DashboardComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_DashboardComponent2.default, {
  app: function app() {
    return __webpack_require__(1258);
  },
  user: function user() {
    return __webpack_require__(1259);
  }
});

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql; /* global graphql */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(16);

var _object = __webpack_require__(212);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _AuthUserComponent = __webpack_require__(149);

var _AuthUserComponent2 = _interopRequireDefault(_AuthUserComponent);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _DashboardContainer = __webpack_require__(1244);

var _DashboardContainer2 = _interopRequireDefault(_DashboardContainer);

var _helpers = __webpack_require__(185);

var _navigation = __webpack_require__(50);

var _constants = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DashboardView = function (_React$Component) {
  _inherits(DashboardView, _React$Component);

  function DashboardView() {
    _classCallCheck(this, DashboardView);

    return _possibleConstructorReturn(this, (DashboardView.__proto__ || Object.getPrototypeOf(DashboardView)).apply(this, arguments));
  }

  _createClass(DashboardView, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _AuthUserComponent2.default,
        null,
        _react2.default.createElement(_reactRelay.QueryRenderer, {
          environment: _relayEnv2.default,
          query: _graphql || (_graphql = function _graphql() {
            return __webpack_require__(1260);
          }),
          render: function render(_ref) {
            var error = _ref.error,
                props = _ref.props,
                retry = _ref.retry;

            if (error && (0, _object.get)(error, 'source.errors')) {
              // If any of the errors is because the user does not exist
              // on the server side, create the user and re-query if
              // possible. If it's not possible to create a new user,
              // redirect to the authentication page.
              var userDoesNotExistError = error.source.errors.some(function (err) {
                return err.code === _constants.ERROR_USER_DOES_NOT_EXIST;
              });

              if (userDoesNotExistError) {
                (0, _helpers.createNewUser)().then(function (user) {
                  retry();
                }).catch(function (e) {
                  (0, _navigation.goTo)(_navigation.loginURL);
                });
              } else {
                var errMsg = 'We had a problem loading your dashboard :(';
                return _react2.default.createElement(_ErrorMessage2.default, { message: errMsg });
              }
            }
            if (!props) {
              props = {};
            }
            var app = props.app || null;
            var user = props.user || null;
            return _react2.default.createElement(_DashboardContainer2.default, { app: app, user: user });
          } })
      );
    }
  }]);

  return DashboardView;
}(_react2.default.Component);

exports.default = DashboardView;

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navigation = __webpack_require__(50);

var _localUserDataMgr = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// The view the extensions open immediately after they're
// added to the browser.
var FirstTabView = function (_React$Component) {
  _inherits(FirstTabView, _React$Component);

  function FirstTabView() {
    _classCallCheck(this, FirstTabView);

    return _possibleConstructorReturn(this, (FirstTabView.__proto__ || Object.getPrototypeOf(FirstTabView)).apply(this, arguments));
  }

  _createClass(FirstTabView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Here, we can do anything we need to do before
      // going to the main dashboard.

      // Set a unique install ID in local storage.
      (0, _localUserDataMgr.setBrowserExtensionInstallId)();

      // Set this as the user's installed time, which helps us
      // distinguish truly new users from returning users who
      // had cleared their local data.
      (0, _localUserDataMgr.setBrowserExtensionInstallTime)();

      (0, _navigation.replaceUrl)(_navigation.dashboardURL);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('span', null);
    }
  }]);

  return FirstTabView;
}(_react2.default.Component);

exports.default = FirstTabView;

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _logEvent = __webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogAccountCreation = function (_React$Component) {
  _inherits(LogAccountCreation, _React$Component);

  function LogAccountCreation() {
    _classCallCheck(this, LogAccountCreation);

    return _possibleConstructorReturn(this, (LogAccountCreation.__proto__ || Object.getPrototypeOf(LogAccountCreation)).apply(this, arguments));
  }

  _createClass(LogAccountCreation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var user = this.props.user;

      // If this is the user's first tab, log the "accountCreated"
      // analytics event. It's a little inefficient to fetch the user's
      // lifetime tabs count just for this purpose, so we may eventually
      // want to move this analytics event to another trigger.

      if (user.tabs === 0) {
        (0, _logEvent.accountCreated)();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return LogAccountCreation;
}(_react2.default.Component);

LogAccountCreation.propTypes = {
  user: _propTypes2.default.shape({
    tabs: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.default = LogAccountCreation;

/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _LogAccountCreationComponent = __webpack_require__(1247);

var _LogAccountCreationComponent2 = _interopRequireDefault(_LogAccountCreationComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_LogAccountCreationComponent2.default, {
  user: function user() {
    return __webpack_require__(1261);
  }
});

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LogUserDataConsentMutation = __webpack_require__(1389);

var _LogUserDataConsentMutation2 = _interopRequireDefault(_LogUserDataConsentMutation);

var _clientLocation = __webpack_require__(232);

var _consentManagement = __webpack_require__(379);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var LogConsentDataComponent = function (_React$Component) {
  _inherits(LogConsentDataComponent, _React$Component);

  function LogConsentDataComponent(props) {
    _classCallCheck(this, LogConsentDataComponent);

    var _this2 = _possibleConstructorReturn(this, (LogConsentDataComponent.__proto__ || Object.getPrototypeOf(LogConsentDataComponent)).call(this, props));

    _this2.consentChangeCallback = null;
    return _this2;
  }

  _createClass(LogConsentDataComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var isEU, consentString, isGlobalConsent;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _clientLocation.isInEuropeanUnion)();

              case 3:
                isEU = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                isEU = false;

              case 9:
                if (isEU) {
                  _this.consentChangeCallback = _this.logDataConsentDecision.bind(_this);
                  (0, _consentManagement.registerConsentCallback)(_this.consentChangeCallback);
                }

                // Check localStorage to see if we have any new consent
                // updates that haven't yet been logged (e.g. consent changes
                // when the user was not authenticated).

                if (!(0, _consentManagement.checkIfNewConsentNeedsToBeLogged)()) {
                  _context.next = 18;
                  break;
                }

                _context.next = 13;
                return (0, _consentManagement.getConsentString)();

              case 13:
                consentString = _context.sent;
                _context.next = 16;
                return (0, _consentManagement.hasGlobalConsent)();

              case 16:
                isGlobalConsent = _context.sent;

                _this.logDataConsentDecision(consentString, isGlobalConsent);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 6]]);
      }))();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.consentChangeCallback) {
        (0, _consentManagement.unregisterConsentCallback)(this.consentChangeCallback);
      }
    }
  }, {
    key: 'logDataConsentDecision',
    value: function logDataConsentDecision(consentString, isGlobalConsent) {
      var _props = this.props,
          relay = _props.relay,
          user = _props.user;
      // If we're missing a consent string, don't log.

      if (!consentString) {
        return;
      }

      var onCompleted = function onCompleted() {
        (0, _consentManagement.markConsentDataAsLogged)();
      };
      (0, _LogUserDataConsentMutation2.default)(relay.environment, user.id, consentString, isGlobalConsent, onCompleted);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return LogConsentDataComponent;
}(_react2.default.Component);

LogConsentDataComponent.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired,
  relay: _propTypes2.default.shape({
    environment: _propTypes2.default.object.isRequired
  })
};

exports.default = LogConsentDataComponent;

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _object = __webpack_require__(212);

var _LogUserRevenueMutation = __webpack_require__(1390);

var _LogUserRevenueMutation2 = _interopRequireDefault(_LogUserRevenueMutation);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getGoogleTag = __webpack_require__(184);

var _getGoogleTag2 = _interopRequireDefault(_getGoogleTag);

var _getPrebidPbjs = __webpack_require__(278);

var _getPrebidPbjs2 = _interopRequireDefault(_getPrebidPbjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Log revenue from ads
var LogRevenueComponent = function (_React$Component) {
  _inherits(LogRevenueComponent, _React$Component);

  function LogRevenueComponent() {
    _classCallCheck(this, LogRevenueComponent);

    return _possibleConstructorReturn(this, (LogRevenueComponent.__proto__ || Object.getPrototypeOf(LogRevenueComponent)).apply(this, arguments));
  }

  _createClass(LogRevenueComponent, [{
    key: 'componentDidMount',

    // TODO: to avoid memory leak, unregister the pubads listener on unmount
    value: function componentDidMount() {
      this.listenForSlotsLoadedEvent();
      this.logRevenueForAlreadyLoadedAds();
    }

    /**
     * Get the Prebid revenue for this slot
     * @param {string} slotId - The DFP slot ID
     * @return {number|null} revenue - The $USD revenue equal to the highest Prebid
     *   bid CPM for the slot, divided by 1000 and rounded; null if there were no bids
     */

  }, {
    key: 'getPrebidRevenueForSlot',
    value: function getPrebidRevenueForSlot(slotId) {
      // Get the slot's highest CPM bid from Prebid
      var pbjs = (0, _getPrebidPbjs2.default)();
      var slotBids = pbjs.getHighestCpmBids(slotId);

      // There might not be any bids
      if (!slotBids.length) {
        return null;
      }

      // Convert to real revenue
      var cpm = slotBids[0].cpm;
      var revenue = cpm / 1000;

      // To avoid unnecessary precision, round to 14 decimal places
      var roundedRevenue = Math.round(revenue * 10e14) / 10e14;
      return roundedRevenue;
    }

    /**
     * Get the Amazon bid for this slot
     * @param {string} slotId - The DFP slot ID
     * @return {Object|null} encodedAmazonRevenue - An EncodedRevenueValueType if there
     *   is a bid for the slot, or null if there is no bid
     * @return {string} encodedAmazonRevenue.encodingType - A constant, 'AMAZON_CPM',
     *   which tells the backend how to decode the value
     * @return {string} encodedAmazonRevenue.encodedValue - The Amazon revenue code
     */

  }, {
    key: 'getEncodedAmazonRevenueForSlot',
    value: function getEncodedAmazonRevenueForSlot(slotId) {
      var amazonBids = window.tabforacause.ads.amazonBids;
      var amazonBidExists =
      // An empty string for either of these means no bid
      (0, _object.get)(amazonBids, [slotId, 'amznbid']) && (0, _object.get)(amazonBids, [slotId, 'amzniid']);
      if (!amazonBidExists) {
        return null;
      }
      var amazonAdSize = (0, _object.get)(amazonBids, [slotId, 'size']);

      return {
        encodingType: 'AMAZON_CPM',
        encodedValue: (0, _object.get)(amazonBids, [slotId, 'amznbid']),
        adSize: amazonAdSize
      };
    }

    /**
     * Get the ad dimensions for the winning Prebid bid for this slot
     * @param {string} slotId - The DFP slot ID
     * @return {string|null} revenue - The ad dimensions in the form of
     * 'WIDTHxHEIGHT'.
     */

  }, {
    key: 'getPrebidAdSizeForSlot',
    value: function getPrebidAdSizeForSlot(slotId) {
      // Get the slot's highest CPM bid from Prebid
      var pbjs = (0, _getPrebidPbjs2.default)();
      var slotBids = pbjs.getHighestCpmBids(slotId);

      // There might not be any bids
      if (!(0, _object.get)(slotBids, 'length')) {
        return null;
      }
      return slotBids[0].size;
    }

    /**
     * Gets the googletag "SlotRenderEnded" event object for a slot ID.
     * The event data will be stored by ad code outside the core app code.
     * @param {string} slotId - The DFP slot ID to log
     * @return {Object|null} The googletag "SlotRenderEnded" event object. See:
     *  https://developers.google.com/doubleclick-gpt/reference#googletag.events.SlotRenderEndedEvent
     *  Returns null if we do not have any stored event data.
     */

  }, {
    key: 'getSlotRenderEndedDataForSlotId',
    value: function getSlotRenderEndedDataForSlotId(slotId) {
      var slotRenderEndedData = null;
      try {
        slotRenderEndedData = window.tabforacause.ads.slotsRendered[slotId];
      } catch (e) {
        console.error(e);
      }
      return slotRenderEndedData;
    }

    /**
     * Get the bid for the slot and log the revenue.
     * @param {string} slotId - The DFP slot ID to log
     * @param {string} adUnitCode - The DFP ad unit code
     * @return {null}
     */

  }, {
    key: 'logRevenueForSlotId',
    value: function logRevenueForSlotId(slotId, adUnitCode) {
      try {
        // If we have already logged revenue for this slot, don't log it again
        if (slotId in window.tabforacause.ads.slotsAlreadyLoggedRevenue) {
          return;
        }
        // Mark that we've logged revenue for this slot
        window.tabforacause.ads.slotsAlreadyLoggedRevenue[slotId] = true;

        // Get data for the rendered slot
        var slotRenderedData = this.getSlotRenderEndedDataForSlotId(slotId);
        if (!slotRenderedData) {
          console.warn('Could not find rendered slot data for slot "' + slotId + '"');
          return;
        }

        // Get revenue from highest Prebid bid
        var prebidRevenue = this.getPrebidRevenueForSlot(slotId);

        // Get the slot's bid from Amazon
        var amazonEncodedBid = this.getEncodedAmazonRevenueForSlot(slotId);

        // If no revenue, don't log anything
        if (!prebidRevenue && !amazonEncodedBid) {
          return;
        }

        var adSize = this.getPrebidAdSizeForSlot(slotId);

        // Get the advertiser ID. It will be null if Google Adsense
        // took the impression, so assume nulls are Adsense.
        var GOOGLE_ADSENSE_ID = '99';
        var dfpAdvertiserId = slotRenderedData.advertiserId ? slotRenderedData.advertiserId.toString() : GOOGLE_ADSENSE_ID;

        // Log the revenue
        (0, _LogUserRevenueMutation2.default)(this.props.relay.environment, this.props.user.id, prebidRevenue, dfpAdvertiserId, adSize, amazonEncodedBid,
        // Only send aggregationOperation value if we have more than one
        // revenue value
        prebidRevenue && amazonEncodedBid ? 'MAX' : null, this.props.tabId, adUnitCode);
      } catch (e) {
        console.error('Could not log revenue for ad slot', e);
      }
    }

    // Check if any ad slots have already loaded. If so,
    // log the revenue for those slots.

  }, {
    key: 'logRevenueForAlreadyLoadedAds',
    value: function logRevenueForAlreadyLoadedAds() {
      try {
        // This may be set earlier by ads code (outside of core app code)
        var slotsLoadedObj = window.tabforacause.ads.slotsRendered;
        if (Object.keys(slotsLoadedObj).length) {
          var self = this;
          Object.keys(slotsLoadedObj).forEach(function (slotId) {
            var getAdUnitPathFunc = (0, _object.get)(slotsLoadedObj, [slotId, 'slot', 'getAdUnitPath']);
            var adUnitCode = getAdUnitPathFunc ? getAdUnitPathFunc() : null;
            self.logRevenueForSlotId(slotId, adUnitCode);
          });
        }
      } catch (e) {
        console.error('Could not log revenue for ad slot', e);
      }
    }

    // Listen for the Google ad load event

  }, {
    key: 'listenForSlotsLoadedEvent',
    value: function listenForSlotsLoadedEvent() {
      var _this2 = this;

      var googletag = (0, _getGoogleTag2.default)();
      googletag.cmd.push(function () {
        // When a slot renders (before creative loads), log its revenue
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          try {
            var slotId = event.slot.getSlotElementId();
            var adUnitCode = event.slot.getAdUnitPath();

            // Store rendered slot data
            window.tabforacause.ads.slotsRendered[slotId] = event;
            _this2.logRevenueForSlotId(slotId, adUnitCode);
          } catch (e) {
            console.error('Could not log revenue for ad slot', e);
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return LogRevenueComponent;
}(_react2.default.Component);

LogRevenueComponent.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired,
  tabId: _propTypes2.default.string.isRequired,
  relay: _propTypes2.default.shape({
    environment: _propTypes2.default.object.isRequired
  })
};

exports.default = LogRevenueComponent;

/***/ }),

/***/ 1251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _LogRevenueComponent = __webpack_require__(1250);

var _LogRevenueComponent2 = _interopRequireDefault(_LogRevenueComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_LogRevenueComponent2.default, {
  user: function user() {
    return __webpack_require__(1263);
  }
});

/***/ }),

/***/ 1252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LogTabMutation = __webpack_require__(1388);

var _LogTabMutation2 = _interopRequireDefault(_LogTabMutation);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localUserDataMgr = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogTabComponent = function (_React$Component) {
  _inherits(LogTabComponent, _React$Component);

  function LogTabComponent() {
    _classCallCheck(this, LogTabComponent);

    return _possibleConstructorReturn(this, (LogTabComponent.__proto__ || Object.getPrototypeOf(LogTabComponent)).apply(this, arguments));
  }

  _createClass(LogTabComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Delay so that:
      // * the user sees their VC increment
      // * ads are more likely to have loaded
      var LOG_TAB_DELAY = 1000;
      setTimeout(function () {
        (0, _LogTabMutation2.default)(_this2.props.relay.environment, _this2.props.user.id, _this2.props.tabId);
      }, LOG_TAB_DELAY);

      // Update today's tab count in localStorage.
      // This is useful when making rendering decisions before
      // we fetch user data from the server (e.g., whether we
      // should show ads or not).
      (0, _localUserDataMgr.incrementTabsOpenedToday)();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return LogTabComponent;
}(_react2.default.Component);

LogTabComponent.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired,
  tabId: _propTypes2.default.string.isRequired,
  relay: _propTypes2.default.shape({
    environment: _propTypes2.default.object.isRequired
  })
};

exports.default = LogTabComponent;

/***/ }),

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _LogTabComponent = __webpack_require__(1252);

var _LogTabComponent2 = _interopRequireDefault(_LogTabComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_LogTabComponent2.default, {
  user: function user() {
    return __webpack_require__(1264);
  }
});

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJoyride = __webpack_require__(2425);

var _reactJoyride2 = _interopRequireDefault(_reactJoyride);

var _Dialog = __webpack_require__(257);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = __webpack_require__(227);

var _Button2 = _interopRequireDefault(_Button);

var _Paper = __webpack_require__(111);

var _Paper2 = _interopRequireDefault(_Paper);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _Earth = __webpack_require__(2212);

var _Earth2 = _interopRequireDefault(_Earth);

var _favorite = __webpack_require__(485);

var _favorite2 = _interopRequireDefault(_favorite);

var _InviteFriendContainer = __webpack_require__(572);

var _InviteFriendContainer2 = _interopRequireDefault(_InviteFriendContainer);

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

var _constants = __webpack_require__(46);

var _default = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Note that the target components must be mounted
// before the tour begins.
// https://github.com/gilbarbara/react-joyride/blob/master/docs/step.md
var tourSteps = [{
  target: '[data-tour-id="hearts"]',
  content: "You'll earn a Heart with every tab you open. Donate your Hearts to your favorite charity to tell us where to give money.",
  placement: 'bottom',
  disableBeacon: true,
  disableOverlayClose: true
}, {
  target: '[data-tour-id="settings-button"]',
  content: 'Visit your settings to change your background image, donate Hearts, and track your progress.',
  placement: 'bottom',
  disableBeacon: true
}, {
  target: '[data-tour-id="widgets"]',
  content: 'Use widgets to add bookmarks, take notes, and more.',
  placement: 'bottom',
  disableBeacon: true
}];

var CustomTooltip = function CustomTooltip(props) {
  return _react2.default.createElement(
    'div',
    { style: { width: 300 } },
    _react2.default.createElement(
      _Paper2.default,
      null,
      _react2.default.createElement(
        'div',
        { style: { padding: 20 } },
        _react2.default.createElement(
          _Typography2.default,
          { variant: 'body2' },
          props.content
        )
      ),
      _react2.default.createElement(
        'span',
        { style: { display: 'flex', justifyContent: 'flex-end', padding: 10 } },
        props.stepIndex > 0 ? _react2.default.createElement(
          _Button2.default,
          {
            onClick: props.goToPreviousStep,
            color: 'default'
          },
          'Back'
        ) : null,
        _react2.default.createElement(
          _Button2.default,
          {
            onClick: props.goToNextStep,
            color: 'primary'
          },
          'Next'
        )
      )
    )
  );
};

CustomTooltip.propTypes = {
  content: _propTypes2.default.string,
  stepIndex: _propTypes2.default.number.isRequired,
  goToNextStep: _propTypes2.default.func.isRequired,
  goToPreviousStep: _propTypes2.default.func.isRequired
};

CustomTooltip.defaultProps = {};

var NewUserTour = function (_React$Component) {
  _inherits(NewUserTour, _React$Component);

  function NewUserTour(props) {
    _classCallCheck(this, NewUserTour);

    var _this = _possibleConstructorReturn(this, (NewUserTour.__proto__ || Object.getPrototypeOf(NewUserTour)).call(this, props));

    _this.state = {
      introModalOpen: true,
      beginTour: false,
      stepIndex: 0,
      introFinalModalOpen: false
    };
    return _this;
  }

  _createClass(NewUserTour, [{
    key: 'joyrideCallback',
    value: function joyrideCallback(data) {
      var action = data.action,
          index = data.index;

      var isTourFinished = action === 'next' && index >= tourSteps.length;
      if (isTourFinished) {
        this.setState({
          introFinalModalOpen: true
        });

        // Mark that the user has viewed the tour
        _localstorageMgr2.default.setItem(_constants.STORAGE_NEW_USER_HAS_COMPLETED_TOUR, 'true');
      }
    }
  }, {
    key: 'introModalButtonClick',
    value: function introModalButtonClick() {
      this.setState({
        introModalOpen: false,
        beginTour: true
      });
    }
  }, {
    key: 'goToPreviousStep',
    value: function goToPreviousStep() {
      this.setState({
        stepIndex: this.state.stepIndex - 1
      });
    }
  }, {
    key: 'goToNextStep',
    value: function goToNextStep() {
      this.setState({
        stepIndex: this.state.stepIndex + 1
      });
    }
  }, {
    key: 'getCurrentStepContent',
    value: function getCurrentStepContent() {
      var stepObj = tourSteps[this.state.stepIndex];
      if (stepObj && stepObj.content) {
        return stepObj.content;
      } else {
        return null;
      }
    }
  }, {
    key: 'introFinalModalButtonClick',
    value: function introFinalModalButtonClick() {
      this.setState({
        introFinalModalOpen: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _Dialog2.default,
          {
            title: 'Your tabs are changing the world!',
            actionsContainerStyle: {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end'
            },
            actions: [_react2.default.createElement(
              _Button2.default,
              {
                onClick: this.introModalButtonClick.bind(this),
                color: 'primary'
              },
              'Next'
            )],
            modal: true,
            open: this.state.introModalOpen,
            contentStyle: {
              maxWidth: 500
            }
          },
          _react2.default.createElement(
            'span',
            { style: { display: 'flex', justifyContent: 'center' } },
            _react2.default.createElement(_Earth2.default, { style: { color: _default.primaryColor, width: 32, height: 32, margin: 10, marginTop: 0 } }),
            _react2.default.createElement(_favorite2.default, { color: _default.primaryColor, style: { width: 32, height: 32, margin: 10, marginTop: 0 } })
          ),
          _react2.default.createElement(
            _Typography2.default,
            { variant: 'body2', paragraph: true },
            'Now, every tab you open raises money for charity. (The money comes from showing ads in the corner of the page.)'
          ),
          _react2.default.createElement(
            _Typography2.default,
            { variant: 'body2', paragraph: true },
            'Just by surfing the web, you\'re feeding children, protecting the rainforest, and more.'
          )
        ),
        _react2.default.createElement(_reactJoyride2.default, {
          steps: tourSteps,
          stepIndex: this.state.stepIndex,
          run: this.state.beginTour,
          continuous: true,
          disableOverlayClose: true,
          callback: this.joyrideCallback.bind(this),
          styles: {
            zIndex: 4600,
            options: {
              arrowColor: '#fff',
              backgroundColor: '#fff',
              primaryColor: _default.primaryColor,
              textColor: _default.textColor,
              overlayColor: 'rgba(0, 0, 0, 0.56)'
            },
            overlay: {
              cursor: 'default'
            }
          },
          floaterProps: {
            disableAnimation: true
          }
          // We're choosing to control the component so it will match
          // the app theme. But we can remove this and the "stepIndex"
          // prop to let Joyride handle it.
          , tooltipComponent: _react2.default.createElement(CustomTooltip, {
            content: this.getCurrentStepContent(),
            stepIndex: this.state.stepIndex,
            goToNextStep: this.goToNextStep.bind(this),
            goToPreviousStep: this.goToPreviousStep.bind(this)
          })
        }),
        _react2.default.createElement(
          _Dialog2.default,
          {
            title: 'We\'re thrilled to have you!',
            actionsContainerStyle: {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end'
            },
            actions: [_react2.default.createElement(
              _Button2.default,
              {
                onClick: this.introFinalModalButtonClick.bind(this),
                color: 'default'
              },
              'Skip for now'
            )],
            modal: true,
            open: this.state.introFinalModalOpen,
            contentStyle: {
              maxWidth: 500
            }
          },
          _react2.default.createElement(
            'div',
            { style: {
                display: 'flex',
                flexDirection: 'column'
              } },
            _react2.default.createElement(
              _Typography2.default,
              { variant: 'body2', paragraph: true },
              'Thanks for making the world a better place, one tab at a time.'
            ),
            _react2.default.createElement(
              _Typography2.default,
              { variant: 'body2', paragraph: true },
              'We can make a bigger impact together. Share Tab for a Cause with a few friends!'
            ),
            _react2.default.createElement(_InviteFriendContainer2.default, { style: { alignSelf: 'center' }, user: user })
          )
        )
      );
    }
  }]);

  return NewUserTour;
}(_react2.default.Component);

NewUserTour.propTypes = {
  user: _propTypes2.default.shape({}).isRequired
};

NewUserTour.defaultProps = {};

exports.default = NewUserTour;

/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _NewUserTourComponent = __webpack_require__(1254);

var _NewUserTourComponent2 = _interopRequireDefault(_NewUserTourComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// If this needs to fetch substantially more data
// than we currently do on the new tab page, we
// may want to give it its own QueryRenderer so
// that we don't fetch unneeded data on every tab.
exports.default = (0, _reactRelay.createFragmentContainer)(_NewUserTourComponent2.default, {
  user: function user() {
    return __webpack_require__(1265);
  }
});

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navigation = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// The view the extensions open immediately after the
// user uninstalls the extension.
var PostUninstallView = function (_React$Component) {
  _inherits(PostUninstallView, _React$Component);

  function PostUninstallView() {
    _classCallCheck(this, PostUninstallView);

    return _possibleConstructorReturn(this, (PostUninstallView.__proto__ || Object.getPrototypeOf(PostUninstallView)).apply(this, arguments));
  }

  _createClass(PostUninstallView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _navigation.externalRedirect)(_navigation.postUninstallSurveyURL);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('span', null);
    }
  }]);

  return PostUninstallView;
}(_react2.default.Component);

exports.default = PostUninstallView;

/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AssignExperimentGroupsContainer_user$ref: FragmentReference;
export type AssignExperimentGroupsContainer_user = {|
  +id: string,
  +joined: ?string,
  +$refType: AssignExperimentGroupsContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "AssignExperimentGroupsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "joined",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'f4aa90f54f79b136be7e4764da1f0611';
module.exports = node;

/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type MoneyRaisedContainer_app$ref = any;
type UserMenuContainer_app$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DashboardContainer_app$ref: FragmentReference;
export type DashboardContainer_app = {|
  +isGlobalCampaignLive: ?boolean,
  +$fragmentRefs: MoneyRaisedContainer_app$ref & UserMenuContainer_app$ref,
  +$refType: DashboardContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "DashboardContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "isGlobalCampaignLive",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "MoneyRaisedContainer_app",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "UserMenuContainer_app",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '2458d86b995bfab1ffd24dc399e13e2e';
module.exports = node;

/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type AssignExperimentGroupsContainer_user$ref = any;
type LogAccountCreationContainer_user$ref = any;
type LogConsentDataContainer_user$ref = any;
type LogRevenueContainer_user$ref = any;
type LogTabContainer_user$ref = any;
type NewUserTourContainer_user$ref = any;
type UserBackgroundImageContainer_user$ref = any;
type UserMenuContainer_user$ref = any;
type WidgetsContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DashboardContainer_user$ref: FragmentReference;
export type DashboardContainer_user = {|
  +id: string,
  +joined: ?string,
  +$fragmentRefs: WidgetsContainer_user$ref & UserBackgroundImageContainer_user$ref & UserMenuContainer_user$ref & LogTabContainer_user$ref & LogRevenueContainer_user$ref & LogConsentDataContainer_user$ref & LogAccountCreationContainer_user$ref & NewUserTourContainer_user$ref & AssignExperimentGroupsContainer_user$ref,
  +$refType: DashboardContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "DashboardContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "FragmentSpread",
    "name": "LogTabContainer_user",
    "args": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "WidgetsContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "UserBackgroundImageContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "UserMenuContainer_user",
    "args": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "joined",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "LogRevenueContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "LogConsentDataContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "LogAccountCreationContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "NewUserTourContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "AssignExperimentGroupsContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '6f75b14eecf91e41dd4a93677a663e0c';
module.exports = node;

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0c9f8213cd78f8a1abba1e4003687a79
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type DashboardContainer_app$ref = any;
type DashboardContainer_user$ref = any;
export type DashboardViewQueryVariables = {|
  userId: string
|};
export type DashboardViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: DashboardContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: DashboardContainer_user$ref
  |},
|};
export type DashboardViewQuery = {|
  variables: DashboardViewQueryVariables,
  response: DashboardViewQueryResponse,
|};
*/

/*
query DashboardViewQuery(
  $userId: String!
) {
  app {
    ...DashboardContainer_app
    id
  }
  user(userId: $userId) {
    ...DashboardContainer_user
    id
  }
}

fragment DashboardContainer_app on App {
  isGlobalCampaignLive
  ...MoneyRaisedContainer_app
  ...UserMenuContainer_app
}

fragment DashboardContainer_user on User {
  id
  joined
  ...WidgetsContainer_user
  ...UserBackgroundImageContainer_user
  ...UserMenuContainer_user
  ...LogTabContainer_user
  ...LogRevenueContainer_user
  ...LogConsentDataContainer_user
  ...LogAccountCreationContainer_user
  ...NewUserTourContainer_user
  ...AssignExperimentGroupsContainer_user
}

fragment WidgetsContainer_user on User {
  id
  activeWidget
  ...WidgetContainer_user
  widgets(first: 20, enabled: true) {
    edges {
      node {
        id
        type
        ...WidgetContainer_widget
        ...WidgetIconContainer_widget
      }
    }
  }
}

fragment UserBackgroundImageContainer_user on User {
  id
  backgroundOption
  customImage
  backgroundColor
  backgroundImage {
    imageURL
    timestamp
    id
  }
}

fragment UserMenuContainer_user on User {
  id
  vcCurrent
  level
  heartsUntilNextLevel
  vcDonatedAllTime
  numUsersRecruited
  tabsToday
}

fragment LogTabContainer_user on User {
  id
}

fragment LogRevenueContainer_user on User {
  id
}

fragment LogConsentDataContainer_user on User {
  id
}

fragment LogAccountCreationContainer_user on User {
  tabs
}

fragment NewUserTourContainer_user on User {
  ...InviteFriendContainer_user
}

fragment AssignExperimentGroupsContainer_user on User {
  id
  joined
}

fragment InviteFriendContainer_user on User {
  username
}

fragment WidgetContainer_user on User {
  ...BookmarksWidgetContainer_user
  ...SearchWidgetContainer_user
  ...ClockWidgetContainer_user
  ...NotesWidgetContainer_user
  ...TodosWidgetContainer_user
}

fragment WidgetContainer_widget on Widget {
  type
  ...BookmarksWidgetContainer_widget
  ...SearchWidgetContainer_widget
  ...ClockWidgetContainer_widget
  ...NotesWidgetContainer_widget
  ...TodosWidgetContainer_widget
}

fragment WidgetIconContainer_widget on Widget {
  id
  type
  visible
}

fragment BookmarksWidgetContainer_widget on Widget {
  id
  name
  enabled
  visible
  data
  type
}

fragment SearchWidgetContainer_widget on Widget {
  id
  name
  enabled
  data
  config
  settings
  type
}

fragment ClockWidgetContainer_widget on Widget {
  id
  name
  enabled
  config
  settings
  type
}

fragment NotesWidgetContainer_widget on Widget {
  id
  name
  enabled
  visible
  data
  type
}

fragment TodosWidgetContainer_widget on Widget {
  id
  name
  enabled
  visible
  data
  type
}

fragment BookmarksWidgetContainer_user on User {
  id
}

fragment SearchWidgetContainer_user on User {
  id
}

fragment ClockWidgetContainer_user on User {
  id
}

fragment NotesWidgetContainer_user on User {
  id
}

fragment TodosWidgetContainer_user on User {
  id
}

fragment MoneyRaisedContainer_app on App {
  moneyRaised
  dollarsPerDayRate
}

fragment UserMenuContainer_app on App {
  referralVcReward
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "DashboardViewQuery",
    "id": null,
    "text": "query DashboardViewQuery(\n  $userId: String!\n) {\n  app {\n    ...DashboardContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...DashboardContainer_user\n    id\n  }\n}\n\nfragment DashboardContainer_app on App {\n  isGlobalCampaignLive\n  ...MoneyRaisedContainer_app\n  ...UserMenuContainer_app\n}\n\nfragment DashboardContainer_user on User {\n  id\n  joined\n  ...WidgetsContainer_user\n  ...UserBackgroundImageContainer_user\n  ...UserMenuContainer_user\n  ...LogTabContainer_user\n  ...LogRevenueContainer_user\n  ...LogConsentDataContainer_user\n  ...LogAccountCreationContainer_user\n  ...NewUserTourContainer_user\n  ...AssignExperimentGroupsContainer_user\n}\n\nfragment WidgetsContainer_user on User {\n  id\n  activeWidget\n  ...WidgetContainer_user\n  widgets(first: 20, enabled: true) {\n    edges {\n      node {\n        id\n        type\n        ...WidgetContainer_widget\n        ...WidgetIconContainer_widget\n      }\n    }\n  }\n}\n\nfragment UserBackgroundImageContainer_user on User {\n  id\n  backgroundOption\n  customImage\n  backgroundColor\n  backgroundImage {\n    imageURL\n    timestamp\n    id\n  }\n}\n\nfragment UserMenuContainer_user on User {\n  id\n  vcCurrent\n  level\n  heartsUntilNextLevel\n  vcDonatedAllTime\n  numUsersRecruited\n  tabsToday\n}\n\nfragment LogTabContainer_user on User {\n  id\n}\n\nfragment LogRevenueContainer_user on User {\n  id\n}\n\nfragment LogConsentDataContainer_user on User {\n  id\n}\n\nfragment LogAccountCreationContainer_user on User {\n  tabs\n}\n\nfragment NewUserTourContainer_user on User {\n  ...InviteFriendContainer_user\n}\n\nfragment AssignExperimentGroupsContainer_user on User {\n  id\n  joined\n}\n\nfragment InviteFriendContainer_user on User {\n  username\n}\n\nfragment WidgetContainer_user on User {\n  ...BookmarksWidgetContainer_user\n  ...SearchWidgetContainer_user\n  ...ClockWidgetContainer_user\n  ...NotesWidgetContainer_user\n  ...TodosWidgetContainer_user\n}\n\nfragment WidgetContainer_widget on Widget {\n  type\n  ...BookmarksWidgetContainer_widget\n  ...SearchWidgetContainer_widget\n  ...ClockWidgetContainer_widget\n  ...NotesWidgetContainer_widget\n  ...TodosWidgetContainer_widget\n}\n\nfragment WidgetIconContainer_widget on Widget {\n  id\n  type\n  visible\n}\n\nfragment BookmarksWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  visible\n  data\n  type\n}\n\nfragment SearchWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  data\n  config\n  settings\n  type\n}\n\nfragment ClockWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  config\n  settings\n  type\n}\n\nfragment NotesWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  visible\n  data\n  type\n}\n\nfragment TodosWidgetContainer_widget on Widget {\n  id\n  name\n  enabled\n  visible\n  data\n  type\n}\n\nfragment BookmarksWidgetContainer_user on User {\n  id\n}\n\nfragment SearchWidgetContainer_user on User {\n  id\n}\n\nfragment ClockWidgetContainer_user on User {\n  id\n}\n\nfragment NotesWidgetContainer_user on User {\n  id\n}\n\nfragment TodosWidgetContainer_user on User {\n  id\n}\n\nfragment MoneyRaisedContainer_app on App {\n  moneyRaised\n  dollarsPerDayRate\n}\n\nfragment UserMenuContainer_app on App {\n  referralVcReward\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "DashboardViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "DashboardContainer_app",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "DashboardContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "DashboardViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "isGlobalCampaignLive",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "moneyRaised",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "dollarsPerDayRate",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "referralVcReward",
          "args": null,
          "storageKey": null
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "vcCurrent",
          "args": null,
          "storageKey": null
        }, v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "activeWidget",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "widgets",
          "storageKey": "widgets(enabled:true,first:20)",
          "args": [{
            "kind": "Literal",
            "name": "enabled",
            "value": true,
            "type": "Boolean"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 20,
            "type": "Int"
          }],
          "concreteType": "WidgetConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "WidgetEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Widget",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "enabled",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "visible",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "data",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "config",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "settings",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "backgroundOption",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "customImage",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "backgroundColor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "backgroundImage",
          "storageKey": null,
          "args": null,
          "concreteType": "BackgroundImage",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "imageURL",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "timestamp",
            "args": null,
            "storageKey": null
          }, v2]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "joined",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "level",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "heartsUntilNextLevel",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "vcDonatedAllTime",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "numUsersRecruited",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "tabsToday",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "tabs",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "username",
          "args": null,
          "storageKey": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '6d65813bcddb9b2c684e114c891ac83f';
module.exports = node;

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogAccountCreationContainer_user$ref: FragmentReference;
export type LogAccountCreationContainer_user = {|
  +tabs: ?number,
  +$refType: LogAccountCreationContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LogAccountCreationContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "tabs",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '8cc603755d6dc31f91ced32ad999df9c';
module.exports = node;

/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogConsentDataContainer_user$ref: FragmentReference;
export type LogConsentDataContainer_user = {|
  +id: string,
  +$refType: LogConsentDataContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LogConsentDataContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'e4be365deebdcf4465922e6d56f2a146';
module.exports = node;

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogRevenueContainer_user$ref: FragmentReference;
export type LogRevenueContainer_user = {|
  +id: string,
  +$refType: LogRevenueContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LogRevenueContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '222a0becdf70c0d3b5c6cca076be9f6d';
module.exports = node;

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogTabContainer_user$ref: FragmentReference;
export type LogTabContainer_user = {|
  +id: string,
  +$refType: LogTabContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LogTabContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '6fa1db8df0de1d3467b7dfc64de4d82d';
module.exports = node;

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type InviteFriendContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type NewUserTourContainer_user$ref: FragmentReference;
export type NewUserTourContainer_user = {|
  +$fragmentRefs: InviteFriendContainer_user$ref,
  +$refType: NewUserTourContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "NewUserTourContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "FragmentSpread",
    "name": "InviteFriendContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '09192f1c237709ffd84b9d2d3c9dcc6c';
module.exports = node;

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(111);

var _Paper2 = _interopRequireDefault(_Paper);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _DonateHeartsControlsContainer = __webpack_require__(569);

var _DonateHeartsControlsContainer2 = _interopRequireDefault(_DonateHeartsControlsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Charity = function (_React$Component) {
  _inherits(Charity, _React$Component);

  function Charity() {
    _classCallCheck(this, Charity);

    return _possibleConstructorReturn(this, (Charity.__proto__ || Object.getPrototypeOf(Charity)).apply(this, arguments));
  }

  _createClass(Charity, [{
    key: 'openCharityWebsite',
    value: function openCharityWebsite() {
      var charity = this.props.charity;

      // The page might be iframed, so opening in _top or _blank is critical.

      window.open(charity.website, '_blank');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          charity = _props.charity,
          user = _props.user,
          style = _props.style,
          showError = _props.showError;


      return _react2.default.createElement(
        _Paper2.default,
        {
          style: Object.assign({}, {
            minWidth: 250,
            maxWidth: 360
          }, style)
        },
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '100%'
            }
          },
          _react2.default.createElement(
            'span',
            {
              style: {
                padding: 0
              }
            },
            _react2.default.createElement('img', {
              alt: 'Logo for the charity ' + charity.name,
              style: {
                cursor: 'pointer',
                maxWidth: '100%',
                minWidth: '100%'
              },
              src: charity.logo,
              onClick: this.openCharityWebsite.bind(this) })
          ),
          _react2.default.createElement(
            _Typography2.default,
            {
              variant: 'h5',
              style: {
                padding: 16,
                display: 'block',
                textAlign: 'center'
              }
            },
            charity.name
          ),
          _react2.default.createElement(
            _Typography2.default,
            {
              variant: 'body2',
              style: {
                boxSizing: 'border-box',
                paddingLeft: 16,
                paddingRight: 16,
                textAlign: 'center',
                display: 'block'
              }
            },
            charity.description
          ),
          _react2.default.createElement(_DonateHeartsControlsContainer2.default, {
            charity: charity,
            user: user,
            showError: showError,
            style: {
              padding: 24
            }
          })
        )
      );
    }
  }]);

  return Charity;
}(_react2.default.Component);

Charity.propTypes = {
  charity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string.isRequired,
    logo: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    website: _propTypes2.default.string.isRequired
  }),
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    vcCurrent: _propTypes2.default.number.isRequired
  }),
  showError: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object
};

Charity.defaultProps = {
  style: {}
};

exports.default = Charity;

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _CharityComponent = __webpack_require__(1266);

var _CharityComponent2 = _interopRequireDefault(_CharityComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_CharityComponent2.default, {
  charity: function charity() {
    return __webpack_require__(1269);
  },
  user: function user() {
    return __webpack_require__(1270);
  }
});

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _sanitizeHtml = __webpack_require__(2611);

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _styles = __webpack_require__(79);

var _Button = __webpack_require__(227);

var _Button2 = _interopRequireDefault(_Button);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _Dialog = __webpack_require__(1069);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _DialogActions = __webpack_require__(1071);

var _DialogActions2 = _interopRequireDefault(_DialogActions);

var _DialogContent = __webpack_require__(1073);

var _DialogContent2 = _interopRequireDefault(_DialogContent);

var _DialogTitle = __webpack_require__(1075);

var _DialogTitle2 = _interopRequireDefault(_DialogTitle);

var _Popover = __webpack_require__(548);

var _Popover2 = _interopRequireDefault(_Popover);

var _Slider = __webpack_require__(1184);

var _Slider2 = _interopRequireDefault(_Slider);

var _DonateVcMutation = __webpack_require__(1386);

var _DonateVcMutation2 = _interopRequireDefault(_DonateVcMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = function styles(theme) {
  return {
    charityTitleLink: {
      color: '#9d4ba3',
      textDecoration: 'none',
      cursor: 'pointer',
      whiteSpace: 'nowrap'
    },
    charityImpactText: {
      '& a': {
        color: '#9d4ba3',
        textDecoration: 'none'
      }
    }
  };
};

var DonateHeartsControls = function (_React$Component) {
  _inherits(DonateHeartsControls, _React$Component);

  function DonateHeartsControls(props) {
    _classCallCheck(this, DonateHeartsControls);

    var _this = _possibleConstructorReturn(this, (DonateHeartsControls.__proto__ || Object.getPrototypeOf(DonateHeartsControls)).call(this, props));

    _this.state = {
      amountToDonate: 1,
      customAmountSliderOpen: false,
      donateInProgress: false,
      thanksDialog: false
    };
    return _this;
  }

  _createClass(DonateHeartsControls, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var user = this.props.user;

      this.setState({
        amountToDonate: user.vcCurrent
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.user.vcCurrent !== nextProps.user.vcCurrent) {
        this.setState({
          amountToDonate: nextProps.user.vcCurrent
        });
      }
    }
  }, {
    key: 'openCustomSlider',
    value: function openCustomSlider(event) {
      this.setState({
        customAmountSliderOpen: true,
        anchorEl: event.currentTarget
      });
    }
  }, {
    key: 'closeCustomSlider',
    value: function closeCustomSlider() {
      this.setState({
        customAmountSliderOpen: false
      });
    }
  }, {
    key: 'onCustomSliderValChange',
    value: function onCustomSliderValChange(event, value) {
      this.setState({ amountToDonate: value });
    }
  }, {
    key: 'thanksDialogClose',
    value: function thanksDialogClose() {
      this.setState({
        thanksDialog: false
      });
    }
  }, {
    key: 'donateHearts',
    value: function donateHearts() {
      if (this.state.amountToDonate <= 0 || this.state.donateInProgress) {
        return;
      }
      this.setState({
        donateInProgress: true
      });
      var _props = this.props,
          charity = _props.charity,
          user = _props.user,
          _props$heartDonationC = _props.heartDonationCampaign;
      _props$heartDonationC = _props$heartDonationC === undefined ? {} : _props$heartDonationC;
      var _props$heartDonationC2 = _props$heartDonationC.time,
          time = _props$heartDonationC2 === undefined ? {} : _props$heartDonationC2;

      var self = this;
      return (0, _DonateVcMutation2.default)({
        userId: user.id,
        charityId: charity.id,
        vc: this.state.amountToDonate
      }, Object.assign({},
      // Optionally provided so we know which Relay record to
      // update to increase the total VC this charity has received.
      time.start && time.end && {
        vcReceivedArgs: {
          startTime: (0, _moment2.default)(time.start).toISOString(),
          endTime: (0, _moment2.default)(time.end).toISOString()
        }
      })).then(function () {
        self.setState({
          thanksDialog: true,
          donateInProgress: false
        });
      }).catch(function () {
        self.props.showError('Oops, we could not donate your Hearts just now :(');
        self.setState({
          donateInProgress: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          charity = _props2.charity,
          user = _props2.user,
          theme = _props2.theme,
          style = _props2.style,
          classes = _props2.classes;


      var MIN_VC_FOR_CUSTOM_SLIDER = 2;
      var heartsText = this.state.amountToDonate === 1 ? 'Heart' : 'Hearts';

      var impactMessage = (0, _sanitizeHtml2.default)(charity.impact, {
        allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p'],
        allowedAttributes: {
          a: ['href', 'target', 'rel']
        }
      });

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          {
            style: Object.assign({}, style, {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            })
          },
          _react2.default.createElement(
            _Button2.default,
            {
              color: 'primary',
              variant: 'contained',
              disabled: this.state.amountToDonate <= 0 || this.state.donateInProgress,
              onClick: this.donateHearts.bind(this)
            },
            'Donate ',
            this.state.amountToDonate,
            ' ',
            heartsText
          ),
          user.vcCurrent > MIN_VC_FOR_CUSTOM_SLIDER ? _react2.default.createElement(
            'span',
            {
              style: {
                fontSize: 11,
                color: theme.palette.text.disabled,
                cursor: 'pointer',
                marginTop: 5
              },
              onClick: this.openCustomSlider.bind(this) },
            _react2.default.createElement(
              _Typography2.default,
              {
                variant: 'caption',
                style: {
                  color: theme.palette.text.disabled
                }
              },
              'Or, donate a specific amount'
            )
          ) : null
        ),
        _react2.default.createElement(
          _Popover2.default,
          {
            open: this.state.customAmountSliderOpen,
            anchorEl: this.state.anchorEl,
            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
            transformOrigin: { horizontal: 'left', vertical: 'top' },
            onClose: this.closeCustomSlider.bind(this)
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                width: 330,
                height: 'auto',
                padding: 20
              }
            },
            _react2.default.createElement(
              'div',
              {
                style: {
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: 15
                }
              },
              _react2.default.createElement(
                _Typography2.default,
                {
                  variant: 'body2'
                },
                'Fewer Hearts'
              ),
              _react2.default.createElement(
                _Typography2.default,
                {
                  variant: 'body2'
                },
                'More Hearts'
              )
            ),
            _react2.default.createElement(_Slider2.default, {
              min: 1,
              max: user.vcCurrent,
              step: 1,
              value: this.state.amountToDonate,
              onChange: this.onCustomSliderValChange.bind(this)
            })
          )
        ),
        _react2.default.createElement(
          _Dialog2.default,
          {
            open: this.state.thanksDialog,
            onClose: this.thanksDialogClose.bind(this)
          },
          _react2.default.createElement(
            _DialogTitle2.default,
            { disableTypography: true },
            _react2.default.createElement(
              _Typography2.default,
              {
                variant: 'h5',
                style: {
                  lineHeight: 1.3,
                  textAlign: 'center'
                }
              },
              'Thanks for supporting',
              ' ',
              _react2.default.createElement(
                'a',
                {
                  href: charity.website,
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  className: classes.charityTitleLink
                },
                charity.name
              ),
              '!'
            )
          ),
          _react2.default.createElement(
            _DialogContent2.default,
            null,
            _react2.default.createElement(
              'span',
              {
                style: {
                  display: 'flex',
                  justifyContent: 'center',
                  maxWidth: '100%'
                }
              },
              _react2.default.createElement('img', {
                alt: 'A demonstration of the work by ' + charity.name + '.',
                style: {
                  height: 240,
                  border: '4px solid ' + theme.palette.primary.main
                },
                src: charity.image
              })
            ),
            _react2.default.createElement(
              'div',
              {
                style: {
                  paddingTop: charity.imageCaption ? 0 : 14,
                  paddingLeft: 34,
                  paddingRight: 34,
                  paddingBottom: 0
                }
              },
              charity.imageCaption ? _react2.default.createElement(
                _Typography2.default,
                {
                  variant: 'caption',
                  style: {
                    color: theme.palette.text.disabled,
                    marginBottom: 4
                  }
                },
                charity.imageCaption
              ) : null,
              _react2.default.createElement('span', {
                style: theme.typography.body2,
                className: classes.charityImpactText,
                dangerouslySetInnerHTML: { __html: impactMessage }
              })
            )
          ),
          _react2.default.createElement(
            _DialogActions2.default,
            {
              style: {
                margin: 10
              }
            },
            _react2.default.createElement(
              _Button2.default,
              {
                color: 'primary',
                variant: 'contained',
                onClick: this.thanksDialogClose.bind(this)
              },
              'Done'
            )
          )
        )
      );
    }
  }]);

  return DonateHeartsControls;
}(_react2.default.Component);

DonateHeartsControls.propTypes = {
  charity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    image: _propTypes2.default.string.isRequired,
    impact: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    website: _propTypes2.default.string.isRequired
  }),
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    vcCurrent: _propTypes2.default.number.isRequired
  }),
  // Provided so we know which Relay record to update
  // to increase the Hearts donated to the campaign.
  heartDonationCampaign: _propTypes2.default.shape({
    time: _propTypes2.default.shape({
      start: _propTypes2.default.instanceOf(_moment2.default),
      end: _propTypes2.default.instanceOf(_moment2.default)
    })
  }),
  showError: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.object.isRequired,
  style: _propTypes2.default.object.isRequired,
  classes: _propTypes2.default.object.isRequired
};

DonateHeartsControls.defaultProps = {
  style: {}
};

exports.default = (0, _styles.withStyles)(styles, { withTheme: true })(DonateHeartsControls);

/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type DonateHeartsControlsContainer_charity$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CharityContainer_charity$ref: FragmentReference;
export type CharityContainer_charity = {|
  +id: string,
  +description: ?string,
  +logo: ?string,
  +name: ?string,
  +website: ?string,
  +$fragmentRefs: DonateHeartsControlsContainer_charity$ref,
  +$refType: CharityContainer_charity$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "CharityContainer_charity",
  "type": "Charity",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "logo",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "website",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "DonateHeartsControlsContainer_charity",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '4f54fe6a40bcb6a02b0aed5c94ec91ba';
module.exports = node;

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type DonateHeartsControlsContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CharityContainer_user$ref: FragmentReference;
export type CharityContainer_user = {|
  +id: string,
  +vcCurrent: ?number,
  +$fragmentRefs: DonateHeartsControlsContainer_user$ref,
  +$refType: CharityContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "CharityContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "vcCurrent",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "DonateHeartsControlsContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '6a9d647a3f197b6856d98bbc6c583b76';
module.exports = node;

/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DonateHeartsControlsContainer_charity$ref: FragmentReference;
export type DonateHeartsControlsContainer_charity = {|
  +id: string,
  +image: ?string,
  +imageCaption: ?string,
  +impact: ?string,
  +name: ?string,
  +website: ?string,
  +$refType: DonateHeartsControlsContainer_charity$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "DonateHeartsControlsContainer_charity",
  "type": "Charity",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "image",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "imageCaption",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "impact",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "website",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'ebfca4dc81fb985782e3fff4d8497793';
module.exports = node;

/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DonateHeartsControlsContainer_user$ref: FragmentReference;
export type DonateHeartsControlsContainer_user = {|
  +id: string,
  +vcCurrent: ?number,
  +$refType: DonateHeartsControlsContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "DonateHeartsControlsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "vcCurrent",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'cc85aa7b76248acc180093074e7d0d4f';
module.exports = node;

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseContainer = function (_React$Component) {
  _inherits(BaseContainer, _React$Component);

  function BaseContainer() {
    _classCallCheck(this, BaseContainer);

    return _possibleConstructorReturn(this, (BaseContainer.__proto__ || Object.getPrototypeOf(BaseContainer)).apply(this, arguments));
  }

  _createClass(BaseContainer, [{
    key: 'render',
    value: function render() {
      var root = {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        margin: 0,
        padding: 0,
        border: 'none'
      };

      return _react2.default.createElement(
        'div',
        { style: root },
        this.props.children
      );
    }
  }]);

  return BaseContainer;
}(_react2.default.Component);

exports.default = BaseContainer;

/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CenteredWidgetsContainer = function (_React$Component) {
  _inherits(CenteredWidgetsContainer, _React$Component);

  function CenteredWidgetsContainer() {
    _classCallCheck(this, CenteredWidgetsContainer);

    return _possibleConstructorReturn(this, (CenteredWidgetsContainer.__proto__ || Object.getPrototypeOf(CenteredWidgetsContainer)).apply(this, arguments));
  }

  _createClass(CenteredWidgetsContainer, [{
    key: 'render',
    value: function render() {
      var root = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        overflow: 'hidden',
        boxSizing: 'border-box',
        pointerEvents: 'none'
      };

      return _react2.default.createElement(
        'div',
        { style: root },
        this.props.children
      );
    }
  }]);

  return CenteredWidgetsContainer;
}(_react2.default.Component);

exports.default = CenteredWidgetsContainer;

/***/ }),

/***/ 1275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FadeInAnimation = function (_React$Component) {
  _inherits(FadeInAnimation, _React$Component);

  function FadeInAnimation() {
    _classCallCheck(this, FadeInAnimation);

    return _possibleConstructorReturn(this, (FadeInAnimation.__proto__ || Object.getPrototypeOf(FadeInAnimation)).apply(this, arguments));
  }

  _createClass(FadeInAnimation, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        null,
        _react2.default.Children.map(this.props.children, function (item, i) {
          return item ? _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
              key: i,
              classNames: 'fade',
              appear: true,
              timeout: {
                enter: 300,
                exit: 300
              } },
            item
          ) : null;
        })
      );
    }
  }]);

  return FadeInAnimation;
}(_react2.default.Component);

FadeInAnimation.propTypes = {
  children: _propTypes2.default.object.isRequired
};

exports.default = FadeInAnimation;

/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(79);

var _Divider = __webpack_require__(368);

var _Divider2 = _interopRequireDefault(_Divider);

var _FacebookBox = __webpack_require__(2213);

var _FacebookBox2 = _interopRequireDefault(_FacebookBox);

var _Twitter = __webpack_require__(2214);

var _Twitter2 = _interopRequireDefault(_Twitter);

var _logoGrey = __webpack_require__(1758);

var _logoGrey2 = _interopRequireDefault(_logoGrey);

var _navigation = __webpack_require__(50);

var _Link = __webpack_require__(1277);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Matches tab-homepage style.
var fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif';
var lightestShadingColor = 'rgba(128, 128, 128, 0.04)';
var lighterTextColor = '#838383';
var lightestTextColor = '#cecece';

var styles = function styles(theme) {
  return {
    footerLink: {
      textDecoration: 'none',
      color: lightestTextColor,
      fontSize: 12,
      margin: 20,
      '&:hover': {
        color: lighterTextColor
      }
    },
    socialIcon: {
      color: lightestTextColor,
      width: 20,
      height: 20,
      '&:hover': {
        color: lighterTextColor
      }
    }
  };
};

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          style = _props.style;

      return _react2.default.createElement(
        'div',
        {
          style: Object.assign({}, {
            background: lightestShadingColor,
            paddingTop: 1,
            paddingBottom: 20,
            paddingLeft: 40,
            paddingRight: 40,
            fontFamily: fontFamily
          }, style)
        },
        _react2.default.createElement(_Divider2.default, { style: { width: '100%', marginBottom: 20 } }),
        _react2.default.createElement(
          'div',
          {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                display: 'flex',
                justifyContent: 'flex-start',
                flexWrap: 'nowrap',
                alignItems: 'center'
              }
            },
            _react2.default.createElement(
              _Link2.default,
              { to: _navigation.homeURL },
              _react2.default.createElement('img', { src: _logoGrey2.default, style: { height: 43 }, alt: 'Tab for a Cause logo in grey' })
            ),
            _react2.default.createElement(
              'div',
              {
                style: {
                  marginLeft: 30,
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start'
                }
              },
              _react2.default.createElement(
                _Link2.default,
                {
                  to: _navigation.externalHelpURL,
                  className: classes.footerLink
                },
                'Help'
              ),
              _react2.default.createElement(
                _Link2.default,
                {
                  to: _navigation.adblockerWhitelistingURL,
                  className: classes.footerLink
                },
                'Adblockers'
              ),
              _react2.default.createElement(
                _Link2.default,
                {
                  to: _navigation.financialsURL,
                  className: classes.footerLink
                },
                'Financials'
              ),
              _react2.default.createElement(
                _Link2.default,
                {
                  to: _navigation.termsOfServiceURL,
                  className: classes.footerLink
                },
                'Terms'
              ),
              _react2.default.createElement(
                _Link2.default,
                {
                  to: _navigation.privacyPolicyURL,
                  className: classes.footerLink
                },
                'Privacy'
              ),
              _react2.default.createElement(
                _Link2.default,
                {
                  to: _navigation.teamURL,
                  className: classes.footerLink
                },
                'Team'
              ),
              _react2.default.createElement(
                _Link2.default,
                {
                  to: _navigation.contactUsURL,
                  className: classes.footerLink
                },
                'Contact'
              ),
              _react2.default.createElement(
                _Link2.default,
                {
                  to: _navigation.jobsURL,
                  className: classes.footerLink
                },
                'Jobs'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center', paddingTop: 4 } },
            _react2.default.createElement(
              _Link2.default,
              { to: _navigation.facebookPageURL, style: { margin: 12 } },
              _react2.default.createElement(_FacebookBox2.default, {
                className: classes.socialIcon
              })
            ),
            _react2.default.createElement(
              _Link2.default,
              { to: _navigation.twitterPageURL, style: { margin: 12 } },
              _react2.default.createElement(_Twitter2.default, {
                className: classes.socialIcon
              })
            )
          )
        )
      );
    }
  }]);

  return Footer;
}(_react2.default.Component);

Footer.propTypes = {
  style: _propTypes2.default.object,
  classes: _propTypes2.default.object.isRequired
};

Footer.defaultProps = {
  style: {}
};

exports.default = (0, _styles.withStyles)(styles)(Footer);

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// To handle both internal and external links.
var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          to = _props.to,
          style = _props.style,
          className = _props.className;

      // This assumes that any internal link (intended for Gatsby) starts
      // with exactly one slash, and that anything else is external.

      var internal = /^\/(?!\/)/.test(to);

      // Use gatsby-link for internal links, and <a> for others
      if (internal) {
        return _react2.default.createElement(
          _reactRouter.Link,
          {
            to: to,
            style: style,
            className: className
          },
          children
        );
      }
      return _react2.default.createElement(
        'a',
        {
          href: to,
          style: style,
          className: className
        },
        children
      );
    }
  }]);

  return Link;
}(_react2.default.Component);

Link.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  style: _propTypes2.default.object,
  to: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

Link.defaultProps = {
  style: {},
  className: ''
};

exports.default = Link;

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// A link element that knows if it's active. If active,
// it sets an active class and passes an active={true}
// prop to children components.
// Note: this may not be relevant in react-router 4.0+.
// https://stackoverflow.com/q/34418254/1332513
var NavLink = function (_React$Component) {
  _inherits(NavLink, _React$Component);

  function NavLink() {
    _classCallCheck(this, NavLink);

    return _possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).apply(this, arguments));
  }

  _createClass(NavLink, [{
    key: 'render',
    value: function render() {
      var isActive = this.context.router.isActive(this.props.to);
      var className = isActive ? 'active' : '';
      return _react2.default.createElement(
        _reactRouter.Link,
        {
          to: this.props.to,
          className: className,
          style: this.props.style
        },
        this.props.children
      );
    }
  }]);

  return NavLink;
}(_react2.default.Component);

NavLink.propTypes = {
  to: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object
};

NavLink.contextTypes = {
  router: _propTypes2.default.object
};

NavLink.defaultProps = {
  style: {}
};

exports.default = NavLink;

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCustomScrollbars = __webpack_require__(2388);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollable = function (_React$Component) {
  _inherits(Scrollable, _React$Component);

  function Scrollable() {
    _classCallCheck(this, Scrollable);

    return _possibleConstructorReturn(this, (Scrollable.__proto__ || Object.getPrototypeOf(Scrollable)).apply(this, arguments));
  }

  _createClass(Scrollable, [{
    key: 'render',
    value: function render() {
      // Must either set a height or set autoHeight=true.
      // https://github.com/malte-wessel/react-custom-scrollbars
      return _react2.default.createElement(
        _reactCustomScrollbars.Scrollbars,
        _extends({
          style: Object.assign({}, {
            display: 'block',
            padding: 0,
            margin: 0,
            height: 200
          }, this.props.style)
        }, this.props),
        this.props.children
      );
    }
  }]);

  return Scrollable;
}(_react2.default.Component);

Scrollable.propTypes = {
  style: _propTypes2.default.object
};

Scrollable.defaultProps = {
  style: {}
};

exports.default = Scrollable;

/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = __webpack_require__(95);

var _TextField2 = _interopRequireDefault(_TextField);

var _utils = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsernameField = function (_React$Component) {
  _inherits(UsernameField, _React$Component);

  function UsernameField(props) {
    _classCallCheck(this, UsernameField);

    var _this = _possibleConstructorReturn(this, (UsernameField.__proto__ || Object.getPrototypeOf(UsernameField)).call(this, props));

    _this.username = null;
    _this.state = {
      username: null,
      error: null
    };
    return _this;
  }

  _createClass(UsernameField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.usernameDuplicate) {
        this.setErrorMessage('Username is already taken. Please choose another.');
      } else if (nextProps.otherError) {
        this.setErrorMessage('There was an error saving your username. Please try again later.');
      }
    }
  }, {
    key: 'hasValue',
    value: function hasValue() {
      return this.username.input && this.username.input.value && this.username.input.value.trim();
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      if (this.hasValue) {
        return this.username.input.value.trim();
      }
      return null;
    }
  }, {
    key: 'setErrorMessage',
    value: function setErrorMessage(message) {
      this.setState({
        error: message
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (this.hasValue()) {
        var username = this.username.input.value.trim();
        var isValid = (0, _utils.validateUsername)(username);
        if (!isValid) {
          if (username.length < 2) {
            this.setErrorMessage('Must be at least two characters.');
          } else {
            this.setErrorMessage('Username is invalid.');
          }
        } else {
          this.setErrorMessage(null);
        }
        return isValid;
      } else {
        this.setErrorMessage('Must be at least two characters.');
        return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = Object.assign({}, this.props);
      delete props['usernameDuplicate'];
      delete props['otherError'];

      return _react2.default.createElement(_TextField2.default, _extends({
        id: 'username-input',
        'data-test-id': 'username-field-text-input',
        ref: function ref(input) {
          _this2.username = input;
        },
        floatingLabelText: _react2.default.createElement(
          'span',
          null,
          'Username'
        )
      }, props, {
        errorText: this.state.error }));
    }
  }]);

  return UsernameField;
}(_react2.default.Component);

UsernameField.propTypes = {
  usernameDuplicate: _propTypes2.default.bool,
  otherError: _propTypes2.default.bool
};

UsernameField.defaultProps = {
  usernameDuplicate: false,
  otherError: false
};

exports.default = UsernameField;

/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _logo = __webpack_require__(1761);

var _logo2 = _interopRequireDefault(_logo);

var _logoWhite = __webpack_require__(1759);

var _logoWhite2 = _interopRequireDefault(_logoWhite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoWithText = function (_React$Component) {
  _inherits(LogoWithText, _React$Component);

  function LogoWithText() {
    _classCallCheck(this, LogoWithText);

    return _possibleConstructorReturn(this, (LogoWithText.__proto__ || Object.getPrototypeOf(LogoWithText)).apply(this, arguments));
  }

  _createClass(LogoWithText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          style = _props.style;

      var finalStyle = Object.assign({}, {
        height: 40
      }, style);
      var logo = color === 'purple' ? _logo2.default : _logoWhite2.default;
      return _react2.default.createElement('img', { style: finalStyle, src: logo, alt: 'Tab for a Cause logo' });
    }
  }]);

  return LogoWithText;
}(_react2.default.Component);

LogoWithText.props = {
  style: _propTypes2.default.object,
  color: _propTypes2.default.oneOf(['purple', 'white'])
};

LogoWithText.defaultProps = {
  style: {},
  color: 'purple'
};

exports.default = LogoWithText;

/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(81);

var _DashboardPopover = __webpack_require__(567);

var _DashboardPopover2 = _interopRequireDefault(_DashboardPopover);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _navigation = __webpack_require__(50);

var _reactSparkle = __webpack_require__(2459);

var _reactSparkle2 = _interopRequireDefault(_reactSparkle);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoneyRaised = function (_React$Component) {
  _inherits(MoneyRaised, _React$Component);

  function MoneyRaised(props) {
    _classCallCheck(this, MoneyRaised);

    var _this = _possibleConstructorReturn(this, (MoneyRaised.__proto__ || Object.getPrototypeOf(MoneyRaised)).call(this, props));

    _this.timer = 0;
    _this.state = {
      amountDonated: 0,
      hovering: false,
      open: false
    };
    return _this;
  }

  _createClass(MoneyRaised, [{
    key: 'incrementAmount',
    value: function incrementAmount() {
      var latestAmountRaised = this.state.amountDonated;
      var newAmountRaisedRounded = +(latestAmountRaised + 0.01).toFixed(2);
      this.setState({
        amountDonated: newAmountRaisedRounded
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setCounter(this.props.app);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.app && nextProps.app) {
        this.setCounter(nextProps.app);
      }
    }
  }, {
    key: 'setCounter',
    value: function setCounter(app) {
      if (!app) {
        return;
      }

      var secondsInDay = 864;
      // Recalculate based on time that elapsed since the base amount.
      var moneyRaised = app.moneyRaised;
      var dollarsPerDayRate = app.dollarsPerDayRate;
      var secondsPerPenny = secondsInDay / dollarsPerDayRate;

      this.setState({
        amountDonated: moneyRaised
      });

      if (!(secondsPerPenny <= 0)) {
        var millisecondsPerPenny = Math.round(Math.abs(secondsPerPenny) * 1000);
        this.timer = setInterval(this.incrementAmount.bind(this), millisecondsPerPenny);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'onHover',
    value: function onHover(hovering) {
      this.setState({
        hover: hovering
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(event) {
      if (this.celebratingMilestone()) {
        this.props.launchFireworks(true);
      } else {
        this.setState({
          open: !this.state.open,
          anchorEl: event.currentTarget
        });
      }
    }
  }, {
    key: 'handlePopoverRequestClose',
    value: function handlePopoverRequestClose() {
      this.setState({
        open: false
      });
    }

    // Returns boolean, whether we're drawing attention to the current
    // amount raised

  }, {
    key: 'celebratingMilestone',
    value: function celebratingMilestone() {
      var milestoneStart = 5e5;
      var milestoneEnd = 5.03e5;
      return this.state.amountDonated >= milestoneStart && this.state.amountDonated < milestoneEnd;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.app) {
        return null;
      }

      var celebrateMilestone = this.celebratingMilestone();
      var milestoneMoneyRaisedColor = '#FFEBA2';

      var containerStyle = {
        position: 'relative',
        userSelect: 'none',
        cursor: 'default'
      };
      var popoverStyle = {
        width: 180
      };
      var buttonContainerStyle = {
        textAlign: 'center'
      };
      var textStyle = Object.assign({}, {
        color: celebrateMilestone ? milestoneMoneyRaisedColor : this.state.hover ? _default.dashboardIconActiveColor : _default.dashboardIconInactiveColor,
        transition: 'color 300ms ease-in',
        cursor: 'pointer',
        fontSize: 18,
        fontFamily: _default2.default.fontFamily,
        fontWeight: 'normal'
      }, this.props.style);

      var moneyRaised = this.state.amountDonated;
      var amountDonated = '$' + (0, _utils.commaFormatted)((0, _utils.currencyFormatted)(moneyRaised));

      return _react2.default.createElement(
        'div',
        {
          onClick: this.onClick.bind(this),
          onMouseEnter: this.onHover.bind(this, true),
          onMouseLeave: this.onHover.bind(this, false),
          style: containerStyle },
        _react2.default.createElement(
          'span',
          {
            style: textStyle },
          amountDonated
        ),
        celebrateMilestone ? _react2.default.createElement(_reactSparkle2.default, {
          color: milestoneMoneyRaisedColor,
          count: 18,
          fadeOutSpeed: 40,
          overflowPx: 14,
          flicker: false
        }) : null,
        _react2.default.createElement(
          _DashboardPopover2.default,
          {
            style: popoverStyle,
            open: this.state.open,
            anchorEl: this.state.anchorEl,
            onRequestClose: this.handlePopoverRequestClose.bind(this) },
          _react2.default.createElement(
            'div',
            { style: { padding: 10, paddingTop: 0 } },
            _react2.default.createElement(
              'p',
              null,
              'This is how much money Tabbers have raised for charity.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Recruit your friends to raise more!'
            ),
            _react2.default.createElement(
              'div',
              { style: buttonContainerStyle },
              _react2.default.createElement(_RaisedButton2.default, {
                label: 'Invite Friends',
                primary: true,
                onClick: _navigation.goToInviteFriends,
                labelStyle: {
                  fontSize: 13
                }
              })
            )
          )
        )
      );
    }
  }]);

  return MoneyRaised;
}(_react2.default.Component);

MoneyRaised.propTypes = {
  app: _propTypes2.default.shape({
    moneyRaised: _propTypes2.default.number.isRequired,
    dollarsPerDayRate: _propTypes2.default.number.isRequired
  }),
  style: _propTypes2.default.object,
  launchFireworks: _propTypes2.default.func
};

MoneyRaised.defaultProps = {
  style: {},
  launchFireworks: function launchFireworks() {}
};

exports.default = MoneyRaised;

/***/ }),

/***/ 1283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _MoneyRaisedComponent = __webpack_require__(1282);

var _MoneyRaisedComponent2 = _interopRequireDefault(_MoneyRaisedComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_MoneyRaisedComponent2.default, {
  app: function app() {
    return __webpack_require__(1284);
  }
});

/***/ }),

/***/ 1284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MoneyRaisedContainer_app$ref: FragmentReference;
export type MoneyRaisedContainer_app = {|
  +moneyRaised: ?number,
  +dollarsPerDayRate: ?number,
  +$refType: MoneyRaisedContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "MoneyRaisedContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "moneyRaised",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "dollarsPerDayRate",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '8d58b1350b6477d8ee290add8e1d271f';
module.exports = node;

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(79);

var _Input = __webpack_require__(274);

var _Input2 = _interopRequireDefault(_Input);

var _IconButton = __webpack_require__(542);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _InputAdornment = __webpack_require__(1091);

var _InputAdornment2 = _interopRequireDefault(_InputAdornment);

var _Search = __webpack_require__(1174);

var _Search2 = _interopRequireDefault(_Search);

var _Tabs = __webpack_require__(1131);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Tab = __webpack_require__(1126);

var _Tab2 = _interopRequireDefault(_Tab);

var _featureFlags = __webpack_require__(234);

var _navigation = __webpack_require__(50);

var _LogoWithText = __webpack_require__(571);

var _LogoWithText2 = _interopRequireDefault(_LogoWithText);

var _utils = __webpack_require__(81);

var _SearchResults = __webpack_require__(1287);

var _SearchResults2 = _interopRequireDefault(_SearchResults);

var _Footer = __webpack_require__(1276);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var searchBoxBorderColor = '#ced4da';
var searchBoxBorderColorFocused = '#bdbdbd';

var styles = function styles(theme) {
  return {
    inputRootStyle: {
      padding: 0,
      borderRadius: 28,
      backgroundColor: theme.palette.common.white,
      border: '1px solid ' + searchBoxBorderColor,
      fontSize: 16,
      boxShadow: '0rem 0rem 0.02rem 0.02rem rgba(0, 0, 0, 0.1)',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:hover': {
        borderColor: searchBoxBorderColorFocused,
        boxShadow: '0rem 0.05rem 0.2rem 0.05rem rgba(0, 0, 0, 0.1)'
      }
    },
    inputRootFocused: {
      borderColor: searchBoxBorderColorFocused,
      boxShadow: '0rem 0.05rem 0.2rem 0.05rem rgba(0, 0, 0, 0.1)'
    },
    inputStyle: {
      padding: '12px 16px'
    },
    tabsContainerRootStyle: {
      minHeight: 0
    },
    tabRootStyle: {
      color: '#505050', // Same as search result description
      minHeight: 34,
      minWidth: 10
    }
  };
};

var SearchPage = function (_React$Component) {
  _inherits(SearchPage, _React$Component);

  function SearchPage(props) {
    _classCallCheck(this, SearchPage);

    var _this = _possibleConstructorReturn(this, (SearchPage.__proto__ || Object.getPrototypeOf(SearchPage)).call(this, props));

    _this.state = {
      searchFeatureEnabled: (0, _featureFlags.isSearchPageEnabled)(),
      searchText: ''
    };
    return _this;
  }

  _createClass(SearchPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.state.searchFeatureEnabled) {
        (0, _navigation.goTo)(_navigation.dashboardURL);
      }
    }
  }, {
    key: 'getSearchQueryDecoded',
    value: function getSearchQueryDecoded() {
      var location = this.props.location;

      return (0, _utils.parseUrlSearchString)(location.search).q;
    }
  }, {
    key: 'search',
    value: function search() {
      var newQuery = this.state.searchText;
      if (newQuery) {
        (0, _navigation.modifyURLParams)({
          q: newQuery
        });
      }
    }
  }, {
    key: 'onSearchTextChange',
    value: function onSearchTextChange(e) {
      this.setState({
        searchText: e.target.value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;

      var query = this.getSearchQueryDecoded();
      var queryEncoded = query ? encodeURI(query) : '';
      var searchResultsPaddingLeft = 170;
      if (!this.state.searchFeatureEnabled) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        {
          'data-test-id': 'search-page',
          style: {
            backgroundColor: '#fff',
            minWidth: '100vw',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column'
          }
        },
        _react2.default.createElement(
          'div',
          {
            style: {
              backgroundColor: '#fff',
              borderBottom: '1px solid #e4e4e4'
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                padding: '20px 18px 6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start'
              }
            },
            _react2.default.createElement(_LogoWithText2.default, {
              style: {
                width: 100,
                height: 36
              }
            }),
            _react2.default.createElement(
              'div',
              {
                style: {
                  maxWidth: 600,
                  marginLeft: 30,
                  flex: 1
                }
              },
              _react2.default.createElement(_Input2.default, {
                id: 'search-input',
                type: 'text',
                defaultValue: query,
                onChange: this.onSearchTextChange.bind(this),
                onKeyPress: function onKeyPress(e) {
                  if (e.key === 'Enter') {
                    _this2.search();
                  }
                },
                placeholder: 'Search to raise money for charity...',
                disableUnderline: true,
                fullWidth: true,
                classes: {
                  root: classes.inputRootStyle,
                  input: classes.inputStyle,
                  focused: classes.inputRootFocused
                },
                endAdornment: _react2.default.createElement(
                  _InputAdornment2.default,
                  { position: 'end' },
                  _react2.default.createElement(
                    _IconButton2.default,
                    {
                      'aria-label': 'Search button',
                      onClick: this.search.bind(this)
                    },
                    _react2.default.createElement(_Search2.default, { style: { color: searchBoxBorderColorFocused } })
                  )
                )
              })
            )
          ),
          _react2.default.createElement(
            _Tabs2.default,
            {
              value: 0,
              indicatorColor: 'secondary',
              style: {
                marginTop: 8,
                marginLeft: 149
              },
              classes: {
                root: classes.tabsContainerRootStyle
              }
            },
            _react2.default.createElement(_Tab2.default, { label: 'Web',
              classes: {
                root: classes.tabRootStyle
              }
            }),
            _react2.default.createElement(_Tab2.default, {
              label: 'Images',
              target: '_top',
              href: queryEncoded ? 'https://www.google.com/search?q=' + queryEncoded + '&tbm=isch' : 'https://images.google.com',
              classes: {
                root: classes.tabRootStyle
              }
            }),
            _react2.default.createElement(_Tab2.default, {
              label: 'News',
              target: '_top',
              href: queryEncoded ? 'https://www.google.com/search?q=' + queryEncoded + '&tbm=nws' : 'https://www.google.com',
              classes: {
                root: classes.tabRootStyle
              }
            }),
            _react2.default.createElement(_Tab2.default, {
              label: 'Videos',
              target: '_top',
              href: queryEncoded ? 'https://www.google.com/search?q=' + queryEncoded + '&tbm=vid' : 'https://www.google.com',
              classes: {
                root: classes.tabRootStyle
              }
            }),
            _react2.default.createElement(_Tab2.default, {
              label: 'Maps',
              target: '_top',
              href: queryEncoded ? 'https://www.google.com/maps/?q=' + queryEncoded : 'https://www.google.com/maps',
              classes: {
                root: classes.tabRootStyle
              }
            })
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_SearchResults2.default, {
            query: query,
            style: {
              marginLeft: searchResultsPaddingLeft,
              maxWidth: 600,
              paddingTop: 20,
              marginBottom: 40
            }
          })
        ),
        _react2.default.createElement(_Footer2.default, {
          style: {
            marginTop: 'auto'
          }
        })
      );
    }
  }]);

  return SearchPage;
}(_react2.default.Component);

SearchPage.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  location: _propTypes2.default.shape({
    search: _propTypes2.default.string.isRequired
  }),
  // May not exist if the user is not signed in.
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  app: _propTypes2.default.shape({
    // TODO: pass these to the MoneyRaised component
    // moneyRaised: PropTypes.number.isRequired
    // dollarsPerDayRate: PropTypes.number.isRequired
  }).isRequired
};

SearchPage.defaultProps = {};

exports.default = (0, _styles.withStyles)(styles)(SearchPage);

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _SearchPageComponent = __webpack_require__(1285);

var _SearchPageComponent2 = _interopRequireDefault(_SearchPageComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_SearchPageComponent2.default, {
  app: function app() {
    return __webpack_require__(1289);
  },
  user: function user() {
    return __webpack_require__(1290);
  }
});

/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lang = __webpack_require__(107);

var _reactHelmet = __webpack_require__(2411);

var _styles = __webpack_require__(79);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _logger = __webpack_require__(187);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Important: to modify some styles within the iframe, we
// pass an external stylesheet URL to the YPA API below.
// This file lives in web/public/. It does not get a hash
// appended to its filename, so we should rename it when
// it's modified. We should only add CSS to this external
// stylesheet when absolutely necessary.
var searchExternalCSSLink = 'https://tab.gladly.io/newtab/search-2018.29.11.16.35.css';

var styles = function styles(theme) {
  return {
    searchAdsContainer: {
      '& iframe': {
        width: '100%'
      },
      // To address the unnecessary bottom padding in the ads
      // iframe.
      marginBottom: -16
    },
    searchResultsContainer: {
      '& iframe': {
        width: '100%'
      }
    }
  };
};

var backgroundColor = '#fff';
var fontFamily = "'Roboto', arial, sans-serif";
var grey = '#aaa';
var resultStyle = {
  adSpacing: 26,
  lineSpacing: 18,
  title: {
    fontSize: 18,
    color: '#1a0dab',
    underline: false,
    bold: false,
    onHover: {
      color: '#1a0dab',
      underline: true
    }
  },
  description: {
    fontSize: 13,
    color: '#505050',
    underline: false,
    bold: false,
    onHover: {
      color: '#505050',
      underline: false
    }
  },
  URL: {
    fontSize: 13,
    color: '#007526',
    underline: false,
    bold: false,
    onHover: {
      color: '#007526',
      underline: false
    }
  }
};

var templateStyles = {
  AdUnit: {
    backgroundColor: backgroundColor,
    borderColor: backgroundColor,
    lineSpacing: resultStyle.lineSpacing, // valid values: 8-25
    adSpacing: resultStyle.adSpacing, // valid values: 5-30
    font: fontFamily,
    urlAboveDescription: true,
    // How many lines to show the ad on.
    // adLayout: 3,
    // Additional CSS to apply within the YPA iframe.
    cssLink: searchExternalCSSLink
  },
  // The "Ads" label.
  AdUnitLabel: {
    position: 'Top Left',
    fontsize: 11, // valid values: 6-24
    color: grey
  },
  Title: {
    fontsize: resultStyle.title.fontSize,
    color: resultStyle.title.color,
    underline: resultStyle.title.underline,
    bold: resultStyle.title.bold,
    onHover: {
      color: resultStyle.title.onHover.color,
      underline: resultStyle.title.onHover.underline
    }
  },
  Description: {
    fontsize: resultStyle.description.fontSize,
    color: resultStyle.description.color,
    underline: resultStyle.description.underline,
    bold: resultStyle.description.bold,
    onHover: {
      color: resultStyle.description.onHover.color,
      underline: resultStyle.description.onHover.underline
    }
  },
  URL: {
    fontsize: resultStyle.URL.fontSize,
    color: resultStyle.URL.color,
    underline: resultStyle.URL.underline,
    bold: resultStyle.URL.bold,
    onHover: {
      color: resultStyle.URL.onHover.color,
      underline: resultStyle.URL.onHover.underline
    }
  },
  LocalAds: {
    fontsize: resultStyle.description.fontSize,
    color: grey,
    underline: resultStyle.description.underline,
    bold: resultStyle.description.bold,
    onHover: {
      color: resultStyle.description.onHover.color,
      underline: resultStyle.description.onHover.underline
    }
  },
  MerchantRating: {
    fontsize: resultStyle.description.fontSize,
    color: grey,
    underline: resultStyle.description.underline,
    bold: resultStyle.description.bold,
    onHover: {
      color: resultStyle.description.onHover.color,
      underline: resultStyle.description.onHover.underline
    }
  },
  SiteLink: {
    fontsize: resultStyle.description.fontSize,
    color: resultStyle.title.color, // same as title
    underline: resultStyle.description.underline,
    bold: resultStyle.description.bold,
    onHover: {
      // Same as title
      color: resultStyle.title.onHover.color,
      underline: resultStyle.title.onHover.underline
    }
  },
  EnhancedSiteLink: {
    fontsize: resultStyle.description.fontSize,
    color: resultStyle.title.color, // same as title
    underline: resultStyle.description.underline,
    bold: resultStyle.description.bold,
    onHover: {
      // Same as title
      color: resultStyle.title.onHover.color,
      underline: resultStyle.title.onHover.underline
    }
  },
  SmartAnnotations: {
    fontsize: resultStyle.description.fontSize,
    color: grey,
    underline: resultStyle.description.underline,
    bold: resultStyle.description.bold,
    onHover: {
      color: resultStyle.description.onHover.color,
      underline: resultStyle.description.onHover.underline
    }
  },
  ImageInAds: {
    align: 'right',
    size: '50x50'
  },
  OfficialSiteBadge: {
    fontsize: resultStyle.description.fontSize,
    color: backgroundColor,
    backgroundColor: grey
  },
  CallExtension: {
    fontsize: resultStyle.description.fontSize,
    color: resultStyle.title.color, // same as title
    underline: resultStyle.description.underline,
    bold: resultStyle.description.bold,
    onHover: {
      // Same as title
      color: resultStyle.title.onHover.color,
      underline: resultStyle.title.onHover.underline
    }
  }

  /**
   * Call the YPA API to display search results in their iframe.
   * @param {String} query - The search query, unencoded.
   * @param {Function} onNoResults - A callback function that will
   *   be invoked if there are zero results for the search.
   * @return {undefined}
   */
};var fetchSearchResults = function fetchSearchResults() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var onNoResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  var adOptions = {
    // The ad start rank and the ad end rank in the list of
    // search results.
    AdRange: '1-4',
    // Whether to show favicons near ads.
    Favicon: false,
    // Whether to show local ads.
    LocalAds: true,
    // Whether to use the "long ad title".
    Lat: true,
    // Whether to show "site links" in ads.
    SiteLink: true,
    // Whether to show merchant star ratings on ads.
    MerchantRating: true,
    // Whether to show images in ads.
    ImageInAds: false,
    // Whether to show "enhanced site links" in ads.
    EnhancedSiteLink: true,
    // Whether to show "smart annotations" in ads.
    SmartAnnotations: false,
    // Whether to show an "official site badge" next to ads
    // with a verified site.
    OfficialSiteBadge: true,
    // Whether to show an option to call the businesses next
    // to their ads.
    CallExtension: true,
    // Not in YPA documentation. Wheteher to show an
    // advertiser-selected review quote.
    ReviewExtension: false,
    // Not in YPA documentation. Wheteher to show a number
    // of keywords that look mostly unhelpful.
    CalloutExtension: false

    // Fetch search results.
    // Note: YPA mutates objects we pass to it, so make sure to
    // clone everything we pass.
  };window.ypaAds.insertMultiAd({
    ypaPubParams: {
      query: query
    },
    ypaAdTagOptions: {
      adultFilter: false // false means do not allow adult ads
    },
    ypaAdConfig: '00000129a',
    ypaAdTypeTag: '',
    // For now, we'll just show non-personalized ads in the EU:
    // "When gdpr=0 or missing, Oath will perform an IP check on the user
    // to determine jurisdiction. If euconsent is empty, or if the IAB string
    // is missing, Oath will return non-personalized search ads and search web
    // results."
    // gdpr: false
    // euconsent: '',
    ypaAdSlotInfo: [{
      ypaAdSlotId: 'GY_Top_Center',
      ypaAdDivId: 'search-ads',
      ypaAdWidth: '600',
      ypaAdHeight: '891',
      // Callback function for when there are no ads.
      // ypaOnNoAd: foo,
      ypaSlotOptions: {
        AdOptions: {
          Mobile: Object.assign({}, (0, _lang.cloneDeep)(adOptions), {
            AdRange: '1-2'
          }),
          DeskTop: Object.assign({}, (0, _lang.cloneDeep)(adOptions))
        },
        TemplateOptions: {
          Mobile: (0, _lang.cloneDeep)(templateStyles),
          DeskTop: (0, _lang.cloneDeep)(templateStyles)
        }
      }
    }, {
      ypaAdSlotId: 'GY_Algo',
      ypaAdDivId: 'search-results',
      ypaAdWidth: '600',
      ypaAdHeight: '827',
      // Callback function for when there are no search results.
      ypaOnNoAd: onNoResults,
      ypaSlotOptions: {
        TemplateOptions: {
          Mobile: (0, _lang.cloneDeep)(templateStyles),
          DeskTop: (0, _lang.cloneDeep)(templateStyles)
        }
      }
    }]
  });
};

var SearchResults = function (_React$Component) {
  _inherits(SearchResults, _React$Component);

  function SearchResults(props) {
    _classCallCheck(this, SearchResults);

    var _this = _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call(this, props));

    _this.state = {
      noSearchResults: false,
      unexpectedSearchError: false
    };
    return _this;
  }

  _createClass(SearchResults, [{
    key: 'getSearchResults',
    value: function getSearchResults() {
      if (!window.ypaAds) {
        console.error('\n        Search provider Javascript not loaded.\n        Could not fetch search results.');
        this.setState({
          unexpectedSearchError: true
        });
        return;
      }
      var query = this.props.query;

      if (!query) {
        return;
      }

      // Reset state of search results.
      this.setState({
        noSearchResults: false,
        unexpectedSearchError: false
      });

      var self = this;
      try {
        fetchSearchResults(query, function (err) {
          if (err.NO_COVERAGE) {
            // No results for this search.
            self.setState({
              noSearchResults: true
            });
          } else if (err.URL_UNREGISTERED) {
            self.setState({
              unexpectedSearchError: true
            });
            _logger2.default.error(new Error('Domain is not registered with our search partner.'));
          } else {
            self.setState({
              unexpectedSearchError: true
            });
            _logger2.default.error(new Error('Unexpected search error:', err));
          }
        });
      } catch (e) {
        this.setState({
          unexpectedSearchError: true
        });
        _logger2.default.error(e);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.query && this.props.query !== prevProps.query) {
        this.getSearchResults();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          query = _props.query,
          classes = _props.classes,
          style = _props.style;

      return _react2.default.createElement(
        'div',
        {
          'data-test-id': 'search-results-container',
          style: Object.assign({}, {
            // Min height prevents visibly shifting content below,
            // like the footer.
            minHeight: this.state.noSearchResults ? 0 : 1200,
            boxSizing: 'border-box'
          }, style)
        },
        _react2.default.createElement(
          _reactHelmet.Helmet,
          {
            onChangeClientState: function onChangeClientState(newState, addedTags) {
              // Fetch search results after the external JS has loaded.
              // https://github.com/nfl/react-helmet/issues/146#issuecomment-271552211
              // This solution isn't great for page speed when we're not
              // server-rendering this page.
              var self = _this2;
              var scriptTags = addedTags.scriptTags;

              if (scriptTags && scriptTags.length) {
                scriptTags[0].addEventListener('load', function () {
                  self.getSearchResults();
                });
              }
            }
          },
          _react2.default.createElement('script', { src: 'https://s.yimg.com/uv/dm/scripts/syndication.js' }),
          _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500' })
        ),
        _react2.default.createElement(
          'div',
          null,
          this.state.noSearchResults ? _react2.default.createElement(
            _Typography2.default,
            { variant: 'body1', gutterBottom: true },
            'No results found for ',
            _react2.default.createElement(
              'span',
              { style: { fontWeight: 'bold' } },
              query
            )
          ) : null,
          this.state.unexpectedSearchError ? _react2.default.createElement(
            _Typography2.default,
            { variant: 'body1', gutterBottom: true },
            'Unable to search at this time.'
          ) : null,
          _react2.default.createElement('div', {
            id: 'search-ads',
            className: classes.searchAdsContainer
          }),
          _react2.default.createElement('div', {
            id: 'search-results',
            className: classes.searchResultsContainer
          })
        )
      );
    }
  }]);

  return SearchResults;
}(_react2.default.Component);

SearchResults.propTypes = {
  query: _propTypes2.default.string,
  classes: _propTypes2.default.object.isRequired,
  style: _propTypes2.default.object
};

SearchResults.defaultProps = {
  style: {}
};

exports.default = (0, _styles.withStyles)(styles)(SearchResults);

/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _graphql, _graphql2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__(16);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _SearchPageContainer = __webpack_require__(1286);

var _SearchPageContainer2 = _interopRequireDefault(_SearchPageContainer);

var _withUserId = __webpack_require__(570);

var _withUserId2 = _interopRequireDefault(_withUserId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* global graphql */

// Make a different query for anonymous users than for
// authenticated users.
var SearchViewQuery = function SearchViewQuery(props) {
  var userId = props.userId,
      queryRendererProps = _objectWithoutProperties(props, ['userId']);
  if (userId) {
    return _react2.default.createElement(_reactRelay.QueryRenderer, _extends({
      query: _graphql || (_graphql = function _graphql() {
        return __webpack_require__(1292);
      }),
      variables: {
        userId: userId
      }
    }, queryRendererProps));
  } else {
    return _react2.default.createElement(_reactRelay.QueryRenderer, _extends({
      query: _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__(1291);
      })
    }, queryRendererProps));
  }
};

var SearchView = function (_React$Component) {
  _inherits(SearchView, _React$Component);

  function SearchView() {
    _classCallCheck(this, SearchView);

    return _possibleConstructorReturn(this, (SearchView.__proto__ || Object.getPrototypeOf(SearchView)).apply(this, arguments));
  }

  _createClass(SearchView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var userId = this.props.userId;

      return _react2.default.createElement(SearchViewQuery, {
        userId: userId,
        environment: _relayEnv2.default,
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props;

          if (error) {
            console.error(error);
          }
          if (!props) {
            props = {};
          }

          // Require the app data but allow a null user prop.
          if (!props.app) {
            return null;
          }
          var user = props.user || null;
          return _react2.default.createElement(_SearchPageContainer2.default, {
            app: props.app,
            user: user,
            location: _this2.props.location
          });
        } });
    }
  }]);

  return SearchView;
}(_react2.default.Component);

SearchView.propTypes = {
  location: _propTypes2.default.shape({
    search: _propTypes2.default.string.isRequired
  })
};

SearchView.defaultProps = {};

exports.default = (0, _withUserId2.default)({
  renderIfNoUser: true
})(SearchView);

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type MoneyRaisedContainer_app$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchPageContainer_app$ref: FragmentReference;
export type SearchPageContainer_app = {|
  +moneyRaised: ?number,
  +$fragmentRefs: MoneyRaisedContainer_app$ref,
  +$refType: SearchPageContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchPageContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "moneyRaised",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "MoneyRaisedContainer_app",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '32de0e65a1d97d3c2ea4117adbe0c037';
module.exports = node;

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchPageContainer_user$ref: FragmentReference;
export type SearchPageContainer_user = {|
  +id: string,
  +$refType: SearchPageContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchPageContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '112aa941f43fb99044f849263d733265';
module.exports = node;

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4d7df6d8cda7c81d86b2e870db66068f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchPageContainer_app$ref = any;
export type SearchViewAnonymousQueryVariables = {||};
export type SearchViewAnonymousQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: SearchPageContainer_app$ref
  |}
|};
export type SearchViewAnonymousQuery = {|
  variables: SearchViewAnonymousQueryVariables,
  response: SearchViewAnonymousQueryResponse,
|};
*/

/*
query SearchViewAnonymousQuery {
  app {
    ...SearchPageContainer_app
    id
  }
}

fragment SearchPageContainer_app on App {
  moneyRaised
  ...MoneyRaisedContainer_app
}

fragment MoneyRaisedContainer_app on App {
  moneyRaised
  dollarsPerDayRate
}
*/

var node /*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "SearchViewAnonymousQuery",
  "id": null,
  "text": "query SearchViewAnonymousQuery {\n  app {\n    ...SearchPageContainer_app\n    id\n  }\n}\n\nfragment SearchPageContainer_app on App {\n  moneyRaised\n  ...MoneyRaisedContainer_app\n}\n\nfragment MoneyRaisedContainer_app on App {\n  moneyRaised\n  dollarsPerDayRate\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SearchViewAnonymousQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "app",
      "storageKey": null,
      "args": null,
      "concreteType": "App",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "SearchPageContainer_app",
        "args": null
      }]
    }]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchViewAnonymousQuery",
    "argumentDefinitions": [],
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "app",
      "storageKey": null,
      "args": null,
      "concreteType": "App",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "moneyRaised",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "dollarsPerDayRate",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }
};
// prettier-ignore
node /*: any*/.hash = '20163436c37da419f9bc157fd05f9919';
module.exports = node;

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ab3c34119f97d078aa6a151c3ad87286
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchPageContainer_app$ref = any;
type SearchPageContainer_user$ref = any;
export type SearchViewQueryVariables = {|
  userId: string
|};
export type SearchViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: SearchPageContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: SearchPageContainer_user$ref
  |},
|};
export type SearchViewQuery = {|
  variables: SearchViewQueryVariables,
  response: SearchViewQueryResponse,
|};
*/

/*
query SearchViewQuery(
  $userId: String!
) {
  app {
    ...SearchPageContainer_app
    id
  }
  user(userId: $userId) {
    ...SearchPageContainer_user
    id
  }
}

fragment SearchPageContainer_app on App {
  moneyRaised
  ...MoneyRaisedContainer_app
}

fragment SearchPageContainer_user on User {
  id
}

fragment MoneyRaisedContainer_app on App {
  moneyRaised
  dollarsPerDayRate
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "SearchViewQuery",
    "id": null,
    "text": "query SearchViewQuery(\n  $userId: String!\n) {\n  app {\n    ...SearchPageContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...SearchPageContainer_user\n    id\n  }\n}\n\nfragment SearchPageContainer_app on App {\n  moneyRaised\n  ...MoneyRaisedContainer_app\n}\n\nfragment SearchPageContainer_user on User {\n  id\n}\n\nfragment MoneyRaisedContainer_app on App {\n  moneyRaised\n  dollarsPerDayRate\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SearchViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "SearchPageContainer_app",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "SearchPageContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SearchViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "moneyRaised",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "dollarsPerDayRate",
          "args": null,
          "storageKey": null
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f868bc12382c2dc381d46732c7f0fd00';
module.exports = node;

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(111);

var _Paper2 = _interopRequireDefault(_Paper);

var _Divider = __webpack_require__(368);

var _Divider2 = _interopRequireDefault(_Divider);

var _Typography = __webpack_require__(73);

var _Typography2 = _interopRequireDefault(_Typography);

var _Button = __webpack_require__(227);

var _Button2 = _interopRequireDefault(_Button);

var _clientLocation = __webpack_require__(232);

var _consentManagement = __webpack_require__(379);

var _LogConsentDataContainer = __webpack_require__(568);

var _LogConsentDataContainer2 = _interopRequireDefault(_LogConsentDataContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var AccountItem = exports.AccountItem = function AccountItem(props) {
  return _react2.default.createElement(
    'div',
    { style: {
        display: 'flex',
        alignItems: 'center',
        padding: 20
      }
    },
    _react2.default.createElement(
      _Typography2.default,
      {
        variant: 'body2',
        style: { flex: 1, fontWeight: 'bold' }
      },
      props.name
    ),
    props.value ? _react2.default.createElement(
      _Typography2.default,
      {
        variant: 'body2',
        style: { flex: 2 }
      },
      props.value
    ) : null,
    props.actionButton ? _react2.default.createElement(
      'div',
      { style: { flex: 2 } },
      props.actionButton
    ) : null
  );
};

AccountItem.propTypes = {
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  actionButton: _propTypes2.default.element
};

var Account = function (_React$Component) {
  _inherits(Account, _React$Component);

  function Account(props) {
    _classCallCheck(this, Account);

    var _this2 = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, props));

    _this2.state = {
      showDataPrivacyOption: false
    };
    return _this2;
  }

  _createClass(Account, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var isInEU;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _clientLocation.isInEuropeanUnion)();

              case 3:
                isInEU = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

                isInEU = false;

              case 9:
                if (isInEU) {
                  _this.setState({
                    showDataPrivacyOption: true
                  });
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 6]]);
      }))();
    }
  }, {
    key: 'reviewDataPrivacy',
    value: function reviewDataPrivacy() {
      (0, _consentManagement.displayConsentUI)();
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      return _react2.default.createElement(
        _Paper2.default,
        null,
        _react2.default.createElement(
          _Typography2.default,
          { variant: 'h5', style: { padding: 20 } },
          'Account'
        ),
        _react2.default.createElement(_Divider2.default, null),
        _react2.default.createElement(AccountItem, { name: 'Username', value: user.username ? user.username : 'Not signed in' }),
        _react2.default.createElement(_Divider2.default, null),
        _react2.default.createElement(AccountItem, { name: 'Email', value: user.email ? user.email : 'Not signed in' }),
        this.state.showDataPrivacyOption ? _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_Divider2.default, null),
          _react2.default.createElement(AccountItem, {
            name: 'Data privacy choices',
            actionButton: _react2.default.createElement(
              _Button2.default,
              {
                color: 'primary',
                variant: 'raised',
                onClick: this.reviewDataPrivacy
              },
              'Review choices'
            )
          }),
          user ? _react2.default.createElement(_LogConsentDataContainer2.default, { user: user }) : null
        ) : null
      );
    }
  }]);

  return Account;
}(_react2.default.Component);

Account.propTypes = {
  user: _propTypes2.default.shape({
    email: _propTypes2.default.string,
    username: _propTypes2.default.string
  })
};

exports.default = Account;

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _AccountComponent = __webpack_require__(1293);

var _AccountComponent2 = _interopRequireDefault(_AccountComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_AccountComponent2.default, {
  user: function user() {
    return __webpack_require__(1296);
  }
});

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql; /* global graphql */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(16);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _SettingsChildWrapperComponent = __webpack_require__(186);

var _SettingsChildWrapperComponent2 = _interopRequireDefault(_SettingsChildWrapperComponent);

var _AccountContainer = __webpack_require__(1294);

var _AccountContainer2 = _interopRequireDefault(_AccountContainer);

var _AuthUserComponent = __webpack_require__(149);

var _AuthUserComponent2 = _interopRequireDefault(_AuthUserComponent);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountView = function (_React$Component) {
  _inherits(AccountView, _React$Component);

  function AccountView() {
    _classCallCheck(this, AccountView);

    return _possibleConstructorReturn(this, (AccountView.__proto__ || Object.getPrototypeOf(AccountView)).apply(this, arguments));
  }

  _createClass(AccountView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _AuthUserComponent2.default,
        null,
        _react2.default.createElement(_reactRelay.QueryRenderer, {
          environment: _relayEnv2.default,
          query: _graphql || (_graphql = function _graphql() {
            return __webpack_require__(1297);
          }),
          render: function render(_ref) {
            var error = _ref.error,
                props = _ref.props;

            if (error) {
              console.error(error, error.source);
              var errMsg = 'We had a problem loading your account :(';
              return _react2.default.createElement(_ErrorMessage2.default, { message: errMsg });
            }
            var showError = _this2.props.showError;
            var dataLoaded = !!props;
            return _react2.default.createElement(
              _SettingsChildWrapperComponent2.default,
              { loaded: dataLoaded },
              dataLoaded ? _react2.default.createElement(_AccountContainer2.default, {
                user: props.user,
                showError: showError }) : null
            );
          } })
      );
    }
  }]);

  return AccountView;
}(_react2.default.Component);

exports.default = AccountView;

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type LogConsentDataContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AccountContainer_user$ref: FragmentReference;
export type AccountContainer_user = {|
  +id: string,
  +email: ?string,
  +username: ?string,
  +$fragmentRefs: LogConsentDataContainer_user$ref,
  +$refType: AccountContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "AccountContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "username",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "LogConsentDataContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '9fa403edf6ae91c333f625b09a99e561';
module.exports = node;

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 74923a281afcab5b250629a33abe4bf4
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type AccountContainer_user$ref = any;
export type AccountViewQueryVariables = {|
  userId: string
|};
export type AccountViewQueryResponse = {|
  +user: ?{|
    +$fragmentRefs: AccountContainer_user$ref
  |}
|};
export type AccountViewQuery = {|
  variables: AccountViewQueryVariables,
  response: AccountViewQueryResponse,
|};
*/

/*
query AccountViewQuery(
  $userId: String!
) {
  user(userId: $userId) {
    ...AccountContainer_user
    id
  }
}

fragment AccountContainer_user on User {
  id
  email
  username
  ...LogConsentDataContainer_user
}

fragment LogConsentDataContainer_user on User {
  id
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "AccountViewQuery",
    "id": null,
    "text": "query AccountViewQuery(\n  $userId: String!\n) {\n  user(userId: $userId) {\n    ...AccountContainer_user\n    id\n  }\n}\n\nfragment AccountContainer_user on User {\n  id\n  email\n  username\n  ...LogConsentDataContainer_user\n}\n\nfragment LogConsentDataContainer_user on User {\n  id\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "AccountViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "AccountContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "AccountViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "username",
          "args": null,
          "storageKey": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '79a617f710f43d30bb2e1829480e9689';
module.exports = node;

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _object = __webpack_require__(212);

var _RadioButton = __webpack_require__(478);

var _Divider = __webpack_require__(258);

var _Divider2 = _interopRequireDefault(_Divider);

var _Card = __webpack_require__(471);

var _BackgroundImagePickerContainer = __webpack_require__(1229);

var _BackgroundImagePickerContainer2 = _interopRequireDefault(_BackgroundImagePickerContainer);

var _BackgroundColorPickerContainer = __webpack_require__(1225);

var _BackgroundColorPickerContainer2 = _interopRequireDefault(_BackgroundColorPickerContainer);

var _BackgroundCustomImagePickerContainer = __webpack_require__(1227);

var _BackgroundCustomImagePickerContainer2 = _interopRequireDefault(_BackgroundCustomImagePickerContainer);

var _default = __webpack_require__(44);

var _localBkgSettings = __webpack_require__(576);

var _constants = __webpack_require__(46);

var _SetBackgroundImageMutation = __webpack_require__(1394);

var _SetBackgroundImageMutation2 = _interopRequireDefault(_SetBackgroundImageMutation);

var _SetBackgroundColorMutation = __webpack_require__(1392);

var _SetBackgroundColorMutation2 = _interopRequireDefault(_SetBackgroundColorMutation);

var _SetBackgroundCustomImageMutation = __webpack_require__(1393);

var _SetBackgroundCustomImageMutation2 = _interopRequireDefault(_SetBackgroundCustomImageMutation);

var _SetBackgroundDailyImageMutation = __webpack_require__(575);

var _SetBackgroundDailyImageMutation2 = _interopRequireDefault(_SetBackgroundDailyImageMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundSettings = function (_React$Component) {
  _inherits(BackgroundSettings, _React$Component);

  function BackgroundSettings(props) {
    _classCallCheck(this, BackgroundSettings);

    var _this = _possibleConstructorReturn(this, (BackgroundSettings.__proto__ || Object.getPrototypeOf(BackgroundSettings)).call(this, props));

    _this.defaultSelection = _constants.USER_BACKGROUND_OPTION_PHOTO;

    _this.state = {
      selected: props.user.backgroundOption || _this.defaultSelection
    };
    return _this;
  }

  _createClass(BackgroundSettings, [{
    key: 'onChange',
    value: function onChange(event, backgroundOption) {
      if (!backgroundOption) {
        return;
      }
      this.setState({
        selected: backgroundOption
      });
      this.updateLocalStorageBackgroundSettings(backgroundOption);

      // We expect each background selection component to call its
      // data callbacks immediately on mount, which will save the
      // user's selection. The daily photo option does not have a
      // selection component, so we update the user's settings here.
      if (backgroundOption === _constants.USER_BACKGROUND_OPTION_DAILY) {
        this.onDailyPhotoOptionSelected();
      }
    }

    /**
     * Update localStorage and extension storage with the chosen background
     * settings. If a value is not provided, we use the current value from
     * props.
     * @param {string} backgroundOption - The value of the user's background
     *   option; one of 'custom', 'photo', 'daily', or 'color'
     * @return {undefined}
     */

  }, {
    key: 'updateLocalStorageBackgroundSettings',
    value: function updateLocalStorageBackgroundSettings() {
      var backgroundOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var customImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var backgroundColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var backgroundImageURL = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      (0, _localBkgSettings.setBackgroundSettings)(backgroundOption || this.props.user.backgroundOption, customImage || this.props.user.customImage, backgroundColor || this.props.user.backgroundColor, backgroundImageURL || this.props.user.backgroundImage.imageURL);
    }

    /**
     * Handler for when the user selects a specific background image.
     * Update database and localStorage.
     * @param {Object} image - The image object
     * @param {string} image.id - The image ID
     * @param {string} image.name - The image's display name
     * @param {string} image.imageURL - The image URL
     * @param {string} image.thumbnailURL - The image's thumbnail URL
     * @return {undefined}
     */

  }, {
    key: 'onBackgroundImageSelection',
    value: function onBackgroundImageSelection(image) {
      _SetBackgroundImageMutation2.default.commit(this.props.relay.environment, this.props.user, image, this.onSaveSuccess.bind(this), this.onSaveError.bind(this));
      this.updateLocalStorageBackgroundSettings(_constants.USER_BACKGROUND_OPTION_PHOTO, null, null, image.imageURL);
    }

    /**
     * Handler for when the user selects a specific color. Update
     * database and localStorage.
     * @param {string} color - The color hex value
     * @return {undefined}
     */

  }, {
    key: 'onBackgroundColorSelection',
    value: function onBackgroundColorSelection(color) {
      _SetBackgroundColorMutation2.default.commit(this.props.relay.environment, this.props.user, color, this.onSaveSuccess.bind(this), this.onSaveError.bind(this));
      this.updateLocalStorageBackgroundSettings(_constants.USER_BACKGROUND_OPTION_COLOR, null, color, null);
    }

    /**
     * Handler for when the user selects a specific custom image.
     * Update database and localStorage.
     * @param {string} imgURL - The custom image's URL
     * @return {undefined}
     */

  }, {
    key: 'onCustomImageSelection',
    value: function onCustomImageSelection(imgURL) {
      _SetBackgroundCustomImageMutation2.default.commit(this.props.relay.environment, this.props.user, imgURL, this.onSaveSuccess.bind(this), this.onSaveError.bind(this));
      this.updateLocalStorageBackgroundSettings(_constants.USER_BACKGROUND_OPTION_CUSTOM, imgURL, null, null);
    }

    /**
     * Handler for when the user selects a new photo daily.
     * Update database and localStorage.
     * @return {undefined}
     */

  }, {
    key: 'onDailyPhotoOptionSelected',
    value: function onDailyPhotoOptionSelected() {
      var _this2 = this;

      (0, _SetBackgroundDailyImageMutation2.default)(this.props.relay.environment, this.props.user.id, function (data) {
        // Update the image URL in localStorage when the new daily
        // image returns. However, we need to make sure we don't
        // overwrite the value if the user chooses a custom or
        // selected photo before the server responds.
        if (_this2.state.selected !== _constants.USER_BACKGROUND_OPTION_DAILY) {
          return;
        }
        var newImgURL = (0, _object.get)(data, 'setUserBkgDailyImage.user.backgroundImage.imageURL');
        _this2.updateLocalStorageBackgroundSettings(_constants.USER_BACKGROUND_OPTION_DAILY, null, null, newImgURL);
      }, this.onSaveError.bind(this));

      this.updateLocalStorageBackgroundSettings(_constants.USER_BACKGROUND_OPTION_DAILY, null, null, null);
    }
  }, {
    key: 'onSaveSuccess',
    value: function onSaveSuccess() {}
  }, {
    key: 'onSaveError',
    value: function onSaveError() {
      this.props.showError('Oops, we are having trouble saving your settings right now :(');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          app = _props.app,
          user = _props.user,
          showError = _props.showError;

      if (!this.state.selected) {
        return null;
      }

      var optionContainer = {
        padding: 10
      };
      var divider = {
        marginTop: 24,
        marginBottom: 8
      };
      var radioBtnGroupStyle = {
        marginLeft: 4,
        width: 220
      };
      var radioBtnStyle = {
        marginBottom: 6,
        fontSize: 14
      };
      var cardBody = {
        padding: 10
      };

      var backgroundPicker;
      var dividerCmp = _react2.default.createElement(_Divider2.default, { style: divider });

      // These components display below the radio buttons when
      // an option is selected.
      switch (this.state.selected) {
        case _constants.USER_BACKGROUND_OPTION_DAILY:
          dividerCmp = null;
          backgroundPicker = null;
          break;
        case _constants.USER_BACKGROUND_OPTION_CUSTOM:
          // We expect this to call `onCustomImageSelection` on mount.
          backgroundPicker = _react2.default.createElement(_BackgroundCustomImagePickerContainer2.default, {
            user: user,
            onCustomImageSelection: this.onCustomImageSelection.bind(this),
            showError: showError
          });
          break;
        case _constants.USER_BACKGROUND_OPTION_COLOR:
          // We expect this to call `onBackgroundColorSelection` on mount.
          backgroundPicker = _react2.default.createElement(_BackgroundColorPickerContainer2.default, {
            user: user,
            onBackgroundColorSelection: this.onBackgroundColorSelection.bind(this)
          });
          break;
        case _constants.USER_BACKGROUND_OPTION_PHOTO:
          // We expect this to call `onBackgroundImageSelection` on mount.
          backgroundPicker = _react2.default.createElement(_BackgroundImagePickerContainer2.default, {
            app: app,
            user: user,
            onBackgroundImageSelection: this.onBackgroundImageSelection.bind(this)
          });
          break;
        default:
          // Fall back to selecting the photo option.
          backgroundPicker = _react2.default.createElement(_BackgroundImagePickerContainer2.default, {
            app: app,
            user: user,
            onBackgroundImageSelection: this.onBackgroundImageSelection.bind(this)
          });
          break;
      }

      return _react2.default.createElement(
        _Card.Card,
        {
          style: optionContainer },
        _react2.default.createElement(_Card.CardHeader, {
          title: 'Background',
          titleStyle: _default.cardHeaderTitleStyle,
          subtitleStyle: _default.cardHeaderSubtitleStyle,
          actAsExpander: false,
          showExpandableButton: false }),
        _react2.default.createElement(
          'div',
          { style: cardBody },
          _react2.default.createElement(
            _RadioButton.RadioButtonGroup,
            {
              style: radioBtnGroupStyle,
              onChange: this.onChange.bind(this),
              name: 'photoModes',
              valueSelected: this.state.selected },
            _react2.default.createElement(_RadioButton.RadioButton, {
              style: radioBtnStyle,
              value: _constants.USER_BACKGROUND_OPTION_DAILY,
              label: 'New photo daily' }),
            _react2.default.createElement(_RadioButton.RadioButton, {
              style: radioBtnStyle,
              value: _constants.USER_BACKGROUND_OPTION_PHOTO,
              label: 'Selected photo' }),
            _react2.default.createElement(_RadioButton.RadioButton, {
              style: radioBtnStyle,
              value: _constants.USER_BACKGROUND_OPTION_CUSTOM,
              label: 'Custom photo' }),
            _react2.default.createElement(_RadioButton.RadioButton, {
              style: radioBtnStyle,
              value: _constants.USER_BACKGROUND_OPTION_COLOR,
              label: 'Color' })
          ),
          dividerCmp,
          backgroundPicker
        )
      );
    }
  }]);

  return BackgroundSettings;
}(_react2.default.Component);

BackgroundSettings.propTypes = {
  app: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    backgroundOption: _propTypes2.default.string,
    customImage: _propTypes2.default.string,
    backgroundColor: _propTypes2.default.string,
    backgroundImage: _propTypes2.default.shape({
      imageURL: _propTypes2.default.string
    })
  }),
  showError: _propTypes2.default.func.isRequired,
  relay: _propTypes2.default.shape({
    environment: _propTypes2.default.object.isRequired
  })
};

exports.default = BackgroundSettings;

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _BackgroundSettingsComponent = __webpack_require__(1298);

var _BackgroundSettingsComponent2 = _interopRequireDefault(_BackgroundSettingsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_BackgroundSettingsComponent2.default, {
  user: function user() {
    return __webpack_require__(1302);
  },
  app: function app() {
    return __webpack_require__(1301);
  }
});

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql; /* global graphql */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(16);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _SettingsChildWrapperComponent = __webpack_require__(186);

var _SettingsChildWrapperComponent2 = _interopRequireDefault(_SettingsChildWrapperComponent);

var _BackgroundSettingsContainer = __webpack_require__(1299);

var _BackgroundSettingsContainer2 = _interopRequireDefault(_BackgroundSettingsContainer);

var _AuthUserComponent = __webpack_require__(149);

var _AuthUserComponent2 = _interopRequireDefault(_AuthUserComponent);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundSettingsView = function (_React$Component) {
  _inherits(BackgroundSettingsView, _React$Component);

  function BackgroundSettingsView() {
    _classCallCheck(this, BackgroundSettingsView);

    return _possibleConstructorReturn(this, (BackgroundSettingsView.__proto__ || Object.getPrototypeOf(BackgroundSettingsView)).apply(this, arguments));
  }

  _createClass(BackgroundSettingsView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _AuthUserComponent2.default,
        null,
        _react2.default.createElement(_reactRelay.QueryRenderer, {
          environment: _relayEnv2.default,
          query: _graphql || (_graphql = function _graphql() {
            return __webpack_require__(1303);
          }),
          render: function render(_ref) {
            var error = _ref.error,
                props = _ref.props;

            if (error) {
              console.error(error, error.source);
              var errMsg = 'We had a problem loading the background settings :(';
              return _react2.default.createElement(_ErrorMessage2.default, { message: errMsg });
            }
            var showError = _this2.props.showError;
            var dataLoaded = !!props;
            return _react2.default.createElement(
              _SettingsChildWrapperComponent2.default,
              { loaded: dataLoaded },
              dataLoaded ? _react2.default.createElement(_BackgroundSettingsContainer2.default, {
                app: props.app,
                user: props.user,
                showError: showError }) : null
            );
          } })
      );
    }
  }]);

  return BackgroundSettingsView;
}(_react2.default.Component);

exports.default = BackgroundSettingsView;

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type BackgroundImagePickerContainer_app$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundSettingsContainer_app$ref: FragmentReference;
export type BackgroundSettingsContainer_app = {|
  +$fragmentRefs: BackgroundImagePickerContainer_app$ref,
  +$refType: BackgroundSettingsContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundSettingsContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "FragmentSpread",
    "name": "BackgroundImagePickerContainer_app",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '940de37edc00e37d1865d1b34d1ff688';
module.exports = node;

/***/ }),

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type BackgroundColorPickerContainer_user$ref = any;
type BackgroundCustomImagePickerContainer_user$ref = any;
type BackgroundImagePickerContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundSettingsContainer_user$ref: FragmentReference;
export type BackgroundSettingsContainer_user = {|
  +id: string,
  +backgroundOption: ?string,
  +customImage: ?string,
  +backgroundColor: ?string,
  +backgroundImage: ?{|
    +imageURL: ?string
  |},
  +$fragmentRefs: BackgroundImagePickerContainer_user$ref & BackgroundColorPickerContainer_user$ref & BackgroundCustomImagePickerContainer_user$ref,
  +$refType: BackgroundSettingsContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundSettingsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundOption",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "customImage",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundColor",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "backgroundImage",
    "storageKey": null,
    "args": null,
    "concreteType": "BackgroundImage",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "imageURL",
      "args": null,
      "storageKey": null
    }]
  }, {
    "kind": "FragmentSpread",
    "name": "BackgroundImagePickerContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "BackgroundColorPickerContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "BackgroundCustomImagePickerContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'a05ac9eba9ccf79cfd07d7a6feebad97';
module.exports = node;

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 548c9dbea0050536a38a48085f27c0b9
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type BackgroundSettingsContainer_app$ref = any;
type BackgroundSettingsContainer_user$ref = any;
export type BackgroundSettingsViewQueryVariables = {|
  userId: string
|};
export type BackgroundSettingsViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: BackgroundSettingsContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: BackgroundSettingsContainer_user$ref
  |},
|};
export type BackgroundSettingsViewQuery = {|
  variables: BackgroundSettingsViewQueryVariables,
  response: BackgroundSettingsViewQueryResponse,
|};
*/

/*
query BackgroundSettingsViewQuery(
  $userId: String!
) {
  app {
    ...BackgroundSettingsContainer_app
    id
  }
  user(userId: $userId) {
    ...BackgroundSettingsContainer_user
    id
  }
}

fragment BackgroundSettingsContainer_app on App {
  ...BackgroundImagePickerContainer_app
}

fragment BackgroundSettingsContainer_user on User {
  id
  backgroundOption
  customImage
  backgroundColor
  backgroundImage {
    imageURL
    id
  }
  ...BackgroundImagePickerContainer_user
  ...BackgroundColorPickerContainer_user
  ...BackgroundCustomImagePickerContainer_user
}

fragment BackgroundImagePickerContainer_user on User {
  backgroundImage {
    id
    imageURL
  }
}

fragment BackgroundColorPickerContainer_user on User {
  backgroundColor
}

fragment BackgroundCustomImagePickerContainer_user on User {
  customImage
}

fragment BackgroundImagePickerContainer_app on App {
  backgroundImages(first: 50) {
    edges {
      node {
        id
        name
        imageURL
        thumbnailURL
      }
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "imageURL",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "BackgroundSettingsViewQuery",
    "id": null,
    "text": "query BackgroundSettingsViewQuery(\n  $userId: String!\n) {\n  app {\n    ...BackgroundSettingsContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...BackgroundSettingsContainer_user\n    id\n  }\n}\n\nfragment BackgroundSettingsContainer_app on App {\n  ...BackgroundImagePickerContainer_app\n}\n\nfragment BackgroundSettingsContainer_user on User {\n  id\n  backgroundOption\n  customImage\n  backgroundColor\n  backgroundImage {\n    imageURL\n    id\n  }\n  ...BackgroundImagePickerContainer_user\n  ...BackgroundColorPickerContainer_user\n  ...BackgroundCustomImagePickerContainer_user\n}\n\nfragment BackgroundImagePickerContainer_user on User {\n  backgroundImage {\n    id\n    imageURL\n  }\n}\n\nfragment BackgroundColorPickerContainer_user on User {\n  backgroundColor\n}\n\nfragment BackgroundCustomImagePickerContainer_user on User {\n  customImage\n}\n\nfragment BackgroundImagePickerContainer_app on App {\n  backgroundImages(first: 50) {\n    edges {\n      node {\n        id\n        name\n        imageURL\n        thumbnailURL\n      }\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "BackgroundSettingsViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "BackgroundSettingsContainer_app",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "BackgroundSettingsContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "BackgroundSettingsViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "backgroundImages",
          "storageKey": "backgroundImages(first:50)",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 50,
            "type": "Int"
          }],
          "concreteType": "BackgroundImageConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "BackgroundImageEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "BackgroundImage",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }, v3, {
                "kind": "ScalarField",
                "alias": null,
                "name": "thumbnailURL",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "backgroundOption",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "customImage",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "backgroundColor",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "backgroundImage",
          "storageKey": null,
          "args": null,
          "concreteType": "BackgroundImage",
          "plural": false,
          "selections": [v3, v2]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a493cf5b4093e9ce1e498dc271107391';
module.exports = node;

/***/ }),

/***/ 1304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextField = __webpack_require__(549);

var _TextField2 = _interopRequireDefault(_TextField);

var _styles = __webpack_require__(79);

var _default = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Can replace this with a proper theme after fully migrating to
// material-ui 1.0.
// https://github.com/callemall/material-ui/blob/v1-beta/src/Input/Input.js#L78
var styles = function styles(theme) {
  return {
    inputUnderline: {
      '&:after': {
        borderColor: _default.alternateAccentColor
      }
    },
    formLabelRoot: {
      '&$formLabelFocused': {
        color: _default.alternateAccentColor
      }
    },
    formLabelFocused: {}
  };
};

var InviteFriend = function (_React$Component) {
  _inherits(InviteFriend, _React$Component);

  function InviteFriend() {
    _classCallCheck(this, InviteFriend);

    return _possibleConstructorReturn(this, (InviteFriend.__proto__ || Object.getPrototypeOf(InviteFriend)).apply(this, arguments));
  }

  _createClass(InviteFriend, [{
    key: 'getReferralUrl',
    value: function getReferralUrl() {
      var baseURL = 'https://tab.gladly.io';
      var referralUrl = this.props.user.username ? baseURL + '/?u=' + this.props.user.username : baseURL;
      return referralUrl;
    }
  }, {
    key: 'onTextFieldClicked',
    value: function onTextFieldClicked() {
      this.input.select();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;

      var referralUrl = this.getReferralUrl();

      return _react2.default.createElement(_TextField2.default, {
        id: 'refer-friend-input',
        inputRef: function inputRef(input) {
          _this2.input = input;
        },
        onClick: this.onTextFieldClicked.bind(this),
        value: referralUrl,
        label: 'Share this link',
        helperText: this.props.user.username ? 'and you\'ll get 350 Hearts for every person who joins!' : 'and have a bigger positive impact!',
        InputProps: {
          classes: {
            underline: classes.inputUnderline
          }
        }
        /* eslint-disable-next-line react/jsx-no-duplicate-props */
        , inputProps: {
          style: {
            textAlign: 'left'
          }
        },
        InputLabelProps: {
          FormLabelClasses: {
            root: classes.formLabelRoot,
            focused: classes.formLabelFocused
          }
        },
        style: this.props.style
      });
    }
  }]);

  return InviteFriend;
}(_react2.default.Component);

InviteFriend.propTypes = {
  user: _propTypes2.default.shape({
    username: _propTypes2.default.string
  }),
  classes: _propTypes2.default.object.isRequired,
  style: _propTypes2.default.object
};

InviteFriend.defaultProps = {
  style: {}
};

exports.default = (0, _styles.withStyles)(styles)(InviteFriend);

/***/ }),

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CharityContainer = __webpack_require__(1267);

var _CharityContainer2 = _interopRequireDefault(_CharityContainer);

var _materialUi = __webpack_require__(120);

var _infoOutline = __webpack_require__(2182);

var _infoOutline2 = _interopRequireDefault(_infoOutline);

var _default = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileDonateHearts = function (_React$Component) {
  _inherits(ProfileDonateHearts, _React$Component);

  function ProfileDonateHearts() {
    _classCallCheck(this, ProfileDonateHearts);

    return _possibleConstructorReturn(this, (ProfileDonateHearts.__proto__ || Object.getPrototypeOf(ProfileDonateHearts)).apply(this, arguments));
  }

  _createClass(ProfileDonateHearts, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          app = _props.app,
          user = _props.user;

      var containerStyle = {};
      var spacingPx = 6;
      return _react2.default.createElement(
        'div',
        {
          key: 'charities-container-key',
          style: containerStyle },
        _react2.default.createElement(
          _materialUi.Paper,
          {
            style: {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingLeft: 20,
              paddingRight: 20,
              marginBottom: 2 * spacingPx,
              color: _default.lighterTextColor
            }
          },
          _react2.default.createElement(_infoOutline2.default, {
            style: {
              marginRight: 8,
              color: _default.lighterTextColor,
              minHeight: 24,
              minWidth: 24
            }
          }),
          _react2.default.createElement(
            'p',
            null,
            'When you donate Hearts, you\'re telling us to give more of the money we raise to that charity.'
          )
        ),
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              marginBottom: 34
            }
          },
          app.charities.edges.map(function (edge) {
            return _react2.default.createElement(_CharityContainer2.default, {
              key: edge.node.id,
              charity: edge.node,
              user: user,
              showError: _this2.props.showError,
              style: {
                margin: spacingPx
              }
            });
          })
        )
      );
    }
  }]);

  return ProfileDonateHearts;
}(_react2.default.Component);

ProfileDonateHearts.propTypes = {
  app: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  showError: _propTypes2.default.func.isRequired
};

exports.default = ProfileDonateHearts;

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _ProfileDonateHeartsComponent = __webpack_require__(1305);

var _ProfileDonateHeartsComponent2 = _interopRequireDefault(_ProfileDonateHeartsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_ProfileDonateHeartsComponent2.default, {
  app: function app() {
    return __webpack_require__(1315);
  },
  user: function user() {
    return __webpack_require__(1316);
  }
});

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql; /* global graphql */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(16);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _SettingsChildWrapperComponent = __webpack_require__(186);

var _SettingsChildWrapperComponent2 = _interopRequireDefault(_SettingsChildWrapperComponent);

var _ProfileDonateHeartsContainer = __webpack_require__(1306);

var _ProfileDonateHeartsContainer2 = _interopRequireDefault(_ProfileDonateHeartsContainer);

var _AuthUserComponent = __webpack_require__(149);

var _AuthUserComponent2 = _interopRequireDefault(_AuthUserComponent);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileDonateHeartsView = function (_React$Component) {
  _inherits(ProfileDonateHeartsView, _React$Component);

  function ProfileDonateHeartsView() {
    _classCallCheck(this, ProfileDonateHeartsView);

    return _possibleConstructorReturn(this, (ProfileDonateHeartsView.__proto__ || Object.getPrototypeOf(ProfileDonateHeartsView)).apply(this, arguments));
  }

  _createClass(ProfileDonateHeartsView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _AuthUserComponent2.default,
        null,
        _react2.default.createElement(_reactRelay.QueryRenderer, {
          environment: _relayEnv2.default,
          query: _graphql || (_graphql = function _graphql() {
            return __webpack_require__(1317);
          }),
          render: function render(_ref) {
            var error = _ref.error,
                props = _ref.props;

            if (error) {
              console.error(error, error.source);
              var errMsg = 'We had a problem loading the Donate Hearts page.';
              return _react2.default.createElement(_ErrorMessage2.default, { message: errMsg });
            }
            var showError = _this2.props.showError;
            var dataLoaded = !!props;
            return _react2.default.createElement(
              _SettingsChildWrapperComponent2.default,
              { loaded: dataLoaded },
              dataLoaded ? _react2.default.createElement(_ProfileDonateHeartsContainer2.default, {
                app: props.app,
                user: props.user,
                showError: showError
              }) : null
            );
          } })
      );
    }
  }]);

  return ProfileDonateHeartsView;
}(_react2.default.Component);

exports.default = ProfileDonateHeartsView;

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InviteFriendContainer = __webpack_require__(572);

var _InviteFriendContainer2 = _interopRequireDefault(_InviteFriendContainer);

var _StatComponent = __webpack_require__(573);

var _StatComponent2 = _interopRequireDefault(_StatComponent);

var _default = __webpack_require__(44);

var _mood = __webpack_require__(2201);

var _mood2 = _interopRequireDefault(_mood);

var _materialUi = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileInviteFriend = function (_React$Component) {
  _inherits(ProfileInviteFriend, _React$Component);

  function ProfileInviteFriend() {
    _classCallCheck(this, ProfileInviteFriend);

    return _possibleConstructorReturn(this, (ProfileInviteFriend.__proto__ || Object.getPrototypeOf(ProfileInviteFriend)).apply(this, arguments));
  }

  _createClass(ProfileInviteFriend, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          app = _props.app,
          user = _props.user;

      var tabberWord = user.numUsersRecruited === 1 ? 'Tabber' : 'Tabbers';
      var spacingPx = 6;
      var statStyle = {
        margin: spacingPx,
        flex: 1,
        paddingTop: 40,
        paddingBottom: 40
      };
      return _react2.default.createElement(
        'span',
        {
          style: {
            display: 'flex',
            flexWrap: 'wrap',
            margin: -spacingPx
          }
        },
        _react2.default.createElement(
          _materialUi.Paper,
          { style: {
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'middle',
              padding: 10,
              margin: spacingPx,
              flex: 2,
              flexBasis: '40%',
              minWidth: 200
            } },
          _react2.default.createElement(
            'span',
            {
              style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'middle',
                width: '100%',
                maxWidth: 300,
                marginTop: 30,
                marginBottom: 30,
                marginLeft: 8,
                marginRight: 8,
                boxSizing: 'border-box'
              }
            },
            _react2.default.createElement(_InviteFriendContainer2.default, {
              user: user
            })
          )
        ),
        _react2.default.createElement(_StatComponent2.default, {
          stat: user.numUsersRecruited,
          statText: tabberWord + ' recruited',
          style: statStyle
        }),
        _react2.default.createElement(_StatComponent2.default, {
          stat: app.referralVcReward,
          statText: 'extra Hearts when you recruit a new friend',
          style: statStyle
        }),
        _react2.default.createElement(
          _materialUi.Paper,
          {
            style: {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              flexBasis: '50%',
              minWidth: 200,
              padding: 20,
              color: _default.lighterTextColor,
              margin: spacingPx
            }
          },
          _react2.default.createElement(_mood2.default, {
            style: {
              minHeight: 24,
              minWidth: 24,
              marginRight: 8,
              color: _default.lighterTextColor
            }
          }),
          _react2.default.createElement(
            'p',
            null,
            'Thank you! Every new Tabber raises more money for charity, and we depend on people like you to get the word out.'
          )
        )
      );
    }
  }]);

  return ProfileInviteFriend;
}(_react2.default.Component);

ProfileInviteFriend.propTypes = {
  app: _propTypes2.default.shape({
    referralVcReward: _propTypes2.default.number.isRequired
  }),
  user: _propTypes2.default.shape({
    numUsersRecruited: _propTypes2.default.number.isRequired
  })
};

exports.default = ProfileInviteFriend;

/***/ }),

/***/ 1309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _ProfileInviteFriendComponent = __webpack_require__(1308);

var _ProfileInviteFriendComponent2 = _interopRequireDefault(_ProfileInviteFriendComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_ProfileInviteFriendComponent2.default, {
  app: function app() {
    return __webpack_require__(1318);
  },
  user: function user() {
    return __webpack_require__(1319);
  }
});

/***/ }),

/***/ 1310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql; /* global graphql */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(16);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _SettingsChildWrapperComponent = __webpack_require__(186);

var _SettingsChildWrapperComponent2 = _interopRequireDefault(_SettingsChildWrapperComponent);

var _ProfileInviteFriendContainer = __webpack_require__(1309);

var _ProfileInviteFriendContainer2 = _interopRequireDefault(_ProfileInviteFriendContainer);

var _AuthUserComponent = __webpack_require__(149);

var _AuthUserComponent2 = _interopRequireDefault(_AuthUserComponent);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileInviteFriendView = function (_React$Component) {
  _inherits(ProfileInviteFriendView, _React$Component);

  function ProfileInviteFriendView() {
    _classCallCheck(this, ProfileInviteFriendView);

    return _possibleConstructorReturn(this, (ProfileInviteFriendView.__proto__ || Object.getPrototypeOf(ProfileInviteFriendView)).apply(this, arguments));
  }

  _createClass(ProfileInviteFriendView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _AuthUserComponent2.default,
        null,
        _react2.default.createElement(_reactRelay.QueryRenderer, {
          environment: _relayEnv2.default,
          query: _graphql || (_graphql = function _graphql() {
            return __webpack_require__(1320);
          }),
          render: function render(_ref) {
            var error = _ref.error,
                props = _ref.props;

            if (error) {
              console.error(error, error.source);
              var errMsg = 'We had a problem loading this page :(';
              return _react2.default.createElement(_ErrorMessage2.default, { message: errMsg });
            }
            var showError = _this2.props.showError;
            var dataLoaded = !!props;
            return _react2.default.createElement(
              _SettingsChildWrapperComponent2.default,
              { loaded: dataLoaded },
              dataLoaded ? _react2.default.createElement(_ProfileInviteFriendContainer2.default, {
                app: props.app,
                user: props.user,
                showError: showError }) : null
            );
          } })
      );
    }
  }]);

  return ProfileInviteFriendView;
}(_react2.default.Component);

exports.default = ProfileInviteFriendView;

/***/ }),

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _favoriteBorder = __webpack_require__(793);

var _favoriteBorder2 = _interopRequireDefault(_favoriteBorder);

var _StatComponent = __webpack_require__(573);

var _StatComponent2 = _interopRequireDefault(_StatComponent);

var _materialUi = __webpack_require__(120);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

var _insertChart = __webpack_require__(796);

var _insertChart2 = _interopRequireDefault(_insertChart);

var _navigation = __webpack_require__(50);

var _utils = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileStats = function (_React$Component) {
  _inherits(ProfileStats, _React$Component);

  function ProfileStats() {
    _classCallCheck(this, ProfileStats);

    return _possibleConstructorReturn(this, (ProfileStats.__proto__ || Object.getPrototypeOf(ProfileStats)).apply(this, arguments));
  }

  _createClass(ProfileStats, [{
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var now = (0, _moment2.default)().utc();
      var daysSinceJoined = now.diff((0, _moment2.default)(user.joined), 'days');
      var dayWord = daysSinceJoined === 1 ? 'day' : 'days';
      var tabberWord = user.numUsersRecruited === 1 ? 'Tabber' : 'Tabbers';
      var heartsWord = user.vcDonatedAllTime === 1 ? 'Heart' : 'Hearts';
      var extraContentTextStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: _default2.default.palette.disabledColor
      };
      var spacingPx = 6;
      var statStyle = {
        flex: 1,
        flexBasis: '20%',
        margin: spacingPx
      };
      var greeting = user.username ? 'Hi, ' + user.username + '!' : 'Hi!';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Paper,
          {
            style: {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingLeft: 20,
              paddingRight: 20,
              marginBottom: 2 * spacingPx,
              color: _default.lighterTextColor
            }
          },
          _react2.default.createElement(_insertChart2.default, {
            style: {
              marginRight: 8,
              color: _default.lighterTextColor,
              minHeight: 24,
              minWidth: 24
            }
          }),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'span',
              { style: { fontWeight: 500 } },
              greeting
            ),
            _react2.default.createElement(
              'span',
              null,
              ' Here\'s all your great work Tabbing, by the numbers.'
            )
          )
        ),
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              flexWrap: 'wrap',
              margin: -spacingPx
            }
          },
          _react2.default.createElement(_StatComponent2.default, {
            stat: (0, _utils.commaFormatted)(daysSinceJoined),
            statText: dayWord + ' as a Tabber',
            style: statStyle
          }),
          _react2.default.createElement(_StatComponent2.default, {
            stat: (0, _utils.abbreviateNumber)(user.tabs, 1),
            statText: 'tabs all time',
            style: statStyle
          }),
          _react2.default.createElement(_StatComponent2.default, {
            stat: (0, _utils.commaFormatted)(user.maxTabsDay.numTabs),
            statText: 'max tabs in one day',
            extraContent: _react2.default.createElement(
              'span',
              { style: extraContentTextStyle },
              'on ',
              (0, _moment2.default)(user.maxTabsDay.date).format('LL')
            ),
            style: statStyle
          }),
          _react2.default.createElement(_StatComponent2.default, {
            stat: user.level,
            statText: 'your level',
            extraContent: _react2.default.createElement(
              'span',
              { style: extraContentTextStyle },
              _react2.default.createElement(
                'span',
                null,
                user.heartsUntilNextLevel
              ),
              _react2.default.createElement(_favoriteBorder2.default, {
                style: { marginLeft: 0, marginRight: 2, height: 16, width: 16, paddingBottom: 0 },
                color: _default2.default.palette.disabledColor
              }),
              _react2.default.createElement(
                'span',
                null,
                'until next level'
              )
            ),
            style: statStyle
          }),
          _react2.default.createElement(_StatComponent2.default, {
            stat: (0, _utils.commaFormatted)(user.numUsersRecruited),
            statText: tabberWord + ' recruited',
            style: statStyle,
            extraContent: _react2.default.createElement(_RaisedButton2.default, {
              label: 'Invite Friends',
              style: { marginTop: 14 },
              primary: true,
              onClick: _navigation.goToInviteFriends
            })
          }),
          _react2.default.createElement(_StatComponent2.default, {
            stat: (0, _utils.abbreviateNumber)(user.vcDonatedAllTime, 1),
            statText: heartsWord + ' donated',
            style: statStyle,
            extraContent: _react2.default.createElement(_RaisedButton2.default, {
              label: 'Donate Hearts',
              style: { marginTop: 14 },
              primary: true,
              onClick: _navigation.goToDonate
            })
          })
        )
      );
    }
  }]);

  return ProfileStats;
}(_react2.default.Component);

ProfileStats.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    username: _propTypes2.default.string,
    heartsUntilNextLevel: _propTypes2.default.number.isRequired,
    joined: _propTypes2.default.string.isRequired,
    level: _propTypes2.default.number.isRequired,
    maxTabsDay: _propTypes2.default.shape({
      date: _propTypes2.default.string.isRequired,
      numTabs: _propTypes2.default.number.isRequired
    }),
    numUsersRecruited: _propTypes2.default.number.isRequired,
    tabs: _propTypes2.default.number.isRequired,
    vcDonatedAllTime: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.default = ProfileStats;

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _ProfileStatsComponent = __webpack_require__(1311);

var _ProfileStatsComponent2 = _interopRequireDefault(_ProfileStatsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_ProfileStatsComponent2.default, {
  user: function user() {
    return __webpack_require__(1321);
  }
});

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql; /* global graphql */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(16);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _SettingsChildWrapperComponent = __webpack_require__(186);

var _SettingsChildWrapperComponent2 = _interopRequireDefault(_SettingsChildWrapperComponent);

var _ProfileStatsContainer = __webpack_require__(1312);

var _ProfileStatsContainer2 = _interopRequireDefault(_ProfileStatsContainer);

var _AuthUserComponent = __webpack_require__(149);

var _AuthUserComponent2 = _interopRequireDefault(_AuthUserComponent);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfileStatsView = function (_React$Component) {
  _inherits(ProfileStatsView, _React$Component);

  function ProfileStatsView() {
    _classCallCheck(this, ProfileStatsView);

    return _possibleConstructorReturn(this, (ProfileStatsView.__proto__ || Object.getPrototypeOf(ProfileStatsView)).apply(this, arguments));
  }

  _createClass(ProfileStatsView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _AuthUserComponent2.default,
        null,
        _react2.default.createElement(_reactRelay.QueryRenderer, {
          environment: _relayEnv2.default,
          query: _graphql || (_graphql = function _graphql() {
            return __webpack_require__(1322);
          }),
          render: function render(_ref) {
            var error = _ref.error,
                props = _ref.props;

            if (error) {
              console.error(error, error.source);
              var errMsg = 'We had a problem loading your stats :(';
              return _react2.default.createElement(_ErrorMessage2.default, { message: errMsg });
            }
            var showError = _this2.props.showError;
            var dataLoaded = !!props;
            return _react2.default.createElement(
              _SettingsChildWrapperComponent2.default,
              { loaded: dataLoaded },
              dataLoaded ? _react2.default.createElement(_ProfileStatsContainer2.default, {
                user: props.user,
                showError: showError }) : null
            );
          } })
      );
    }
  }]);

  return ProfileStatsView;
}(_react2.default.Component);

exports.default = ProfileStatsView;

/***/ }),

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InviteFriendContainer_user$ref: FragmentReference;
export type InviteFriendContainer_user = {|
  +username: ?string,
  +$refType: InviteFriendContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "InviteFriendContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "username",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '891893ae6ca183d633adb64da973db66';
module.exports = node;

/***/ }),

/***/ 1315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type CharityContainer_charity$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileDonateHeartsContainer_app$ref: FragmentReference;
export type ProfileDonateHeartsContainer_app = {|
  +charities: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: CharityContainer_charity$ref,
      |}
    |}>
  |},
  +$refType: ProfileDonateHeartsContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileDonateHeartsContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "charities",
    "storageKey": "charities(first:20)",
    "args": [{
      "kind": "Literal",
      "name": "first",
      "value": 20,
      "type": "Int"
    }],
    "concreteType": "CharityConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "CharityEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Charity",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "FragmentSpread",
          "name": "CharityContainer_charity",
          "args": null
        }]
      }]
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '98e71fd658d1784141c9e62d08df3c7d';
module.exports = node;

/***/ }),

/***/ 1316:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type CharityContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileDonateHeartsContainer_user$ref: FragmentReference;
export type ProfileDonateHeartsContainer_user = {|
  +$fragmentRefs: CharityContainer_user$ref,
  +$refType: ProfileDonateHeartsContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileDonateHeartsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "FragmentSpread",
    "name": "CharityContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'fe70f6383e8f67c21c5d8c52123b6099';
module.exports = node;

/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 299d48304dedd924f126a250120c3e92
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProfileDonateHeartsContainer_app$ref = any;
type ProfileDonateHeartsContainer_user$ref = any;
export type ProfileDonateHeartsViewQueryVariables = {|
  userId: string
|};
export type ProfileDonateHeartsViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: ProfileDonateHeartsContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: ProfileDonateHeartsContainer_user$ref
  |},
|};
export type ProfileDonateHeartsViewQuery = {|
  variables: ProfileDonateHeartsViewQueryVariables,
  response: ProfileDonateHeartsViewQueryResponse,
|};
*/

/*
query ProfileDonateHeartsViewQuery(
  $userId: String!
) {
  app {
    ...ProfileDonateHeartsContainer_app
    id
  }
  user(userId: $userId) {
    ...ProfileDonateHeartsContainer_user
    id
  }
}

fragment ProfileDonateHeartsContainer_app on App {
  charities(first: 20) {
    edges {
      node {
        id
        ...CharityContainer_charity
      }
    }
  }
}

fragment ProfileDonateHeartsContainer_user on User {
  ...CharityContainer_user
}

fragment CharityContainer_user on User {
  id
  vcCurrent
  ...DonateHeartsControlsContainer_user
}

fragment DonateHeartsControlsContainer_user on User {
  id
  vcCurrent
}

fragment CharityContainer_charity on Charity {
  id
  description
  logo
  name
  website
  ...DonateHeartsControlsContainer_charity
}

fragment DonateHeartsControlsContainer_charity on Charity {
  id
  image
  imageCaption
  impact
  name
  website
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "ProfileDonateHeartsViewQuery",
    "id": null,
    "text": "query ProfileDonateHeartsViewQuery(\n  $userId: String!\n) {\n  app {\n    ...ProfileDonateHeartsContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...ProfileDonateHeartsContainer_user\n    id\n  }\n}\n\nfragment ProfileDonateHeartsContainer_app on App {\n  charities(first: 20) {\n    edges {\n      node {\n        id\n        ...CharityContainer_charity\n      }\n    }\n  }\n}\n\nfragment ProfileDonateHeartsContainer_user on User {\n  ...CharityContainer_user\n}\n\nfragment CharityContainer_user on User {\n  id\n  vcCurrent\n  ...DonateHeartsControlsContainer_user\n}\n\nfragment DonateHeartsControlsContainer_user on User {\n  id\n  vcCurrent\n}\n\nfragment CharityContainer_charity on Charity {\n  id\n  description\n  logo\n  name\n  website\n  ...DonateHeartsControlsContainer_charity\n}\n\nfragment DonateHeartsControlsContainer_charity on Charity {\n  id\n  image\n  imageCaption\n  impact\n  name\n  website\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ProfileDonateHeartsViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ProfileDonateHeartsContainer_app",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ProfileDonateHeartsContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ProfileDonateHeartsViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "charities",
          "storageKey": "charities(first:20)",
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 20,
            "type": "Int"
          }],
          "concreteType": "CharityConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CharityEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Charity",
              "plural": false,
              "selections": [v2, {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "logo",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "website",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "image",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "imageCaption",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "impact",
                "args": null,
                "storageKey": null
              }]
            }]
          }]
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [v2, {
          "kind": "ScalarField",
          "alias": null,
          "name": "vcCurrent",
          "args": null,
          "storageKey": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2925300cfd8a9ba6a5bbf039c6d68739';
module.exports = node;

/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileInviteFriendContainer_app$ref: FragmentReference;
export type ProfileInviteFriendContainer_app = {|
  +referralVcReward: ?number,
  +$refType: ProfileInviteFriendContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileInviteFriendContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "referralVcReward",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'efb97ecccfcd9534e199193f0016e9fa';
module.exports = node;

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type InviteFriendContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileInviteFriendContainer_user$ref: FragmentReference;
export type ProfileInviteFriendContainer_user = {|
  +numUsersRecruited: ?number,
  +$fragmentRefs: InviteFriendContainer_user$ref,
  +$refType: ProfileInviteFriendContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileInviteFriendContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "numUsersRecruited",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "InviteFriendContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '50dd149a86421d4ed4cdcb825c32acdb';
module.exports = node;

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5ddffcaf2ef03a888e7f345b504084de
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProfileInviteFriendContainer_app$ref = any;
type ProfileInviteFriendContainer_user$ref = any;
export type ProfileInviteFriendViewQueryVariables = {|
  userId: string
|};
export type ProfileInviteFriendViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: ProfileInviteFriendContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: ProfileInviteFriendContainer_user$ref
  |},
|};
export type ProfileInviteFriendViewQuery = {|
  variables: ProfileInviteFriendViewQueryVariables,
  response: ProfileInviteFriendViewQueryResponse,
|};
*/

/*
query ProfileInviteFriendViewQuery(
  $userId: String!
) {
  app {
    ...ProfileInviteFriendContainer_app
    id
  }
  user(userId: $userId) {
    ...ProfileInviteFriendContainer_user
    id
  }
}

fragment ProfileInviteFriendContainer_app on App {
  referralVcReward
}

fragment ProfileInviteFriendContainer_user on User {
  numUsersRecruited
  ...InviteFriendContainer_user
}

fragment InviteFriendContainer_user on User {
  username
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "ProfileInviteFriendViewQuery",
    "id": null,
    "text": "query ProfileInviteFriendViewQuery(\n  $userId: String!\n) {\n  app {\n    ...ProfileInviteFriendContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...ProfileInviteFriendContainer_user\n    id\n  }\n}\n\nfragment ProfileInviteFriendContainer_app on App {\n  referralVcReward\n}\n\nfragment ProfileInviteFriendContainer_user on User {\n  numUsersRecruited\n  ...InviteFriendContainer_user\n}\n\nfragment InviteFriendContainer_user on User {\n  username\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ProfileInviteFriendViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ProfileInviteFriendContainer_app",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ProfileInviteFriendContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ProfileInviteFriendViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "referralVcReward",
          "args": null,
          "storageKey": null
        }, v2]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "numUsersRecruited",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "username",
          "args": null,
          "storageKey": null
        }, v2]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd487adab777b4260ebde88a95f91e674';
module.exports = node;

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileStatsContainer_user$ref: FragmentReference;
export type ProfileStatsContainer_user = {|
  +id: string,
  +username: ?string,
  +heartsUntilNextLevel: ?number,
  +joined: ?string,
  +level: ?number,
  +maxTabsDay: ?{|
    +date: ?string,
    +numTabs: ?number,
  |},
  +numUsersRecruited: ?number,
  +tabs: ?number,
  +vcDonatedAllTime: ?number,
  +$refType: ProfileStatsContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileStatsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "username",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "heartsUntilNextLevel",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "joined",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "level",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "maxTabsDay",
    "storageKey": null,
    "args": null,
    "concreteType": "MaxTabsDay",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "date",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "numTabs",
      "args": null,
      "storageKey": null
    }]
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "numUsersRecruited",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "tabs",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "vcDonatedAllTime",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'ec5799307f69f8ef3b060415e136ad01';
module.exports = node;

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash db85c6c2d3f2a31a4cd3eb1c7f5dffdf
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProfileStatsContainer_user$ref = any;
export type ProfileStatsViewQueryVariables = {|
  userId: string
|};
export type ProfileStatsViewQueryResponse = {|
  +user: ?{|
    +$fragmentRefs: ProfileStatsContainer_user$ref
  |}
|};
export type ProfileStatsViewQuery = {|
  variables: ProfileStatsViewQueryVariables,
  response: ProfileStatsViewQueryResponse,
|};
*/

/*
query ProfileStatsViewQuery(
  $userId: String!
) {
  user(userId: $userId) {
    ...ProfileStatsContainer_user
    id
  }
}

fragment ProfileStatsContainer_user on User {
  id
  username
  heartsUntilNextLevel
  joined
  level
  maxTabsDay {
    date
    numTabs
  }
  numUsersRecruited
  tabs
  vcDonatedAllTime
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }];
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "ProfileStatsViewQuery",
    "id": null,
    "text": "query ProfileStatsViewQuery(\n  $userId: String!\n) {\n  user(userId: $userId) {\n    ...ProfileStatsContainer_user\n    id\n  }\n}\n\nfragment ProfileStatsContainer_user on User {\n  id\n  username\n  heartsUntilNextLevel\n  joined\n  level\n  maxTabsDay {\n    date\n    numTabs\n  }\n  numUsersRecruited\n  tabs\n  vcDonatedAllTime\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "ProfileStatsViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "ProfileStatsContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "ProfileStatsViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "username",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "heartsUntilNextLevel",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "joined",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "level",
          "args": null,
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "name": "maxTabsDay",
          "storageKey": null,
          "args": null,
          "concreteType": "MaxTabsDay",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "name": "date",
            "args": null,
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "name": "numTabs",
            "args": null,
            "storageKey": null
          }]
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "numUsersRecruited",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "tabs",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "vcDonatedAllTime",
          "args": null,
          "storageKey": null
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '27c52e53129ab27d635f00d7281c2b21';
module.exports = node;

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(79);

var _ListItem = __webpack_require__(1099);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _ListItemText = __webpack_require__(1101);

var _ListItemText2 = _interopRequireDefault(_ListItemText);

var _NavLink = __webpack_require__(1278);

var _NavLink2 = _interopRequireDefault(_NavLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsMenuItem = function (_React$Component) {
  _inherits(SettingsMenuItem, _React$Component);

  function SettingsMenuItem() {
    _classCallCheck(this, SettingsMenuItem);

    return _possibleConstructorReturn(this, (SettingsMenuItem.__proto__ || Object.getPrototypeOf(SettingsMenuItem)).apply(this, arguments));
  }

  _createClass(SettingsMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          to = _props.to;

      var isActive = this.context.router.isActive(to);
      var listItemStyle = Object.assign({}, isActive ? {
        background: theme.palette.action.hover
      } : null);
      return _react2.default.createElement(
        _NavLink2.default,
        {
          to: this.props.to,
          style: { textDecoration: 'none' }
        },
        _react2.default.createElement(
          _ListItem2.default,
          { style: listItemStyle, button: true },
          _react2.default.createElement(_ListItemText2.default, {
            primary: this.props.children,
            primaryTypographyProps: {
              variant: 'body2'
            }
          })
        )
      );
    }
  }]);

  return SettingsMenuItem;
}(_react2.default.Component);

SettingsMenuItem.contextTypes = {
  router: _propTypes2.default.object
};

SettingsMenuItem.propTypes = {
  theme: _propTypes2.default.object.isRequired,
  to: _propTypes2.default.string.isRequired
};
exports.default = (0, _styles.withTheme)()(SettingsMenuItem);

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _navigation = __webpack_require__(50);

var _styles = __webpack_require__(79);

var _AppBar = __webpack_require__(1059);

var _AppBar2 = _interopRequireDefault(_AppBar);

var _Divider = __webpack_require__(368);

var _Divider2 = _interopRequireDefault(_Divider);

var _IconButton = __webpack_require__(542);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _List = __webpack_require__(543);

var _List2 = _interopRequireDefault(_List);

var _ListSubheader = __webpack_require__(1103);

var _ListSubheader2 = _interopRequireDefault(_ListSubheader);

var _SettingsMenuItem = __webpack_require__(1323);

var _SettingsMenuItem2 = _interopRequireDefault(_SettingsMenuItem);

var _Toolbar = __webpack_require__(1134);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Logo = __webpack_require__(1281);

var _Logo2 = _interopRequireDefault(_Logo);

var _close = __webpack_require__(797);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = function styles(theme) {
  return {
    listSubheader: {
      paddingLeft: 14
    }
  };
};

var SettingsPage = function (_React$Component) {
  _inherits(SettingsPage, _React$Component);

  function SettingsPage(props) {
    _classCallCheck(this, SettingsPage);

    var _this = _possibleConstructorReturn(this, (SettingsPage.__proto__ || Object.getPrototypeOf(SettingsPage)).call(this, props));

    _this.state = {
      errorMessage: null
    };
    return _this;
  }

  _createClass(SettingsPage, [{
    key: 'goToHome',
    value: function goToHome() {
      (0, _navigation.goToDashboard)();
    }
  }, {
    key: 'showError',
    value: function showError(msg) {
      this.setState({
        errorMessage: msg
      });
    }
  }, {
    key: 'clearError',
    value: function clearError() {
      this.showError(null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;

      var showError = this.showError;
      var errorMessage = this.state.errorMessage;
      var sidebarWidth = 240;
      var sidebarLeftMargin = 10;
      return _react2.default.createElement(
        'div',
        {
          'data-test-id': 'app-settings-id',
          key: 'settings-view-key',
          style: {
            color: '#fff',
            backgroundColor: '#F2F2F2',
            minWidth: '100vw',
            minHeight: '100vh'
          } },
        _react2.default.createElement(
          _AppBar2.default,
          {
            color: 'primary',
            position: 'sticky'
          },
          _react2.default.createElement(
            _Toolbar2.default,
            null,
            _react2.default.createElement(
              'div',
              { style: { flex: 1 } },
              _react2.default.createElement(_Logo2.default, { color: 'white' })
            ),
            _react2.default.createElement(
              _IconButton2.default,
              { onClick: this.goToHome.bind(this) },
              _react2.default.createElement(_close2.default, {
                style: {
                  color: '#fff',
                  width: 28,
                  height: 28
                }
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { width: sidebarWidth, position: 'fixed' } },
          _react2.default.createElement(
            _List2.default,
            { style: { marginLeft: sidebarLeftMargin } },
            _react2.default.createElement(
              _ListSubheader2.default,
              {
                disableSticky: true,
                className: classes.listSubheader },
              'Settings'
            ),
            _react2.default.createElement(
              _SettingsMenuItem2.default,
              {
                key: 'widgets',
                to: _navigation.widgetSettingsURL },
              'Widgets'
            ),
            _react2.default.createElement(
              _SettingsMenuItem2.default,
              {
                key: 'background',
                to: _navigation.backgroundSettingsURL },
              'Background'
            ),
            _react2.default.createElement(_Divider2.default, null),
            _react2.default.createElement(
              _ListSubheader2.default,
              {
                disableSticky: true,
                className: classes.listSubheader },
              'Your Profile'
            ),
            _react2.default.createElement(
              _SettingsMenuItem2.default,
              {
                key: 'stats',
                to: _navigation.statsURL },
              'Your Stats'
            ),
            _react2.default.createElement(
              _SettingsMenuItem2.default,
              {
                key: 'donate',
                to: _navigation.donateURL },
              'Donate Hearts'
            ),
            _react2.default.createElement(
              _SettingsMenuItem2.default,
              {
                key: 'invite',
                to: _navigation.inviteFriendsURL },
              'Invite Friends'
            ),
            _react2.default.createElement(_Divider2.default, null),
            _react2.default.createElement(
              _SettingsMenuItem2.default,
              {
                key: 'account',
                to: _navigation.accountURL },
              'Account'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: {
              marginLeft: sidebarWidth,
              boxSizing: 'border-box',
              display: 'flex',
              justifyContent: 'center'
            } },
          _react2.default.Children.map(this.props.children, function (child) {
            return _react2.default.cloneElement(child, {
              showError: showError.bind(_this2)
            });
          })
        ),
        errorMessage ? _react2.default.createElement(_ErrorMessage2.default, { message: errorMessage,
          onRequestClose: this.clearError.bind(this) }) : null
      );
    }
  }]);

  return SettingsPage;
}(_react2.default.Component);

SettingsPage.propTypes = {
  classes: _propTypes2.default.object.isRequired
};

exports.default = (0, _styles.withStyles)(styles)(SettingsPage);

/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Toggle = __webpack_require__(480);

var _Toggle2 = _interopRequireDefault(_Toggle);

var _RadioButton = __webpack_require__(478);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetConfig = function (_React$Component) {
  _inherits(WidgetConfig, _React$Component);

  function WidgetConfig() {
    _classCallCheck(this, WidgetConfig);

    return _possibleConstructorReturn(this, (WidgetConfig.__proto__ || Object.getPrototypeOf(WidgetConfig)).apply(this, arguments));
  }

  _createClass(WidgetConfig, [{
    key: 'render',
    value: function render() {
      var setting = this.props.setting;

      switch (setting.type) {
        case 'boolean':
          return _react2.default.createElement(BooleanWidgetConfig, {
            setting: setting,
            onConfigUpdated: this.props.onConfigUpdated });
        case 'choices':
          return _react2.default.createElement(ChoicesWidgetConfig, {
            setting: setting,
            onConfigUpdated: this.props.onConfigUpdated });
        default:
          return null;
      }
    }
  }]);

  return WidgetConfig;
}(_react2.default.Component);

WidgetConfig.propTypes = {
  setting: _propTypes2.default.object.isRequired,
  onConfigUpdated: _propTypes2.default.func.isRequired
};

exports.default = WidgetConfig;

var BooleanWidgetConfig = function (_React$Component2) {
  _inherits(BooleanWidgetConfig, _React$Component2);

  function BooleanWidgetConfig() {
    _classCallCheck(this, BooleanWidgetConfig);

    return _possibleConstructorReturn(this, (BooleanWidgetConfig.__proto__ || Object.getPrototypeOf(BooleanWidgetConfig)).apply(this, arguments));
  }

  _createClass(BooleanWidgetConfig, [{
    key: 'onToggle',
    value: function onToggle(event, checked) {
      var setting = this.props.setting;

      this.props.onConfigUpdated(setting.field, checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var setting = this.props.setting;


      var toggleContainerStyle = {
        width: '80%',
        marginLeft: '5%',
        marginRight: '5%'
      };

      return _react2.default.createElement(
        'div',
        { style: toggleContainerStyle },
        _react2.default.createElement(_Toggle2.default, {
          label: setting.display,
          defaultToggled: setting.value,
          onToggle: this.onToggle.bind(this)
        })
      );
    }
  }]);

  return BooleanWidgetConfig;
}(_react2.default.Component);

var ChoicesWidgetConfig = function (_React$Component3) {
  _inherits(ChoicesWidgetConfig, _React$Component3);

  function ChoicesWidgetConfig() {
    _classCallCheck(this, ChoicesWidgetConfig);

    return _possibleConstructorReturn(this, (ChoicesWidgetConfig.__proto__ || Object.getPrototypeOf(ChoicesWidgetConfig)).apply(this, arguments));
  }

  _createClass(ChoicesWidgetConfig, [{
    key: 'onChange',
    value: function onChange(event, value) {
      var setting = this.props.setting;

      this.props.onConfigUpdated(setting.field, value);
    }
  }, {
    key: 'render',
    value: function render() {
      var setting = this.props.setting;


      var choicesContainerStyle = {
        width: '90%',
        margin: 'auto',
        display: 'flex'
      };
      var settingDisplayStyle = {
        flex: 5
      };
      var btnGroupStyle = {
        display: 'flex',
        width: 'auto',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-start'
      };
      var radioBtnStyle = {
        width: 'auto',
        marginBottom: 6,
        fontSize: 14
      };

      return _react2.default.createElement(
        'div',
        { style: choicesContainerStyle },
        _react2.default.createElement(
          'span',
          { style: settingDisplayStyle },
          setting.display
        ),
        _react2.default.createElement(
          _RadioButton.RadioButtonGroup,
          {
            onChange: this.onChange.bind(this),
            style: btnGroupStyle,
            name: setting.field + '-choices',
            defaultSelected: setting.value },
          setting.choices.map(function (choice, index) {
            return _react2.default.createElement(_RadioButton.RadioButton, {
              key: index,
              style: radioBtnStyle,
              value: choice,
              label: choice });
          })
        )
      );
    }
  }]);

  return ChoicesWidgetConfig;
}(_react2.default.Component);

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Toggle = __webpack_require__(480);

var _Toggle2 = _interopRequireDefault(_Toggle);

var _WidgetConfigComponent = __webpack_require__(1325);

var _WidgetConfigComponent2 = _interopRequireDefault(_WidgetConfigComponent);

var _Card = __webpack_require__(471);

var _default = __webpack_require__(44);

var _widgetUtils = __webpack_require__(1384);

var _UpdateWidgetEnabledMutation = __webpack_require__(1398);

var _UpdateWidgetEnabledMutation2 = _interopRequireDefault(_UpdateWidgetEnabledMutation);

var _UpdateWidgetConfigMutation = __webpack_require__(1397);

var _UpdateWidgetConfigMutation2 = _interopRequireDefault(_UpdateWidgetConfigMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetSettings = function (_React$Component) {
  _inherits(WidgetSettings, _React$Component);

  function WidgetSettings(props) {
    _classCallCheck(this, WidgetSettings);

    var _this = _possibleConstructorReturn(this, (WidgetSettings.__proto__ || Object.getPrototypeOf(WidgetSettings)).call(this, props));

    _this.state = {
      settings: []
    };
    return _this;
  }

  _createClass(WidgetSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          appWidget = _props.appWidget,
          widget = _props.widget;


      var config;
      if (widget && widget.config) {
        config = JSON.parse(widget.config);
      }

      var settings = this.getConfig(JSON.parse(appWidget.settings), config);

      this.setState({
        settings: settings
      });
    }
  }, {
    key: 'getConfig',
    value: function getConfig(settings, config) {
      if (!settings.length) {
        return [];
      }

      var value;
      for (var i = 0; i < settings.length; i++) {
        if (!config || !(settings[i].field in config)) {
          value = settings[i].defaultValue;
        } else {
          value = config[settings[i].field];
        }

        settings[i].value = value;
      }
      return settings;
    }
  }, {
    key: 'onSettingsSave',
    value: function onSettingsSave() {}
  }, {
    key: 'onSaveError',
    value: function onSaveError() {
      this.props.showError('Oops, we are having trouble saving your settings right now :(');
    }
  }, {
    key: 'onWidgetEnableChange',
    value: function onWidgetEnableChange(event, checked) {
      // Call mutation to update widget enabled status.
      var _props2 = this.props,
          appWidget = _props2.appWidget,
          user = _props2.user;

      _UpdateWidgetEnabledMutation2.default.commit(this.props.relay.environment, user, appWidget, checked, this.onSettingsSave.bind(this), this.onSaveError.bind(this));
    }
  }, {
    key: 'onWidgetConfigUpdated',
    value: function onWidgetConfigUpdated(field, value) {
      var _props3 = this.props,
          widget = _props3.widget,
          user = _props3.user,
          appWidget = _props3.appWidget;

      var widgetConfig = {};
      if (widget) {
        widgetConfig = JSON.parse(widget.config);
      }

      widgetConfig[field] = value;

      var strConfig = JSON.stringify(widgetConfig);
      // Call mutation to update widget config.

      _UpdateWidgetConfigMutation2.default.commit(this.props.relay.environment, user, appWidget, strConfig, this.onSettingsSave.bind(this), this.onSaveError.bind(this));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          appWidget = _props4.appWidget,
          widget = _props4.widget;

      var enabled = widget && widget.enabled;
      var settings = this.state.settings || [];

      var cardStyle = {
        marginBottom: 10
      };
      var enableToggleStyle = {
        width: 'initial',
        marginRight: 10
      };
      var cardHeaderStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      };
      var cardTitleStyle = Object.assign({}, _default.cardHeaderTitleStyle, {
        fontSize: 16
      });
      var settingsContainerStyle = {
        display: 'flex',
        flexDirection: 'column'
      };
      var settingsComponent;
      if (settings && settings.length) {
        settingsComponent = _react2.default.createElement(
          _Card.CardText,
          null,
          _react2.default.createElement(
            'div',
            { style: settingsContainerStyle },
            settings.map(function (setting, index) {
              return _react2.default.createElement(_WidgetConfigComponent2.default, {
                key: index,
                setting: setting,
                onConfigUpdated: _this2.onWidgetConfigUpdated.bind(_this2)
              });
            })
          )
        );
      }

      var WidgetIcon = (0, _widgetUtils.getWidgetIconFromWidgetType)(appWidget.type);

      return _react2.default.createElement(
        _Card.Card,
        { style: cardStyle },
        _react2.default.createElement(
          _Card.CardHeader,
          {
            style: cardHeaderStyle,
            title: _react2.default.createElement(
              'span',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center'
                }
              },
              _react2.default.createElement(WidgetIcon, {
                style: {
                  height: 18,
                  width: 18,
                  marginRight: 8
                }
              }),
              appWidget.name
            ),
            titleStyle: cardTitleStyle,
            actAsExpander: false,
            showExpandableButton: false },
          _react2.default.createElement(_Toggle2.default, {
            style: enableToggleStyle,
            defaultToggled: enabled,
            onToggle: this.onWidgetEnableChange.bind(this) })
        ),
        settingsComponent
      );
    }
  }]);

  return WidgetSettings;
}(_react2.default.Component);

WidgetSettings.propTypes = {
  widget: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    enabled: _propTypes2.default.bool.isRequired,
    config: _propTypes2.default.string,
    settings: _propTypes2.default.string
  }),
  appWidget: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    settings: _propTypes2.default.string
  }),
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }),
  showError: _propTypes2.default.func.isRequired
};

exports.default = WidgetSettings;

/***/ }),

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _WidgetSettingsComponent = __webpack_require__(1326);

var _WidgetSettingsComponent2 = _interopRequireDefault(_WidgetSettingsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_WidgetSettingsComponent2.default, {
  widget: function widget() {
    return __webpack_require__(1333);
  },
  user: function user() {
    return __webpack_require__(1332);
  },
  appWidget: function appWidget() {
    return __webpack_require__(1331);
  }
});

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WidgetSettingsContainer = __webpack_require__(1327);

var _WidgetSettingsContainer2 = _interopRequireDefault(_WidgetSettingsContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetsSettings = function (_React$Component) {
  _inherits(WidgetsSettings, _React$Component);

  function WidgetsSettings(props) {
    _classCallCheck(this, WidgetsSettings);

    var _this = _possibleConstructorReturn(this, (WidgetsSettings.__proto__ || Object.getPrototypeOf(WidgetsSettings)).call(this, props));

    _this.state = {
      userWidgets: null
    };
    return _this;
  }

  _createClass(WidgetsSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var user = this.props.user;


      var userWidgets = {};
      var node;

      for (var index in user.widgets.edges) {
        node = user.widgets.edges[index].node;
        userWidgets[node.name] = node;
      }

      this.setState({
        userWidgets: userWidgets
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          app = _props.app,
          showError = _props.showError;

      // We need to wait for the
      // userWidgetsMap to be created before
      // mounting the WidgetSettings.

      if (!this.state.userWidgets) {
        return null;
      }

      var self = this;
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 0 } },
        app.widgets.edges.map(function (edge, index) {
          return _react2.default.createElement(_WidgetSettingsContainer2.default, {
            key: index,
            user: user,
            appWidget: edge.node,
            widget: self.state.userWidgets[edge.node.name] || null,
            showError: showError });
        })
      );
    }
  }]);

  return WidgetsSettings;
}(_react2.default.Component);

WidgetsSettings.propTypes = {
  user: _propTypes2.default.object.isRequired,
  app: _propTypes2.default.object.isRequired,
  showError: _propTypes2.default.func.isRequired
};

exports.default = WidgetsSettings;

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _WidgetsSettingsComponent = __webpack_require__(1328);

var _WidgetsSettingsComponent2 = _interopRequireDefault(_WidgetsSettingsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_WidgetsSettingsComponent2.default, {
  user: function user() {
    return __webpack_require__(1335);
  },
  app: function app() {
    return __webpack_require__(1334);
  }
});

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql; /* global graphql */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(16);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _SettingsChildWrapperComponent = __webpack_require__(186);

var _SettingsChildWrapperComponent2 = _interopRequireDefault(_SettingsChildWrapperComponent);

var _WidgetsSettingsContainer = __webpack_require__(1329);

var _WidgetsSettingsContainer2 = _interopRequireDefault(_WidgetsSettingsContainer);

var _AuthUserComponent = __webpack_require__(149);

var _AuthUserComponent2 = _interopRequireDefault(_AuthUserComponent);

var _ErrorMessage = __webpack_require__(112);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetsSettingsView = function (_React$Component) {
  _inherits(WidgetsSettingsView, _React$Component);

  function WidgetsSettingsView() {
    _classCallCheck(this, WidgetsSettingsView);

    return _possibleConstructorReturn(this, (WidgetsSettingsView.__proto__ || Object.getPrototypeOf(WidgetsSettingsView)).apply(this, arguments));
  }

  _createClass(WidgetsSettingsView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _AuthUserComponent2.default,
        null,
        _react2.default.createElement(_reactRelay.QueryRenderer, {
          environment: _relayEnv2.default,
          query: _graphql || (_graphql = function _graphql() {
            return __webpack_require__(1336);
          }),
          render: function render(_ref) {
            var error = _ref.error,
                props = _ref.props;

            if (error) {
              console.error(error, error.source);
              var errMsg = 'We had a problem loading the widget settings :(';
              return _react2.default.createElement(_ErrorMessage2.default, { message: errMsg });
            }
            var showError = _this2.props.showError;
            var dataLoaded = !!props;
            return _react2.default.createElement(
              _SettingsChildWrapperComponent2.default,
              { loaded: dataLoaded },
              dataLoaded ? _react2.default.createElement(_WidgetsSettingsContainer2.default, {
                app: props.app,
                user: props.user,
                showError: showError }) : null
            );
          } })
      );
    }
  }]);

  return WidgetsSettingsView;
}(_react2.default.Component);

exports.default = WidgetsSettingsView;

/***/ }),

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetSettingsContainer_appWidget$ref: FragmentReference;
export type WidgetSettingsContainer_appWidget = {|
  +id: string,
  +name: ?string,
  +type: ?string,
  +settings: ?string,
  +$refType: WidgetSettingsContainer_appWidget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetSettingsContainer_appWidget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "settings",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '407aff42f3fe283896873dd0d0931647';
module.exports = node;

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetSettingsContainer_user$ref: FragmentReference;
export type WidgetSettingsContainer_user = {|
  +id: string,
  +$refType: WidgetSettingsContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetSettingsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '84a2914ef404b266baa43b151aaf86a0';
module.exports = node;

/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetSettingsContainer_widget$ref: FragmentReference;
export type WidgetSettingsContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +config: ?string,
  +settings: ?string,
  +$refType: WidgetSettingsContainer_widget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetSettingsContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "config",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "settings",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'bdc4c18b781168319e4048c127334ce1';
module.exports = node;

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type WidgetSettingsContainer_appWidget$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetsSettingsContainer_app$ref: FragmentReference;
export type WidgetsSettingsContainer_app = {|
  +widgets: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +$fragmentRefs: WidgetSettingsContainer_appWidget$ref,
      |}
    |}>
  |},
  +$refType: WidgetsSettingsContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetsSettingsContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "name": "widgets",
    "storageKey": "widgets(first:20)",
    "args": [{
      "kind": "Literal",
      "name": "first",
      "value": 20,
      "type": "Int"
    }],
    "concreteType": "WidgetConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "WidgetEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Widget",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "FragmentSpread",
          "name": "WidgetSettingsContainer_appWidget",
          "args": null
        }]
      }]
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = 'bffaf541158cf1e353d66cacfeb913de';
module.exports = node;

/***/ }),

/***/ 1335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type WidgetSettingsContainer_user$ref = any;
type WidgetSettingsContainer_widget$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetsSettingsContainer_user$ref: FragmentReference;
export type WidgetsSettingsContainer_user = {|
  +widgets: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +$fragmentRefs: WidgetSettingsContainer_widget$ref,
      |}
    |}>
  |},
  +$fragmentRefs: WidgetSettingsContainer_user$ref,
  +$refType: WidgetsSettingsContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetsSettingsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "FragmentSpread",
    "name": "WidgetSettingsContainer_user",
    "args": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "widgets",
    "storageKey": "widgets(first:20)",
    "args": [{
      "kind": "Literal",
      "name": "first",
      "value": 20,
      "type": "Int"
    }],
    "concreteType": "WidgetConnection",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "WidgetEdge",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "Widget",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }, {
          "kind": "FragmentSpread",
          "name": "WidgetSettingsContainer_widget",
          "args": null
        }]
      }]
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '36a8c3eb320cf43d9b81e25191abccc4';
module.exports = node;

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0ad98e0d772e07a415c732da9993218d
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
type WidgetsSettingsContainer_app$ref = any;
type WidgetsSettingsContainer_user$ref = any;
export type WidgetsSettingsViewQueryVariables = {|
  userId: string
|};
export type WidgetsSettingsViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: WidgetsSettingsContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: WidgetsSettingsContainer_user$ref
  |},
|};
export type WidgetsSettingsViewQuery = {|
  variables: WidgetsSettingsViewQueryVariables,
  response: WidgetsSettingsViewQueryResponse,
|};
*/

/*
query WidgetsSettingsViewQuery(
  $userId: String!
) {
  app {
    ...WidgetsSettingsContainer_app
    id
  }
  user(userId: $userId) {
    ...WidgetsSettingsContainer_user
    id
  }
}

fragment WidgetsSettingsContainer_app on App {
  widgets(first: 20) {
    edges {
      node {
        id
        name
        ...WidgetSettingsContainer_appWidget
      }
    }
  }
}

fragment WidgetsSettingsContainer_user on User {
  ...WidgetSettingsContainer_user
  widgets(first: 20) {
    edges {
      node {
        id
        name
        ...WidgetSettingsContainer_widget
      }
    }
  }
}

fragment WidgetSettingsContainer_user on User {
  id
}

fragment WidgetSettingsContainer_widget on Widget {
  id
  name
  enabled
  config
  settings
}

fragment WidgetSettingsContainer_appWidget on Widget {
  id
  name
  type
  settings
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }],
      v2 = [{
    "kind": "Literal",
    "name": "first",
    "value": 20,
    "type": "Int"
  }],
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "settings",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "query",
    "name": "WidgetsSettingsViewQuery",
    "id": null,
    "text": "query WidgetsSettingsViewQuery(\n  $userId: String!\n) {\n  app {\n    ...WidgetsSettingsContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...WidgetsSettingsContainer_user\n    id\n  }\n}\n\nfragment WidgetsSettingsContainer_app on App {\n  widgets(first: 20) {\n    edges {\n      node {\n        id\n        name\n        ...WidgetSettingsContainer_appWidget\n      }\n    }\n  }\n}\n\nfragment WidgetsSettingsContainer_user on User {\n  ...WidgetSettingsContainer_user\n  widgets(first: 20) {\n    edges {\n      node {\n        id\n        name\n        ...WidgetSettingsContainer_widget\n      }\n    }\n  }\n}\n\nfragment WidgetSettingsContainer_user on User {\n  id\n}\n\nfragment WidgetSettingsContainer_widget on Widget {\n  id\n  name\n  enabled\n  config\n  settings\n}\n\nfragment WidgetSettingsContainer_appWidget on Widget {\n  id\n  name\n  type\n  settings\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "WidgetsSettingsViewQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "WidgetsSettingsContainer_app",
          "args": null
        }]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "WidgetsSettingsContainer_user",
          "args": null
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "WidgetsSettingsViewQuery",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "widgets",
          "storageKey": "widgets(first:20)",
          "args": v2,
          "concreteType": "WidgetConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "WidgetEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Widget",
              "plural": false,
              "selections": [v3, v4, {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              }, v5]
            }]
          }]
        }, v3]
      }, {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [v3, {
          "kind": "LinkedField",
          "alias": null,
          "name": "widgets",
          "storageKey": "widgets(first:20)",
          "args": v2,
          "concreteType": "WidgetConnection",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "WidgetEdge",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Widget",
              "plural": false,
              "selections": [v3, v4, {
                "kind": "ScalarField",
                "alias": null,
                "name": "enabled",
                "args": null,
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "name": "config",
                "args": null,
                "storageKey": null
              }, v5]
            }]
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '31bf55c7dfa924f7f38a30623ff3b467';
module.exports = node;

/***/ }),

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _object = __webpack_require__(212);

var _lang = __webpack_require__(107);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(46);

var _localBkgSettings = __webpack_require__(576);

var _SetBackgroundDailyImageMutation = __webpack_require__(575);

var _SetBackgroundDailyImageMutation2 = _interopRequireDefault(_SetBackgroundDailyImageMutation);

var _FadeBackgroundAnimation = __webpack_require__(1230);

var _FadeBackgroundAnimation2 = _interopRequireDefault(_FadeBackgroundAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/href-no-hash */


/*
 * We want to load the background as quickly as possible,
 * so this component interacts with local storage and the
 * parent frame (the browser extension's local new tab page).
 * On mount, it tries to load background settings from
 * local storage; if settings exist in local storage, it posts
 * a message to the parent frame to make sure the background
 * settings used by the extension new tab page are up to date.
 * When the user data returns from the server, if the user's
 * background settings are different from those in local
 * storage, it updates the component state and messages the parent
 * frame. If the user's settings from the server are identical,
 * it should not update state or message the parent frame.
*/
var UserBackgroundImage = function (_React$Component) {
  _inherits(UserBackgroundImage, _React$Component);

  function UserBackgroundImage(props) {
    _classCallCheck(this, UserBackgroundImage);

    var _this = _possibleConstructorReturn(this, (UserBackgroundImage.__proto__ || Object.getPrototypeOf(UserBackgroundImage)).call(this, props));

    _this.state = {
      // The image we are currently showing (or fading in to show).
      currentlyDisplayedImgURL: null,
      // Whether there was a problem preloading the user's image.
      imgPreloadError: false,
      // Whether we are currently waiting on a response for a
      // request to get a new daily background image.
      currentlyFetchingNewBackgroundImage: false,
      // The user's background settings. They might not reflect what
      // background is currently displayed because we want to fully
      // preload images before displaying them.
      backgroundOption: (0, _localBkgSettings.getUserBackgroundOption)(),
      customImage: (0, _localBkgSettings.getUserBackgroundCustomImage)(),
      backgroundColor: (0, _localBkgSettings.getUserBackgroundColor)(),
      backgroundImageURL: (0, _localBkgSettings.getUserBackgroundImageURL)()
    };
    return _this;
  }

  _createClass(UserBackgroundImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handlePropChanges(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.handlePropChanges(nextProps);
    }
  }, {
    key: 'handlePropChanges',
    value: function handlePropChanges(props) {
      // Update the state, localStorage, and extension
      // background settings if we have all prop data from
      // the server and the props differ from current state.
      if (this.arePropsReady(props)) {
        if (this.arePropsDifferentFromState(props)) {
          this.updateBackgroundSettings(props);
        }

        // See if we should fetch a new daily background image.
        this.getNewDailyImageIfNeeded(props);
      }
    }

    /**
     * Determine if all background data has returned from
     * the server.
     * @return {Boolean} Whether all necessary props are defined
     */

  }, {
    key: 'arePropsReady',
    value: function arePropsReady(props) {
      return (0, _object.has)(props, ['user', 'backgroundOption']) && (0, _object.has)(props, ['user', 'customImage']) && (0, _object.has)(props, ['user', 'backgroundColor']) && (0, _object.has)(props, ['user', 'backgroundImage', 'imageURL']) && (0, _object.has)(props, ['user', 'backgroundImage', 'timestamp']);
    }

    /**
     * Determine if the props hold background settings that are
     * different from the background settings currently in this
     * component's state.
     * @param {Object} props - The component props, either `this.props`
     *   or the next `this.props` from componentWillReceiveProps
     * @return {Boolean} Whether prop values differ from state values
     */

  }, {
    key: 'arePropsDifferentFromState',
    value: function arePropsDifferentFromState(props) {
      return (0, _object.get)(props, ['user', 'backgroundOption']) !== this.state.backgroundOption || (0, _object.get)(props, ['user', 'customImage']) !== this.state.customImage || (0, _object.get)(props, ['user', 'backgroundColor']) !== this.state.backgroundColor || (0, _object.get)(props, ['user', 'backgroundImage', 'imageURL']) !== this.state.backgroundImageURL;
    }

    /**
     * Update component state and make sure localStorage and the extension's
     * storage are in sync with the latest state. We can't just rely on when the
     * user changes their settings on this device, because the user might
     * change their background on another device or we might otherwise update
     * the values in the database.
     * @param {Object} props - The component props, either `this.props`
     *   or the next `this.props` from componentWillReceiveProps
     * @return {undefined}
     */

  }, {
    key: 'updateBackgroundSettings',
    value: function updateBackgroundSettings(props) {
      var backgroundOption = (0, _object.get)(props, ['user', 'backgroundOption']);
      var customImage = (0, _object.get)(props, ['user', 'customImage']);
      var backgroundColor = (0, _object.get)(props, ['user', 'backgroundColor']);
      var backgroundImageURL = (0, _object.get)(props, ['user', 'backgroundImage', 'imageURL']);
      this.setState({
        backgroundOption: backgroundOption,
        customImage: customImage,
        backgroundColor: backgroundColor,
        backgroundImageURL: backgroundImageURL
      });

      // Update in localStorage and extension storage.
      (0, _localBkgSettings.setBackgroundSettings)(backgroundOption, customImage, backgroundColor, backgroundImageURL);
    }

    /**
     * If the user's background settings are to show a new photo daily,
     * determine if it's a new day and the photo needs to be updated.
     * If so, fetch a new background photo.
     * @param {Object} props - The component props, either `this.props`
     *   or the next `this.props` from componentWillReceiveProps. We
     *   can't assume that `props.user` will be defined.
     * @return {undefined}
     */

  }, {
    key: 'getNewDailyImageIfNeeded',
    value: function getNewDailyImageIfNeeded(props) {
      var _this2 = this;

      if ((0, _object.get)(props, ['user', 'backgroundOption']) !== _constants.USER_BACKGROUND_OPTION_DAILY) {
        return;
      }
      var lastTimeBackgroundImgChanged = (0, _object.get)(props, ['user', 'backgroundImage', 'timestamp']);
      if ((0, _lang.isNil)(lastTimeBackgroundImgChanged)) {
        return;
      }

      var shouldChangeBackgroundImg = !this.state.currentlyFetchingNewBackgroundImage &&
      // Check if today is a different day (in local time) than
      // the last time the background image changed.
      !(0, _moment2.default)().local().startOf('day').isSame((0, _moment2.default)(lastTimeBackgroundImgChanged).local().startOf('day'));

      this.setState({
        currentlyFetchingNewBackgroundImage: true
      });

      // Fetch a new background image for today.
      if (shouldChangeBackgroundImg) {
        (0, _SetBackgroundDailyImageMutation2.default)(props.relay.environment, props.user.id,
        // When the request returns, unmark that a request
        // is outstanding.
        function () {
          _this2.setState({
            currentlyFetchingNewBackgroundImage: false
          });
        }, function () {
          _this2.setState({
            currentlyFetchingNewBackgroundImage: false
          });
        });
      }
    }

    /**
     * Handler for when the preloaded background image has loaded.
     * @return {undefined}
     */

  }, {
    key: 'onImgLoad',
    value: function onImgLoad() {
      this.setState({
        currentlyDisplayedImgURL: this.getImgURL()
      });
    }

    /**
     * Handler for when the preloaded background image fails to
     * load and throws an error.
     * @return {undefined}
     */

  }, {
    key: 'onImgError',
    value: function onImgError() {
      this.setState({
        imgPreloadError: true
      });
      this.props.showError('We could not load your background image.');
    }

    /**
     * Get the image URL if the user has an image background. Note:
     * this is the user's current setting but not necessarily the image
     * we are currently displaying, because we'll wait to preload the
     * image first.
     * @return {String|null} The image URL if one exists, or null
     *   if the user does not have an image background.
     */

  }, {
    key: 'getImgURL',
    value: function getImgURL() {
      var backgroundOption = this.state.backgroundOption;
      switch (backgroundOption) {
        case _constants.USER_BACKGROUND_OPTION_CUSTOM:
          return this.state.customImage;
        case _constants.USER_BACKGROUND_OPTION_PHOTO:
          return this.state.backgroundImageURL;
        case _constants.USER_BACKGROUND_OPTION_DAILY:
          return this.state.backgroundImageURL;
        default:
          return null;
      }
    }

    /**
     * Return whether the user has a photo/image background (e.g.
     * not a color background).
     * @return {Boolean} Whether the user's background setting is
     *   for a photo background.
     */

  }, {
    key: 'isImgBackground',
    value: function isImgBackground() {
      return [_constants.USER_BACKGROUND_OPTION_CUSTOM, _constants.USER_BACKGROUND_OPTION_DAILY, _constants.USER_BACKGROUND_OPTION_PHOTO].indexOf(this.state.backgroundOption) > -1;
    }
  }, {
    key: 'render',
    value: function render() {
      var isImgBackground = this.isImgBackground();
      var newestImgURL = this.getImgURL();

      // Construct the style for the background element.
      var defaultStyle = {
        boxShadow: 'rgba(0, 0, 0, 0.5) 0px 0px 120px inset',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        WebkitBackgroundSize: 'cover',
        MozBackgroundSize: 'cover',
        backgroundSize: 'cover',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: 'auto'
      };
      var backgroundStyle = {};
      var invalidBackgroundSettings = false;
      var backgroundOption = this.state.backgroundOption;
      var currentlyDisplayedImgURL = this.state.currentlyDisplayedImgURL;
      switch (backgroundOption) {
        case _constants.USER_BACKGROUND_OPTION_CUSTOM:
          if (this.state.customImage) {
            backgroundStyle = {
              backgroundImage: 'url(' + currentlyDisplayedImgURL + ')'
            };
          } else {
            invalidBackgroundSettings = true;
          }
          break;
        case _constants.USER_BACKGROUND_OPTION_COLOR:
          if (this.state.backgroundColor) {
            backgroundStyle = {
              backgroundColor: this.state.backgroundColor
            };
          } else {
            invalidBackgroundSettings = true;
          }
          break;
        case _constants.USER_BACKGROUND_OPTION_PHOTO:
          if (this.state.backgroundImageURL) {
            backgroundStyle = {
              backgroundImage: 'url(' + currentlyDisplayedImgURL + ')'
            };
          } else {
            invalidBackgroundSettings = true;
          }
          break;
        case _constants.USER_BACKGROUND_OPTION_DAILY:
          if (this.state.backgroundImageURL) {
            backgroundStyle = {
              backgroundImage: 'url(' + currentlyDisplayedImgURL + ')'
            };
          } else {
            invalidBackgroundSettings = true;
          }
          break;
        default:
          backgroundStyle = {
            backgroundImage: 'none',
            backgroundColor: 'transparent'
          };
          break;
      }

      // The fallback style if there's an error.
      if (this.state.imgPreloadError || invalidBackgroundSettings) {
        backgroundStyle = {
          backgroundColor: '#4a90e2'
        };
      }
      var finalBackgroundStyle = Object.assign({}, defaultStyle, backgroundStyle);

      // React key for the background element
      var backgroundKey = '';
      if (isImgBackground) {
        backgroundKey = 'img-' + this.state.currentlyDisplayedImgURL;
      } else {
        backgroundKey = 'color-' + this.state.backgroundColor;
      }

      // Only show image backgrounds if the image has already loaded.
      // Immediately show color backgrounds and the fallback background for
      // when images fail to load.
      var showBackground;
      if (invalidBackgroundSettings || this.state.imgPreloadError) {
        showBackground = true;
      } else if (isImgBackground && !this.state.currentlyDisplayedImgURL) {
        showBackground = false;
      } else {
        showBackground = true;
      }

      // For image backgrounds, we use an img element to "preload"
      // the image before displaying the background.
      // Note: if the props return a different image URL than what's
      // in localStorage, it's possible for the old and new images to
      // fade in at the same time (which doesn't look good). We should
      // handle this with a callback from the animated components
      // when they're done animating to prevent two at the same time,
      // but react-transition-group only supports this in v2. For now,
      // we've slightly delayed the CSS "enter" transition for new
      // images.
      return _react2.default.createElement(
        'div',
        null,
        showBackground ? _react2.default.createElement(
          _FadeBackgroundAnimation2.default,
          null,
          _react2.default.createElement(
            'div',
            { key: backgroundKey, style: finalBackgroundStyle, 'data-test-id': 'dashboard-background-img' },
            _react2.default.createElement('div', {
              'data-test-id': 'background-tint-overlay',
              style: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                zIndex: 'auto',
                // Needs to match shading in extension new tab page.
                backgroundColor: 'rgba(0, 0, 0, ' + (isImgBackground ? 0.15 : 0.03) + ')'
              } })
          )
        ) : null,
        isImgBackground ? _react2.default.createElement('img', {
          style: { display: 'none' },
          src: newestImgURL,
          alt: '',
          onLoad: this.onImgLoad.bind(this),
          onError: this.onImgError.bind(this) }) : null
      );
    }
  }]);

  return UserBackgroundImage;
}(_react2.default.Component);

UserBackgroundImage.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    backgroundOption: _propTypes2.default.string,
    customImage: _propTypes2.default.string,
    backgroundColor: _propTypes2.default.string,
    backgroundImage: _propTypes2.default.shape({
      imageURL: _propTypes2.default.string,
      timestamp: _propTypes2.default.string
    })
  }),
  showError: _propTypes2.default.func,
  relay: _propTypes2.default.shape({
    environment: _propTypes2.default.object.isRequired
  })
};

UserBackgroundImage.defaultProps = {
  showError: function showError() {}
};

exports.default = UserBackgroundImage;

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _UserBackgroundImageComponent = __webpack_require__(1337);

var _UserBackgroundImageComponent2 = _interopRequireDefault(_UserBackgroundImageComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_UserBackgroundImageComponent2.default, {
  user: function user() {
    return __webpack_require__(1341);
  }
});

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DashboardPopover = __webpack_require__(567);

var _DashboardPopover2 = _interopRequireDefault(_DashboardPopover);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _Divider = __webpack_require__(258);

var _Divider2 = _interopRequireDefault(_Divider);

var _Menu = __webpack_require__(475);

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__(334);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _IconButton = __webpack_require__(119);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _favorite = __webpack_require__(485);

var _favorite2 = _interopRequireDefault(_favorite);

var _favoriteBorder = __webpack_require__(793);

var _favoriteBorder2 = _interopRequireDefault(_favoriteBorder);

var _moreVert = __webpack_require__(2200);

var _moreVert2 = _interopRequireDefault(_moreVert);

var _settings = __webpack_require__(2186);

var _settings2 = _interopRequireDefault(_settings);

var _help = __webpack_require__(2181);

var _help2 = _interopRequireDefault(_help);

var _personAdd = __webpack_require__(2202);

var _personAdd2 = _interopRequireDefault(_personAdd);

var _insertChart = __webpack_require__(796);

var _insertChart2 = _interopRequireDefault(_insertChart);

var _done = __webpack_require__(2179);

var _done2 = _interopRequireDefault(_done);

var _exitToApp = __webpack_require__(2180);

var _exitToApp2 = _interopRequireDefault(_exitToApp);

var _navigation = __webpack_require__(50);

var _user = __webpack_require__(64);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

var _utils = __webpack_require__(81);

var _constants = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var UserMenu = function (_React$Component) {
  _inherits(UserMenu, _React$Component);

  function UserMenu(props) {
    _classCallCheck(this, UserMenu);

    var _this = _possibleConstructorReturn(this, (UserMenu.__proto__ || Object.getPrototypeOf(UserMenu)).call(this, props));

    _this.state = {
      heartsHover: false,
      heartsPopoverOpen: false,
      menuIconHover: false,
      menuOpen: false,
      // refs
      heartsPopoverAnchorElem: null,
      heartsHoverPopoverAnchorElem: null,
      menuPopoverAnchorElem: null
    };
    return _this;
  }

  _createClass(UserMenu, [{
    key: 'logout',
    value: function logout() {
      var _this2 = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var logoutSuccess;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logoutSuccess = false;
                _context.prev = 1;
                _context.next = 4;
                return (0, _user.logout)();

              case 4:
                logoutSuccess = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);

              case 10:
                if (logoutSuccess) {
                  (0, _navigation.goToLogin)();
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 7]]);
      }))();
    }
  }, {
    key: 'onHeartsHover',
    value: function onHeartsHover(hovering, event) {
      this.setState({
        heartsHover: hovering,
        heartsHoverPopoverAnchorElem: event.currentTarget
      });
    }
  }, {
    key: 'onHeartsClick',
    value: function onHeartsClick(event) {
      this.setState({
        heartsPopoverOpen: !this.state.open,
        heartsPopoverAnchorElem: event.currentTarget
      });
    }
  }, {
    key: 'handleHeartsPopoverClose',
    value: function handleHeartsPopoverClose() {
      this.setState({
        heartsPopoverOpen: false
      });
    }
  }, {
    key: 'onMenuClick',
    value: function onMenuClick(event) {
      this.setState({
        menuOpen: !this.state.open,
        menuPopoverAnchorElem: event.currentTarget
      });
    }
  }, {
    key: 'handleMenuPopoverClose',
    value: function handleMenuPopoverClose() {
      this.setState({
        menuOpen: false
      });
    }
  }, {
    key: 'onMenuIconHover',
    value: function onMenuIconHover(hovering) {
      this.setState({
        menuIconHover: hovering
      });
    }
  }, {
    key: 'onHover',
    value: function onHover(hovering) {
      this.setState({
        hover: hovering
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          app = _props.app,
          user = _props.user,
          isUserAnonymous = _props.isUserAnonymous;

      if (!user || !app) {
        return null;
      }

      var userMenuStyle = {
        display: 'flex',
        alignItems: 'center'

        // Hearts style
      };var textStyle = Object.assign({}, {
        color: this.state.heartsHover ? _default.dashboardIconActiveColor : _default.dashboardIconInactiveColor,
        transition: 'color 300ms ease-in',
        fontSize: 18,
        fontWeight: 'normal',
        fontFamily: _default2.default.fontFamily,
        userSelect: 'none',
        cursor: 'pointer'
      }, this.props.style);
      var heartsStyle = Object.assign({}, textStyle, {
        marginRight: 0,
        display: 'flex',
        alignItems: 'center'
      });

      // Hearts popover style
      var heartsPopoverStyle = {
        textAlign: 'center',
        width: 210
      };
      var heartsPopoverSectionStyle = {};
      var dividerStyle = {
        marginTop: 16,
        marginBottom: 12
      };
      var statTextStyle = {
        fontSize: 14,
        display: 'block',
        marginTop: 4,
        marginBottom: 4
      };
      var smallHeartIconStyle = {
        height: 16,
        marginLeft: -3
      };
      var statNumberStyle = {
        fontSize: 24,
        display: 'block'
      };
      var popoverButtonStyle = {
        marginTop: 6,
        marginBottom: 0
      };
      var popoverButtonLabelStyle = {
        fontSize: 13

        // Popover section on how to earn Hearts.
      };var rewardMethodContainerStyle = Object.assign({}, statTextStyle, {
        display: 'flex',
        textAlign: 'left',
        color: _default.dividerColor,
        marginTop: 1,
        marginBottom: 1
      });
      var rewardAmountsSectionStyle = Object.assign({}, heartsPopoverSectionStyle, {
        paddingLeft: 22,
        paddingRight: 22
      });
      var rewardTextStyle = {
        textAlign: 'left',
        flex: 6
      };
      var rewardValueStyle = {
        flex: 3,
        textAlign: 'right'

        // Menu style
      };var menuWidth = 200;
      var menuPopoverStyle = {
        padding: 0,
        width: menuWidth
      };
      var menuIconButtonStyle = {
        padding: 0,
        width: 40,
        height: 40
      };
      var menuIconStyle = {
        color: this.state.menuIconHover ? _default.dashboardIconActiveColor : _default.dashboardIconInactiveColor,
        transition: 'color 300ms ease-in',
        fontSize: 22
      };
      var menuStyle = {
        width: menuWidth,
        overflowX: 'hidden',
        backgroundColor: 'transparent',
        fontFamily: _default2.default.fontFamily
      };
      var menuItemStyle = {
        fontSize: 14,
        color: _default2.default.palette.alternateTextColor
      };
      var menuItemIconColor = '#FFFFFF';
      var menuItemSvgIconStyle = {
        color: menuItemIconColor,
        height: 22,
        width: 22

        // Used to let the user know they aren't earning any more
        // Hearts from tabs today.
      };var reachedMaxDailyHearts = user.tabsToday >= _constants.MAX_DAILY_HEARTS_FROM_TABS;

      // TODO: add level bar
      return _react2.default.createElement(
        'div',
        {
          style: userMenuStyle },
        _react2.default.createElement(
          'div',
          {
            style: heartsStyle,
            onMouseEnter: this.onHeartsHover.bind(this, true),
            onMouseLeave: this.onHeartsHover.bind(this, false),
            onClick: this.onHeartsClick.bind(this),
            'data-tour-id': 'hearts'
          },
          _react2.default.createElement(
            'span',
            null,
            (0, _utils.commaFormatted)(user.vcCurrent)
          ),
          _react2.default.createElement(
            'span',
            {
              style: { position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' },
              ref: function ref(_ref) {
                _this3.heartIconContainer = _ref;
              }
            },
            _react2.default.createElement(_favoriteBorder2.default, {
              style: { marginLeft: 2, height: 24, width: 24, paddingBottom: 0 },
              color: _default.dashboardIconInactiveColor,
              hoverColor: _default.dashboardIconActiveColor
            }),
            reachedMaxDailyHearts ? _react2.default.createElement(_done2.default, {
              style: { height: 16, width: 16, position: 'absolute', paddingLeft: 4, paddingBottom: 2 },
              color: _default.dashboardIconInactiveColor,
              hoverColor: _default.dashboardIconActiveColor
            }) : null,
            reachedMaxDailyHearts ? _react2.default.createElement(
              _DashboardPopover2.default,
              {
                open: this.state.heartsHover && !this.state.heartsPopoverOpen,
                anchorEl: this.state.heartsHoverPopoverAnchorElem,
                style: heartsPopoverStyle
              },
              _react2.default.createElement(
                'div',
                { style: { padding: 10 } },
                'You\'ve earned the maximum Hearts from opening tabs today! You\'ll be able to earn more Hearts in a few hours.'
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          _DashboardPopover2.default,
          {
            open: this.state.heartsPopoverOpen,
            anchorEl: this.state.heartsPopoverAnchorElem,
            onRequestClose: this.handleHeartsPopoverClose.bind(this),
            style: heartsPopoverStyle
          },
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 10, paddingBottom: 10 } },
            _react2.default.createElement(
              'div',
              { style: heartsPopoverSectionStyle },
              _react2.default.createElement(
                'span',
                { style: statTextStyle },
                _react2.default.createElement(
                  'span',
                  { style: statNumberStyle },
                  'Level ',
                  user.level
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                _react2.default.createElement(
                  'span',
                  null,
                  user.heartsUntilNextLevel
                ),
                _react2.default.createElement(_favoriteBorder2.default, {
                  style: smallHeartIconStyle,
                  color: _default.dashboardIconActiveColor
                }),
                _react2.default.createElement(
                  'span',
                  null,
                  ' until next level'
                )
              )
            ),
            _react2.default.createElement(_Divider2.default, { style: dividerStyle }),
            _react2.default.createElement(
              'div',
              { style: heartsPopoverSectionStyle },
              _react2.default.createElement(
                'span',
                { style: statTextStyle },
                _react2.default.createElement(
                  'span',
                  { style: Object.assign({}, statNumberStyle, {
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }) },
                  _react2.default.createElement(
                    'span',
                    null,
                    user.vcDonatedAllTime
                  ),
                  _react2.default.createElement(_favoriteBorder2.default, {
                    style: { marginLeft: 2, height: 24, width: 24, paddingBottom: 1 },
                    color: _default.dashboardIconActiveColor
                  })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  'Donated'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_RaisedButton2.default, {
                  label: 'Donate Hearts',
                  style: popoverButtonStyle,
                  labelStyle: popoverButtonLabelStyle,
                  primary: true,
                  onClick: _navigation.goToDonate
                })
              )
            ),
            _react2.default.createElement(_Divider2.default, { style: dividerStyle }),
            _react2.default.createElement(
              'div',
              { style: heartsPopoverSectionStyle },
              _react2.default.createElement(
                'span',
                { style: statTextStyle },
                _react2.default.createElement(
                  'span',
                  { style: statNumberStyle },
                  user.numUsersRecruited
                ),
                ' Tabbers Recruited'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_RaisedButton2.default, {
                  label: 'Invite A Friend',
                  labelPosition: 'before',
                  style: popoverButtonStyle,
                  labelStyle: popoverButtonLabelStyle,
                  primary: true,
                  onClick: _navigation.goToInviteFriends
                })
              )
            ),
            _react2.default.createElement(_Divider2.default, { style: dividerStyle }),
            _react2.default.createElement(
              'div',
              { style: rewardAmountsSectionStyle },
              _react2.default.createElement(
                'span',
                { style: rewardMethodContainerStyle },
                _react2.default.createElement(
                  'span',
                  { style: rewardTextStyle },
                  'Open a tab'
                ),
                _react2.default.createElement(
                  'span',
                  { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                  _react2.default.createElement(
                    'span',
                    { style: rewardValueStyle },
                    '1'
                  ),
                  _react2.default.createElement(_favoriteBorder2.default, {
                    style: Object.assign({}, smallHeartIconStyle, { marginRight: -4 }),
                    color: _default.dividerColor
                  })
                )
              ),
              _react2.default.createElement(
                'span',
                { style: rewardMethodContainerStyle },
                _react2.default.createElement(
                  'span',
                  { style: rewardTextStyle },
                  'Recruit a friend'
                ),
                _react2.default.createElement(
                  'span',
                  { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                  _react2.default.createElement(
                    'span',
                    { style: rewardValueStyle },
                    app.referralVcReward
                  ),
                  _react2.default.createElement(_favoriteBorder2.default, {
                    style: Object.assign({}, smallHeartIconStyle, { marginRight: -4 }),
                    color: _default.dividerColor
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _IconButton2.default,
          {
            style: menuIconButtonStyle,
            iconStyle: menuIconStyle,
            onMouseEnter: this.onMenuIconHover.bind(this, true),
            onMouseLeave: this.onMenuIconHover.bind(this, false),
            onClick: this.onMenuClick.bind(this),
            'data-test-id': 'app-menu-icon',
            'data-tour-id': 'settings-button'
          },
          _react2.default.createElement(_moreVert2.default, null)
        ),
        _react2.default.createElement(
          _DashboardPopover2.default,
          {
            style: menuPopoverStyle,
            open: this.state.menuOpen,
            anchorEl: this.state.menuPopoverAnchorElem,
            onRequestClose: this.handleMenuPopoverClose.bind(this)
          },
          _react2.default.createElement(
            _Menu2.default,
            {
              width: menuWidth,
              autoWidth: false,
              style: menuStyle,
              menuItemStyle: menuItemStyle
            },
            _react2.default.createElement(_MenuItem2.default, { primaryText: 'Settings', onClick: _navigation.goToSettings,
              leftIcon: _react2.default.createElement(_settings2.default, { color: menuItemIconColor, style: menuItemSvgIconStyle })
            }),
            _react2.default.createElement(_MenuItem2.default, { primaryText: 'Donate Hearts', onClick: _navigation.goToDonate,
              leftIcon: _react2.default.createElement(_favorite2.default, { color: menuItemIconColor, style: menuItemSvgIconStyle })
            }),
            _react2.default.createElement(_MenuItem2.default, { primaryText: 'Invite Friends', onClick: _navigation.goToInviteFriends,
              leftIcon: _react2.default.createElement(_personAdd2.default, { color: menuItemIconColor, style: menuItemSvgIconStyle })
            }),
            _react2.default.createElement(_MenuItem2.default, { primaryText: 'Your Stats', onClick: _navigation.goToStats,
              leftIcon: _react2.default.createElement(_insertChart2.default, { color: menuItemIconColor, style: menuItemSvgIconStyle })
            }),
            _react2.default.createElement(_Divider2.default, { style: { marginBottom: 0, marginTop: 0 } }),
            _react2.default.createElement(
              'a',
              {
                href: 'https://gladly.zendesk.com/hc/en-us/categories/201939608-Tab-for-a-Cause',
                target: '_blank',
                style: {
                  color: menuItemIconColor,
                  textDecoration: 'none'
                }
              },
              _react2.default.createElement(_MenuItem2.default, { primaryText: 'Help', onClick: _navigation.goToStats,
                leftIcon: _react2.default.createElement(_help2.default, { color: menuItemIconColor, style: menuItemSvgIconStyle }),
                style: menuItemStyle
              })
            ),
            !isUserAnonymous ? _react2.default.createElement(_Divider2.default, { style: { marginBottom: 0, marginTop: 0 } }) : null,
            !isUserAnonymous ? _react2.default.createElement(_MenuItem2.default, {
              primaryText: 'Sign Out',
              onClick: this.logout.bind(this),
              'data-test-id': 'app-menu-sign-out',
              leftIcon: _react2.default.createElement(_exitToApp2.default, { color: menuItemIconColor, style: menuItemSvgIconStyle })
            }) : null
          )
        )
      );
    }
  }]);

  return UserMenu;
}(_react2.default.Component);

UserMenu.propTypes = {
  app: _propTypes2.default.shape({
    referralVcReward: _propTypes2.default.number.isRequired
  }),
  user: _propTypes2.default.shape({
    vcCurrent: _propTypes2.default.number.isRequired,
    level: _propTypes2.default.number.isRequired,
    heartsUntilNextLevel: _propTypes2.default.number.isRequired,
    vcDonatedAllTime: _propTypes2.default.number.isRequired,
    numUsersRecruited: _propTypes2.default.number.isRequired,
    tabsToday: _propTypes2.default.number.isRequired
  }),
  isUserAnonymous: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

UserMenu.defaultProps = {
  isUserAnonymous: false,
  style: {}
};

exports.default = UserMenu;

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _UserMenuComponent = __webpack_require__(1339);

var _UserMenuComponent2 = _interopRequireDefault(_UserMenuComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_UserMenuComponent2.default, {
  app: function app() {
    return __webpack_require__(1342);
  },
  user: function user() {
    return __webpack_require__(1343);
  }
});

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserBackgroundImageContainer_user$ref: FragmentReference;
export type UserBackgroundImageContainer_user = {|
  +id: string,
  +backgroundOption: ?string,
  +customImage: ?string,
  +backgroundColor: ?string,
  +backgroundImage: ?{|
    +imageURL: ?string,
    +timestamp: ?string,
  |},
  +$refType: UserBackgroundImageContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "UserBackgroundImageContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundOption",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "customImage",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundColor",
    "args": null,
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "name": "backgroundImage",
    "storageKey": null,
    "args": null,
    "concreteType": "BackgroundImage",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "imageURL",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    }]
  }]
};
// prettier-ignore
node /*: any*/.hash = '145a4f533fcf42c7355d51459702c96d';
module.exports = node;

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserMenuContainer_app$ref: FragmentReference;
export type UserMenuContainer_app = {|
  +referralVcReward: ?number,
  +$refType: UserMenuContainer_app$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "UserMenuContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "referralVcReward",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '858779025ef331f3a6ee835602f68d08';
module.exports = node;

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserMenuContainer_user$ref: FragmentReference;
export type UserMenuContainer_user = {|
  +id: string,
  +vcCurrent: ?number,
  +level: ?number,
  +heartsUntilNextLevel: ?number,
  +vcDonatedAllTime: ?number,
  +numUsersRecruited: ?number,
  +tabsToday: ?number,
  +$refType: UserMenuContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "UserMenuContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "vcCurrent",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "level",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "heartsUntilNextLevel",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "vcDonatedAllTime",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "numUsersRecruited",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "tabsToday",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '54464f78ee3572819a3a6acad7a842ef';
module.exports = node;

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActiveWidgetAnimation = function (_React$Component) {
  _inherits(ActiveWidgetAnimation, _React$Component);

  function ActiveWidgetAnimation() {
    _classCallCheck(this, ActiveWidgetAnimation);

    return _possibleConstructorReturn(this, (ActiveWidgetAnimation.__proto__ || Object.getPrototypeOf(ActiveWidgetAnimation)).apply(this, arguments));
  }

  _createClass(ActiveWidgetAnimation, [{
    key: 'render',
    value: function render() {
      var animationDurationMs = 220;
      return _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        null,
        _react2.default.Children.map(this.props.children, function (item, i) {
          return item ? _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
              key: i,
              classNames: 'active-widget',
              appear: true,
              timeout: {
                enter: animationDurationMs,
                exit: animationDurationMs
              } },
            item
          ) : null;
        })
      );
    }
  }]);

  return ActiveWidgetAnimation;
}(_react2.default.Component);

exports.default = ActiveWidgetAnimation;

/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditWidgetChipAnimation = function (_React$Component) {
  _inherits(EditWidgetChipAnimation, _React$Component);

  function EditWidgetChipAnimation() {
    _classCallCheck(this, EditWidgetChipAnimation);

    return _possibleConstructorReturn(this, (EditWidgetChipAnimation.__proto__ || Object.getPrototypeOf(EditWidgetChipAnimation)).apply(this, arguments));
  }

  _createClass(EditWidgetChipAnimation, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        null,
        _react2.default.Children.map(this.props.children, function (item, i) {
          return item ? _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
              key: i,
              classNames: 'edit-widget-chip',
              appear: false,
              timeout: {
                enter: 300,
                exit: 100
              } },
            item
          ) : null;
        })
      );
    }
  }]);

  return EditWidgetChipAnimation;
}(_react2.default.Component);

exports.default = EditWidgetChipAnimation;

/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(46);

var _BookmarksWidgetContainer = __webpack_require__(1353);

var _BookmarksWidgetContainer2 = _interopRequireDefault(_BookmarksWidgetContainer);

var _SearchWidgetContainer = __webpack_require__(1369);

var _SearchWidgetContainer2 = _interopRequireDefault(_SearchWidgetContainer);

var _ClockWidgetContainer = __webpack_require__(1358);

var _ClockWidgetContainer2 = _interopRequireDefault(_ClockWidgetContainer);

var _NotesWidgetContainer = __webpack_require__(1364);

var _NotesWidgetContainer2 = _interopRequireDefault(_NotesWidgetContainer);

var _TodosWidgetContainer = __webpack_require__(1375);

var _TodosWidgetContainer2 = _interopRequireDefault(_TodosWidgetContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Widget = function (_React$Component) {
  _inherits(Widget, _React$Component);

  function Widget() {
    _classCallCheck(this, Widget);

    return _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).apply(this, arguments));
  }

  _createClass(Widget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          widget = _props.widget,
          user = _props.user;


      switch (widget.type) {
        case _constants.WIDGET_TYPE_BOOKMARKS:
          return _react2.default.createElement(_BookmarksWidgetContainer2.default, {
            widget: widget,
            user: user,
            showError: this.props.showError });

        case _constants.WIDGET_TYPE_SEARCH:
          return _react2.default.createElement(_SearchWidgetContainer2.default, {
            widget: widget,
            user: user });

        case _constants.WIDGET_TYPE_CLOCK:
          return _react2.default.createElement(_ClockWidgetContainer2.default, {
            widget: widget,
            user: user });

        case _constants.WIDGET_TYPE_NOTES:
          return _react2.default.createElement(_NotesWidgetContainer2.default, {
            widget: widget,
            user: user,
            showError: this.props.showError });

        case _constants.WIDGET_TYPE_TODOS:
          return _react2.default.createElement(_TodosWidgetContainer2.default, {
            widget: widget,
            user: user,
            showError: this.props.showError });
        default:
          return null;
      }
    }
  }]);

  return Widget;
}(_react2.default.Component);

Widget.propTypes = {
  widget: _propTypes2.default.shape({
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  user: _propTypes2.default.object.isRequired,
  showError: _propTypes2.default.func.isRequired
};

exports.default = Widget;

/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _WidgetComponent = __webpack_require__(1346);

var _WidgetComponent2 = _interopRequireDefault(_WidgetComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_WidgetComponent2.default, {
  widget: function widget() {
    return __webpack_require__(1381);
  },
  user: function user() {
    return __webpack_require__(1380);
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = __webpack_require__(119);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _bookmarkBorder = __webpack_require__(792);

var _bookmarkBorder2 = _interopRequireDefault(_bookmarkBorder);

var _formatListBulleted = __webpack_require__(795);

var _formatListBulleted2 = _interopRequireDefault(_formatListBulleted);

var _chatBubbleOutline = __webpack_require__(794);

var _chatBubbleOutline2 = _interopRequireDefault(_chatBubbleOutline);

var _search = __webpack_require__(486);

var _search2 = _interopRequireDefault(_search);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

var _constants = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import ListIcon from 'material-ui/svg-icons/action/list'

// import NoteIcon from 'material-ui/svg-icons/av/note'
// import EditIcon from 'material-ui/svg-icons/editor/mode-edit'
// import CropPortraitIcon from 'material-ui/svg-icons/image/crop-portrait'
// import FolderOpenIcon from 'material-ui/svg-icons/file/folder-open'


var WidgetIcon = function (_React$Component) {
  _inherits(WidgetIcon, _React$Component);

  function WidgetIcon() {
    _classCallCheck(this, WidgetIcon);

    return _possibleConstructorReturn(this, (WidgetIcon.__proto__ || Object.getPrototypeOf(WidgetIcon)).apply(this, arguments));
  }

  _createClass(WidgetIcon, [{
    key: 'onWidgetIconClicked',
    value: function onWidgetIconClicked() {
      this.props.onWidgetIconClicked(this.props.widget);
    }
  }, {
    key: 'render',
    value: function render() {
      var widget = this.props.widget;


      var style = {
        container: {
          background: 'transparent',
          padding: 0,
          borderRadius: '100%',
          margin: 5,
          width: 44,
          height: 44
        }
      };
      var activeStyle = {};
      if (this.props.active) {
        var boxShadow = 'rgba(0, 0, 0, 0.3) 0px 19px 60px, rgba(0, 0, 0, 0.16) 0px 8px 10px';
        activeStyle = {
          background: _default2.default.palette.primary1Color,
          boxShadow: boxShadow,
          transform: 'scale(1.14)',
          WebkitBoxShadow: boxShadow
        };
      }
      var iconButtonStyle = Object.assign({}, style.container, activeStyle);
      var iconColor = this.props.active ? _default.dashboardIconActiveColor : _default.dashboardIconInactiveColor;
      var iconHoverColor = _default.dashboardIconActiveColor;

      var icon;
      switch (widget.type) {
        case _constants.WIDGET_TYPE_BOOKMARKS:
          icon = _react2.default.createElement(_bookmarkBorder2.default, {
            color: iconColor,
            hoverColor: iconHoverColor
          });
          break;

        case _constants.WIDGET_TYPE_NOTES:
          icon = _react2.default.createElement(_chatBubbleOutline2.default, {
            color: iconColor,
            hoverColor: iconHoverColor
          });
          break;

        case _constants.WIDGET_TYPE_SEARCH:
          icon = _react2.default.createElement(_search2.default, {
            color: iconColor,
            hoverColor: iconHoverColor
          });
          break;

        case _constants.WIDGET_TYPE_TODOS:
          icon = _react2.default.createElement(_formatListBulleted2.default, {
            color: iconColor,
            hoverColor: iconHoverColor
          });
          break;

        default:
          icon = null;
      }

      if (!icon) {
        return null;
      }

      // Note: extra span wrapper needed for fade animation to
      // work properly.
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _IconButton2.default,
          {
            style: iconButtonStyle,
            key: this.props.widget.type + 'animation-key',
            onClick: this.onWidgetIconClicked.bind(this)
          },
          icon
        )
      );
    }
  }]);

  return WidgetIcon;
}(_react2.default.Component);

WidgetIcon.propTypes = {
  widget: _propTypes2.default.object.isRequired,
  onWidgetIconClicked: _propTypes2.default.func.isRequired,
  active: _propTypes2.default.bool
};

WidgetIcon.defaultProps = {
  active: false
};

exports.default = WidgetIcon;

/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _WidgetIconComponent = __webpack_require__(1348);

var _WidgetIconComponent2 = _interopRequireDefault(_WidgetIconComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_WidgetIconComponent2.default, {
  widget: function widget() {
    return __webpack_require__(1382);
  }
});

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditWidgetChip = __webpack_require__(382);

var _EditWidgetChip2 = _interopRequireDefault(_EditWidgetChip);

var _TextField = __webpack_require__(95);

var _TextField2 = _interopRequireDefault(_TextField);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-useless-escape: 0 */

var AddBookmarkForm = function (_React$Component) {
  _inherits(AddBookmarkForm, _React$Component);

  function AddBookmarkForm(props) {
    _classCallCheck(this, AddBookmarkForm);

    var _this = _possibleConstructorReturn(this, (AddBookmarkForm.__proto__ || Object.getPrototypeOf(AddBookmarkForm)).call(this, props));

    _this.state = {
      open: false,
      nameRequiredError: false,
      urlRequiredError: false
    };
    return _this;
  }

  _createClass(AddBookmarkForm, [{
    key: '_handleKeyPress',
    value: function _handleKeyPress(e) {
      if (e.key === 'Enter') {
        if (!e.shiftKey) {
          e.stopPropagation();
          e.preventDefault();
          this.create();
        }
      }
    }
  }, {
    key: 'openForm',
    value: function openForm() {
      var _this2 = this;

      this.setState({
        open: true
      }, function () {
        _this2.focusInput();
      });
    }
  }, {
    key: 'closeForm',
    value: function closeForm() {
      this.setState({
        open: false
      });
    }
  }, {
    key: 'focusInput',
    value: function focusInput() {
      this.bookmarkNameTextField.focus();
    }
  }, {
    key: 'onNameValChange',
    value: function onNameValChange() {
      var name = this.bookmarkNameTextField.input.value;
      this.setState({
        nameRequiredError: !name
      });
    }
  }, {
    key: 'onURLValChange',
    value: function onURLValChange() {
      var url = this.bLink.input.value;
      this.setState({
        urlRequiredError: !url
      });
    }
  }, {
    key: 'addProtocolToURLIfNeeded',
    value: function addProtocolToURLIfNeeded(url) {
      var hasProtocol = function hasProtocol(s) {
        var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return regexp.test(s);
      };

      if (!hasProtocol(url)) {
        return 'http://' + url;
      }
      return url;
    }
  }, {
    key: 'create',
    value: function create() {
      var name = this.bookmarkNameTextField.input.value;
      var url = this.bLink.input.value;

      if (!name) {
        this.setState({
          nameRequiredError: true
        });
      }
      if (!url) {
        this.setState({
          urlRequiredError: true
        });
      }
      if (!name || !url) {
        return;
      }

      var link = this.addProtocolToURLIfNeeded(this.bLink.input.value);
      this.props.addBookmark(name, link);
      this.bookmarkNameTextField.input.value = '';
      this.bLink.input.value = '';

      this.closeForm();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var textField = {
        underlineStyle: {
          borderColor: _default2.default.textField.underlineColor
        },
        underlineFocusStyle: {
          borderColor: _default.widgetEditButtonHover
        },
        hintStyle: {
          color: _default2.default.textField.underlineColor,
          fontSize: 14
        },
        inputStyle: {
          color: '#FFF',
          fontSize: 14
        }
      };

      return _react2.default.createElement(_EditWidgetChip2.default, {
        open: this.state.open,
        widgetName: 'Bookmarks',
        onAddItemClick: this.openForm.bind(this),
        onCancelAddItemClick: this.closeForm.bind(this),
        onItemCreatedClick: this.create.bind(this),
        showEditOption: this.props.showEditButton,
        onEditModeToggle: this.props.onEditModeToggle,
        editMode: this.props.editMode,
        widgetAddItemForm: _react2.default.createElement(
          'span',
          {
            key: 'widget-add-form-elem',
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: 20
            }
          },
          _react2.default.createElement(_TextField2.default, {
            ref: function ref(input) {
              _this3.bookmarkNameTextField = input;
            },
            onKeyPress: this._handleKeyPress.bind(this),
            hintText: 'Ex: Google',
            style: textField.style,
            inputStyle: textField.inputStyle,
            hintStyle: textField.hintStyle,
            underlineStyle: textField.underlineStyle,
            underlineFocusStyle: textField.underlineFocusStyle,
            onChange: this.onNameValChange.bind(this),
            errorText: this.state.nameRequiredError ? 'Enter a name' : null
          }),
          _react2.default.createElement(_TextField2.default, {
            ref: function ref(input) {
              _this3.bLink = input;
            },
            onKeyPress: this._handleKeyPress.bind(this),
            hintText: 'Ex: google.com',
            style: textField.style,
            inputStyle: textField.inputStyle,
            hintStyle: textField.hintStyle,
            underlineStyle: textField.underlineStyle,
            underlineFocusStyle: textField.underlineFocusStyle,
            onChange: this.onURLValChange.bind(this),
            errorText: this.state.urlRequiredError ? 'Enter a URL' : null
          })
        )
      });
    }
  }]);

  return AddBookmarkForm;
}(_react2.default.Component);

AddBookmarkForm.propTypes = {
  addBookmark: _propTypes2.default.func.isRequired,
  onEditModeToggle: _propTypes2.default.func.isRequired,
  editMode: _propTypes2.default.bool.isRequired,
  showEditButton: _propTypes2.default.bool.isRequired
};

AddBookmarkForm.defaultProps = {
  showEditButton: true
};

exports.default = AddBookmarkForm;

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(60);

var _Paper2 = _interopRequireDefault(_Paper);

var _modeEdit = __webpack_require__(2189);

var _modeEdit2 = _interopRequireDefault(_modeEdit);

var _EditBookmarkWidgetModal = __webpack_require__(1354);

var _EditBookmarkWidgetModal2 = _interopRequireDefault(_EditBookmarkWidgetModal);

var _default = __webpack_require__(44);

var _hexToRgba = __webpack_require__(1769);

var _hexToRgba2 = _interopRequireDefault(_hexToRgba);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-useless-escape */

var BookmarkChip = function (_React$Component) {
  _inherits(BookmarkChip, _React$Component);

  function BookmarkChip(props) {
    _classCallCheck(this, BookmarkChip);

    var _this = _possibleConstructorReturn(this, (BookmarkChip.__proto__ || Object.getPrototypeOf(BookmarkChip)).call(this, props));

    _this.state = {
      isEditing: false,
      startingIndex: _this.props.index,
      // Set while modifying the widget settings
      temporaryColor: _this.props.bookmark.color
    };
    return _this;
  }

  _createClass(BookmarkChip, [{
    key: 'onDeleteBookmark',
    value: function onDeleteBookmark() {
      this.props.deleteBookmark(this.props.index);
      this.setState({
        isEditing: false
      });
    }
  }, {
    key: 'addProtocolToURLIfNeeded',
    value: function addProtocolToURLIfNeeded(url) {
      var hasProtocol = function hasProtocol(s) {
        var regexp = /(ftp|http|https|file):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        return regexp.test(s);
      };

      if (!hasProtocol(url)) {
        return 'http://' + url;
      }
      return url;
    }
  }, {
    key: 'openLink',
    value: function openLink(link) {
      // The page might be iframed, so opening in _top is critical.
      window.open(this.addProtocolToURLIfNeeded(link), '_top');
      this.setState({
        open: false
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.editMode) {
        this.setState({
          isEditing: true,
          startingIndex: this.props.index
        });
      } else {
        this.openLink(this.props.bookmark.link);
      }
    }
  }, {
    key: 'onEditCancel',
    value: function onEditCancel() {
      // Revert position changes if needed
      if (this.props.index > this.state.startingIndex) {
        this.props.onReorderMoveUp(this.props.index, this.props.index - this.state.startingIndex);
      } else if (this.props.index < this.state.startingIndex) {
        this.props.onReorderMoveDown(this.props.index, this.state.startingIndex - this.props.index);
      }

      // Revert color change
      this.setTemporaryColor(null);

      // Close modal
      this.setState({
        isEditing: false
      });
    }
  }, {
    key: 'onEditSave',
    value: function onEditSave(name, link) {
      var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      // Clear any temporary colors
      this.setTemporaryColor(null);

      this.props.editBookmark(this.props.index, name, link, color);
      this.setState({
        isEditing: false
      });
    }
  }, {
    key: 'onReorderMoveUp',
    value: function onReorderMoveUp() {
      this.props.onReorderMoveUp(this.props.index);
    }
  }, {
    key: 'onReorderMoveDown',
    value: function onReorderMoveDown() {
      this.props.onReorderMoveDown(this.props.index);
    }
  }, {
    key: 'setTemporaryColor',
    value: function setTemporaryColor(color) {
      this.setState({
        temporaryColor: color
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var bookmark = this.props.bookmark;


      var bookmarkColor = _default.dashboardTransparentBackground;
      var bookmarkHex = '#000';
      var colorOverride = this.state.temporaryColor || bookmark.color;
      if (colorOverride) {
        try {
          // May fail if the color is an invalid hex.
          bookmarkColor = (0, _hexToRgba2.default)(colorOverride, 0.36);
          bookmarkHex = colorOverride;
        } catch (e) {
          console.error('Error converting bookmark color to RGBA.', e);
        }
      }
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _Paper2.default,
          {
            zDepth: 0,
            style: {
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              cursor: 'pointer',
              alignItems: 'center',
              margin: 5,
              minWidth: 84,
              maxWidth: 150,
              height: 50,
              fontSize: 14,
              padding: 10,
              backgroundColor: bookmarkColor,
              color: '#FFF',
              userSelect: 'none'
            },
            onClick: this.onClick.bind(this)
          },
          _react2.default.createElement(_modeEdit2.default, {
            color: _default.widgetEditButtonInactive,
            hoverColor: _default.widgetEditButtonHover,
            style: {
              position: 'absolute',
              zIndex: 5,
              top: 2,
              right: 2,
              opacity: this.props.editMode ? 1 : 0,
              transition: 'opacity 0.1s ease-in',
              pointerEvents: this.props.editMode ? 'all' : 'none'
            }
          }),
          _react2.default.createElement(
            'span',
            { style: {
                color: '#FFF',
                pointerEvents: 'none',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }
            },
            bookmark.name
          )
        ),
        _react2.default.createElement(_EditBookmarkWidgetModal2.default, {
          ref: function ref(modal) {
            _this2.editBookmarkModal = modal;
          },
          open: this.state.isEditing,
          onEditCancel: this.onEditCancel.bind(this),
          onEditSave: this.onEditSave.bind(this),
          onDeleteBookmark: this.onDeleteBookmark.bind(this),
          currentBookmarkName: bookmark.name,
          currentBookmarkLink: bookmark.link,
          currentBookmarkColor: bookmarkHex,
          onReorderMoveUp: this.onReorderMoveUp.bind(this),
          onReorderMoveDown: this.onReorderMoveDown.bind(this),
          setTemporaryColor: this.setTemporaryColor.bind(this)
        })
      );
    }
  }]);

  return BookmarkChip;
}(_react2.default.Component);

BookmarkChip.propTypes = {
  bookmark: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    link: _propTypes2.default.string.isRequired,
    color: _propTypes2.default.string,
    order: _propTypes2.default.number
  }).isRequired,
  index: _propTypes2.default.number.isRequired,
  editMode: _propTypes2.default.bool.isRequired,
  editBookmark: _propTypes2.default.func.isRequired,
  deleteBookmark: _propTypes2.default.func.isRequired,
  onReorderMoveUp: _propTypes2.default.func.isRequired,
  onReorderMoveDown: _propTypes2.default.func.isRequired
};

exports.default = BookmarkChip;

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WidgetSharedSpace = __webpack_require__(381);

var _WidgetSharedSpace2 = _interopRequireDefault(_WidgetSharedSpace);

var _WidgetScrollSection = __webpack_require__(384);

var _WidgetScrollSection2 = _interopRequireDefault(_WidgetScrollSection);

var _EmptyWidgetMsg = __webpack_require__(383);

var _EmptyWidgetMsg2 = _interopRequireDefault(_EmptyWidgetMsg);

var _BookmarkChip = __webpack_require__(1351);

var _BookmarkChip2 = _interopRequireDefault(_BookmarkChip);

var _AddBookmarkForm = __webpack_require__(1350);

var _AddBookmarkForm2 = _interopRequireDefault(_AddBookmarkForm);

var _UpdateWidgetDataMutation = __webpack_require__(386);

var _UpdateWidgetDataMutation2 = _interopRequireDefault(_UpdateWidgetDataMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookmarksWidget = function (_React$Component) {
  _inherits(BookmarksWidget, _React$Component);

  function BookmarksWidget(props) {
    _classCallCheck(this, BookmarksWidget);

    var _this = _possibleConstructorReturn(this, (BookmarksWidget.__proto__ || Object.getPrototypeOf(BookmarksWidget)).call(this, props));

    _this.state = {
      bookmarks: [],
      editMode: false
    };
    return _this;
  }

  // FIXME
  // This is a temporary hack. Should pass unique ID
  // from the server.


  _createClass(BookmarksWidget, [{
    key: 'randomString',
    value: function randomString(length) {
      var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var result = '';
      for (var i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }return result;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var widget = this.props.widget;

      // TODO: have the server send obj, not string.

      var data = JSON.parse(widget.data);
      var bookmarks = data.bookmarks || [];
      bookmarks.forEach(function (bookmark) {
        if (bookmark.id) {
          return;
        }
        bookmark.id = _this2.randomString(6);
      });
      this.setState({
        bookmarks: bookmarks
      });
    }
  }, {
    key: 'getFavicon',
    value: function getFavicon(link) {
      return 'https://www.google.com/s2/favicons?domain_url=' + encodeURI(link);
    }
  }, {
    key: 'onSaveSuccess',
    value: function onSaveSuccess() {}
  }, {
    key: 'onSaveError',
    value: function onSaveError() {
      this.props.showError('Oops, we are having trouble saving your widgets right now :(');
    }
  }, {
    key: 'updateWidget',
    value: function updateWidget(bookmarks) {
      var widgetData = {
        bookmarks: bookmarks
      };
      var data = JSON.stringify(widgetData);
      _UpdateWidgetDataMutation2.default.commit(this.props.relay.environment, this.props.user, this.props.widget, data, this.onSaveSuccess.bind(this), this.onSaveError.bind(this));
    }
  }, {
    key: 'addBookmark',
    value: function addBookmark(name, link) {
      var _this3 = this;

      var newBookmark = {
        id: this.randomString(6),
        name: name,
        link: link
      };
      this.setState({
        bookmarks: [newBookmark].concat(_toConsumableArray(this.state.bookmarks))
      }, function () {
        _this3.updateWidget(_this3.state.bookmarks);
      });
    }
  }, {
    key: 'editBookmark',
    value: function editBookmark(index, name, link) {
      var _this4 = this;

      var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var bookmarks = [].concat(_toConsumableArray(this.state.bookmarks));
      bookmarks[index].name = name;
      bookmarks[index].link = link;
      if (color) {
        bookmarks[index].color = color;
      }
      this.setState({
        bookmarks: bookmarks
      }, function () {
        _this4.updateWidget(_this4.state.bookmarks);
      });
    }
  }, {
    key: 'removeBookmark',
    value: function removeBookmark(index) {
      var _this5 = this;

      this.setState({
        bookmarks: this.state.bookmarks.filter(function (_, i) {
          return i !== index;
        })
      }, function () {
        _this5.updateWidget(_this5.state.bookmarks);
      });
    }
  }, {
    key: 'onEditModeToggle',
    value: function onEditModeToggle(editModeEnabled) {
      this.setState({
        editMode: editModeEnabled
      });
    }
  }, {
    key: '_moveItem',
    value: function _moveItem(array, fromIndex, toIndex) {
      array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
    }
  }, {
    key: 'onReorderMoveUp',
    value: function onReorderMoveUp(index) {
      var spotsToMove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var newBookmarks = [].concat(_toConsumableArray(this.state.bookmarks));
      var destinationIndex = index === 0 ? 0 : index - spotsToMove;
      this._moveItem(newBookmarks, index, destinationIndex);
      this.setState({
        bookmarks: newBookmarks
      });
    }
  }, {
    key: 'onReorderMoveDown',
    value: function onReorderMoveDown(index) {
      var spotsToMove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var newBookmarks = [].concat(_toConsumableArray(this.state.bookmarks));
      var destinationIndex = index === newBookmarks.length - 1 ? index : index + spotsToMove;
      this._moveItem(newBookmarks, index, destinationIndex);
      this.setState({
        bookmarks: newBookmarks
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var bookmarks = this.state.bookmarks || [];

      var sharedSpaceStyle = {
        overflowX: 'visible',
        overflowY: 'visible',
        overflow: 'visible'
      };

      var wrapper = {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start'
      };

      var bookmarksContainer = {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 27
      };

      var nodataMsg;
      if (!bookmarks.length) {
        nodataMsg = _react2.default.createElement(_EmptyWidgetMsg2.default, {
          widgetName: 'Bookmarks' });
      }

      return _react2.default.createElement(
        _WidgetSharedSpace2.default,
        {
          containerStyle: sharedSpaceStyle },
        _react2.default.createElement(
          'div',
          { style: bookmarksContainer },
          _react2.default.createElement(_AddBookmarkForm2.default, {
            addBookmark: this.addBookmark.bind(this),
            showEditButton: bookmarks.length > 0,
            editMode: this.state.editMode,
            onEditModeToggle: this.onEditModeToggle.bind(this)
          }),
          _react2.default.createElement(
            _WidgetScrollSection2.default,
            null,
            _react2.default.createElement(
              'div',
              { style: wrapper },
              nodataMsg,
              bookmarks.map(function (bookmark, index) {
                return _react2.default.createElement(_BookmarkChip2.default, {
                  key: bookmark.id,
                  index: index,
                  bookmark: bookmark,
                  editBookmark: _this6.editBookmark.bind(_this6),
                  deleteBookmark: _this6.removeBookmark.bind(_this6),
                  editMode: _this6.state.editMode,
                  onReorderMoveUp: _this6.onReorderMoveUp.bind(_this6),
                  onReorderMoveDown: _this6.onReorderMoveDown.bind(_this6)
                });
              })
            )
          )
        )
      );
    }
  }]);

  return BookmarksWidget;
}(_react2.default.Component);

BookmarksWidget.propTypes = {
  widget: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    enabled: _propTypes2.default.bool.isRequired,
    visible: _propTypes2.default.bool.isRequired,
    data: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired,
  showError: _propTypes2.default.func.isRequired
};

exports.default = BookmarksWidget;

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _BookmarksWidgetComponent = __webpack_require__(1352);

var _BookmarksWidgetComponent2 = _interopRequireDefault(_BookmarksWidgetComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_BookmarksWidgetComponent2.default, {
  widget: function widget() {
    return __webpack_require__(1356);
  },
  user: function user() {
    return __webpack_require__(1355);
  }
});

/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dialog = __webpack_require__(257);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _FlatButton = __webpack_require__(214);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _RaisedButton = __webpack_require__(94);

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _TextField = __webpack_require__(95);

var _TextField2 = _interopRequireDefault(_TextField);

var _reactColor = __webpack_require__(941);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditBookmarkWidgetModal = function (_React$Component) {
  _inherits(EditBookmarkWidgetModal, _React$Component);

  function EditBookmarkWidgetModal(props) {
    _classCallCheck(this, EditBookmarkWidgetModal);

    var _this = _possibleConstructorReturn(this, (EditBookmarkWidgetModal.__proto__ || Object.getPrototypeOf(EditBookmarkWidgetModal)).call(this, props));

    _this.state = {
      nameRequiredError: false,
      urlRequiredError: false,
      colorPickerColor: null
    };
    return _this;
  }

  _createClass(EditBookmarkWidgetModal, [{
    key: '_handleKeyPress',
    value: function _handleKeyPress(e) {
      if (e.key === 'Enter') {
        if (!e.shiftKey) {
          e.stopPropagation();
          e.preventDefault();
          this.save();
        }
      }
    }
  }, {
    key: 'onNameValChange',
    value: function onNameValChange() {
      var name = this.bookmarkNameTextField.input.value;
      this.setState({
        nameRequiredError: !name
      });
    }
  }, {
    key: 'onURLValChange',
    value: function onURLValChange() {
      var url = this.bookmarkLinkTextField.input.value;
      this.setState({
        urlRequiredError: !url
      });
    }
  }, {
    key: 'setColor',
    value: function setColor(colorInfo) {
      this.setState({
        colorPickerColor: colorInfo.hex
      });
      this.props.setTemporaryColor(colorInfo.hex);
    }
  }, {
    key: 'save',
    value: function save() {
      var name = this.bookmarkNameTextField.input.value;
      var url = this.bookmarkLinkTextField.input.value;
      var color = this.state.colorPickerColor;

      if (!name) {
        this.setState({
          nameRequiredError: true
        });
      }
      if (!url) {
        this.setState({
          urlRequiredError: true
        });
      }
      if (!name || !url) {
        return;
      }
      this.props.onEditSave(name, url, color);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _Dialog2.default,
        {
          title: 'Edit Bookmark',
          actionsContainerStyle: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
            // alignItems: 'flex-start'
          },
          autoScrollBodyContent: true,
          actions: [_react2.default.createElement(_FlatButton2.default, {
            label: 'DELETE',
            primary: true,
            style: {
              color: '#FF0000'
            },
            onClick: this.props.onDeleteBookmark
          }), _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_FlatButton2.default, {
              label: 'CANCEL',
              primary: true,
              style: {
                margin: 2
              },
              onClick: this.props.onEditCancel
            }),
            _react2.default.createElement(_RaisedButton2.default, {
              label: 'SAVE',
              primary: true,
              style: {
                margin: 2
              },
              onClick: this.save.bind(this)
            })
          )],
          modal: true,
          open: this.props.open,
          contentStyle: {
            maxWidth: 500
          }
        },
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }
          },
          _react2.default.createElement(_TextField2.default, {
            ref: function ref(input) {
              _this2.bookmarkNameTextField = input;
            },
            onKeyPress: this._handleKeyPress.bind(this),
            defaultValue: this.props.currentBookmarkName,
            hintText: 'Ex: Google',
            onChange: this.onNameValChange.bind(this),
            errorText: this.state.nameRequiredError ? 'Enter a name' : null
          }),
          _react2.default.createElement(_TextField2.default, {
            ref: function ref(input) {
              _this2.bookmarkLinkTextField = input;
            },
            onKeyPress: this._handleKeyPress.bind(this),
            defaultValue: this.props.currentBookmarkLink,
            hintText: 'Ex: google.com',
            onChange: this.onURLValChange.bind(this),
            errorText: this.state.urlRequiredError ? 'Enter a URL' : null
          }),
          _react2.default.createElement(
            'span',
            {
              style: {
                margin: 10
              }
            },
            _react2.default.createElement(_RaisedButton2.default, {
              label: 'MOVE UP',
              'default': true,
              style: {
                margin: 2
              },
              onClick: this.props.onReorderMoveUp
            }),
            _react2.default.createElement(_RaisedButton2.default, {
              label: 'MOVE DOWN',
              'default': true,
              style: {
                margin: 2
              },
              onClick: this.props.onReorderMoveDown
            })
          ),
          _react2.default.createElement(
            'span',
            {
              style: {
                margin: 10
              }
            },
            _react2.default.createElement(_reactColor.TwitterPicker, {
              color: this.props.currentBookmarkColor,
              onChangeComplete: this.setColor.bind(this),
              triangle: 'hide'
            })
          )
        )
      );
    }
  }]);

  return EditBookmarkWidgetModal;
}(_react2.default.Component);

exports.default = EditBookmarkWidgetModal;


EditBookmarkWidgetModal.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  onEditCancel: _propTypes2.default.func.isRequired,
  onEditSave: _propTypes2.default.func.isRequired,
  onDeleteBookmark: _propTypes2.default.func.isRequired,
  onReorderMoveUp: _propTypes2.default.func.isRequired,
  onReorderMoveDown: _propTypes2.default.func.isRequired,
  currentBookmarkName: _propTypes2.default.string.isRequired,
  currentBookmarkLink: _propTypes2.default.string.isRequired,
  currentBookmarkColor: _propTypes2.default.string.isRequired
};

EditBookmarkWidgetModal.defaultProps = {};

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BookmarksWidgetContainer_user$ref: FragmentReference;
export type BookmarksWidgetContainer_user = {|
  +id: string,
  +$refType: BookmarksWidgetContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BookmarksWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '1116745567fbd3546789253d635752ac';
module.exports = node;

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BookmarksWidgetContainer_widget$ref: FragmentReference;
export type BookmarksWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +visible: ?boolean,
  +data: ?string,
  +type: ?string,
  +$refType: BookmarksWidgetContainer_widget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BookmarksWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "visible",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "data",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '514961423238dba8006dc6e5f4f9fbf8';
module.exports = node;

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _widgetsUtils = __webpack_require__(577);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClockWidget = function (_React$Component) {
  _inherits(ClockWidget, _React$Component);

  function ClockWidget(props) {
    _classCallCheck(this, ClockWidget);

    var _this = _possibleConstructorReturn(this, (ClockWidget.__proto__ || Object.getPrototypeOf(ClockWidget)).call(this, props));

    _this.updateClockInterval = 0;

    _this.state = {
      date: '',
      time: '',
      config: {}
    };
    return _this;
  }

  _createClass(ClockWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var self = this;
      this.updateClockInterval = setInterval(function () {
        self.setDateTime(self.state.config);
      }, 1000);

      var widget = this.props.widget;


      var config = JSON.parse(widget.config);
      var settings = JSON.parse(widget.settings);
      var configuration = (0, _widgetsUtils.getWidgetConfig)(config, settings);
      this.setState({
        config: configuration
      });
      this.setDateTime(configuration);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.updateClockInterval);
    }
  }, {
    key: 'setDateTime',
    value: function setDateTime(config) {
      var format24 = config.format24;
      var date = (0, _moment2.default)().format('dddd, MMMM D');
      var time;
      if (format24) {
        // If it's midnight, show two leading zeros
        if ((0, _moment2.default)().get('hour') === 0) {
          time = (0, _moment2.default)().format('HH:mm');
        } else {
          time = (0, _moment2.default)().format('H:mm');
        }
      } else {
        time = (0, _moment2.default)().format('h:mm');
      }

      this.setState({
        date: date,
        time: time
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var clockContainer = {
        marginBottom: 110,
        pointerEvents: 'none',
        userSelect: 'none'
      };

      var timeStyle = {
        color: '#FFF',
        fontSize: 140,
        fontWeight: 'bold',
        margin: 0,
        lineHeight: '90%',
        fontFamily: _default2.default.fontFamily
      };

      var dateStyle = {
        color: '#FFF',
        fontSize: 28,
        margin: 0,
        fontWeight: 'normal',
        fontFamily: _default2.default.fontFamily
      };

      return _react2.default.createElement(
        'div',
        { style: clockContainer },
        _react2.default.createElement(
          'h1',
          { style: timeStyle, 'data-test-id': 'clock-widget-time' },
          this.state.time
        ),
        _react2.default.createElement(
          'h2',
          { style: dateStyle, 'data-test-id': 'clock-widget-date' },
          this.state.date
        )
      );
    }
  }]);

  return ClockWidget;
}(_react2.default.Component);

ClockWidget.propTypes = {
  widget: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    enabled: _propTypes2.default.bool.isRequired,
    config: _propTypes2.default.string.isRequired,
    settings: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = ClockWidget;

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _ClockWidgetComponent = __webpack_require__(1357);

var _ClockWidgetComponent2 = _interopRequireDefault(_ClockWidgetComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_ClockWidgetComponent2.default, {
  widget: function widget() {
    return __webpack_require__(1360);
  },
  user: function user() {
    return __webpack_require__(1359);
  }
});

/***/ }),

/***/ 1359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ClockWidgetContainer_user$ref: FragmentReference;
export type ClockWidgetContainer_user = {|
  +id: string,
  +$refType: ClockWidgetContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ClockWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '0b6e0b03a2b28a7a066b5b2a9250c30c';
module.exports = node;

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ClockWidgetContainer_widget$ref: FragmentReference;
export type ClockWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +config: ?string,
  +settings: ?string,
  +type: ?string,
  +$refType: ClockWidgetContainer_widget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ClockWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "config",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "settings",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '4b0423624c7b83a6515ee712c6554bef';
module.exports = node;

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditWidgetChip = __webpack_require__(382);

var _EditWidgetChip2 = _interopRequireDefault(_EditWidgetChip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddNoteForm = function (_React$Component) {
  _inherits(AddNoteForm, _React$Component);

  function AddNoteForm() {
    _classCallCheck(this, AddNoteForm);

    return _possibleConstructorReturn(this, (AddNoteForm.__proto__ || Object.getPrototypeOf(AddNoteForm)).apply(this, arguments));
  }

  _createClass(AddNoteForm, [{
    key: 'create',
    value: function create() {
      this.props.addNote('');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_EditWidgetChip2.default, {
        widgetName: 'Notes',
        onAddItemClick: this.create.bind(this)
      });
    }
  }]);

  return AddNoteForm;
}(_react2.default.Component);

AddNoteForm.propTypes = {
  addNote: _propTypes2.default.func.isRequired
};

AddNoteForm.defaultProps = {};

exports.default = AddNoteForm;

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _WidgetPieceWrapper = __webpack_require__(574);

var _WidgetPieceWrapper2 = _interopRequireDefault(_WidgetPieceWrapper);

var _cancel = __webpack_require__(338);

var _cancel2 = _interopRequireDefault(_cancel);

var _Chip = __webpack_require__(765);

var _Chip2 = _interopRequireDefault(_Chip);

var _TextField = __webpack_require__(549);

var _TextField2 = _interopRequireDefault(_TextField);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

var _styles = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Custom styling for placeholder text.
var placeholder = {
  color: _default2.default.textField.underlineColor

  // https://github.com/callemall/material-ui/blob/86dbd4986c6fdc1f32c088abb3b73d25974272e8/src/Input/Input.js#L117-L120
};var styles = function styles(theme) {
  return {
    textFieldInput: {
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      '&:-ms-input-placeholder': placeholder,
      '&::-ms-input-placeholder': placeholder
    }
  };
};

var Note = function (_React$Component) {
  _inherits(Note, _React$Component);

  function Note(props) {
    _classCallCheck(this, Note);

    var _this = _possibleConstructorReturn(this, (Note.__proto__ || Object.getPrototypeOf(Note)).call(this, props));

    _this.state = {
      showDeleteButton: false
    };

    _this.noteChangedTimer = 0;
    _this.hoverTimer = 0;
    return _this;
  }

  _createClass(Note, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      if (this.noteChangedTimer) {
        clearTimeout(this.noteChangedTimer);
      }
    }
  }, {
    key: 'removeStickyNote',
    value: function removeStickyNote() {
      this.props.removeStickyNote(this.props.index);
    }
  }, {
    key: 'onMouseHoverChange',
    value: function onMouseHoverChange(isHovering) {
      var _this2 = this;

      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      if (isHovering) {
        this.hoverTimer = setTimeout(function () {
          _this2.setState({
            showDeleteButton: true
          });
        }, 500);
      } else {
        this.setState({
          showDeleteButton: false
        });
      }
    }
  }, {
    key: 'onNoteClick',
    value: function onNoteClick() {
      this.noteInput.focus();
    }
  }, {
    key: 'onNoteChanged',
    value: function onNoteChanged(event) {
      var _this3 = this;

      if (this.noteChangedTimer) {
        clearTimeout(this.noteChangedTimer);
      }
      var value = event.target.value;
      this.noteChangedTimer = setTimeout(function () {
        if (_this3.props.onNoteUpdated) {
          _this3.props.onNoteUpdated(value, _this3.props.index);
        }
      }, 500);
    }
  }, {
    key: 'getNoteDate',
    value: function getNoteDate() {
      var noteDateFormat = 'MMM D';
      var now = (0, _moment2.default)();
      var noteDate = (0, _moment2.default)(this.props.note.created);
      if (now.date() === noteDate.date()) {
        noteDateFormat = 'h:mm A';
      }
      return noteDate.format(noteDateFormat);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          note = _props.note,
          classes = _props.classes;


      var defaultPaper = {
        margin: 5,
        backgroundColor: _default.dashboardTransparentBackground,
        borderRadius: 3,
        borderLeftStyle: 'solid',
        borderLeftColor: note.color,
        borderLeftWidth: 5
      };
      var noteContent = {
        padding: '0 15px 5px 15px'
      };
      var chip = {
        style: {
          margin: 5
        },
        labelColor: _default2.default.textField.underlineColor,
        backgroundColor: 'rgba(0,0,0,0)'
      };

      var otherTransitions = 'fill 0.15s ease-in';
      var deleteIconStyle = {
        cursor: 'pointer',
        float: 'right',
        margin: '5px 5px 0px 0px',
        opacity: this.state.showDeleteButton ? 1 : 0,
        transition: this.state.showDeleteButton ? 'opacity 0.2s ease-in 0.5s, ' + otherTransitions : 'opacity 0.1s ease-in, ' + otherTransitions,
        pointerEvents: this.state.showDeleteButton ? 'all' : 'none',
        display: 'inline-block'
      };
      var noteDate = this.getNoteDate();

      return _react2.default.createElement(
        _WidgetPieceWrapper2.default,
        null,
        _react2.default.createElement(
          'div',
          {
            key: 'note_' + this.props.index,
            style: defaultPaper,
            onClick: this.onNoteClick.bind(this),
            onMouseEnter: this.onMouseHoverChange.bind(this, true),
            onMouseLeave: this.onMouseHoverChange.bind(this, false)
          },
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-block' } },
            _react2.default.createElement(
              _Chip2.default,
              {
                labelColor: chip.labelColor,
                backgroundColor: chip.backgroundColor,
                style: chip.style },
              noteDate
            )
          ),
          _react2.default.createElement(_cancel2.default, {
            color: _default.widgetEditButtonInactive,
            hoverColor: _default.widgetEditButtonHover,
            style: deleteIconStyle,
            onClick: this.removeStickyNote.bind(this) }),
          _react2.default.createElement(
            'div',
            { style: noteContent },
            _react2.default.createElement(_TextField2.default, {
              id: 'note-content-' + this.props.index,
              InputProps: {
                disableUnderline: true,
                style: {
                  color: '#FFF',
                  fontSize: 14,
                  fontFamily: _default2.default.fontFamily
                },
                classes: {
                  input: classes.textFieldInput
                }
              },
              multiline: true,
              fullWidth: true,
              placeholder: 'Your note here...',
              defaultValue: note.content ? note.content : '',
              onChange: this.onNoteChanged.bind(this),
              inputRef: function inputRef(note) {
                _this4.noteInput = note;
              }
            })
          )
        )
      );
    }
  }]);

  return Note;
}(_react2.default.Component);

Note.propTypes = {
  index: _propTypes2.default.number.isRequired,
  removeStickyNote: _propTypes2.default.func.isRequired,
  note: _propTypes2.default.object.isRequired,
  onNoteUpdated: _propTypes2.default.func,
  classes: _propTypes2.default.object.isRequired
};

exports.default = (0, _styles.withStyles)(styles)(Note);

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _WidgetSharedSpace = __webpack_require__(381);

var _WidgetSharedSpace2 = _interopRequireDefault(_WidgetSharedSpace);

var _EmptyWidgetMsg = __webpack_require__(383);

var _EmptyWidgetMsg2 = _interopRequireDefault(_EmptyWidgetMsg);

var _WidgetScrollSection = __webpack_require__(384);

var _WidgetScrollSection2 = _interopRequireDefault(_WidgetScrollSection);

var _Note = __webpack_require__(1362);

var _Note2 = _interopRequireDefault(_Note);

var _AddNoteForm = __webpack_require__(1361);

var _AddNoteForm2 = _interopRequireDefault(_AddNoteForm);

var _UpdateWidgetDataMutation = __webpack_require__(386);

var _UpdateWidgetDataMutation2 = _interopRequireDefault(_UpdateWidgetDataMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotesWidget = function (_React$Component) {
  _inherits(NotesWidget, _React$Component);

  function NotesWidget(props) {
    _classCallCheck(this, NotesWidget);

    var _this = _possibleConstructorReturn(this, (NotesWidget.__proto__ || Object.getPrototypeOf(NotesWidget)).call(this, props));

    _this.noteColors = ['#A5D6A7', '#FFF59D', '#FFF', '#FF4081', '#2196F3', '#757575', '#FF3D00'];
    _this.state = {
      notes: []
    };
    return _this;
  }

  _createClass(NotesWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var widget = this.props.widget;


      var data = JSON.parse(widget.data);
      var notes = data.notes || [];

      this.setState({
        notes: notes
      });
    }
  }, {
    key: 'onSaveSuccess',
    value: function onSaveSuccess() {}
  }, {
    key: 'onSaveError',
    value: function onSaveError() {
      this.props.showError('Oops, we are having trouble saving your widgets right now :(');
    }
  }, {
    key: 'updateWidget',
    value: function updateWidget(notes) {
      var widgetData = {
        notes: notes
      };

      var data = JSON.stringify(widgetData);

      _UpdateWidgetDataMutation2.default.commit(this.props.relay.environment, this.props.user, this.props.widget, data, this.onSaveSuccess.bind(this), this.onSaveError.bind(this));
    }
  }, {
    key: 'addNewNote',
    value: function addNewNote(text) {
      var _this2 = this;

      var colorIndex = Math.floor(Math.random() * this.noteColors.length);
      var newNote = {
        id: this.randomString(6),
        color: this.noteColors[colorIndex],
        content: text,
        created: _moment2.default.utc().format()
      };
      this.setState({
        notes: [newNote].concat(_toConsumableArray(this.state.notes))
      }, function () {
        _this2.updateWidget(_this2.state.notes);

        // Focus new note.
        _this2.newestNote.noteInput.focus();
      });
    }
  }, {
    key: 'removeStickyNote',
    value: function removeStickyNote(index) {
      var _this3 = this;

      this.setState({
        notes: this.state.notes.filter(function (_, i) {
          return i !== index;
        })
      }, function () {
        _this3.updateWidget(_this3.state.notes);
      });
    }
  }, {
    key: 'updateStickyNote',
    value: function updateStickyNote(content, index) {
      var _this4 = this;

      var notes = [].concat(_toConsumableArray(this.state.notes));
      notes[index].content = content;
      this.setState({
        notes: notes
      }, function () {
        _this4.updateWidget(_this4.state.notes);
      });
    }

    // This is a temporary solution since we are updating the
    // widget data, if we have specific mutations for the notes
    // then we should generate the id of the note on the server.

  }, {
    key: 'randomString',
    value: function randomString(length) {
      var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var result = '';
      for (var i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var sharedSpaceStyle = {
        overflowX: 'visible',
        overflowY: 'visible',
        overflow: 'visible'
      };

      var mainContainer = {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 27
      };

      var nodataMsg;
      if (!this.state.notes.length) {
        nodataMsg = _react2.default.createElement(_EmptyWidgetMsg2.default, {
          widgetName: 'Notes' });
      }

      return _react2.default.createElement(
        _WidgetSharedSpace2.default,
        {
          containerStyle: sharedSpaceStyle },
        _react2.default.createElement(
          'div',
          { style: mainContainer },
          _react2.default.createElement(_AddNoteForm2.default, {
            addNote: this.addNewNote.bind(this) }),
          _react2.default.createElement(
            _WidgetScrollSection2.default,
            null,
            nodataMsg,
            this.state.notes.map(function (note, index) {
              return _react2.default.createElement(_Note2.default, {
                key: note.id,
                index: index,
                innerRef: function innerRef(note) {
                  if (index === 0) {
                    _this5.newestNote = note;
                  }
                },
                removeStickyNote: _this5.removeStickyNote.bind(_this5),
                onNoteUpdated: _this5.updateStickyNote.bind(_this5),
                note: note });
            })
          )
        )
      );
    }
  }]);

  return NotesWidget;
}(_react2.default.Component);

NotesWidget.propTypes = {
  widget: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    enabled: _propTypes2.default.bool.isRequired,
    visible: _propTypes2.default.bool.isRequired,
    data: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired,
  showError: _propTypes2.default.func.isRequired
};

exports.default = NotesWidget;

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _NotesWidgetComponent = __webpack_require__(1363);

var _NotesWidgetComponent2 = _interopRequireDefault(_NotesWidgetComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_NotesWidgetComponent2.default, {
  widget: function widget() {
    return __webpack_require__(1366);
  },
  user: function user() {
    return __webpack_require__(1365);
  }
});

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type NotesWidgetContainer_user$ref: FragmentReference;
export type NotesWidgetContainer_user = {|
  +id: string,
  +$refType: NotesWidgetContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "NotesWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'ffa584151975cac7a92e5c62231e6b1b';
module.exports = node;

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type NotesWidgetContainer_widget$ref: FragmentReference;
export type NotesWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +visible: ?boolean,
  +data: ?string,
  +type: ?string,
  +$refType: NotesWidgetContainer_widget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "NotesWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "visible",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "data",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '5310709e262754d5c517227bec22c4b8';
module.exports = node;

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _search = __webpack_require__(486);

var _search2 = _interopRequireDefault(_search);

var _TextField = __webpack_require__(95);

var _TextField2 = _interopRequireDefault(_TextField);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

var _widgetsUtils = __webpack_require__(577);

var _logEvent = __webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Search = function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this2 = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this2.state = {
      hover: false,
      focused: false,
      config: {}
    };
    return _this2;
  }

  _createClass(Search, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var widget = this.props.widget;

      // TODO: have server send these as objects

      var config = JSON.parse(widget.config);
      var settings = JSON.parse(widget.settings);
      var configuration = (0, _widgetsUtils.getWidgetConfig)(config, settings);
      this.setState({
        config: configuration
      });
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(e) {
      if (e.key === 'Enter') {
        this.executeSearch();
      }
    }
  }, {
    key: 'executeSearch',
    value: function executeSearch() {
      var _this3 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var engine, searchApi, searchTerm;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _logEvent.searchExecuted)();

              case 2:
                engine = _this.state.config.engine || 'Google';
                searchApi = _this.getSearchApi(engine);
                searchTerm = _this.searchInput.input.value;

                // The page might be iframed, so opening in _top is critical.

                window.open(searchApi + searchTerm, '_top');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  }, {
    key: 'onSearchHover',
    value: function onSearchHover(hover) {
      this.setState({
        hover: hover
      });
    }
  }, {
    key: 'onSearchClick',
    value: function onSearchClick() {
      this.searchInput.focus();
    }
  }, {
    key: 'onInputFocusChanged',
    value: function onInputFocusChanged(focused) {
      this.setState({
        focused: focused
      });
    }
  }, {
    key: 'getSearchApi',
    value: function getSearchApi(engine) {
      switch (engine) {
        case 'Google':
          return 'https://www.google.com/search?q=';
        case 'Bing':
          return 'https://www.bing.com/search?q=';
        case 'Ecosia':
          return 'https://www.ecosia.org/search?q=';
        default:
          return 'https://www.google.com/search?q=';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var searchContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'relative',
        zIndex: 1,
        marginLeft: 14,
        height: 56
      };
      var iconStyle = {
        marginRight: 14
      };
      var underlineStyle = {
        borderColor: _default2.default.palette.borderColor,
        opacity: this.state.hover || this.state.focused ? 100 : 0,
        transition: 'opacity 150ms ease-in'
      };
      var underlineFocusStyle = {
        borderColor: _default.dashboardIconActiveColor
      };
      var inputContainerStyle = {
        width: 220
      };
      var inputStyle = {
        textAlign: 'left',
        color: _default.dashboardIconActiveColor,
        fontSize: 18,
        fontWeight: 'normal',
        fontFamily: _default2.default.fontFamily
      };

      return _react2.default.createElement(
        'span',
        {
          style: searchContainerStyle,
          onClick: this.onSearchClick.bind(this),
          onMouseEnter: this.onSearchHover.bind(this, true),
          onMouseLeave: this.onSearchHover.bind(this, false) },
        _react2.default.createElement(_search2.default, {
          color: this.state.hover || this.state.focused ? _default.dashboardIconActiveColor : _default.dashboardIconInactiveColor,
          hoverColor: _default.dashboardIconActiveColor,
          style: iconStyle
        }),
        _react2.default.createElement(_TextField2.default, {
          id: 'tab-search-id',
          onFocus: this.onInputFocusChanged.bind(this, true),
          onBlur: this.onInputFocusChanged.bind(this, false),
          ref: function ref(input) {
            _this4.searchInput = input;
          },
          onKeyPress: this.handleKeyPress.bind(this),
          style: inputContainerStyle,
          inputStyle: inputStyle,
          underlineStyle: underlineStyle,
          underlineFocusStyle: underlineFocusStyle })
      );
    }
  }]);

  return Search;
}(_react2.default.Component);

Search.propTypes = {
  widget: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    enabled: _propTypes2.default.bool.isRequired,
    data: _propTypes2.default.string.isRequired,
    config: _propTypes2.default.string.isRequired,
    settings: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = Search;

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Search = __webpack_require__(1367);

var _Search2 = _interopRequireDefault(_Search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchWidget = function (_React$Component) {
  _inherits(SearchWidget, _React$Component);

  function SearchWidget() {
    _classCallCheck(this, SearchWidget);

    return _possibleConstructorReturn(this, (SearchWidget.__proto__ || Object.getPrototypeOf(SearchWidget)).apply(this, arguments));
  }

  _createClass(SearchWidget, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Search2.default, {
        widget: this.props.widget,
        user: this.props.user });
    }
  }]);

  return SearchWidget;
}(_react2.default.Component);

SearchWidget.propTypes = {
  widget: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    enabled: _propTypes2.default.bool.isRequired,
    data: _propTypes2.default.string.isRequired,
    config: _propTypes2.default.string.isRequired,
    settings: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = SearchWidget;

/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _SearchWidgetComponent = __webpack_require__(1368);

var _SearchWidgetComponent2 = _interopRequireDefault(_SearchWidgetComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_SearchWidgetComponent2.default, {
  widget: function widget() {
    return __webpack_require__(1371);
  },
  user: function user() {
    return __webpack_require__(1370);
  }
});

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchWidgetContainer_user$ref: FragmentReference;
export type SearchWidgetContainer_user = {|
  +id: string,
  +$refType: SearchWidgetContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '8e92c17960a693d18485f0714d95af79';
module.exports = node;

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchWidgetContainer_widget$ref: FragmentReference;
export type SearchWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +data: ?string,
  +config: ?string,
  +settings: ?string,
  +type: ?string,
  +$refType: SearchWidgetContainer_widget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "data",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "config",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "settings",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '923e61c7bf8901c9d58106111518d996';
module.exports = node;

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditWidgetChip = __webpack_require__(382);

var _EditWidgetChip2 = _interopRequireDefault(_EditWidgetChip);

var _TextField = __webpack_require__(95);

var _TextField2 = _interopRequireDefault(_TextField);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddTodoForm = function (_React$Component) {
  _inherits(AddTodoForm, _React$Component);

  function AddTodoForm(props) {
    _classCallCheck(this, AddTodoForm);

    var _this = _possibleConstructorReturn(this, (AddTodoForm.__proto__ || Object.getPrototypeOf(AddTodoForm)).call(this, props));

    _this.state = {
      open: false,
      textRequiredError: false
    };
    return _this;
  }

  _createClass(AddTodoForm, [{
    key: '_handleKeyPress',
    value: function _handleKeyPress(e) {
      if (e.key === 'Enter') {
        if (!e.shiftKey) {
          e.stopPropagation();
          e.preventDefault();
          this.create();
        }
      }
    }
  }, {
    key: 'openForm',
    value: function openForm() {
      var _this2 = this;

      this.setState({
        open: true
      }, function () {
        _this2.focusInput();
      });
    }
  }, {
    key: 'closeForm',
    value: function closeForm() {
      this.setState({
        open: false
      });
    }
  }, {
    key: 'focusInput',
    value: function focusInput() {
      this.todoTextField.focus();
    }
  }, {
    key: 'validateTodoText',
    value: function validateTodoText() {
      var text = this.todoTextField.input.refs.input.value;
      this.setState({
        textRequiredError: !text
      });
    }
  }, {
    key: 'create',
    value: function create() {
      this.validateTodoText();

      var text = this.todoTextField.input.refs.input.value;
      if (!text) {
        return;
      }

      this.props.addTodo(text);
      this.todoTextField.input.value = '';
      this.closeForm();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var textField = {
        underlineStyle: {
          borderColor: _default2.default.textField.underlineColor
        },
        underlineFocusStyle: {
          borderColor: _default.widgetEditButtonHover
        },
        hintStyle: {
          color: _default2.default.textField.underlineColor,
          fontSize: 14
        },
        inputStyle: {
          color: '#FFF',
          fontSize: 14
        }
      };

      return _react2.default.createElement(_EditWidgetChip2.default, {
        open: this.state.open,
        widgetName: 'Tasks',
        onAddItemClick: this.openForm.bind(this),
        onCancelAddItemClick: this.closeForm.bind(this),
        onItemCreatedClick: this.create.bind(this),
        widgetAddItemForm: _react2.default.createElement(
          'span',
          {
            key: 'widget-add-form-elem',
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: 20
            }
          },
          _react2.default.createElement(_TextField2.default, {
            ref: function ref(input) {
              _this3.todoTextField = input;
            },
            multiLine: true,
            onKeyPress: this._handleKeyPress.bind(this),
            hintText: 'What do you need to do?',
            textareaStyle: textField.inputStyle,
            hintStyle: textField.hintStyle,
            underlineStyle: textField.underlineStyle,
            underlineFocusStyle: textField.underlineFocusStyle,
            onChange: this.validateTodoText.bind(this),
            errorText: this.state.textRequiredError ? 'Enter a todo' : null
          })
        )
      });
    }
  }]);

  return AddTodoForm;
}(_react2.default.Component);

AddTodoForm.propTypes = {
  addTodo: _propTypes2.default.func.isRequired
};

AddTodoForm.defaultProps = {};

exports.default = AddTodoForm;

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WidgetPieceWrapper = __webpack_require__(574);

var _WidgetPieceWrapper2 = _interopRequireDefault(_WidgetPieceWrapper);

var _Checkbox = __webpack_require__(332);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _cancel = __webpack_require__(338);

var _cancel2 = _interopRequireDefault(_cancel);

var _checkCircle = __webpack_require__(337);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _SvgIcon = __webpack_require__(24);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Todo = function (_React$Component) {
  _inherits(Todo, _React$Component);

  function Todo(props) {
    _classCallCheck(this, Todo);

    var _this = _possibleConstructorReturn(this, (Todo.__proto__ || Object.getPrototypeOf(Todo)).call(this, props));

    _this.state = {
      showDeleteButton: false
    };
    _this.hoverTimer = 0;
    return _this;
  }

  _createClass(Todo, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
    }
  }, {
    key: 'onMouseHoverChange',
    value: function onMouseHoverChange(isHovering) {
      var _this2 = this;

      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      if (isHovering) {
        this.hoverTimer = setTimeout(function () {
          _this2.setState({
            showDeleteButton: true
          });
        }, 500);
      } else {
        this.setState({
          showDeleteButton: false
        });
      }
    }
  }, {
    key: 'removeTodo',
    value: function removeTodo() {
      var index = this.props.index;

      this.props.remove(index);
    }
  }, {
    key: 'onCompletedChange',
    value: function onCompletedChange() {
      var _props = this.props,
          index = _props.index,
          completed = _props.completed;

      this.props.onCompletedChange(index, !completed);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          todo = _props2.todo,
          completed = _props2.completed;


      var styles = {
        container: {
          display: 'flex',
          alignItems: 'center',
          overflowWrap: 'break-word',
          backgroundColor: _default.dashboardTransparentBackground,
          borderRadius: 3,
          margin: '5px 5px',
          paddingLeft: 5
        },
        defaultTodoText: {
          flex: 1,
          fontSize: 14,
          fontFamily: _default2.default.fontFamily
        },
        todo: {
          color: '#FFF'
        },
        completed: {
          color: _default.dashboardIconInactiveColor,
          textDecoration: 'line-through'
        }
      };

      var checkedIcon = _react2.default.createElement(_checkCircle2.default, {
        color: 'FFF',
        style: { color: '#FFF' } });

      var uncheckedIcon = _react2.default.createElement(
        _SvgIcon2.default,
        { color: '#FFF' },
        _react2.default.createElement(
          'svg',
          { fill: '#FFFFFF', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' }),
          _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
        )
      );

      var todoTextStyle = Object.assign({}, styles.defaultTodoText, completed ? styles.completed : styles.todo);

      var otherTransitions = 'fill 0.15s ease-in';
      var deleteIconStyle = {
        cursor: 'pointer',
        margin: '0px 4px',
        opacity: this.state.showDeleteButton ? 1 : 0,
        transition: this.state.showDeleteButton ? 'opacity 0.2s ease-in 0.5s, ' + otherTransitions : 'opacity 0.1s ease-in, ' + otherTransitions,
        pointerEvents: this.state.showDeleteButton ? 'all' : 'none',
        display: 'inline-block'
      };

      return _react2.default.createElement(
        _WidgetPieceWrapper2.default,
        null,
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            onMouseEnter: this.onMouseHoverChange.bind(this, true),
            onMouseLeave: this.onMouseHoverChange.bind(this, false) },
          _react2.default.createElement(_Checkbox2.default, {
            style: {
              width: 'auto'
            },
            onCheck: this.onCompletedChange.bind(this),
            defaultChecked: completed,
            checkedIcon: checkedIcon,
            uncheckedIcon: uncheckedIcon,
            iconStyle: {
              fill: completed ? _default.dashboardIconInactiveColor : _default.dashboardIconActiveColor,
              marginRight: 10
            }
          }),
          _react2.default.createElement(
            'p',
            {
              style: todoTextStyle },
            todo.text
          ),
          _react2.default.createElement(_cancel2.default, {
            color: _default.widgetEditButtonInactive,
            hoverColor: _default.widgetEditButtonHover,
            style: deleteIconStyle,
            onClick: this.removeTodo.bind(this) })
        )
      );
    }
  }]);

  return Todo;
}(_react2.default.Component);

Todo.propTypes = {
  todo: _propTypes2.default.object.isRequired,
  index: _propTypes2.default.number.isRequired,
  completed: _propTypes2.default.bool,
  remove: _propTypes2.default.func,
  onCompletedChange: _propTypes2.default.func
};

Todo.defaultProps = {
  completed: false,
  remove: function remove(index) {},
  onCompletedChange: function onCompletedChange(index, completed) {}
};

exports.default = Todo;

/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FlatButton = __webpack_require__(214);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _WidgetSharedSpace = __webpack_require__(381);

var _WidgetSharedSpace2 = _interopRequireDefault(_WidgetSharedSpace);

var _EmptyWidgetMsg = __webpack_require__(383);

var _EmptyWidgetMsg2 = _interopRequireDefault(_EmptyWidgetMsg);

var _WidgetScrollSection = __webpack_require__(384);

var _WidgetScrollSection2 = _interopRequireDefault(_WidgetScrollSection);

var _UpdateWidgetDataMutation = __webpack_require__(386);

var _UpdateWidgetDataMutation2 = _interopRequireDefault(_UpdateWidgetDataMutation);

var _Todo = __webpack_require__(1373);

var _Todo2 = _interopRequireDefault(_Todo);

var _AddTodoForm = __webpack_require__(1372);

var _AddTodoForm2 = _interopRequireDefault(_AddTodoForm);

var _Subheader = __webpack_require__(215);

var _Subheader2 = _interopRequireDefault(_Subheader);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TodosWidget = function (_React$Component) {
  _inherits(TodosWidget, _React$Component);

  function TodosWidget(props) {
    _classCallCheck(this, TodosWidget);

    var _this = _possibleConstructorReturn(this, (TodosWidget.__proto__ || Object.getPrototypeOf(TodosWidget)).call(this, props));

    _this.state = {
      completed: [],
      todos: []
    };
    return _this;
  }

  _createClass(TodosWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var widget = this.props.widget;

      var data = JSON.parse(widget.data);

      this.setState({
        completed: data.completed || [],
        todos: data.todos || []
      });
    }
  }, {
    key: 'completeTodo',
    value: function completeTodo(index) {
      this.setState({
        todos: this.state.todos.filter(function (_, i) {
          return i !== index;
        }),
        completed: [this.state.todos[index]].concat(_toConsumableArray(this.state.completed))
      }, this.updateWidget);
    }
  }, {
    key: 'setNotCompleted',
    value: function setNotCompleted(index) {
      this.setState({
        todos: [this.state.completed[index]].concat(_toConsumableArray(this.state.todos)),
        completed: this.state.completed.filter(function (_, i) {
          return i !== index;
        })
      }, this.updateWidget);
    }
  }, {
    key: 'addNewTodo',
    value: function addNewTodo(text) {
      var content = text;
      if (content) {
        var newTodo = {
          id: this.randomString(6),
          text: content
        };
        this.setState({
          todos: [].concat(_toConsumableArray(this.state.todos), [newTodo])
        }, this.updateWidget);
      }
    }
  }, {
    key: 'removeCompletedTodo',
    value: function removeCompletedTodo(index) {
      this.setState({
        completed: this.state.completed.filter(function (_, i) {
          return i !== index;
        })
      }, this.updateWidget);
    }
  }, {
    key: 'removeAllCompletedTodos',
    value: function removeAllCompletedTodos() {
      this.setState({
        completed: []
      }, this.updateWidget);
    }
  }, {
    key: 'removeTodo',
    value: function removeTodo(index) {
      this.setState({
        todos: this.state.todos.filter(function (_, i) {
          return i !== index;
        })
      }, this.updateWidget);
    }
  }, {
    key: 'getWidgetData',
    value: function getWidgetData() {
      var data = {
        completed: this.state.completed,
        todos: this.state.todos
      };
      return JSON.stringify(data);
    }
  }, {
    key: 'onSaveSuccess',
    value: function onSaveSuccess() {}
  }, {
    key: 'onSaveError',
    value: function onSaveError() {
      this.props.showError('Oops, we are having trouble saving your widgets right now :(');
    }
  }, {
    key: 'updateWidget',
    value: function updateWidget() {
      var data = this.getWidgetData();

      _UpdateWidgetDataMutation2.default.commit(this.props.relay.environment, this.props.user, this.props.widget, data, this.onSaveSuccess.bind(this), this.onSaveError.bind(this));
    }

    // This is a temporary solution since we are updating the
    // widget data, if we have specific mutations for the notes
    // then we should generate the id of the note on the server.

  }, {
    key: 'randomString',
    value: function randomString(length) {
      var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var result = '';
      for (var i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sharedSpaceStyle = {
        overflowX: 'visible',
        overflowY: 'visible',
        overflow: 'visible'
      };

      var mainContainer = {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 27
      };

      var nodataMsg;
      if (!this.state.todos.length && !this.state.completed.length) {
        nodataMsg = _react2.default.createElement(_EmptyWidgetMsg2.default, {
          widgetName: 'Todos' });
      }

      return _react2.default.createElement(
        _WidgetSharedSpace2.default,
        {
          containerStyle: sharedSpaceStyle },
        _react2.default.createElement(
          'div',
          { style: mainContainer },
          _react2.default.createElement(_AddTodoForm2.default, {
            addTodo: this.addNewTodo.bind(this) }),
          _react2.default.createElement(
            _WidgetScrollSection2.default,
            null,
            nodataMsg,
            this.state.todos.map(function (todo, index) {
              return _react2.default.createElement(_Todo2.default, {
                key: todo.id,
                todo: todo,
                index: index,
                completed: false,
                onCompletedChange: _this2.completeTodo.bind(_this2),
                remove: _this2.removeTodo.bind(_this2) });
            }),
            this.state.completed.length ? _react2.default.createElement(
              _Subheader2.default,
              {
                style: {
                  color: _default.dashboardIconInactiveColor,
                  borderTop: '2px ' + _default.primaryColor + ' solid',
                  borderBottom: '2px ' + _default.primaryColor + ' solid',
                  lineHeight: '100%',
                  margin: 5,
                  width: 'auto',
                  padding: '6px 12px',
                  boxSizing: 'border-box',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  fontSize: 14,
                  fontFamily: _default2.default.fontFamily,
                  backgroundColor: 'rgba(0,0,0,.3)'
                },
                inset: false
              },
              'Completed',
              _react2.default.createElement(
                _FlatButton2.default,
                {
                  style: {
                    fontSize: 12,
                    height: 24,
                    fontWeight: _default.buttonFontWeight,
                    lineHeight: '24px',
                    color: _default.dashboardIconInactiveColor
                  },
                  onClick: this.removeAllCompletedTodos.bind(this)
                },
                'CLEAR'
              )
            ) : null,
            this.state.completed.map(function (todo, index) {
              return _react2.default.createElement(_Todo2.default, {
                key: todo.id,
                todo: todo,
                index: index,
                completed: true,
                onCompletedChange: _this2.setNotCompleted.bind(_this2),
                remove: _this2.removeCompletedTodo.bind(_this2) });
            })
          )
        )
      );
    }
  }]);

  return TodosWidget;
}(_react2.default.Component);

TodosWidget.propTypes = {
  widget: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    enabled: _propTypes2.default.bool.isRequired,
    visible: _propTypes2.default.bool.isRequired,
    data: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  }).isRequired,
  showError: _propTypes2.default.func.isRequired
};

exports.default = TodosWidget;

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _TodosWidgetComponent = __webpack_require__(1374);

var _TodosWidgetComponent2 = _interopRequireDefault(_TodosWidgetComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_TodosWidgetComponent2.default, {
  widget: function widget() {
    return __webpack_require__(1377);
  },
  user: function user() {
    return __webpack_require__(1376);
  }
});

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TodosWidgetContainer_user$ref: FragmentReference;
export type TodosWidgetContainer_user = {|
  +id: string,
  +$refType: TodosWidgetContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "TodosWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '1add81b6529f0c97903c0d0f28d9af8e';
module.exports = node;

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TodosWidgetContainer_widget$ref: FragmentReference;
export type TodosWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +visible: ?boolean,
  +data: ?string,
  +type: ?string,
  +$refType: TodosWidgetContainer_widget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "TodosWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "visible",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "data",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '1d2e22c7aecfad49a1b3fe27b76b718e';
module.exports = node;

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WidgetIconContainer = __webpack_require__(1349);

var _WidgetIconContainer2 = _interopRequireDefault(_WidgetIconContainer);

var _WidgetContainer = __webpack_require__(1347);

var _WidgetContainer2 = _interopRequireDefault(_WidgetContainer);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FadeInDashboardAnimation = __webpack_require__(380);

var _FadeInDashboardAnimation2 = _interopRequireDefault(_FadeInDashboardAnimation);

var _constants = __webpack_require__(46);

var _CenteredWidgetsContainer = __webpack_require__(1274);

var _CenteredWidgetsContainer2 = _interopRequireDefault(_CenteredWidgetsContainer);

var _SetUserActiveWidgetMutation = __webpack_require__(1395);

var _SetUserActiveWidgetMutation2 = _interopRequireDefault(_SetUserActiveWidgetMutation);

var _ActiveWidgetAnimation = __webpack_require__(1344);

var _ActiveWidgetAnimation2 = _interopRequireDefault(_ActiveWidgetAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Widgets = function (_React$Component) {
  _inherits(Widgets, _React$Component);

  function Widgets() {
    _classCallCheck(this, Widgets);

    return _possibleConstructorReturn(this, (Widgets.__proto__ || Object.getPrototypeOf(Widgets)).apply(this, arguments));
  }

  _createClass(Widgets, [{
    key: 'onWidgetIconClicked',
    value: function onWidgetIconClicked(widget) {
      var user = this.props.user;


      if (user.activeWidget === widget.id) {
        widget = {
          id: 'no-active-widget'
        };
      }

      _SetUserActiveWidgetMutation2.default.commit(this.props.relay.environment, user, widget);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          isCampaignLive = _props.isCampaignLive;

      if (!user) {
        return null;
      }

      var widgetsContainer = {
        position: 'absolute',
        zIndex: 2,
        top: 5,
        display: 'flex',
        justifyContent: 'flex-start'
      };

      var separator = {
        width: 5
      };

      return _react2.default.createElement(
        _FadeInDashboardAnimation2.default,
        null,
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'div',
            { style: widgetsContainer, 'data-tour-id': 'widgets' },
            _react2.default.createElement('div', { style: separator }),
            user.widgets.edges.map(function (edge, index) {
              if (edge.node.type === _constants.WIDGET_TYPE_SEARCH) {
                return _react2.default.createElement(_WidgetContainer2.default, {
                  key: index,
                  user: user,
                  widget: edge.node,
                  showError: _this2.props.showError });
              } else {
                return _react2.default.createElement(_WidgetIconContainer2.default, {
                  key: index,
                  widget: edge.node,
                  active: user.activeWidget && edge.node.id === user.activeWidget,
                  onWidgetIconClicked: _this2.onWidgetIconClicked.bind(_this2) });
              }
            })
          ),
          isCampaignLive ? null : _react2.default.createElement(
            _CenteredWidgetsContainer2.default,
            null,
            user.widgets.edges.map(function (edge, index) {
              if (edge.node.type === _constants.WIDGET_TYPE_CLOCK) {
                return _react2.default.createElement(_WidgetContainer2.default, {
                  key: index,
                  user: user,
                  widget: edge.node,
                  'data-test-id': 'widget-clock',
                  showError: _this2.props.showError });
              }
            })
          ),
          _react2.default.createElement(
            _FadeInDashboardAnimation2.default,
            null,
            _react2.default.createElement(
              _ActiveWidgetAnimation2.default,
              null,
              user.widgets.edges.map(function (edge, index) {
                if (user.activeWidget && edge.node.id === user.activeWidget) {
                  return _react2.default.createElement(_WidgetContainer2.default, {
                    key: index,
                    user: user,
                    widget: edge.node,
                    showError: _this2.props.showError
                  });
                }
              })
            )
          )
        )
      );
    }
  }]);

  return Widgets;
}(_react2.default.Component);

Widgets.propTypes = {
  user: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    widgets: _propTypes2.default.shape({
      edges: _propTypes2.default.array.isRequired
    }).isRequired,
    activeWidget: _propTypes2.default.string
  }),
  isCampaignLive: _propTypes2.default.bool,
  showError: _propTypes2.default.func.isRequired
};

Widgets.defaultProps = {
  isCampaignLive: false
};

exports.default = Widgets;

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _WidgetsComponent = __webpack_require__(1378);

var _WidgetsComponent2 = _interopRequireDefault(_WidgetsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_WidgetsComponent2.default, {
  user: function user() {
    return __webpack_require__(1383);
  }
});

/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type BookmarksWidgetContainer_user$ref = any;
type ClockWidgetContainer_user$ref = any;
type NotesWidgetContainer_user$ref = any;
type SearchWidgetContainer_user$ref = any;
type TodosWidgetContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetContainer_user$ref: FragmentReference;
export type WidgetContainer_user = {|
  +$fragmentRefs: BookmarksWidgetContainer_user$ref & SearchWidgetContainer_user$ref & ClockWidgetContainer_user$ref & NotesWidgetContainer_user$ref & TodosWidgetContainer_user$ref,
  +$refType: WidgetContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "FragmentSpread",
    "name": "BookmarksWidgetContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "SearchWidgetContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "ClockWidgetContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "NotesWidgetContainer_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "TodosWidgetContainer_user",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '72463cb7c70533dabda1b64cdafc8624';
module.exports = node;

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type BookmarksWidgetContainer_widget$ref = any;
type ClockWidgetContainer_widget$ref = any;
type NotesWidgetContainer_widget$ref = any;
type SearchWidgetContainer_widget$ref = any;
type TodosWidgetContainer_widget$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetContainer_widget$ref: FragmentReference;
export type WidgetContainer_widget = {|
  +type: ?string,
  +$fragmentRefs: BookmarksWidgetContainer_widget$ref & SearchWidgetContainer_widget$ref & ClockWidgetContainer_widget$ref & NotesWidgetContainer_widget$ref & TodosWidgetContainer_widget$ref,
  +$refType: WidgetContainer_widget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "BookmarksWidgetContainer_widget",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "SearchWidgetContainer_widget",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "ClockWidgetContainer_widget",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "NotesWidgetContainer_widget",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "TodosWidgetContainer_widget",
    "args": null
  }]
};
// prettier-ignore
node /*: any*/.hash = '219df5ac5e2f6c46fa93156450c20d14';
module.exports = node;

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetIconContainer_widget$ref: FragmentReference;
export type WidgetIconContainer_widget = {|
  +id: string,
  +type: ?string,
  +visible: ?boolean,
  +$refType: WidgetIconContainer_widget$ref,
|};
*/

var node /*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetIconContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "type",
    "args": null,
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "name": "visible",
    "args": null,
    "storageKey": null
  }]
};
// prettier-ignore
node /*: any*/.hash = 'bdfef46af212213efb1aef4c634d4a8a';
module.exports = node;

/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type { ConcreteFragment } from 'relay-runtime';
type WidgetContainer_user$ref = any;
type WidgetContainer_widget$ref = any;
type WidgetIconContainer_widget$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetsContainer_user$ref: FragmentReference;
export type WidgetsContainer_user = {|
  +id: string,
  +activeWidget: ?string,
  +widgets: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +type: ?string,
        +$fragmentRefs: WidgetContainer_widget$ref & WidgetIconContainer_widget$ref,
      |}
    |}>
  |},
  +$fragmentRefs: WidgetContainer_user$ref,
  +$refType: WidgetsContainer_user$ref,
|};
*/

var node /*: ConcreteFragment*/ = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Fragment",
    "name": "WidgetsContainer_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [v0, {
      "kind": "ScalarField",
      "alias": null,
      "name": "activeWidget",
      "args": null,
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "WidgetContainer_user",
      "args": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "name": "widgets",
      "storageKey": "widgets(enabled:true,first:20)",
      "args": [{
        "kind": "Literal",
        "name": "enabled",
        "value": true,
        "type": "Boolean"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 20,
        "type": "Int"
      }],
      "concreteType": "WidgetConnection",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WidgetEdge",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Widget",
          "plural": false,
          "selections": [v0, {
            "kind": "ScalarField",
            "alias": null,
            "name": "type",
            "args": null,
            "storageKey": null
          }, {
            "kind": "FragmentSpread",
            "name": "WidgetContainer_widget",
            "args": null
          }, {
            "kind": "FragmentSpread",
            "name": "WidgetIconContainer_widget",
            "args": null
          }]
        }]
      }]
    }]
  };
}();
// prettier-ignore
node /*: any*/.hash = 'e3b6f600329cff6495ef999c25d4b03f';
module.exports = node;

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetIconFromWidgetType = undefined;

var _bookmarkBorder = __webpack_require__(792);

var _bookmarkBorder2 = _interopRequireDefault(_bookmarkBorder);

var _schedule = __webpack_require__(2185);

var _schedule2 = _interopRequireDefault(_schedule);

var _formatListBulleted = __webpack_require__(795);

var _formatListBulleted2 = _interopRequireDefault(_formatListBulleted);

var _chatBubbleOutline = __webpack_require__(794);

var _chatBubbleOutline2 = _interopRequireDefault(_chatBubbleOutline);

var _search = __webpack_require__(486);

var _search2 = _interopRequireDefault(_search);

var _widgets = __webpack_require__(2188);

var _widgets2 = _interopRequireDefault(_widgets);

var _constants = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWidgetIconFromWidgetType = exports.getWidgetIconFromWidgetType = function getWidgetIconFromWidgetType(widgetType) {
  var icon;
  switch (widgetType) {
    case _constants.WIDGET_TYPE_BOOKMARKS:
      icon = _bookmarkBorder2.default;
      break;

    case _constants.WIDGET_TYPE_CLOCK:
      icon = _schedule2.default;
      break;

    case _constants.WIDGET_TYPE_NOTES:
      icon = _chatBubbleOutline2.default;
      break;

    case _constants.WIDGET_TYPE_SEARCH:
      icon = _search2.default;
      break;

    case _constants.WIDGET_TYPE_TODOS:
      icon = _formatListBulleted2.default;
      break;

    default:
      icon = _widgets2.default;
  }
  return icon;
};

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1399);
};

function commit(environment, userId, email, referralData, experimentGroups, extensionInstallId, extensionInstallTimeApprox, _onCompleted, _onError) {
  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: {
        userId: userId,
        email: email,
        referralData: referralData,
        experimentGroups: experimentGroups,
        extensionInstallId: extensionInstallId,
        extensionInstallTimeApprox: extensionInstallTimeApprox
      }
    },
    onCompleted: function onCompleted(response) {
      _onCompleted(response);
    },
    onError: function onError(err) {
      _onError(err);
    }
  });
}

exports.default = commit;

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _relayCommitMutationPromise = __webpack_require__(2587);

var _relayCommitMutationPromise2 = _interopRequireDefault(_relayCommitMutationPromise);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lang = __webpack_require__(107);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutation = function mutation() {
  return __webpack_require__(1400);
};

// Relay tool for mutations with promises:
// https://github.com/relay-tools/relay-commit-mutation-promise
// A good reference for mutation design:
// https://medium.com/entria/wrangling-the-client-store-with-the-relay-modern-updater-function-5c32149a71ac

exports.default = function (input) {
  var otherVars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var userId = input.userId,
      charityId = input.charityId,
      vc = input.vc;
  var _otherVars$vcReceived = otherVars.vcReceivedArgs,
      vcReceivedArgs = _otherVars$vcReceived === undefined ? {} : _otherVars$vcReceived;

  return (0, _relayCommitMutationPromise2.default)(_relayEnv2.default, {
    mutation: mutation,
    variables: {
      input: {
        userId: userId,
        charityId: charityId,
        vc: vc
      }
    },
    updater: function updater(store) {
      // Update the charity's "vcReceived" field to include the
      // VC this user just donated.
      // There may also be a "vcReceived" field with startTime and
      // endTime arguments-- such as when a "Heart donation" campaign
      // live-- so update that field as well.
      var charityRecord = store.get(charityId);
      if (charityRecord) {
        var vcReceivedFieldName = 'vcReceived';

        // Update the plain "vcReceived" field if it exists.
        var currentVcReceived = charityRecord.getValue(vcReceivedFieldName);
        if (!(0, _lang.isNil)(currentVcReceived)) {
          charityRecord.setValue(vc + currentVcReceived, vcReceivedFieldName);
        }

        // Update the "vcReceived" field for a particular time period if
        // the current time is within the time period.
        if (vcReceivedArgs.startTime && vcReceivedArgs.endTime && (0, _moment2.default)() > (0, _moment2.default)(vcReceivedArgs.startTime) && (0, _moment2.default)() < (0, _moment2.default)(vcReceivedArgs.endTime)) {
          var args = {
            startTime: vcReceivedArgs.startTime,
            endTime: vcReceivedArgs.endTime
          };
          var vcReceivedInTimePeriod = charityRecord.getValue(vcReceivedFieldName, args);
          if (!(0, _lang.isNil)(vcReceivedInTimePeriod)) {
            charityRecord.setValue(vc + vcReceivedInTimePeriod, vcReceivedFieldName, args);
          }
        }
      }
    }
  });
};

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1401);
};

function commit(environment, userId) {
  var onCompleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = commit;

/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1402);
};

function commit(environment, userId, tabId) {
  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, tabId: tabId }
    }
  });
}

exports.default = commit;

/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1403);
};

function commit(environment, userId, consentString, isGlobalConsent) {
  var onCompleted = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: {
        userId: userId,
        consentString: consentString,
        isGlobalConsent: isGlobalConsent
      }
    },
    onCompleted: onCompleted
  });
}

exports.default = commit;

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1404);
};

function commit(environment, userId) {
  var revenue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var dfpAdvertiserId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var adSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var encodedRevenue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var aggregationOperation = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var tabId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var adUnitCode = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: {
        userId: userId,
        revenue: revenue,
        dfpAdvertiserId: dfpAdvertiserId,
        encodedRevenue: encodedRevenue,
        aggregationOperation: aggregationOperation,
        tabId: tabId,
        adSize: adSize,
        adUnitCode: adUnitCode
      }
    }
  });
}

exports.default = commit;

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1405);
};

function commit(environment, userId) {
  var onCompleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = commit;

/***/ }),

/***/ 1392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1406);
};

function commit(environment, user, color) {
  var onCompleted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var onError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

  var userId = user.id;

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, color: color }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = { commit: commit };

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1407);
};

function commit(environment, user, image) {
  var onCompleted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var onError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

  var userId = user.id;

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, image: image }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = { commit: commit };

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1409);
};

function commit(environment, user, image) {
  var onCompleted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var onError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

  var userId = user.id;
  var imageId = image.id;

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, imageId: imageId }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = { commit: commit };

/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1410);
};

function commit(environment, user, widget) {
  var onCompleted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var onError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

  var userId = user.id;
  var widgetId = widget.id;

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, widgetId: widgetId }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = { commit: commit };

/***/ }),

/***/ 1396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1411);
};

function commit(environment, userId, username) {
  var onCompleted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var onError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, username: username }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = commit;

/***/ }),

/***/ 1397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1412);
};

function commit(environment, user, widget, config) {
  var onCompleted = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var onError = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};

  var userId = user.id;
  var widgetId = widget.id;

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, widgetId: widgetId, config: config }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = { commit: commit };

/***/ }),

/***/ 1398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1414);
};

function commit(environment, user, widget, enabled) {
  var onCompleted = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var onError = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};

  var userId = user.id;
  var widgetId = widget.id;

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, widgetId: widgetId, enabled: enabled }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = { commit: commit };

/***/ }),

/***/ 1399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5f796c0c60d4c78da90e042eb484ac75
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ExperimentGroupAdExplanation = "DEFAULT" | "NONE" | "SHOW_EXPLANATION" | "%future added value";
export type ExperimentGroupAnonSignIn = "ANONYMOUS_ALLOWED" | "AUTHED_USER_ONLY" | "NONE" | "%future added value";
export type ExperimentGroupOneAdForNewUsers = "DEFAULT" | "NONE" | "ONE_AD_AT_FIRST" | "%future added value";
export type ExperimentGroupThirdAd = "NONE" | "THREE_ADS" | "TWO_ADS" | "%future added value";
export type ExperimentGroupVariousAdSizes = "NONE" | "STANDARD" | "VARIOUS" | "%future added value";
export type CreateNewUserInput = {
  userId: string,
  email?: ?string,
  referralData?: ?ReferralData,
  experimentGroups?: ?ExperimentGroups,
  extensionInstallId?: ?string,
  extensionInstallTimeApprox?: ?string,
  clientMutationId?: ?string,
};
export type ReferralData = {
  referringUser?: ?string,
  referringChannel?: ?string,
};
export type ExperimentGroups = {
  anonSignIn?: ?ExperimentGroupAnonSignIn,
  variousAdSizes?: ?ExperimentGroupVariousAdSizes,
  thirdAd?: ?ExperimentGroupThirdAd,
  oneAdForNewUsers?: ?ExperimentGroupOneAdForNewUsers,
  adExplanation?: ?ExperimentGroupAdExplanation,
};
export type CreateNewUserMutationVariables = {|
  input: CreateNewUserInput
|};
export type CreateNewUserMutationResponse = {|
  +createNewUser: ?{|
    +user: ?{|
      +id: string,
      +email: ?string,
      +username: ?string,
    |}
  |}
|};
export type CreateNewUserMutation = {|
  variables: CreateNewUserMutationVariables,
  response: CreateNewUserMutationResponse,
|};
*/

/*
mutation CreateNewUserMutation(
  $input: CreateNewUserInput!
) {
  createNewUser(input: $input) {
    user {
      id
      email
      username
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateNewUserInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "createNewUser",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "CreateNewUserInput!"
    }],
    "concreteType": "CreateNewUserPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "username",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "CreateNewUserMutation",
    "id": null,
    "text": "mutation CreateNewUserMutation(\n  $input: CreateNewUserInput!\n) {\n  createNewUser(input: $input) {\n    user {\n      id\n      email\n      username\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "CreateNewUserMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "CreateNewUserMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'fc25db3c5643bbcf8e46d09732780fa3';
module.exports = node;

/***/ }),

/***/ 1400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b3f993cd6bf05f7f43519eba249a7304
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DonateVcInput = {
  userId: string,
  charityId: string,
  vc: number,
  clientMutationId?: ?string,
};
export type DonateVcMutationVariables = {|
  input: DonateVcInput
|};
export type DonateVcMutationResponse = {|
  +donateVc: ?{|
    +user: ?{|
      +vcCurrent: ?number
    |}
  |}
|};
export type DonateVcMutation = {|
  variables: DonateVcMutationVariables,
  response: DonateVcMutationResponse,
|};
*/

/*
mutation DonateVcMutation(
  $input: DonateVcInput!
) {
  donateVc(input: $input) {
    user {
      vcCurrent
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "DonateVcInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DonateVcInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "vcCurrent",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "DonateVcMutation",
    "id": null,
    "text": "mutation DonateVcMutation(\n  $input: DonateVcInput!\n) {\n  donateVc(input: $input) {\n    user {\n      vcCurrent\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "DonateVcMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "donateVc",
        "storageKey": null,
        "args": v1,
        "concreteType": "DonateVcPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "DonateVcMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "donateVc",
        "storageKey": null,
        "args": v1,
        "concreteType": "DonateVcPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '08391d46590e2b37a0c845905fa8abc2';
module.exports = node;

/***/ }),

/***/ 1401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 28727ed6b7a788b9c129e08db2495de7
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogEmailVerifiedMutationInput = {
  userId: string,
  clientMutationId?: ?string,
};
export type LogEmailVerifiedMutationVariables = {|
  input: LogEmailVerifiedMutationInput
|};
export type LogEmailVerifiedMutationResponse = {|
  +logEmailVerified: ?{|
    +user: ?{|
      +id: string
    |}
  |}
|};
export type LogEmailVerifiedMutation = {|
  variables: LogEmailVerifiedMutationVariables,
  response: LogEmailVerifiedMutationResponse,
|};
*/

/*
mutation LogEmailVerifiedMutation(
  $input: LogEmailVerifiedMutationInput!
) {
  logEmailVerified(input: $input) {
    user {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogEmailVerifiedMutationInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "logEmailVerified",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "LogEmailVerifiedMutationInput!"
    }],
    "concreteType": "LogEmailVerifiedMutationPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LogEmailVerifiedMutation",
    "id": null,
    "text": "mutation LogEmailVerifiedMutation(\n  $input: LogEmailVerifiedMutationInput!\n) {\n  logEmailVerified(input: $input) {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LogEmailVerifiedMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "LogEmailVerifiedMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '3b384ecf331d8d3428ffd5bbe22b78a9';
module.exports = node;

/***/ }),

/***/ 1402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 09570377625b1f5af4c665d88494953b
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogTabInput = {
  userId: string,
  tabId?: ?string,
  clientMutationId?: ?string,
};
export type LogTabMutationVariables = {|
  input: LogTabInput
|};
export type LogTabMutationResponse = {|
  +logTab: ?{|
    +user: ?{|
      +id: string,
      +heartsUntilNextLevel: ?number,
      +level: ?number,
      +tabs: ?number,
      +tabsToday: ?number,
      +vcCurrent: ?number,
    |}
  |}
|};
export type LogTabMutation = {|
  variables: LogTabMutationVariables,
  response: LogTabMutationResponse,
|};
*/

/*
mutation LogTabMutation(
  $input: LogTabInput!
) {
  logTab(input: $input) {
    user {
      id
      heartsUntilNextLevel
      level
      tabs
      tabsToday
      vcCurrent
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogTabInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "logTab",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "LogTabInput!"
    }],
    "concreteType": "LogTabPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "heartsUntilNextLevel",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "level",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "tabs",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "tabsToday",
        "args": null,
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "name": "vcCurrent",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LogTabMutation",
    "id": null,
    "text": "mutation LogTabMutation(\n  $input: LogTabInput!\n) {\n  logTab(input: $input) {\n    user {\n      id\n      heartsUntilNextLevel\n      level\n      tabs\n      tabsToday\n      vcCurrent\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LogTabMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "LogTabMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2a59efaca4e64321437a5ccb96753c0a';
module.exports = node;

/***/ }),

/***/ 1403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 478ef4ab2476f571a97041085d397af3
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogUserDataConsentInput = {
  userId: string,
  consentString: string,
  isGlobalConsent: boolean,
  clientMutationId?: ?string,
};
export type LogUserDataConsentMutationVariables = {|
  input: LogUserDataConsentInput
|};
export type LogUserDataConsentMutationResponse = {|
  +logUserDataConsent: ?{|
    +success: boolean
  |}
|};
export type LogUserDataConsentMutation = {|
  variables: LogUserDataConsentMutationVariables,
  response: LogUserDataConsentMutationResponse,
|};
*/

/*
mutation LogUserDataConsentMutation(
  $input: LogUserDataConsentInput!
) {
  logUserDataConsent(input: $input) {
    success
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogUserDataConsentInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "logUserDataConsent",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "LogUserDataConsentInput!"
    }],
    "concreteType": "LogUserDataConsentPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "success",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LogUserDataConsentMutation",
    "id": null,
    "text": "mutation LogUserDataConsentMutation(\n  $input: LogUserDataConsentInput!\n) {\n  logUserDataConsent(input: $input) {\n    success\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LogUserDataConsentMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "LogUserDataConsentMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c2bf60f75d4c0a834c5677312a6bc346';
module.exports = node;

/***/ }),

/***/ 1404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9a2322c5f4777f242a93d11784a72a94
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EncodedRevenueValueTypeEnum = "AMAZON_CPM" | "%future added value";
export type LogUserRevenueAggregationOperationEnum = "MAX" | "%future added value";
export type LogUserRevenueInput = {
  userId: string,
  revenue?: ?number,
  encodedRevenue?: ?EncodedRevenueValue,
  aggregationOperation?: ?LogUserRevenueAggregationOperationEnum,
  dfpAdvertiserId?: ?string,
  adUnitCode?: ?string,
  tabId?: ?string,
  adSize?: ?string,
  clientMutationId?: ?string,
};
export type EncodedRevenueValue = {
  encodingType: EncodedRevenueValueTypeEnum,
  encodedValue: string,
  adSize?: ?string,
};
export type LogUserRevenueMutationVariables = {|
  input: LogUserRevenueInput
|};
export type LogUserRevenueMutationResponse = {|
  +logUserRevenue: ?{|
    +success: boolean
  |}
|};
export type LogUserRevenueMutation = {|
  variables: LogUserRevenueMutationVariables,
  response: LogUserRevenueMutationResponse,
|};
*/

/*
mutation LogUserRevenueMutation(
  $input: LogUserRevenueInput!
) {
  logUserRevenue(input: $input) {
    success
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogUserRevenueInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "logUserRevenue",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "LogUserRevenueInput!"
    }],
    "concreteType": "LogUserRevenuePayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "success",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "LogUserRevenueMutation",
    "id": null,
    "text": "mutation LogUserRevenueMutation(\n  $input: LogUserRevenueInput!\n) {\n  logUserRevenue(input: $input) {\n    success\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "LogUserRevenueMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "LogUserRevenueMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '15f5cc90b9b7975a47fe8855e9d34cda';
module.exports = node;

/***/ }),

/***/ 1405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bdbd0138c43a512aff0a00b892b2512f
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MergeIntoExistingUserInput = {
  userId: string,
  clientMutationId?: ?string,
};
export type MergeIntoExistingUserMutationVariables = {|
  input: MergeIntoExistingUserInput
|};
export type MergeIntoExistingUserMutationResponse = {|
  +mergeIntoExistingUser: ?{|
    +success: boolean
  |}
|};
export type MergeIntoExistingUserMutation = {|
  variables: MergeIntoExistingUserMutationVariables,
  response: MergeIntoExistingUserMutationResponse,
|};
*/

/*
mutation MergeIntoExistingUserMutation(
  $input: MergeIntoExistingUserInput!
) {
  mergeIntoExistingUser(input: $input) {
    success
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "MergeIntoExistingUserInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "mergeIntoExistingUser",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "MergeIntoExistingUserInput!"
    }],
    "concreteType": "MergeIntoExistingUserPayload",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "success",
      "args": null,
      "storageKey": null
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "MergeIntoExistingUserMutation",
    "id": null,
    "text": "mutation MergeIntoExistingUserMutation(\n  $input: MergeIntoExistingUserInput!\n) {\n  mergeIntoExistingUser(input: $input) {\n    success\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "MergeIntoExistingUserMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "MergeIntoExistingUserMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'cecbd441c4acbc6b520cdc92edc5d7c4';
module.exports = node;

/***/ }),

/***/ 1406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c18867377bcad002ccae3064115da341
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgColorInput = {
  userId: string,
  color: string,
  clientMutationId?: ?string,
};
export type SetBackgroundColorMutationVariables = {|
  input: SetUserBkgColorInput
|};
export type SetBackgroundColorMutationResponse = {|
  +setUserBkgColor: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +backgroundColor: ?string,
    |}
  |}
|};
export type SetBackgroundColorMutation = {|
  variables: SetBackgroundColorMutationVariables,
  response: SetBackgroundColorMutationResponse,
|};
*/

/*
mutation SetBackgroundColorMutation(
  $input: SetUserBkgColorInput!
) {
  setUserBkgColor(input: $input) {
    user {
      backgroundOption
      backgroundColor
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgColorInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserBkgColorInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundOption",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundColor",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SetBackgroundColorMutation",
    "id": null,
    "text": "mutation SetBackgroundColorMutation(\n  $input: SetUserBkgColorInput!\n) {\n  setUserBkgColor(input: $input) {\n    user {\n      backgroundOption\n      backgroundColor\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SetBackgroundColorMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgColor",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgColorPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v3]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SetBackgroundColorMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgColor",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgColorPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '340f67596a49a6cb1635dc065fa7487b';
module.exports = node;

/***/ }),

/***/ 1407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 293a52128f72eeeedec48a621ef6a668
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgCustomImageInput = {
  userId: string,
  image: string,
  clientMutationId?: ?string,
};
export type SetBackgroundCustomImageMutationVariables = {|
  input: SetUserBkgCustomImageInput
|};
export type SetBackgroundCustomImageMutationResponse = {|
  +setUserBkgCustomImage: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +customImage: ?string,
    |}
  |}
|};
export type SetBackgroundCustomImageMutation = {|
  variables: SetBackgroundCustomImageMutationVariables,
  response: SetBackgroundCustomImageMutationResponse,
|};
*/

/*
mutation SetBackgroundCustomImageMutation(
  $input: SetUserBkgCustomImageInput!
) {
  setUserBkgCustomImage(input: $input) {
    user {
      backgroundOption
      customImage
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgCustomImageInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserBkgCustomImageInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundOption",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "customImage",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SetBackgroundCustomImageMutation",
    "id": null,
    "text": "mutation SetBackgroundCustomImageMutation(\n  $input: SetUserBkgCustomImageInput!\n) {\n  setUserBkgCustomImage(input: $input) {\n    user {\n      backgroundOption\n      customImage\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SetBackgroundCustomImageMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgCustomImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgCustomImagePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v3]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SetBackgroundCustomImageMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgCustomImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgCustomImagePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v3, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'c49e6f251c84d4dd6d1fc92630f7be16';
module.exports = node;

/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b29de6ff1689465f72751aef12389bf0
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgDailyImageInput = {
  userId: string,
  clientMutationId?: ?string,
};
export type SetBackgroundDailyImageMutationVariables = {|
  input: SetUserBkgDailyImageInput
|};
export type SetBackgroundDailyImageMutationResponse = {|
  +setUserBkgDailyImage: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +backgroundImage: ?{|
        +id: string,
        +imageURL: ?string,
        +timestamp: ?string,
      |},
    |}
  |}
|};
export type SetBackgroundDailyImageMutation = {|
  variables: SetBackgroundDailyImageMutationVariables,
  response: SetBackgroundDailyImageMutationResponse,
|};
*/

/*
mutation SetBackgroundDailyImageMutation(
  $input: SetUserBkgDailyImageInput!
) {
  setUserBkgDailyImage(input: $input) {
    user {
      backgroundOption
      backgroundImage {
        id
        imageURL
        timestamp
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgDailyImageInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserBkgDailyImageInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundOption",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "backgroundImage",
    "storageKey": null,
    "args": null,
    "concreteType": "BackgroundImage",
    "plural": false,
    "selections": [v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageURL",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SetBackgroundDailyImageMutation",
    "id": null,
    "text": "mutation SetBackgroundDailyImageMutation(\n  $input: SetUserBkgDailyImageInput!\n) {\n  setUserBkgDailyImage(input: $input) {\n    user {\n      backgroundOption\n      backgroundImage {\n        id\n        imageURL\n        timestamp\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SetBackgroundDailyImageMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgDailyImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgDailyImagePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v4]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SetBackgroundDailyImageMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgDailyImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgDailyImagePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v4, v3]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '50f99e8a8c2ce7d300f7a57c4a15371f';
module.exports = node;

/***/ }),

/***/ 1409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 8ff30b67e63e19e6d8b654577238a9d1
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgImageInput = {
  userId: string,
  imageId: string,
  clientMutationId?: ?string,
};
export type SetBackgroundImageMutationVariables = {|
  input: SetUserBkgImageInput
|};
export type SetBackgroundImageMutationResponse = {|
  +setUserBkgImage: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +backgroundImage: ?{|
        +id: string,
        +imageURL: ?string,
      |},
    |}
  |}
|};
export type SetBackgroundImageMutation = {|
  variables: SetBackgroundImageMutationVariables,
  response: SetBackgroundImageMutationResponse,
|};
*/

/*
mutation SetBackgroundImageMutation(
  $input: SetUserBkgImageInput!
) {
  setUserBkgImage(input: $input) {
    user {
      backgroundOption
      backgroundImage {
        id
        imageURL
      }
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgImageInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserBkgImageInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "backgroundOption",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "backgroundImage",
    "storageKey": null,
    "args": null,
    "concreteType": "BackgroundImage",
    "plural": false,
    "selections": [v3, {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageURL",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SetBackgroundImageMutation",
    "id": null,
    "text": "mutation SetBackgroundImageMutation(\n  $input: SetUserBkgImageInput!\n) {\n  setUserBkgImage(input: $input) {\n    user {\n      backgroundOption\n      backgroundImage {\n        id\n        imageURL\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SetBackgroundImageMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgImagePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v4]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SetBackgroundImageMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgImage",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgImagePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, v4, v3]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'd7e7b1b43266cd83ef7ba1760d26aded';
module.exports = node;

/***/ }),

/***/ 1410:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c26fa01eefbf0dceddd728fe2eba8edb
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserActiveWidgetInput = {
  userId: string,
  widgetId: string,
  clientMutationId?: ?string,
};
export type SetUserActiveWidgetMutationVariables = {|
  input: SetUserActiveWidgetInput
|};
export type SetUserActiveWidgetMutationResponse = {|
  +setUserActiveWidget: ?{|
    +user: ?{|
      +activeWidget: ?string
    |}
  |}
|};
export type SetUserActiveWidgetMutation = {|
  variables: SetUserActiveWidgetMutationVariables,
  response: SetUserActiveWidgetMutationResponse,
|};
*/

/*
mutation SetUserActiveWidgetMutation(
  $input: SetUserActiveWidgetInput!
) {
  setUserActiveWidget(input: $input) {
    user {
      activeWidget
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserActiveWidgetInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserActiveWidgetInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "activeWidget",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SetUserActiveWidgetMutation",
    "id": null,
    "text": "mutation SetUserActiveWidgetMutation(\n  $input: SetUserActiveWidgetInput!\n) {\n  setUserActiveWidget(input: $input) {\n    user {\n      activeWidget\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SetUserActiveWidgetMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserActiveWidget",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserActiveWidgetPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SetUserActiveWidgetMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserActiveWidget",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserActiveWidgetPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b8842e2cd7d06c98b63f8634e1c13cb4';
module.exports = node;

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash bcdb84a4220d8a125876c59b965fc03e
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUsernameInput = {
  userId: string,
  username: string,
  clientMutationId?: ?string,
};
export type SetUsernameMutationVariables = {|
  input: SetUsernameInput
|};
export type SetUsernameMutationResponse = {|
  +setUsername: ?{|
    +user: ?{|
      +username: ?string
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +message: ?string,
    |}>,
  |}
|};
export type SetUsernameMutation = {|
  variables: SetUsernameMutationVariables,
  response: SetUsernameMutationResponse,
|};
*/

/*
mutation SetUsernameMutation(
  $input: SetUsernameInput!
) {
  setUsername(input: $input) {
    user {
      username
      id
    }
    errors {
      code
      message
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUsernameInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUsernameInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "username",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "errors",
    "storageKey": null,
    "args": null,
    "concreteType": "CustomError",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "code",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }]
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "SetUsernameMutation",
    "id": null,
    "text": "mutation SetUsernameMutation(\n  $input: SetUsernameInput!\n) {\n  setUsername(input: $input) {\n    user {\n      username\n      id\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "SetUsernameMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUsername",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUsernamePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2]
        }, v3]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "SetUsernameMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "setUsername",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUsernamePayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }, v3]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'a95b117f38856beed2d5f098125f7fc3';
module.exports = node;

/***/ }),

/***/ 1412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 355e155c1d1030b94d13fc98a269d474
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetConfigInput = {
  userId: string,
  widgetId: string,
  config: string,
  clientMutationId?: ?string,
};
export type UpdateWidgetConfigMutationVariables = {|
  input: UpdateWidgetConfigInput
|};
export type UpdateWidgetConfigMutationResponse = {|
  +updateWidgetConfig: ?{|
    +widget: ?{|
      +config: ?string
    |}
  |}
|};
export type UpdateWidgetConfigMutation = {|
  variables: UpdateWidgetConfigMutationVariables,
  response: UpdateWidgetConfigMutationResponse,
|};
*/

/*
mutation UpdateWidgetConfigMutation(
  $input: UpdateWidgetConfigInput!
) {
  updateWidgetConfig(input: $input) {
    widget {
      config
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWidgetConfigInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateWidgetConfigInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "config",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "UpdateWidgetConfigMutation",
    "id": null,
    "text": "mutation UpdateWidgetConfigMutation(\n  $input: UpdateWidgetConfigInput!\n) {\n  updateWidgetConfig(input: $input) {\n    widget {\n      config\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UpdateWidgetConfigMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetConfig",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetConfigPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "widget",
          "storageKey": null,
          "args": null,
          "concreteType": "Widget",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UpdateWidgetConfigMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetConfig",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetConfigPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "widget",
          "storageKey": null,
          "args": null,
          "concreteType": "Widget",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '2127f87672065f25d565b3bcb954f5e9';
module.exports = node;

/***/ }),

/***/ 1413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f408e68ba7ff5f7993ff16a95e833cef
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetDataInput = {
  userId: string,
  widgetId: string,
  data: string,
  clientMutationId?: ?string,
};
export type UpdateWidgetDataMutationVariables = {|
  input: UpdateWidgetDataInput
|};
export type UpdateWidgetDataMutationResponse = {|
  +updateWidgetData: ?{|
    +widget: ?{|
      +data: ?string
    |}
  |}
|};
export type UpdateWidgetDataMutation = {|
  variables: UpdateWidgetDataMutationVariables,
  response: UpdateWidgetDataMutationResponse,
|};
*/

/*
mutation UpdateWidgetDataMutation(
  $input: UpdateWidgetDataInput!
) {
  updateWidgetData(input: $input) {
    widget {
      data
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWidgetDataInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateWidgetDataInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "data",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "UpdateWidgetDataMutation",
    "id": null,
    "text": "mutation UpdateWidgetDataMutation(\n  $input: UpdateWidgetDataInput!\n) {\n  updateWidgetData(input: $input) {\n    widget {\n      data\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UpdateWidgetDataMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetData",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetDataPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "widget",
          "storageKey": null,
          "args": null,
          "concreteType": "Widget",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UpdateWidgetDataMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetData",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetDataPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "widget",
          "storageKey": null,
          "args": null,
          "concreteType": "Widget",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = '779999ee36248fb05842ed1964087919';
module.exports = node;

/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 728770f7bf0e816e1c0fd2f4a7167162
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetEnabledInput = {
  userId: string,
  widgetId: string,
  enabled: boolean,
  clientMutationId?: ?string,
};
export type UpdateWidgetEnabledMutationVariables = {|
  input: UpdateWidgetEnabledInput
|};
export type UpdateWidgetEnabledMutationResponse = {|
  +updateWidgetEnabled: ?{|
    +widget: ?{|
      +enabled: ?boolean
    |}
  |}
|};
export type UpdateWidgetEnabledMutation = {|
  variables: UpdateWidgetEnabledMutationVariables,
  response: UpdateWidgetEnabledMutationResponse,
|};
*/

/*
mutation UpdateWidgetEnabledMutation(
  $input: UpdateWidgetEnabledInput!
) {
  updateWidgetEnabled(input: $input) {
    widget {
      enabled
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWidgetEnabledInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateWidgetEnabledInput!"
  }],
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "enabled",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "UpdateWidgetEnabledMutation",
    "id": null,
    "text": "mutation UpdateWidgetEnabledMutation(\n  $input: UpdateWidgetEnabledInput!\n) {\n  updateWidgetEnabled(input: $input) {\n    widget {\n      enabled\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UpdateWidgetEnabledMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetEnabled",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetEnabledPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "widget",
          "storageKey": null,
          "args": null,
          "concreteType": "Widget",
          "plural": false,
          "selections": [v2]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "UpdateWidgetEnabledMutation",
      "argumentDefinitions": v0,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetEnabled",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetEnabledPayload",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "name": "widget",
          "storageKey": null,
          "args": null,
          "concreteType": "Widget",
          "plural": false,
          "selections": [v2, {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }]
        }]
      }]
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'f6726e995666d8c93f03c5f31caa0e72';
module.exports = node;

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(220);

var _Route = __webpack_require__(1416);

var _Route2 = _interopRequireDefault(_Route);

var _reactIntl = __webpack_require__(2420);

var _en = __webpack_require__(2421);

var _en2 = _interopRequireDefault(_en);

var _es = __webpack_require__(2422);

var _es2 = _interopRequireDefault(_es);

var _styles = __webpack_require__(79);

var _materialUi = __webpack_require__(120);

var _getMuiTheme = __webpack_require__(790);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _data = __webpack_require__(1824);

var _data2 = _interopRequireDefault(_data);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

var _defaultV = __webpack_require__(1417);

var _defaultV2 = _interopRequireDefault(_defaultV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Our translated strings


var legacyMuiTheme = (0, _getMuiTheme2.default)(_default2.default);
var muiTheme = (0, _styles.createMuiTheme)(_defaultV2.default);

(0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_en2.default), _toConsumableArray(_es2.default)));

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
var language = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;

// Split locales with a region code
var languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

// Try full locale, try locale without region code, fallback to 'en'
var messages = _data2.default[languageWithoutRegionCode] || _data2.default[language] || _data2.default.en;

// @material-ui-1-todo: remove legacy theme provider
var Root = function Root() {
  return _react2.default.createElement(
    _styles.MuiThemeProvider,
    { theme: muiTheme },
    _react2.default.createElement(
      _materialUi.MuiThemeProvider,
      { muiTheme: legacyMuiTheme },
      _react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: language, messages: messages },
        _react2.default.createElement(_reactRouter.Router, {
          history: _reactRouter.browserHistory,
          routes: _Route2.default })
      )
    )
  );
};

exports.default = Root;

/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(220);

var _BaseContainer = __webpack_require__(1273);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _App = __webpack_require__(1212);

var _App2 = _interopRequireDefault(_App);

var _DashboardView = __webpack_require__(1245);

var _DashboardView2 = _interopRequireDefault(_DashboardView);

var _AuthenticationView = __webpack_require__(1215);

var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);

var _FirebaseAuthenticationUI = __webpack_require__(1217);

var _FirebaseAuthenticationUI2 = _interopRequireDefault(_FirebaseAuthenticationUI);

var _FirebaseAuthenticationUIAction = __webpack_require__(1218);

var _FirebaseAuthenticationUIAction2 = _interopRequireDefault(_FirebaseAuthenticationUIAction);

var _VerifyEmailMessage = __webpack_require__(1221);

var _VerifyEmailMessage2 = _interopRequireDefault(_VerifyEmailMessage);

var _EnterUsernameForm = __webpack_require__(1216);

var _EnterUsernameForm2 = _interopRequireDefault(_EnterUsernameForm);

var _SignInIframeMessage = __webpack_require__(1220);

var _SignInIframeMessage2 = _interopRequireDefault(_SignInIframeMessage);

var _MissingEmailMessage = __webpack_require__(1219);

var _MissingEmailMessage2 = _interopRequireDefault(_MissingEmailMessage);

var _SettingsPageComponent = __webpack_require__(1324);

var _SettingsPageComponent2 = _interopRequireDefault(_SettingsPageComponent);

var _BackgroundSettingsView = __webpack_require__(1300);

var _BackgroundSettingsView2 = _interopRequireDefault(_BackgroundSettingsView);

var _WidgetsSettingsView = __webpack_require__(1330);

var _WidgetsSettingsView2 = _interopRequireDefault(_WidgetsSettingsView);

var _ProfileStatsView = __webpack_require__(1313);

var _ProfileStatsView2 = _interopRequireDefault(_ProfileStatsView);

var _ProfileDonateHeartsView = __webpack_require__(1307);

var _ProfileDonateHeartsView2 = _interopRequireDefault(_ProfileDonateHeartsView);

var _ProfileInviteFriendView = __webpack_require__(1310);

var _ProfileInviteFriendView2 = _interopRequireDefault(_ProfileInviteFriendView);

var _AccountView = __webpack_require__(1295);

var _AccountView2 = _interopRequireDefault(_AccountView);

var _FirstTabView = __webpack_require__(1246);

var _FirstTabView2 = _interopRequireDefault(_FirstTabView);

var _PostUninstallView = __webpack_require__(1256);

var _PostUninstallView2 = _interopRequireDefault(_PostUninstallView);

var _SearchView = __webpack_require__(1288);

var _SearchView2 = _interopRequireDefault(_SearchView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default =
// TODO: Show 404 page from IndexRedirect
_react2.default.createElement(
  _reactRouter.Route,
  { path: '/', component: _BaseContainer2.default },
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'newtab', component: _App2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _DashboardView2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _SettingsPageComponent2.default },
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'settings' },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _WidgetsSettingsView2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'widgets', component: _WidgetsSettingsView2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'background', component: _BackgroundSettingsView2.default })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'profile' },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _ProfileStatsView2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'stats', component: _ProfileStatsView2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'donate', component: _ProfileDonateHeartsView2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'invite', component: _ProfileInviteFriendView2.default })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: 'account', component: _AccountView2.default })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'first-tab' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _FirstTabView2.default })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'uninstalled' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _PostUninstallView2.default })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'auth', component: _AuthenticationView2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _FirebaseAuthenticationUI2.default }),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'action', component: _FirebaseAuthenticationUI2.default },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _FirebaseAuthenticationUIAction2.default })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: 'verify-email', component: _VerifyEmailMessage2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'username', component: _EnterUsernameForm2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'welcome', component: _SignInIframeMessage2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'missing-email', component: _MissingEmailMessage2.default })
    ),
    _react2.default.createElement(_reactRouter.Redirect, { from: '*', to: '/newtab/' })
  ),
  _react2.default.createElement(_reactRouter.IndexRedirect, { from: '*', to: '/newtab/' }),
  _react2.default.createElement(_reactRouter.Route, { path: 'search', component: _SearchView2.default })
);

/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = __webpack_require__(79);

// Theme
var primaryMainColor = '#9d4ba3';
var primaryContrastTextColor = '#fff';
var secondaryMainColor = '#4a90e2';
var secondaryContrastTextColor = '#fff';

var theme = (0, _styles.createMuiTheme)({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: primaryMainColor,
      // dark: will be calculated from palette.primary.main,
      contrastText: primaryContrastTextColor
    },
    secondary: {
      // light: will be calculated from palette.primary.main,
      main: secondaryMainColor,
      // dark: will be calculated from palette.primary.main,
      contrastText: secondaryContrastTextColor
    }
  },
  typography: {
    useNextVariants: true,
    fontSize: 14,
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    h5: {
      lineHeight: '1.24'
    },
    title: {
      lineHeight: '1.7em'
    },
    body2: {
      lineHeight: '1.3'
    },
    subheading: {
      lineHeight: '1.16667em'
    }
  },
  shape: {
    borderRadius: 2
  },
  overrides: {
    MuiButtonBase: {
      root: {
        color: 'rgba(0, 0, 0, 0.87)'
      }
    },
    MuiListSubheader: {
      root: {
        fontSize: 12,
        textTransform: 'uppercase'
      }
    }
  }
});

exports.default = theme;

/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var POST_MSG_TYPE_BACKGROUND_SETTINGS = 'background-settings';

var postMessage = exports.postMessage = function postMessage(type, data) {
  // Important: messages sent are NOT private. If we want
  // private messages, we need to postMessage specifically
  // to each of our extensions' domains.
  window.top.postMessage({ type: type, data: data }, '*');
};

var postBackgroundSettings = exports.postBackgroundSettings = function postBackgroundSettings(settings) {
  postMessage(POST_MSG_TYPE_BACKGROUND_SETTINGS, settings);
};

/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () {
    function sliceIterator(arr, i) {
        var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;_e = err;
        } finally {
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }return _arr;
    }return function (arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Rocket = __webpack_require__(1420);

var _Rocket2 = _interopRequireDefault(_Rocket);

var _Smoke = __webpack_require__(1421);

var _Smoke2 = _interopRequireDefault(_Smoke);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
        }return arr2;
    } else {
        return Array.from(arr);
    }
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MAX_PARTICLES = 400;
var FIRE_ROCKET_EVERY_MS = 400;
var REFRESH_EVERY_MS = 40;
var DEFAULT_BACKGROUND_COLOR = "rgba(0, 0, 0, 0.02)";

var Fireworks = function (_Component) {
    _inherits(Fireworks, _Component);

    function Fireworks() {
        _classCallCheck(this, Fireworks);

        return _possibleConstructorReturn(this, (Fireworks.__proto__ || Object.getPrototypeOf(Fireworks)).apply(this, arguments));
    }

    _createClass(Fireworks, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var canvas = this.canvas;
            var _props = this.props,
                width = _props.width,
                height = _props.height,
                background = _props.background;

            this.fireworksContext = canvas.getContext('2d');

            this.fireworksContext.fillStyle = background ? background : DEFAULT_BACKGROUND_COLOR;
            this.fireworksContext.fillRect(0, 0, width + 'px', height + 'px');

            var rockets = [],
                particles = [];
            this.launchInterval = window.setInterval(function () {
                return rockets = _this2.launch.call(_this2, width, height, rockets);
            }, FIRE_ROCKET_EVERY_MS);
            this.loopInterval = window.setInterval(function () {
                var _loop$call, _loop$call2;

                return _loop$call = _this2.loop.call(_this2, width, height, rockets, particles), _loop$call2 = _slicedToArray(_loop$call, 2), rockets = _loop$call2[0], particles = _loop$call2[1], _loop$call;
            }, REFRESH_EVERY_MS);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.clearInterval(this.launchInterval);
            window.clearInterval(this.loopInterval);
        }
    }, {
        key: 'shouldAddSmoke',
        value: function shouldAddSmoke(rocket) {
            var _rocket$getPosition = rocket.getPosition(),
                _rocket$getPosition2 = _slicedToArray(_rocket$getPosition, 2),
                x = _rocket$getPosition2[0],
                y = _rocket$getPosition2[1];

            return Math.random() < 0.6 ? [new _Smoke2.default(x, y, {
                x: Math.random() * 1 - 0.5,
                y: Math.random() * 0.01
            }, 1.03, 1, -0.2, undefined, 0.01, true, 1, Math.random() * 0.03 + 0.02)] : [];
        }
    }, {
        key: 'loop',
        value: function loop(width, height, rockets, particles) {
            var _this3 = this;

            // clear canvas
            this.fireworksContext.fillRect(0, 0, width, height);

            var existingRockets = [];
            var existingParticles = [].concat(_toConsumableArray(particles));

            rockets.forEach(function (rocket) {
                // update and render
                rocket.update();
                rocket.render(_this3.fireworksContext);

                existingParticles = [].concat(_toConsumableArray(existingParticles), _toConsumableArray(_this3.shouldAddSmoke(rocket)));

                // random chance of 1% if rockets is above the middle
                var randomChance = rocket.y < height * 2 / 3 ? Math.random() * 100 <= 1 : false;

                /* Explosion rules
                    - 80% of screen
                    - going down
                    - close to x, y position of rocket location
                    - 1% chance of random explosion
                */
                rocket.y < height / 5 || rocket.vel.y >= 0 || randomChance ? existingParticles = [].concat(_toConsumableArray(existingParticles), _toConsumableArray(rocket.explode())) : existingRockets.push(rocket);
            });

            //        let existingParticles = [];

            existingParticles.forEach(function (particle) {
                particle.update();

                // render and save particles that can be rendered
                if (particle.exists()) {
                    particle.render(_this3.fireworksContext);
                    existingParticles.push(particle);
                }
            });

            while (existingParticles.length > MAX_PARTICLES) {
                existingParticles.shift();
            }

            return [existingRockets, existingParticles];
        }
    }, {
        key: 'launch',
        value: function launch(width, height, rockets) {
            return this.launchFrom(width / 2, height, rockets);
        }
    }, {
        key: 'launchFrom',
        value: function launchFrom(x, y, rockets) {
            var result = [].concat(_toConsumableArray(rockets));

            if (result.length < 10) {
                var rocket = new _Rocket2.default(x, y, {
                    x: Math.random() * 6 - 3,
                    y: Math.random() * -3 - 4
                }, 0.999, 8, 0.01, Math.floor(Math.random() * 360 / 10) * 10);
                result.push(rocket);
            }
            return result;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props2 = this.props,
                width = _props2.width,
                height = _props2.height,
                style = _props2.style;

            return _react2.default.createElement('canvas', { ref: function ref(c) {
                    _this4.canvas = c;
                }, width: width, height: height, style: style });
        }
    }]);

    return Fireworks;
}(_react.Component);

Fireworks.propTypes = {
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    background: _propTypes2.default.string
};

exports.default = Fireworks;

/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _Particle2 = __webpack_require__(578);

var _Particle3 = _interopRequireDefault(_Particle2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Rocket = function (_Particle) {
    _inherits(Rocket, _Particle);

    function Rocket() {
        _classCallCheck(this, Rocket);

        return _possibleConstructorReturn(this, (Rocket.__proto__ || Object.getPrototypeOf(Rocket)).apply(this, arguments));
    }

    _createClass(Rocket, [{
        key: 'explode',
        value: function explode() {
            var count = Math.random() * 10 + 80;

            var particles = [];
            for (var i = 0; i < count; i++) {
                // emulate 3D effect by using cosine and put more particles in the middle
                var speed = Math.cos(Math.random() * Math.PI / 2) * 15;
                var angle = Math.random() * Math.PI * 2;

                var particle = new _Particle3.default(this.x, this.y, {
                    x: Math.cos(angle) * speed,
                    y: Math.sin(angle) * speed
                }, Math.random() * 0.05 + 0.93, 10, 0.2, this.color, 0.92, true);
                particles.push(particle);
            }
            return particles;
        }
    }, {
        key: 'render',
        value: function render(c) {
            if (!this.exists()) {
                return;
            }

            c.save();

            c.globalCompositeOperation = 'lighter';
            var _ref = [this.x, this.y, this.size],
                x = _ref[0],
                y = _ref[1],
                size = _ref[2];

            c.fillStyle = "rgb(255, 200, 0)"; // orange
            c.beginPath();

            // draw several particles for each rocket position
            for (var i = 0; i < 5; i++) {
                var angle = Math.random() * Math.PI * 2,
                    pos = Math.random() * size / 2; // use size like radius
                // draw several 1px particles
                c.arc(x + Math.cos(angle) * pos, y + Math.sin(angle) * pos, 1.2, 0, Math.PI * 2, true);
            }
            c.closePath();
            c.fill();

            c.restore();
        }
    }]);

    return Rocket;
}(_Particle3.default);

exports.default = Rocket;

/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

var _Particle2 = __webpack_require__(578);

var _Particle3 = _interopRequireDefault(_Particle2);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Smoke = function (_Particle) {
    _inherits(Smoke, _Particle);

    function Smoke() {
        _classCallCheck(this, Smoke);

        return _possibleConstructorReturn(this, (Smoke.__proto__ || Object.getPrototypeOf(Smoke)).apply(this, arguments));
    }

    _createClass(Smoke, [{
        key: 'render',
        value: function render(c) {
            if (!this.exists()) {
                return;
            }

            c.save();

            c.globalCompositeOperation = 'lighter';
            var _ref = [this.x, this.y, this.size],
                x = _ref[0],
                y = _ref[1],
                size = _ref[2];

            var gradient = c.createRadialGradient(x, y, 0.1, x, y, size / 2);
            gradient.addColorStop(0.1, "rgba(200, 200, 200," + this.alpha + ")");
            gradient.addColorStop(1, "rgba(150, 150, 150 ," + this.alpha + ")");

            c.fillStyle = gradient;

            c.beginPath();
            c.arc(x, y, size, 0, Math.PI * 2, true);
            c.lineTo(x, y);
            c.closePath();
            c.fill();

            c.restore();
        }
    }]);

    return Smoke;
}(_Particle3.default);

exports.default = Smoke;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHorizontalAdSizes = exports.getVerticalAdSizes = exports.getNumberOfAdsToShow = exports.shouldShowAdExplanation = exports.HORIZONTAL_AD_SLOT_DOM_ID = exports.HORIZONTAL_AD_UNIT_ID = exports.SECOND_VERTICAL_AD_SLOT_DOM_ID = exports.SECOND_VERTICAL_AD_UNIT_ID = exports.VERTICAL_AD_SLOT_DOM_ID = exports.VERTICAL_AD_UNIT_ID = exports.BIDDER_TIMEOUT = exports.CONSENT_MANAGEMENT_TIMEOUT = exports.AUCTION_TIMEOUT = undefined;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _featureFlags = __webpack_require__(234);

var _experiments = __webpack_require__(233);

var _localUserDataMgr = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Time to wait for the entire ad auction before
// calling the ad server.
var AUCTION_TIMEOUT = exports.AUCTION_TIMEOUT = 1000;

// Time to wait for the consent management platform (CMP)
// to respond.
var CONSENT_MANAGEMENT_TIMEOUT = exports.CONSENT_MANAGEMENT_TIMEOUT = 50;

// Timeout for individual bidders.
var BIDDER_TIMEOUT = exports.BIDDER_TIMEOUT = 700;

// "Vertical ad" = the ad that's typically rectangular
// or taller than it is wide. Historically, the right-side
// rectangle ad.
var VERTICAL_AD_UNIT_ID = exports.VERTICAL_AD_UNIT_ID = '/43865596/HBTR';
var VERTICAL_AD_SLOT_DOM_ID = exports.VERTICAL_AD_SLOT_DOM_ID = 'div-gpt-ad-1464385742501-0';

// "Second vertical ad" = the extra rectangle ad.
var SECOND_VERTICAL_AD_UNIT_ID = exports.SECOND_VERTICAL_AD_UNIT_ID = '/43865596/HBTR2';
var SECOND_VERTICAL_AD_SLOT_DOM_ID = exports.SECOND_VERTICAL_AD_SLOT_DOM_ID = 'div-gpt-ad-1539903223131-0';

// "Horizontal ad" = the ad that's typically wider than
// it is tall. Historically, the bottom long leaderboard ad.
var HORIZONTAL_AD_UNIT_ID = exports.HORIZONTAL_AD_UNIT_ID = '/43865596/HBTL';
var HORIZONTAL_AD_SLOT_DOM_ID = exports.HORIZONTAL_AD_SLOT_DOM_ID = 'div-gpt-ad-1464385677836-0';

/**
 * Determine if we should show the explanation that the ads raise
 * money for charity. We'll show it for users in the "ad explanation"
 * experimental group for the first X hours after they join.
 * @return {Boolean} Whether to show one ad.
 */
var shouldShowAdExplanation = exports.shouldShowAdExplanation = function shouldShowAdExplanation() {
  var hoursToShow = 4;
  var installTime = (0, _localUserDataMgr.getBrowserExtensionInstallTime)();
  var joinedRecently = !!installTime && (0, _moment2.default)().diff(installTime, 'hours') < hoursToShow;
  var userInExperimentalGroup = (0, _experiments.getUserExperimentGroup)(_experiments.EXPERIMENT_AD_EXPLANATION) === (0, _experiments.getExperimentGroups)(_experiments.EXPERIMENT_AD_EXPLANATION).SHOW_EXPLANATION;
  return !!(joinedRecently && userInExperimentalGroup && !(0, _localUserDataMgr.hasUserDismissedAdExplanation)());
};

/**
 * Determine if we should show only one ad. We'll show one ad for
 * users in the "one ad" test group for the first X hours after
 * they join.
 * @return {Boolean} Whether to show one ad.
 */
var shouldShowOneAd = function shouldShowOneAd() {
  var installTime = (0, _localUserDataMgr.getBrowserExtensionInstallTime)();
  var joinedRecently = !!installTime && (0, _moment2.default)().diff(installTime, 'hours') < 24;
  var userInOneAdTestGroup = (0, _experiments.getUserExperimentGroup)(_experiments.EXPERIMENT_ONE_AD_FOR_NEW_USERS) === (0, _experiments.getExperimentGroups)(_experiments.EXPERIMENT_ONE_AD_FOR_NEW_USERS).ONE_AD_AT_FIRST;
  return !!(joinedRecently && userInOneAdTestGroup);
};

/**
 * Get the number of banner ads to show on the new tab page.
 * @return {Number} The number of ads
 */
var getNumberOfAdsToShow = exports.getNumberOfAdsToShow = function getNumberOfAdsToShow() {
  return shouldShowOneAd() ? 1 : 3;
};

/**
 * Get an array of ad sizes (each an array with two numbers)
 * of the acceptable ad sizes to display for the veritcal
 * ad.
 * @return {Array[Array]} An array of ad sizes
 */
var getVerticalAdSizes = exports.getVerticalAdSizes = function getVerticalAdSizes() {
  var showVariousAdSizes = (0, _featureFlags.isVariousAdSizesEnabled)();
  return showVariousAdSizes ? [[300, 250],
  // Wider than we probably want to allow.
  // [336, 280],
  [250, 250], [160, 600], [120, 600], [120, 240], [240, 400], [234, 60], [180, 150], [125, 125], [120, 90], [120, 60], [120, 30], [230, 33], [300, 600]] : [[300, 250]];
};

/**
 * Get an array of ad sizes (each an array with two numbers)
 * of the acceptable ad sizes to display for the horizontal
 * ad.
 * @return {Array[Array]} An array of ad sizes
 */
var getHorizontalAdSizes = exports.getHorizontalAdSizes = function getHorizontalAdSizes() {
  var showVariousAdSizes = (0, _featureFlags.isVariousAdSizesEnabled)();
  return showVariousAdSizes ? [[728, 90], [728, 210], [720, 300],
  // Taller than we probably want to allow.
  // [500, 350],
  // [550, 480],
  [468, 60]] : [[728, 90]];
};

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _user = __webpack_require__(64);

var _helpers = __webpack_require__(185);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Get the authenticated user and, if the user is authenticated,
// add the user's ID to the `variables` prop. By default, redirect
// to the authentication view if the user is not authenticated.
// TODO: change to a higher-order component:
// https://reactjs.org/docs/higher-order-components.html
var AuthUserComponent = function (_React$Component) {
  _inherits(AuthUserComponent, _React$Component);

  function AuthUserComponent(props) {
    _classCallCheck(this, AuthUserComponent);

    var _this2 = _possibleConstructorReturn(this, (AuthUserComponent.__proto__ || Object.getPrototypeOf(AuthUserComponent)).call(this, props));

    _this2.state = {
      userId: null
    };
    return _this2;
  }

  _createClass(AuthUserComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      // Store unsubscribe function.
      // https://firebase.google.com/docs/reference/js/firebase.auth.Auth#onAuthStateChanged
      this.authListenerUnsubscribe = (0, _user.getCurrentUserListener)()
      // Note: currently, this callback may be called when a user does not
      // exist on the server side, and some requests may fail.
      .onAuthStateChanged(function (user) {
        // TODO: roll the formatting functionality into the
        // listener.
        if (user) {
          var formattedUser = (0, _user.formatUser)(user);
          _this3.checkUserAuth(formattedUser);
        } else {
          _this3.checkUserAuth(user);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof this.authListenerUnsubscribe === 'function') {
        this.authListenerUnsubscribe();
      }
    }
  }, {
    key: 'checkUserAuth',
    value: function checkUserAuth(user) {
      var _this4 = this;

      var _this = this;

      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var redirecting;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _helpers.checkAuthStateAndRedirectIfNeeded)(user);

              case 3:
                redirecting = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);
                throw _context.t0;

              case 9:

                // If the user is authed, set the ID in state.
                if (!redirecting && user && user.id) {
                  _this.setState({
                    userId: user.id
                  });
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 6]]);
      }))();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      if (!this.state.userId) {
        return null;
      }

      var root = {
        height: '100%',
        width: '100%'
      };

      var childrenWithProps = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          variables: Object.assign({}, _this5.props.variables, {
            userId: _this5.state.userId
          })
        });
      });

      return _react2.default.createElement(
        'div',
        { style: root },
        childrenWithProps
      );
    }
  }]);

  return AuthUserComponent;
}(_react2.default.Component);

AuthUserComponent.propTypes = {
  variables: _propTypes2.default.object
};

AuthUserComponent.defaultProps = {
  variables: {}
};

exports.default = AuthUserComponent;

/***/ }),

/***/ 1693:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(641)(undefined);
// imports


// module
exports.push([module.i, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\n/* Begin fade animation */ \n.fade-enter {\n  opacity: 0.01;\n}\n\n.fade-enter.fade-enter-active {\n  opacity: 1;\n  transition: opacity 300ms ease-in;\n}\n\n.fade-exit {\n  opacity: 1;\n}\n\n.fade-exit.fade-exit-active {\n  opacity: 0.01;\n  transition: opacity 300ms ease-in;\n}\n\n.fade-appear {\n  opacity: 0.01;\n}\n\n.fade-appear.fade-appear-active {\n  opacity: 1;\n  transition: opacity .3s ease-in;\n  -webkit-transition: opacity .3s ease-in;\n  -ms-transition: opacity .3s ease-in;\n  -moz-transition: opacity .3s ease-in;\n}\n/* End fade animation */ \n\n.fade-dashboard-enter {\n  opacity: 0.01;\n}\n\n/* Begin fade-dashboard animation */ \n.fade-dashboard-enter.fade-dashboard-enter-active {\n  opacity: 1;\n  transition: opacity 800ms ease-in;\n}\n\n.fade-dashboard-exit {\n  opacity: 1;\n}\n\n.fade-dashboard-exit.fade-dashboard-exit-active {\n  opacity: 0.01;\n  transition: opacity 800ms ease-in;\n}\n\n.fade-dashboard-appear {\n  opacity: 0.01;\n}\n\n.fade-dashboard-appear.fade-dashboard-appear-active {\n  opacity: 1;\n  transition: opacity 800ms ease-in;\n}\n/* End fade-dashboard animation */\n\n/* Begin fade-background animation */\n.fade-background-enter {\n  opacity: 0.01;\n}\n\n.fade-background-enter.fade-background-enter-active {\n  opacity: 1;\n  /*\n    Slight delay to minimize the possibility that a new\n    image will fade in while an existing image is still\n    fading. We should handle this in UserBackgroundImage\n    instead, but our version of react-transition-group\n    doesn't support callbacks.\n  */\n  transition: opacity 500ms ease-in 150ms;\n}\n\n.fade-background-exit {\n  opacity: 1;\n}\n\n.fade-background-exit.fade-background-exit-active {\n  opacity: 0.01;\n  /* Delay some time to give the underlying image time to render */\n  transition: opacity 700ms ease-in 1500ms;\n}\n\n.fade-background-appear {\n  opacity: 0.01;\n}\n\n.fade-background-appear.fade-background-appear-active {\n  opacity: 1;\n  transition: opacity 500ms ease-in;\n}\n/* End fade-background animation */ \n\n/* Begin active-widget animation */ \n.active-widget-enter {\n  opacity: 0.01;\n  /* Delay some time before entering to give the exiting component time to leave */\n  transition: opacity 200ms ease-in 20ms;\n}\n\n.active-widget-enter.active-widget-enter-active {\n  opacity: 1;\n}\n\n.active-widget-exit {\n  opacity: 1;\n}\n\n.active-widget-exit.active-widget-exit-active {\n  opacity: 0.01;\n  transition: opacity 200ms ease-in;\n}\n\n.active-widget-appear {\n  opacity: 0.01;\n}\n\n.active-widget-appear.active-widget-appear-active {\n  opacity: 1;\n  transition: opacity 0.200s ease-in;\n  -webkit-transition: opacity 0.200s ease-in;\n  -ms-transition: opacity 0.200s ease-in;\n  -moz-transition: opacity 0.200s ease-in;\n}\n/* End active-widget animation */ \n\n/* Begin edit-widget-chip animation */ \n.edit-widget-chip-enter {\n  opacity: 0.01;\n}\n\n.edit-widget-chip-enter.edit-widget-chip-enter-active {\n  opacity: 1;\n  transition: opacity 240ms ease-in 60ms;\n}\n\n.edit-widget-chip-exit {\n  opacity: 1;\n}\n\n.edit-widget-chip-exit.edit-widget-chip-exit-active {\n  opacity: 0.01;\n  transition: opacity 100ms ease-in;\n}\n/* End edit-widget-chip animation */ \n\n/* Links */\na.active {\n  font-weight: bold;\n}\n\n/* @material-ui-1-todo: remove this */\n.tooltip-root {\n  /* This positions the popover offscreen, which is then overridden (fixes flashing) */\n  left: -15000px;\n}\n", ""]);

// exports


/***/ }),

/***/ 1758:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-grey.1d033414.svg";

/***/ }),

/***/ 1759:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-white.88080bea.svg";

/***/ }),

/***/ 1760:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-with-text.257bbffc.svg";

/***/ }),

/***/ 1761:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.539ef9c6.svg";

/***/ }),

/***/ 1824:
/***/ (function(module, exports) {

module.exports = {
	"en": {
		"app.welcome": "Welcome, {name}",
		"app.quote": "“Surf the web, save the world.”"
	},
	"es": {
		"app.welcome": "Bienvenido, {name}",
		"app.quote": "“Navega la web, salva el mundo.”"
	}
};

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var googletag = window.googletag || {};
  googletag.cmd = googletag.cmd || [];
  // We're not running in global scope, so make sure to
  // assign to the window.
  if (!window.googletag) {
    window.googletag = googletag;
  }
  return googletag;
};

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfEmailVerified = exports.createNewUser = exports.checkAuthStateAndRedirectIfNeeded = exports.anonymousUserMandatorySignIn = undefined;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _navigation = __webpack_require__(50);

var _utils = __webpack_require__(81);

var _user = __webpack_require__(64);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _CreateNewUserMutation = __webpack_require__(1385);

var _CreateNewUserMutation2 = _interopRequireDefault(_CreateNewUserMutation);

var _LogEmailVerifiedMutation = __webpack_require__(1387);

var _LogEmailVerifiedMutation2 = _interopRequireDefault(_LogEmailVerifiedMutation);

var _experiments = __webpack_require__(233);

var _featureFlags = __webpack_require__(234);

var _localUserDataMgr = __webpack_require__(113);

var _logger = __webpack_require__(187);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Return whether the current user is an anonymous user who was
 * previously able to see the dashboard but is now required to
 * sign in. This will return false if the user was authenticated
 * but has signed out.
 * @return {Boolean} Whether the current user is a previously-
 *   anonymous user who must now sign in
 */
var anonymousUserMandatorySignIn = exports.anonymousUserMandatorySignIn = function anonymousUserMandatorySignIn() {
  // If the user was authed but logged out, we remove the
  // extension install time from localStorage and this will
  // return false.
  return !inAnonymousUserGracePeriod();
};

/**
 * Return whether the current user has joined recently enough
 * that, if they're an anonymous user, they are not yet required
 * to sign in. In other words, whether the user joined recently.
 * @return {Boolean} Whether the current user is still within
 *   the grace period where anonymous users do not need to sign
 *   in
 */
var inAnonymousUserGracePeriod = function inAnonymousUserGracePeriod() {
  var installTime = (0, _localUserDataMgr.getBrowserExtensionInstallTime)();
  return !!installTime && (0, _moment2.default)().diff(installTime, 'days') < 4;
};

/**
 * Return whether the current user is allowed to have an anonymous
 * account.
 * @return {Boolean} Whether the current user is allowed to have an
 *   anonymous account.
 */
var allowAnonymousUser = function allowAnonymousUser() {
  var userRecentlyJoined = inAnonymousUserGracePeriod();

  // The user can have an anonymous account if the anonymous user
  // feature is enabled and they joined recently.
  return (0, _featureFlags.isAnonymousUserSignInEnabled)() && userRecentlyJoined;
};

/**
 * Return whether we should create an anonymous account for this
 * user: true only if the user installed the browser extension
 * very recently.
 * This is an attempt to reduce the noise of unnecessary user
 * creations, which are likely caused by users whose browsers do
 * not persist the user between tabs/sessions (e.g. incognito
 * browsing).
 * @return {Boolean} Whether we should create an anonymous account
 *   for this user.
 */
var shouldCreateAnonymousUser = function shouldCreateAnonymousUser() {
  var installTime = (0, _localUserDataMgr.getBrowserExtensionInstallTime)();
  var secondsAfterInstallToAllowCreation = 30;
  return installTime && (0, _moment2.default)().diff(installTime, 'seconds') < secondsAfterInstallToAllowCreation;
};

/**
 * Redirect to the main login page if not in an iframe, or redirect
 * to an intermediary page if in an iframe.
 * @return {undefined}
 */
var goToMainLoginPage = function goToMainLoginPage() {
  var urlParamsObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // The user is not allowed to be anonymous, so show the login screen.
  // If the page is in an iframe (e.g. the user opened it via an iframed
  // new tab), authentication may not work correctly. Show an intermediary
  // page that will open a non-iframed auth page.
  if ((0, _utils.isInIframe)()) {
    (0, _navigation.replaceUrl)(_navigation.authMessageURL, urlParamsObj);
  } else {
    (0, _navigation.replaceUrl)(_navigation.loginURL, urlParamsObj);
  }
};

/**
 * Based on the user object state, determine if we need to redirect
 * to an authentication page. If the user is not fully authenticated,
 * redirect and return true. If the user is fully authenticated, do
 * not redirect and return false.
 * @param {object} user - The user object for the app.
 * @param {string} user.id - The user's ID
 * @param {string} user.email - The user's email
 * @param {string} user.username - The user's username
 * @param {boolean} user.isAnonymous - Whether the user is anonymous
 * @param {boolean} user.emailVerified - Whether the user has verified their email
 * @param {string} fetchedUsername - The user's username from the server, which
 *   may differ from the one in localStorage.
 * @return {Promise<boolean>} A Promise resolving into a Boolean, which
 *   represents whether or not we redirected (e.g. true if the user was not fully
 *   authenticated).
 */
var checkAuthStateAndRedirectIfNeeded = exports.checkAuthStateAndRedirectIfNeeded = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(user) {
    var fetchedUsername = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var redirected;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            redirected = true;

            // If the user is not fully logged in, redirect to the
            // appropriate auth page.
            // User is not logged in.

            if (!(!user || !user.id)) {
              _context.next = 26;
              break;
            }

            if (!shouldCreateAnonymousUser()) {
              _context.next = 22;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return (0, _user.signInAnonymously)();

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](3);
            throw _context.t0;

          case 11:
            _context.prev = 11;
            _context.next = 14;
            return createNewUser();

          case 14:
            _context.next = 19;
            break;

          case 16:
            _context.prev = 16;
            _context.t1 = _context['catch'](11);
            throw _context.t1;

          case 19:

            // Determine if anonymous authentication is sufficient.
            if (allowAnonymousUser()) {
              // If the user is allowed to be anonymous, do not redirect.
              redirected = false;
            } else {
              goToMainLoginPage();
              redirected = true;
            }
            // If not creating an anonymous user, go to the login page.
            _context.next = 24;
            break;

          case 22:
            goToMainLoginPage();
            redirected = true;

          case 24:
            _context.next = 27;
            break;

          case 26:
            if (user.isAnonymous) {
              if (allowAnonymousUser()) {
                redirected = false;
              } else {
                // This is an anonymous user who was using the app but is now
                // required to sign in.
                if (anonymousUserMandatorySignIn()) {
                  // Include the "mandatory" URL parameter so we're able to
                  // show an explanation on the sign-in views.
                  goToMainLoginPage({ mandatory: 'true' });
                  redirected = true;
                } else {
                  goToMainLoginPage();
                  redirected = true;
                }
              }
              // If the user does not have an email address, show a message
              // asking them to sign in with a different method.
            } else if (!user.email) {
              (0, _navigation.replaceUrl)(_navigation.missingEmailMessageURL);
              redirected = true;
              // User is logged in but their email is not verified.
            } else if (!user.emailVerified) {
              (0, _navigation.replaceUrl)(_navigation.verifyEmailURL);
              redirected = true;
              // User is logged in but has not set a username.
            } else if (!user.username) {
              // If the username isn't in localStorage, check if it
              // exists on the user from the database.
              // We use the user fetched from the database because
              // the username property isn't present on our auth token
              // user identity.
              if (fetchedUsername) {
                // The username exists; set it in localStorage and do not redirect
                // to an auth page.
                (0, _user.setUsernameInLocalStorage)(fetchedUsername);
                redirected = false;
              } else {
                (0, _navigation.replaceUrl)(_navigation.enterUsernameURL);
                redirected = true;
              }
            } else {
              redirected = false;
            }

          case 27:
            return _context.abrupt('return', redirected);

          case 28:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[3, 8], [11, 16]]);
  }));

  return function checkAuthStateAndRedirectIfNeeded(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Create a new user in our database, or get the user if they already
 * exist. This is idempotent and may be called when returning users sign in.
 * @returns {Promise<object>} user - A promise that resolves into a
 *   user object
 * @returns {string} user.id - The user's ID, the same value as the
 *   userId argument
 * @returns {string|null} user.email - The user's email, the same value as the
 *   email argument
 * @returns {string|null} user.username - The user's username, if already
 *   set; or null, if not yet set
 */
var createNewUser = exports.createNewUser = function createNewUser() {
  // Get the currently-authenticated user.
  return (0, _user.getCurrentUser)().then(function (user) {
    // If there's no authenticated user, we can't create a new user.
    if (!user || !user.id) {
      throw new Error('Cannot create a new user. User is not authenticated.');
    }

    // Force-refetch the user ID token so it will have the
    // correct latest value for email verification.
    return (0, _user.getUserToken)(true).then(function () {
      // Get additional data we want to log with creation.
      var referralData = (0, _utils.getReferralData)();
      var experimentGroups = (0, _experiments.getUserTestGroupsForMutation)();
      var installId = (0, _localUserDataMgr.getBrowserExtensionInstallId)();
      var installTime = (0, _localUserDataMgr.getBrowserExtensionInstallTime)();

      return new Promise(function (resolve, reject) {
        (0, _CreateNewUserMutation2.default)(_relayEnv2.default, user.id, user.email, referralData, experimentGroups, installId, installTime, function (response) {
          resolve(response.createNewUser);
        }, function (err) {
          console.error('Error at createNewUser:', err);
          reject(new Error('Could not create new user', err));
        });
      });
    }).catch(function (e) {
      _logger2.default.error(e);
    });
  }).catch(function (e) {
    console.error(e);
    throw e;
  });
};

/**
 * Poll the user to see if they verified their email address so that
 * we can log it is verified. It would be better to user a cloud
 * function for this, or at least an official callback from the
 * Firebase SDK, but Firebase does not yet support one. See:
 * https://stackoverflow.com/q/43503377
 * @returns {Promise<Boolean>} Whether the user's email is verified.
 */
var checkIfEmailVerified = exports.checkIfEmailVerified = function checkIfEmailVerified() {
  return new Promise(function (resolve, reject) {
    var polledTimes = 0;
    var maxTimesToPoll = 15;
    var msWaitBetweenPolling = 250;
    function seeIfEmailVerified() {
      if (polledTimes > maxTimesToPoll) {
        return resolve(false);
      }
      (0, _user.getCurrentUser)().then(function (user) {
        // The email is verified. Log the verification, stop polling,
        // and return true.
        if (user && user.emailVerified) {
          // Force-refetch the user ID token so it will have the
          // correct latest value for email verification.
          (0, _user.getUserToken)(true).then(function () {
            (0, _LogEmailVerifiedMutation2.default)(_relayEnv2.default, user.id, function () {},
            // onError
            function (err) {
              _logger2.default.error(err);
            });
            resolve(true);
          }).catch(function (e) {
            _logger2.default.error(e);
            reject(e);
          });

          // The email is not yet verified. Wait some time, then try
          // to poll Firebase again to see if it's changed.
        } else {
          polledTimes += 1;

          // Reload the user and check again.
          (0, _user.reloadUser)().then(function () {
            setTimeout(function () {
              seeIfEmailVerified();
            }, msWaitBetweenPolling);
          }).catch(function (e) {
            _logger2.default.error(e);
            reject(e);
          });
        }
      }).catch(function (e) {
        _logger2.default.error(e);
        reject(e);
      });
    }
    seeIfEmailVerified();
  });
};

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FadeInAnimation = __webpack_require__(1275);

var _FadeInAnimation2 = _interopRequireDefault(_FadeInAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsChildWrapper = function (_React$Component) {
  _inherits(SettingsChildWrapper, _React$Component);

  function SettingsChildWrapper() {
    _classCallCheck(this, SettingsChildWrapper);

    return _possibleConstructorReturn(this, (SettingsChildWrapper.__proto__ || Object.getPrototypeOf(SettingsChildWrapper)).apply(this, arguments));
  }

  _createClass(SettingsChildWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          loaded = _props.loaded;

      return _react2.default.createElement(
        'div',
        {
          style: {
            padding: 20,
            minHeight: 400
          }
        },
        loaded ? children ? _react2.default.createElement(
          _FadeInAnimation2.default,
          null,
          children
        ) : null : null
      );
    }
  }]);

  return SettingsChildWrapper;
}(_react2.default.Component);

SettingsChildWrapper.propTypes = {
  children: _propTypes2.default.element,
  loaded: _propTypes2.default.bool
};

SettingsChildWrapper.defaultProps = {
  loaded: false
};

exports.default = SettingsChildWrapper;

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lang = __webpack_require__(107);

var _ravenJs = __webpack_require__(489);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logLevels = {};
logLevels.LOG = 'log';
logLevels.DEBUG = 'debug';
logLevels.INFO = 'info';
logLevels.WARN = 'warn';
logLevels.ERROR = 'error';

var logger = {};

logger.log = function (msg) {
  console.log(msg);
  log(msg, logLevels.LOG);
};

logger.debug = function (msg) {
  console.debug(msg);
  log(msg, logLevels.DEBUG);
};

logger.info = function (msg) {
  console.info(msg);
  log(msg, logLevels.INFO);
};

logger.warn = function (msg) {
  console.warn(msg);
  log(msg, logLevels.WARN);
};

logger.error = function (msg) {
  console.error(msg);
  log(msg, logLevels.ERROR);
};

var log = function log(msg, logLevel) {
  // Sentry expects one of 'info', 'warning', or 'error'
  var level;
  switch (logLevel) {
    case logLevels.LOG:
      level = 'info';
      break;
    case logLevels.DEBUG:
      level = 'info';
      break;
    case logLevels.INFO:
      level = 'info';
      break;
    case logLevels.WARN:
      level = 'warning';
      break;
    case logLevels.ERROR:
      level = 'error';
      break;
    default:
      level = 'error';
  }
  if ((0, _lang.isError)(msg)) {
    _ravenJs2.default.captureException(msg, {
      level: level
    });
  } else {
    _ravenJs2.default.captureMessage(msg, {
      level: level
    });
  }
};

exports.default = logger;

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInEuropeanUnion = exports.getCountry = undefined;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

var _constants = __webpack_require__(46);

var _lang = __webpack_require__(107);

var _logger = __webpack_require__(187);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Get the client location with a country-level granularity.
// This expects that the MaxMind script already created the
// `window.geoip2` object.

// Store location in memory to avoid unnecessary queries.
// This will be an instance of ClientLocation.
var location = null;

// To store in-progress fetches so we don't fetch location
// more than once.
var locationFetchPromise = null;

function ClientLocation(countryIsoCode, isInEuropeanUnion, queryTime) {
  this.countryIsoCode = countryIsoCode;
  this.isInEuropeanUnion = isInEuropeanUnion;

  // An ISO string
  this.queryTime = queryTime;
}

/**
 * Whether a MaxMind error concerns us enough to log.
 * @param {Object} err - The MaxMind error object
 * @return {Boolean} Whether we should log the MaxMind error
 */
var shouldLogMaxMindError = function shouldLogMaxMindError(err) {
  return ['QUERY_FORBIDDEN', 'OUT_OF_QUERIES', 'PERMISSION_REQUIRED'].indexOf(err.code) > -1;
};

/**
 * Call MaxMind for location data and return a ClientLocation object.
 * @return {ClientLocation} The location object
 */
var getLocationFromMaxMind = function getLocationFromMaxMind() {
  // MaxMind response structure. See:
  // https://dev.maxmind.com/geoip/geoip2/web-services/
  // The key "country.is_in_european_union" will be true if the country
  // is in EU. Otherwise, it will be undefined.
  // {
  //   "continent": {
  //     "code": "NA",
  //     "geoname_id": 6255149,
  //     "names": {
  //       "en": "North America"
  //       ...
  //     }
  //   },
  //   "country": {
  //     "iso_code": "US",
  //     "geoname_id": 6252001,
  //     "names": {
  //       "en": "United States",
  //       ...
  //     }
  //   },
  //   "registered_country": {
  //     "iso_code": "US",
  //     "geoname_id": 6252001,
  //     "names": {
  //       "en": "United States",
  //       ...
  //     }
  //   },
  //   "traits": {
  //     "ip_address": "73.xxx.xxx.x"
  //   }
  // }

  // If a fetch is in progress, return that promise
  // so we don't fetch location more than once.
  if (locationFetchPromise) {
    return locationFetchPromise;
  }

  // Store the promise so subsequent requests can use it
  // if this request is still in progress.
  locationFetchPromise = new Promise(function (resolve, reject) {
    // https://dev.maxmind.com/geoip/geoip2/javascript/
    try {
      window.geoip2.country(function (data) {
        var isInEuropeanUnion = data.country.is_in_european_union === true;
        resolve(new ClientLocation(data.country.iso_code, isInEuropeanUnion, _moment2.default.utc().toISOString()));
      }, function (err) {
        // Log a subset of errors that we care about to Sentry.
        if (shouldLogMaxMindError(err)) {
          _logger2.default.error(err);
        }
        reject(err);
      });
    } catch (err) {
      // Log a subset of errors that we care about to Sentry.
      if (shouldLogMaxMindError(err)) {
        _logger2.default.error(err);
      }
      reject(err);
    }
  });
  return locationFetchPromise;
};

/**
 * Try to get location data from localStorage. If it exists and hasn't
 * expired, return a ClientLocation object; else return null.
 * @return {ClientLocation|null} The location object, or null if no
 *   unexpired location exists in localStorage.
 */
var getLocationFromLocalStorage = function getLocationFromLocalStorage() {
  var countryCode = _localstorageMgr2.default.getItem(_constants.STORAGE_LOCATION_COUNTRY_ISO_CODE);
  var isInEuropeanUnionStr = _localstorageMgr2.default.getItem(_constants.STORAGE_LOCATION_IS_IN_EU);
  var queryTimeISO = _localstorageMgr2.default.getItem(_constants.STORAGE_LOCATION_QUERY_TIME);
  var queryTime = (0, _moment2.default)(queryTimeISO);
  var isInEuropeanUnion = _localstorageMgr2.default.getItem(_constants.STORAGE_LOCATION_IS_IN_EU) === 'true';

  // If the location data does not exist, return null.
  var isDataValid = !(0, _lang.isNil)(countryCode) && !(0, _lang.isNil)(isInEuropeanUnionStr) && !(0, _lang.isNil)(queryTime) && queryTime.isValid();
  if (!isDataValid) {
    return null;
  }

  // If the location data is too old, return null.
  var now = (0, _moment2.default)().utc();
  var daysSinceLocationQuery = now.diff(queryTime, 'days');
  var LOCATION_EXPIRE_DAYS = 60;
  if (daysSinceLocationQuery > LOCATION_EXPIRE_DAYS) {
    return null;
  }

  return new ClientLocation(countryCode, isInEuropeanUnion, queryTime);
};

/**
 * Store the location data in localStorage.
 * @param {ClientLocation} location - The ClientLocation object
 * @return {undefined}
 */
var setLocationInLocalStorage = function setLocationInLocalStorage(location) {
  _localstorageMgr2.default.setItem(_constants.STORAGE_LOCATION_COUNTRY_ISO_CODE, location.countryIsoCode);
  _localstorageMgr2.default.setItem(_constants.STORAGE_LOCATION_IS_IN_EU, location.isInEuropeanUnion.toString());
  _localstorageMgr2.default.setItem(_constants.STORAGE_LOCATION_QUERY_TIME, location.queryTime);
};

/**
 * Return client's location. Try to get the location data from memory;
 * fall back to localStorage; then fall back to querying MaxMind for
 * new location data. Throw an error if we cannot determine location.
 * @return {Promise<ClientLocation>} The client's location
 */
var getLocation = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
    var locationLocalStorage, maxMindLocation;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (location) {
              _context.next = 20;
              break;
            }

            // Try to get the location data from localStorage.
            locationLocalStorage = getLocationFromLocalStorage();

            if (!locationLocalStorage) {
              _context.next = 6;
              break;
            }

            location = locationLocalStorage;
            // If location isn't in localStorage, query for it.
            _context.next = 20;
            break;

          case 6:
            // Throw an error if MaxMind cannot determine the location.
            maxMindLocation = null;
            _context.prev = 7;
            _context.next = 10;
            return getLocationFromMaxMind();

          case 10:
            maxMindLocation = _context.sent;
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context['catch'](7);
            throw new Error('Could not determine location.');

          case 16:
            if (maxMindLocation) {
              _context.next = 18;
              break;
            }

            throw new Error('Could not determine location.');

          case 18:

            // Save the location to localStorage and return it.
            location = maxMindLocation;
            setLocationInLocalStorage(location);

          case 20:
            return _context.abrupt('return', location);

          case 21:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[7, 13]]);
  }));

  return function getLocation() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Return the ISO 3166-1 country code of the country the client is in.
 * Throw an error if we could not determine the country.
 * See ISO codes: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 * @return {Promise<string>} The two-character ISO 3166-1 country code
 */
var getCountry = exports.getCountry = function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
    var clientLocation;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return getLocation();

          case 3:
            clientLocation = _context2.sent;
            return _context2.abrupt('return', clientLocation.countryIsoCode);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2['catch'](0);
            throw new Error('Could not determine client location country.');

          case 10:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 7]]);
  }));

  return function getCountry() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Return whether the client is in the European Union.
 * Throw an error if we could not determine the country.
 * @return {Promise<Boolean>} Whether or not the client is in the EU
 */
var isInEuropeanUnion = exports.isInEuropeanUnion = function () {
  var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
    var clientLocation;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return getLocation();

          case 3:
            clientLocation = _context3.sent;
            return _context3.abrupt('return', clientLocation.isInEuropeanUnion);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3['catch'](0);
            throw new Error('Could not determine client location EU membership.');

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[0, 7]]);
  }));

  return function isInEuropeanUnion() {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserTestGroupsForMutation = exports.assignUserToTestGroups = exports.getUserExperimentGroup = exports.getExperimentGroups = exports.experiments = exports.EXPERIMENT_AD_EXPLANATION = exports.EXPERIMENT_ONE_AD_FOR_NEW_USERS = exports.EXPERIMENT_THIRD_AD = exports.createExperimentGroup = exports.createExperiment = undefined;

var _collection = __webpack_require__(736);

var _lang = __webpack_require__(107);

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

var _constants = __webpack_require__(46);

var _experimentFilters = __webpack_require__(388);

var _relayEnv = __webpack_require__(59);

var _relayEnv2 = _interopRequireDefault(_relayEnv);

var _UpdateUserExperimentGroupsMutation = __webpack_require__(385);

var _UpdateUserExperimentGroupsMutation2 = _interopRequireDefault(_UpdateUserExperimentGroupsMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var noneGroupKey = 'NONE';

var createExperiment = exports.createExperiment = function createExperiment(_ref) {
  var name = _ref.name,
      _ref$active = _ref.active,
      active = _ref$active === undefined ? false : _ref$active,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      groups = _ref.groups,
      _ref$filters = _ref.filters,
      filters = _ref$filters === undefined ? [] : _ref$filters,
      _ref$percentageOfExis = _ref.percentageOfExistingUsersInExperiment,
      percentageOfExistingUsersInExperiment = _ref$percentageOfExis === undefined ? 0.0 : _ref$percentageOfExis,
      _ref$percentageOfNewU = _ref.percentageOfNewUsersInExperiment,
      percentageOfNewUsersInExperiment = _ref$percentageOfNewU === undefined ? 100.0 : _ref$percentageOfNewU;

  if (!name) {
    throw new Error('An experiment must have a unique "name" value.');
  }
  return {
    // A unique code (without spaces) for this experiment
    name: name,
    // If true, we will assign users a group in the experiment. If false,
    // we will not assign users to any group.
    active: active,
    // If true, we will always return the "none" test group when getting
    // the user's experiment group, even if the user is assigned to
    // another group. This should effectively disable the effects of the
    // experiment.
    disabled: disabled,
    // The likelihood we'll include an active existing user in the experiment,
    // *after* we filter them through the provided "filters".
    // If this is 100, we will include all users (after filtering) in
    // the experiment.
    // Note: while we technically support increasing the % of active users in
    // an experiment over time, we should ensure we log when a user joins an
    // experiment on the server-side so we can do proper analytics.
    percentageOfExistingUsersInExperiment: percentageOfExistingUsersInExperiment,
    // The likelihood we'll include a new user in the experiment,
    // *after* we filter them through the provided "filters".
    // If this is 100, we will include all new users (after filtering)
    // in the experiment.
    percentageOfNewUsersInExperiment: percentageOfNewUsersInExperiment,
    // An array of functions to call to determine whether a user should
    // be excluded from an experiment based on, e.g., the datetime they
    // joined. Each function will receive a user object with keys:
    //  joined {String}: the datetime the user joined
    //  isNewUser {Boolean}: true if this is a brand new user
    // If any filter function returns false, the user will not be
    // included in the experiment.
    filters: filters,
    // The different experiment groups the user could be assigned to.
    groups: Object.assign({}, groups, _defineProperty({}, noneGroupKey, NoneExperimentGroup)),
    _localStorageKey: _constants.STORAGE_EXPERIMENT_PREFIX + '.' + name,
    _saveTestGroupToLocalStorage: function _saveTestGroupToLocalStorage(testGroupValue) {
      _localstorageMgr2.default.setItem(this._localStorageKey, testGroupValue);
    },
    // This is to track changes/increases in % users included in a test.
    _localStorageKeyForPercentage: _constants.STORAGE_EXPERIMENT_PREFIX + '.' + name + '.percentageOfUsersLastAssigned',
    _savePercentageUsersToLocalStorage: function _savePercentageUsersToLocalStorage() {
      _localstorageMgr2.default.setItem(this._localStorageKeyForPercentage, this.percentageOfExistingUsersInExperiment);
    },
    /**
     * Get the value for the percentage of users included in this
     * experiment the last time we assigned this user to a group.
     * @returns {Number} A float equal to a previous value of
     *   `this.percentageOfExistingUsersInExperiment`; or, if we have never
     *   tried to assign this user, return zero.
     */
    _getPercentageUsersFromLocalStorage: function _getPercentageUsersFromLocalStorage() {
      var percentage = parseFloat(_localstorageMgr2.default.getItem(this._localStorageKeyForPercentage), 10);
      return isNaN(percentage) ? 0.0 : percentage;
    },
    /**
     * Get whether the user has previously been assigned to a group
     * for this experiment.
     * @returns {Boolean} Whether the user has previously been
     *   assigned to a group for this experiment.
     */
    _hasBeenAssignedToGroup: function _hasBeenAssignedToGroup() {
      return !(0, _lang.isNil)(_localstorageMgr2.default.getItem(this._localStorageKey));
    },
    /**
     * Save the assigned test group in local storage and to the
     * server.
     * @param {testGroup} The experiment group object.
     * @param {userInfo} The object of user information passed to
     *   assignTestGroup.
     * @returns {undefined}
     */
    _saveTestGroup: function _saveTestGroup(testGroup, userInfo) {
      this._saveTestGroupToLocalStorage(testGroup.value);

      // Update storage with the current % of users who are included in the
      // experiment.
      this._savePercentageUsersToLocalStorage();

      var experimentName = this.name;
      (0, _UpdateUserExperimentGroupsMutation2.default)(_relayEnv2.default, {
        userId: userInfo.id,
        experimentGroups: _defineProperty({}, experimentName, testGroup.schemaValue)
      });
    },
    /**
     * Assign the user to an experiment group for this experiment.
     * @param {Object} userInfo
     * @param {String} userInfo.id - The user's ID
     * @param {String} userInfo.joined - The ISO string of when the
     *   user joined.
     * @param {Boolean} userInfo.isNewUser - Whether this user has just
     *   signed up.
     * @returns {undefined}
     */
    assignTestGroup: function assignTestGroup(userInfo) {
      if (!this.active) {
        return;
      }

      // This is the value of `this.percentageOfExistingUsersInExperiment`
      // the last time we assigned the user to a group in this experiment.
      var previousPercentage = this._getPercentageUsersFromLocalStorage();

      // If the filters exclude this user, don't assign them to an experiment
      // group.
      if (!this.filters.every(function (filterFunc) {
        return filterFunc.call(this, userInfo);
      })) {
        return;
      }

      // If the user is already assigned to a group, don't assign a new one,
      // unless: the user is in a "none" group and the percentage of users
      // to assign to this experiment has increased.
      var currentGroup = this.getTestGroup();
      if (this._hasBeenAssignedToGroup() && !(currentGroup.value === this.groups.NONE.value && this.percentageOfExistingUsersInExperiment > previousPercentage)) {
        return;
      }

      // Exclude the "none" group.
      var experimentGroups = (0, _collection.filter)(this.groups, function (groupObj) {
        return groupObj.value !== NoneExperimentGroup.value;
      });

      // If there aren't any test groups, just save the "none" value.
      if (!experimentGroups.length) {
        this._saveTestGroup(this.groups.NONE, userInfo);
        return;
      }

      // Calculate the % likelihood of assigning this user to a not-none
      // experiment group. If we previously assigned this user but the
      // % of users we're including in this experiment has increased,
      // we should use the difference in the percentages, which should
      // keep the value of `this.percentageOfExistingUsersInExperiment`
      // as a % of our active user base.
      var likelihoodOfInclusion = userInfo.isNewUser ? this.percentageOfNewUsersInExperiment : 100.0 * (this.percentageOfExistingUsersInExperiment - previousPercentage) / (100 - previousPercentage);

      // Only assign the experiment to a percentage of random users.
      if (100 * Math.random() > likelihoodOfInclusion) {
        this._saveTestGroup(this.groups.NONE, userInfo);
        return;
      }

      // There's an equal chance of being assigned to any group,
      // excepting the "none" group.
      var group = experimentGroups[Math.floor(Math.random() * experimentGroups.length)];
      this._saveTestGroup(group, userInfo);
    },
    // Return the the user's assigned experiment group, or the
    // NoneExperimentGroup if the user is not assigned to one.
    getTestGroup: function getTestGroup() {
      // If the test is disabled, return the "none" group value.
      if (this.disabled) {
        return this.groups.NONE;
      }

      // Get the user's group from localStorage. If it's not one of
      // the valid group values, return the "none" group value.
      var groupVal = _localstorageMgr2.default.getItem(this._localStorageKey);
      var group = (0, _collection.find)(this.groups, { value: groupVal }) || this.groups.NONE;
      return group;
    }
  };
};

/**
 * Return an object representing an experiment group the user could be
 * assigned to.
 * @param {Object} experimentGroupConfig
 * @param {string} experimentGroupConfig.value - The string value we'll
 *   use when representing the user's group.
 * @param {string} experimentGroupConfig.schemaValue - The string value
 *   we'll send to the server-side. It should match the GraphQL enum
 *   value of the experiment group.
 *   use when representing the user's group.
 * @return {Object} An object representing the experiment group
 */
var createExperimentGroup = exports.createExperimentGroup = function createExperimentGroup(_ref2) {
  var value = _ref2.value,
      schemaValue = _ref2.schemaValue;

  if (!(value && schemaValue)) {
    throw new Error('An experiment group must have values for the "value" and "schemaValue" keys.');
  }
  return {
    value: value,
    schemaValue: schemaValue
  };
};

// The experiment group for when the user is not assigned to any
// experiment group (e.g., not included in the experiment).
var NoneExperimentGroup = createExperimentGroup({
  value: 'none',
  schemaValue: 'NONE'
});

// Add experiment names here as constants.
var EXPERIMENT_THIRD_AD = exports.EXPERIMENT_THIRD_AD = 'thirdAd';
var EXPERIMENT_ONE_AD_FOR_NEW_USERS = exports.EXPERIMENT_ONE_AD_FOR_NEW_USERS = 'oneAdForNewUsers';
var EXPERIMENT_AD_EXPLANATION = exports.EXPERIMENT_AD_EXPLANATION = 'adExplanation';

// Add ExperimentGroup objects here to enable new experiments.
// The "name" value of the experiment must be the same as the
// field name of the GraphQL ExperimentGroup field name for
// this test.
var experiments = exports.experiments = [
// @experiment-one-ad-for-new-users
createExperiment({
  name: EXPERIMENT_ONE_AD_FOR_NEW_USERS,
  active: true,
  disabled: false,
  filters: [_experimentFilters.onlyIncludeNewUsers],
  groups: {
    DEFAULT: createExperimentGroup({
      value: 'default',
      schemaValue: 'DEFAULT'
    }),
    ONE_AD_AT_FIRST: createExperimentGroup({
      value: 'oneAd',
      schemaValue: 'ONE_AD_AT_FIRST'
    })
  }
}),
// @experiment-ad-explanation
createExperiment({
  name: EXPERIMENT_AD_EXPLANATION,
  active: true,
  disabled: false,
  filters: [_experimentFilters.onlyIncludeNewUsers],
  groups: {
    DEFAULT: createExperimentGroup({
      value: 'default',
      schemaValue: 'DEFAULT'
    }),
    SHOW_EXPLANATION: createExperimentGroup({
      value: 'explanation',
      schemaValue: 'SHOW_EXPLANATION'
    })
  }
})];

// We do this to be able to modify the experiments
// variable during testing while keeping it in this file.
// https://github.com/facebook/jest/issues/936#issuecomment-214939935
var getExperiments = function getExperiments() {
  return exports.experiments;
};

/**
 * Get the set of available group values for an experiment.
 * If the experiment does not exist, this returns only the
 * the NoneExperimentGroup.
 * @returns {Object} A map of ExperimentGroup values, keyed
 *   by their name.
 */
var getExperimentGroups = exports.getExperimentGroups = function getExperimentGroups(experimentName) {
  if (!experimentName) {
    throw new Error('Must provide an experiment name.');
  }
  var exp = (0, _collection.find)(getExperiments(), { name: experimentName });

  // If there's no experiment with this name, return only the
  // NoneExperimentGroup.
  if (!exp) {
    return _defineProperty({}, noneGroupKey, NoneExperimentGroup.value);
  }

  // Return only the ExperimentGroup string value for ease
  // of comparing user group membership.
  var groups = exp.groups;
  var groupNames = Object.keys(groups).reduce(function (result, key) {
    result[key] = groups[key].value;
    return result;
  }, {});
  return groupNames;
};

/**
 * Get the user's assigned group value for an experiment.
 * If the experiment does not exist or is disabled, this
 * will return the NoneExperimentGroup value.
 * @returns {String} The value of the user's group for this
 *   experiment.
 */
var getUserExperimentGroup = exports.getUserExperimentGroup = function getUserExperimentGroup(experimentName) {
  if (!experimentName) {
    throw new Error('Must provide an experiment name.');
  }
  var exp = (0, _collection.find)(getExperiments(), { name: experimentName });

  // If there's no experiment with this name, return the
  // NoneExperimentGroup value.
  if (!exp) {
    return NoneExperimentGroup.value;
  }
  return exp.getTestGroup().value;
};

/**
 * Assigns the user to test groups for all active tests.
 * @param {Object} userInfo
 * @param {String} userInfo.id - The user's ID
 * @param {String} userInfo.joined - The ISO string of when the
 *   user joined.
 * @param {Boolean} userInfo.isNewUser - Whether this user has just
 *   signed up.
 * @returns {undefined}
 */
var assignUserToTestGroups = exports.assignUserToTestGroups = function assignUserToTestGroups(userInfo) {
  var exps = getExperiments();
  exps.forEach(function (experiment) {
    if (experiment.active) {
      experiment.assignTestGroup(userInfo);
    }
  });
};

/**
 * Returns an object with a key for each active experiment. Each
 * key's value is a string representing the test group to which
 * the user is assigned for that test. The object takes the shape
 * of our GraphQL schema's ExperimentGroupsType.
 * @returns {Object} The object of experiment group assignments
 *   for the user, taking the shape of our GraphQL schema's
 *   ExperimentGroupsType.
 */
var getUserTestGroupsForMutation = exports.getUserTestGroupsForMutation = function getUserTestGroupsForMutation() {
  var exps = getExperiments();
  var userGroupsSchema = exps.reduce(function (result, experiment) {
    result[experiment.name] = experiment.getTestGroup().schemaValue;
    return result;
  }, {});
  return userGroupsSchema;
};

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isAnonymousUserSignInEnabled = exports.isAnonymousUserSignInEnabled = function isAnonymousUserSignInEnabled() {
  return false;
};

var isVariousAdSizesEnabled = exports.isVariousAdSizesEnabled = function isVariousAdSizesEnabled() {
  return false;
};

var isSearchPageEnabled = exports.isSearchPageEnabled = function isSearchPageEnabled() {
  return "false" === 'true';
};

/***/ }),

/***/ 2641:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1693);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(1037)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!./index.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2651:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nopicture.d6cf9bfd.jpg";

/***/ }),

/***/ 2672:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2673:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2674:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2675:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2676:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2677:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2679:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(272);
module.exports = __webpack_require__(1045);


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(932).enable()
  window.Promise = __webpack_require__(931)
}

// fetch() polyfill for making API calls.
__webpack_require__(1039)

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(142)

__webpack_require__(579)


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var pbjs = window.pbjs || {};
  // We're not running in global scope, so make sure to
  // assign to the window.
  if (!window.pbjs) {
    window.pbjs = pbjs;
  }
  pbjs.que = pbjs.que || [];
  return pbjs;
};

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newTabView = exports.searchExecuted = exports.accountCreated = exports.signupPageEmailButtonClick = exports.signupPageSocialButtonClick = exports.signupPageButtonClick = exports.homepageView = exports.pageview = undefined;

var _facebookAnalytics = __webpack_require__(1206);

var _facebookAnalytics2 = _interopRequireDefault(_facebookAnalytics);

var _googleAnalytics = __webpack_require__(1207);

var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);

var _redditAnalytics = __webpack_require__(1208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We automatically track most pageviews on location change.
// See ./withPageviewTracking higher-order component.
var pageview = exports.pageview = function pageview() {
  // GA and fbq pageviews
  (0, _facebookAnalytics2.default)('track', 'PageView');
  _googleAnalytics2.default.pageview();
};

var homepageView = exports.homepageView = function homepageView() {
  (0, _facebookAnalytics2.default)('track', 'ViewContent', { content_name: 'Homepage' });
  (0, _facebookAnalytics2.default)('track', 'PageView');

  // GA pageview
  _googleAnalytics2.default.pageview();
};

var signupPageButtonClick = exports.signupPageButtonClick = function signupPageButtonClick() {
  (0, _facebookAnalytics2.default)('track', 'Lead', { content_name: 'SignupButtonClick' });

  _googleAnalytics2.default.event({
    category: 'ButtonClick',
    action: 'SignupButtonClick'
  });
};

var signupPageSocialButtonClick = exports.signupPageSocialButtonClick = function signupPageSocialButtonClick() {
  (0, _facebookAnalytics2.default)('track', 'Lead', { content_name: 'SocialSignupButtonClick' });

  _googleAnalytics2.default.event({
    category: 'ButtonClick',
    action: 'SocialSignupButtonClick'
  });
};

var signupPageEmailButtonClick = exports.signupPageEmailButtonClick = function signupPageEmailButtonClick() {
  (0, _facebookAnalytics2.default)('track', 'Lead', { content_name: 'EmailSignupButtonClick' });

  _googleAnalytics2.default.event({
    category: 'ButtonClick',
    action: 'EmailSignupButtonClick'
  });
};

var accountCreated = exports.accountCreated = function accountCreated() {
  (0, _facebookAnalytics2.default)('track', 'CompleteRegistration', { content_name: 'AccountCreated' });
  _googleAnalytics2.default.event({
    category: 'ButtonClick',
    action: 'AccountCreation'
  });
  (0, _redditAnalytics.redditAccountCreationEvent)();

  // Google Ads conversion tracking.
  window.gtag('event', 'conversion', {
    'send_to': 'AW-1013744060/v2M_COqV6owBELyDsuMD'
  });
};

var searchExecuted = exports.searchExecuted = function searchExecuted() {
  // Need to wait for events to fire before navigating
  // away from the page.
  // https://support.google.com/analytics/answer/1136920?hl=en
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#hitCallback
  return new Promise(function (resolve) {
    // Using the original ga object because hitCallback isn't
    // implemented in react-ga for events:
    // https://github.com/react-ga/react-ga#reactgaga
    _googleAnalytics2.default.ga('send', {
      hitType: 'event',
      eventCategory: 'Search',
      eventAction: 'SearchExecuted',
      hitCallback: resolve
    });

    // In case GA fails to call the callback within a
    // reasonable amount of time, continue so we don't
    // interrupt the search.
    setTimeout(function () {
      resolve();
    }, 200);
  });
};

// TODO: later
// export const emailVerified = () => {
//   // GA and fbq pageviews
//   fbq('track', 'PageView')
//   GA.pageview()
// }

var newTabView = exports.newTabView = function newTabView() {
  // No Google Analytics because of rate limiting.
  (0, _facebookAnalytics2.default)('track', 'PageView');
  (0, _facebookAnalytics2.default)('track', 'ViewContent', { content_name: 'Newtab' });
};

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _localUserDataMgr = __webpack_require__(113);

var MAX_TABS_WITH_ADS = 150;

exports.default = function () {
  if (false) {
    return false;
  }

  // If the user has exceeded the daily tab maximum,
  // do not show ads.
  // https://github.com/gladly-team/tab/issues/202
  var tabsOpenedToday = (0, _localUserDataMgr.getTabsOpenedToday)();
  return tabsOpenedToday < MAX_TABS_WITH_ADS;
};

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markConsentDataAsLogged = exports.checkIfNewConsentNeedsToBeLogged = exports.saveConsentUpdateEventToLocalStorage = exports.unregisterConsentCallback = exports.registerConsentCallback = exports.displayConsentUI = exports.hasGlobalConsent = exports.getConsentString = undefined;

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

var _constants = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Get the vendor consent string from the consent management platform.
 * @return {Promise<string|null>} A promise that resolves into the
 *   consent string, or null if there was an error getting the string
 */
var getConsentString = exports.getConsentString = function getConsentString() {
  return new Promise(function (resolve, reject) {
    function cmpSuccessCallback(consentData) {
      if (!consentData) {
        resolve(null);
      }
      resolve(consentData.consentData);
    }

    // If the CMP throws any error, just return null.
    try {
      window.__cmp('getConsentData', null, cmpSuccessCallback);
    } catch (e) {
      console.error(e);
      resolve(null);
    }
  });
};

/**
 * Get whether the user has provided global consent for all uses.
 * @return {Promise<boolean|null>} A promise that resolves into a
 *   boolean, or null if there was an error getting the data
 */
var hasGlobalConsent = exports.hasGlobalConsent = function hasGlobalConsent() {
  return new Promise(function (resolve, reject) {
    function cmpSuccessCallback(consentData) {
      if (!consentData) {
        resolve(null);
      }
      resolve(consentData.hasGlobalConsent);
    }

    // If the CMP throws any error, just return null.
    try {
      window.__cmp('getConsentData', null, cmpSuccessCallback);
    } catch (e) {
      console.error(e);
      resolve(null);
    }
  });
};

/**
 * Call the CMP to display the consent UI.
 * @return {undefined}
 */
var displayConsentUI = exports.displayConsentUI = function displayConsentUI() {
  window.__cmp('displayConsentUi');
};

// Our own storage of consent callback functions. We manage
// this ourselves because:
// 1) Quantcast Choice does not have a method to unregister
//   callbacks.
// 2) Quantcast Choice will only call the callback once,
//   so the handler would otherwise have to re-register the
//   callback if it wants to continue to be called, which is
//   not intuitive.
var consentCallbacks = [];
var alreadyRegisteredCMPConsentCallback = false;

/**
 * Make the CMP call all consent callbacks when the user
 * changes their consent options.
 */
var registerConsentChangeCallbacksWithCMP = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
    var callCallbacksAndReRegister;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            callCallbacksAndReRegister = function () {
              var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var consentString, isGlobalConsent;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return getConsentString();

                      case 2:
                        consentString = _context.sent;
                        _context.next = 5;
                        return hasGlobalConsent();

                      case 5:
                        isGlobalConsent = _context.sent;

                        if (consentString) {
                          consentCallbacks.forEach(function (callback) {
                            callback(consentString, isGlobalConsent);
                          });
                        }

                        // Re-register the callback with Quantcast Choice so we can
                        // handle any other consent changes on this same page view.
                        // Quantcast Choice will not call this callback more than once.
                        // "To invoke the callback every time the UI is shown, this
                        // operation will need to be made before each time the UI is
                        // brought up with __cmp('displayConsentUi')."
                        // https://quantcast.zendesk.com/hc/en-us/articles/360003814853-Technical-Implementation-Guide
                        registerConsentChangeCallbacksWithCMP();

                      case 8:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, undefined);
              }));

              return function callCallbacksAndReRegister() {
                return _ref2.apply(this, arguments);
              };
            }();

            // Note: this callback appears to be buggy as of 5/29/2018.
            // It's called every time the CMP loads, regardless of
            // whether in the EU or not. We can't rely on it calling
            // just once, nor can we rely on consent data existing.
            // We reached out to Quantcast about this.


            window.__cmp('setConsentUiCallback', callCallbacksAndReRegister);

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function registerConsentChangeCallbacksWithCMP() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Register a callback that will be triggered when a user
 * changes their consent options (closes the consent UI).
 * @param {function} cb - The callback function
 * @return {undefined}
 */
var registerConsentCallback = exports.registerConsentCallback = function registerConsentCallback(cb) {
  // If this is the first time we've registered a callback,
  // make sure our CMP will call all callbacks when the
  // consent data changes.
  if (!alreadyRegisteredCMPConsentCallback) {
    alreadyRegisteredCMPConsentCallback = true;
    registerConsentChangeCallbacksWithCMP();
  }
  consentCallbacks.push(cb);
};

/**
 * Unregister a callback that was previously registered to
 * to be called when triggered when a user changes their
 * consent options.
 * @param {function} cb - The callback function
 * @return {undefined}
 */
var unregisterConsentCallback = exports.unregisterConsentCallback = function unregisterConsentCallback(cb) {
  var cbIndex = consentCallbacks.indexOf(cb);
  if (cbIndex > -1) {
    consentCallbacks.splice(cbIndex, 1);
  }
};

/**
 * Save a flag in localStorage so that the app knows consent
 * has changed and we need to log updated data to the server.
 * We do this because consent updating may happen when the user
 * is not authenticated. Do not save anything if a consent data
 * is pending (currently in process).
 * @return {undefined}
 */
var saveConsentUpdateEventToLocalStorage = exports.saveConsentUpdateEventToLocalStorage = function saveConsentUpdateEventToLocalStorage() {
  _localstorageMgr2.default.setItem(_constants.STORAGE_NEW_CONSENT_DATA_EXISTS, 'true');
};

/**
 * Determine if we have pending (updated) consent data that we
 * have not yet logged to the server. We may log more than once per
 * updated consent (e.g multiple opened tabs), but that's acceptable.
 * @return {boolean} Whether we need to log new consent data
 */
var checkIfNewConsentNeedsToBeLogged = exports.checkIfNewConsentNeedsToBeLogged = function checkIfNewConsentNeedsToBeLogged() {
  return _localstorageMgr2.default.getItem(_constants.STORAGE_NEW_CONSENT_DATA_EXISTS) === 'true';
};

/**
 * Mark that we've successfully logged the latest consent data
 * to the server.
 * @return {undefined}
 */
var markConsentDataAsLogged = exports.markConsentDataAsLogged = function markConsentDataAsLogged() {
  _localstorageMgr2.default.removeItem(_constants.STORAGE_NEW_CONSENT_DATA_EXISTS);
};

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FadeInDashboardAnimation = function (_React$Component) {
  _inherits(FadeInDashboardAnimation, _React$Component);

  function FadeInDashboardAnimation() {
    _classCallCheck(this, FadeInDashboardAnimation);

    return _possibleConstructorReturn(this, (FadeInDashboardAnimation.__proto__ || Object.getPrototypeOf(FadeInDashboardAnimation)).apply(this, arguments));
  }

  _createClass(FadeInDashboardAnimation, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        null,
        _react2.default.Children.map(this.props.children, function (item, i) {
          return item ? _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
              key: i,
              classNames: 'fade-dashboard',
              appear: _this2.props.transitionAppear,
              timeout: {
                enter: 800,
                exit: 800
              } },
            item
          ) : null;
        })
      );
    }
  }]);

  return FadeInDashboardAnimation;
}(_react2.default.Component);

FadeInDashboardAnimation.propTypes = {
  children: _propTypes2.default.element,
  transitionAppear: _propTypes2.default.bool
};

FadeInDashboardAnimation.defaultProps = {
  transitionAppear: true
};

exports.default = FadeInDashboardAnimation;

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetSharedSpace = function (_React$Component) {
  _inherits(WidgetSharedSpace, _React$Component);

  function WidgetSharedSpace() {
    _classCallCheck(this, WidgetSharedSpace);

    return _possibleConstructorReturn(this, (WidgetSharedSpace.__proto__ || Object.getPrototypeOf(WidgetSharedSpace)).apply(this, arguments));
  }

  _createClass(WidgetSharedSpace, [{
    key: 'render',
    value: function render() {
      var main = {
        position: 'absolute',
        zIndex: 1,
        top: 40,
        left: 5,
        backgroundColor: 'transparent',
        width: 300,
        overflowX: 'hidden',
        overflowY: 'hidden'
      };

      return _react2.default.createElement(
        'div',
        { style: Object.assign({}, main, this.props.containerStyle) },
        this.props.children
      );
    }
  }]);

  return WidgetSharedSpace;
}(_react2.default.Component);

WidgetSharedSpace.propTypes = {
  containerStyle: _propTypes2.default.object
};

WidgetSharedSpace.defaultProps = {
  containerStyle: {}
};

exports.default = WidgetSharedSpace;

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMeasure = __webpack_require__(2429);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _Paper = __webpack_require__(60);

var _Paper2 = _interopRequireDefault(_Paper);

var _cancel = __webpack_require__(338);

var _cancel2 = _interopRequireDefault(_cancel);

var _checkCircle = __webpack_require__(337);

var _checkCircle2 = _interopRequireDefault(_checkCircle);

var _lockOutline = __webpack_require__(2184);

var _lockOutline2 = _interopRequireDefault(_lockOutline);

var _lockOpen = __webpack_require__(2183);

var _lockOpen2 = _interopRequireDefault(_lockOpen);

var _addCircle = __webpack_require__(2187);

var _addCircle2 = _interopRequireDefault(_addCircle);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

var _EditWidgetChipAnimation = __webpack_require__(1345);

var _EditWidgetChipAnimation2 = _interopRequireDefault(_EditWidgetChipAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Holds the widget name and any "add" or "edit"
// buttons and menus.
var EditWidgetChip = function (_React$Component) {
  _inherits(EditWidgetChip, _React$Component);

  function EditWidgetChip(props) {
    _classCallCheck(this, EditWidgetChip);

    var _this = _possibleConstructorReturn(this, (EditWidgetChip.__proto__ || Object.getPrototypeOf(EditWidgetChip)).call(this, props));

    _this.state = {
      dimensions: {}
    };
    return _this;
  }

  _createClass(EditWidgetChip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var animationDurationMs = 140;

      var content = this.props.open ? _react2.default.createElement(
        'span',
        {
          key: 'widget-edit-chip-add-form',
          style: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            paddingTop: 20,
            boxSizing: 'border-box'
          }
        },
        this.props.widgetAddItemForm
      ) : _react2.default.createElement(
        'span',
        {
          key: 'widget-edit-chip-content',
          style: {
            position: 'absolute',
            minHeight: 32,
            top: 0,
            left: 0,
            paddingLeft: 12,
            paddingRight: 8
          }
        },
        _react2.default.createElement(
          'span',
          null,
          this.props.widgetName
        )
      );

      // Measure the dimensions of the child content and add
      // the dimensions to state. Then, we'll set the width
      // and height of the parent container to fit the child
      // content. We do this so we can animate the container
      // expansion while still allowing dynamic child content.
      var measuredContent = _react2.default.createElement(
        _reactMeasure2.default,
        {
          bounds: true,
          onResize: function onResize(contentRect) {
            if (contentRect.bounds) {
              _this2.setState({
                dimensions: contentRect.bounds
              });
            }
          }
        },
        function (_ref) {
          var measureRef = _ref.measureRef;

          return _react2.default.createElement(
            _EditWidgetChipAnimation2.default,
            null,
            _react2.default.cloneElement(content, {
              ref: measureRef
            })
          );
        }
      );

      // Icons
      var iconContainerStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'absolute',
        zIndex: 5,
        top: 4,
        right: 8
      };

      var iconBaseStyle = {
        cursor: 'pointer',
        color: 'rgba(255,255,255,.3)',
        display: 'inline-block'
      };

      var editIcon = null;
      if (this.props.showEditOption) {
        if (this.props.editMode) {
          editIcon = _react2.default.createElement(_lockOpen2.default, {
            onClick: function onClick() {
              _this2.props.onEditModeToggle(false);
            },
            hoverColor: _default.widgetEditButtonHover,
            style: Object.assign({}, iconBaseStyle, {
              color: _default.widgetEditButtonHover,
              float: 'right',
              marginLeft: 4
            })
          });
        } else {
          editIcon = _react2.default.createElement(_lockOutline2.default, {
            onClick: function onClick() {
              _this2.props.onEditModeToggle(true);
            },
            hoverColor: _default.widgetEditButtonHover,
            style: Object.assign({}, iconBaseStyle, {
              float: 'right',
              marginLeft: 4
            })
          });
        }
      }
      var icons = this.props.open ? _react2.default.createElement(
        'div',
        {
          key: 'icons-expanded',
          style: iconContainerStyle
        },
        _react2.default.createElement(_cancel2.default, {
          color: _default.widgetEditButtonInactive,
          hoverColor: _default.widgetEditButtonHover,
          style: iconBaseStyle,
          onClick: function onClick() {
            _this2.props.onCancelAddItemClick();
          }
        }),
        _react2.default.createElement(_checkCircle2.default, {
          color: _default.widgetEditButtonInactive,
          hoverColor: _default.widgetEditButtonHover,
          style: iconBaseStyle,
          onClick: function onClick() {
            _this2.props.onItemCreatedClick();
          }
        })
      ) : _react2.default.createElement(
        'div',
        {
          key: 'icons-closed',
          style: iconContainerStyle
        },
        editIcon,
        _react2.default.createElement(_addCircle2.default, {
          key: 'widget-add-icon',
          color: _default.widgetEditButtonInactive,
          hoverColor: _default.widgetEditButtonHover,
          style: Object.assign({}, iconBaseStyle, {
            float: 'right',
            marginLeft: 4
          }),
          onClick: function onClick() {
            _this2.props.onEditModeToggle(false);
            _this2.props.onAddItemClick();
          }
        })
      );

      // Sizing
      var titleHeight = 32;
      var iconWidth = this.props.showEditOption ? 62 : 36;
      var expandedWidth = 290;
      var width = this.props.open ? expandedWidth : this.state.dimensions.width ? this.state.dimensions.width + iconWidth : 'auto';
      var height = this.state.dimensions.height ? this.state.dimensions.height : 'auto';

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _Paper2.default,
          {
            zDepth: 0,
            style: {
              width: width,
              height: height,
              cursor: 'default',
              position: 'relative',
              overflow: 'hidden',
              justifyContent: 'center',
              alignItems: 'space-between',
              fontSize: 14,
              lineHeight: titleHeight + 'px',
              transition: 'width ' + animationDurationMs + 'ms ease-in-out, height ' + animationDurationMs + 'ms ease-in-out',
              margin: 5,
              background: _default2.default.palette.primary1Color,
              color: '#FFF',
              userSelect: 'none'
            }
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                display: 'inline-flex',
                justifyContent: 'flex-end',
                position: 'absolute',
                zIndex: 3,
                width: '100%',
                left: 0,
                top: 0,
                boxSizing: 'border-box'
              }
            },
            _react2.default.createElement(
              _EditWidgetChipAnimation2.default,
              null,
              icons
            )
          ),
          measuredContent
        )
      );
    }
  }]);

  return EditWidgetChip;
}(_react2.default.Component);

EditWidgetChip.propTypes = {
  open: _propTypes2.default.bool,
  widgetName: _propTypes2.default.string.isRequired,
  // The form to fill when adding a new widget item.
  widgetAddItemForm: _propTypes2.default.element,
  // Whether or not there's an "edit mode" button.
  showEditOption: _propTypes2.default.bool,
  // Called when enabling/disabling edit mode.
  onEditModeToggle: _propTypes2.default.func,
  // Whether we're currently in edit mode.
  editMode: _propTypes2.default.bool,
  // Called when clicking to add a new item.
  onAddItemClick: _propTypes2.default.func,
  // Called when exiting the form without creating a
  // new iem.
  onCancelAddItemClick: _propTypes2.default.func,
  // Called when confirming creation from the
  // `widgetAddItemForm` view.
  onItemCreatedClick: _propTypes2.default.func
};

EditWidgetChip.defaultProps = {
  open: false,
  showEditOption: false,
  onEditModeToggle: function onEditModeToggle() {},
  editMode: false,
  onAddItemClick: function onAddItemClick() {},
  onCancelAddItemClick: function onCancelAddItemClick() {},
  onItemCreatedClick: function onItemCreatedClick() {}
};

exports.default = EditWidgetChip;

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyWidgetMsg = function (_React$Component) {
  _inherits(EmptyWidgetMsg, _React$Component);

  function EmptyWidgetMsg() {
    _classCallCheck(this, EmptyWidgetMsg);

    return _possibleConstructorReturn(this, (EmptyWidgetMsg.__proto__ || Object.getPrototypeOf(EmptyWidgetMsg)).apply(this, arguments));
  }

  _createClass(EmptyWidgetMsg, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return EmptyWidgetMsg;
}(_react2.default.Component);

exports.default = EmptyWidgetMsg;

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Scrollable = __webpack_require__(1279);

var _Scrollable2 = _interopRequireDefault(_Scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var renderView = function renderView(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ['style']);

  var viewStyle = {
    paddingRight: 8
  };
  return _react2.default.createElement('div', _extends({ style: _extends({}, style, viewStyle) }, props));
};

var WidgetScrollSection = function (_React$Component) {
  _inherits(WidgetScrollSection, _React$Component);

  function WidgetScrollSection() {
    _classCallCheck(this, WidgetScrollSection);

    return _possibleConstructorReturn(this, (WidgetScrollSection.__proto__ || Object.getPrototypeOf(WidgetScrollSection)).apply(this, arguments));
  }

  _createClass(WidgetScrollSection, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Scrollable2.default,
        {
          style: {
            height: '60vh',
            paddingRight: 6,
            overflowX: 'hidden'
          },
          renderView: renderView
        },
        this.props.children
      );
    }
  }]);

  return WidgetScrollSection;
}(_react2.default.Component);

WidgetScrollSection.propTypes = {
  style: _propTypes2.default.object
};

WidgetScrollSection.defaultProps = {
  style: {}
};

exports.default = WidgetScrollSection;

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(387);
};

function commit(environment, _ref) {
  var userId = _ref.userId,
      experimentGroups = _ref.experimentGroups;
  var onCompleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: {
        userId: userId,
        experimentGroups: experimentGroups
      }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = commit;

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1413);
};

function commit(environment, user, widget, data) {
  var onCompleted = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var onError = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};

  var userId = user.id;
  var widgetId = widget.id;

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId, widgetId: widgetId, data: data }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = { commit: commit };

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash fb078f6a0b7b715b7f895e0a757a65b3
 */

/* eslint-disable */



/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ExperimentGroupAdExplanation = "DEFAULT" | "NONE" | "SHOW_EXPLANATION" | "%future added value";
export type ExperimentGroupAnonSignIn = "ANONYMOUS_ALLOWED" | "AUTHED_USER_ONLY" | "NONE" | "%future added value";
export type ExperimentGroupOneAdForNewUsers = "DEFAULT" | "NONE" | "ONE_AD_AT_FIRST" | "%future added value";
export type ExperimentGroupThirdAd = "NONE" | "THREE_ADS" | "TWO_ADS" | "%future added value";
export type ExperimentGroupVariousAdSizes = "NONE" | "STANDARD" | "VARIOUS" | "%future added value";
export type UpdateUserExperimentGroupsInput = {
  userId: string,
  experimentGroups?: ?ExperimentGroups,
  clientMutationId?: ?string,
};
export type ExperimentGroups = {
  anonSignIn?: ?ExperimentGroupAnonSignIn,
  variousAdSizes?: ?ExperimentGroupVariousAdSizes,
  thirdAd?: ?ExperimentGroupThirdAd,
  oneAdForNewUsers?: ?ExperimentGroupOneAdForNewUsers,
  adExplanation?: ?ExperimentGroupAdExplanation,
};
export type UpdateUserExperimentGroupsMutationVariables = {|
  input: UpdateUserExperimentGroupsInput
|};
export type UpdateUserExperimentGroupsMutationResponse = {|
  +updateUserExperimentGroups: ?{|
    +user: ?{|
      +id: string
    |}
  |}
|};
export type UpdateUserExperimentGroupsMutation = {|
  variables: UpdateUserExperimentGroupsMutationVariables,
  response: UpdateUserExperimentGroupsMutationResponse,
|};
*/

/*
mutation UpdateUserExperimentGroupsMutation(
  $input: UpdateUserExperimentGroupsInput!
) {
  updateUserExperimentGroups(input: $input) {
    user {
      id
    }
  }
}
*/

var node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateUserExperimentGroupsInput!",
    "defaultValue": null
  }],
      v1 = [{
    "kind": "LinkedField",
    "alias": null,
    "name": "updateUserExperimentGroups",
    "storageKey": null,
    "args": [{
      "kind": "Variable",
      "name": "input",
      "variableName": "input",
      "type": "UpdateUserExperimentGroupsInput!"
    }],
    "concreteType": "UpdateUserExperimentGroupsPayload",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }]
    }]
  }];
  return {
    "kind": "Request",
    "operationKind": "mutation",
    "name": "UpdateUserExperimentGroupsMutation",
    "id": null,
    "text": "mutation UpdateUserExperimentGroupsMutation(\n  $input: UpdateUserExperimentGroupsInput!\n) {\n  updateUserExperimentGroups(input: $input) {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {},
    "fragment": {
      "kind": "Fragment",
      "name": "UpdateUserExperimentGroupsMutation",
      "type": "Mutation",
      "metadata": null,
      "argumentDefinitions": v0,
      "selections": v1
    },
    "operation": {
      "kind": "Operation",
      "name": "UpdateUserExperimentGroupsMutation",
      "argumentDefinitions": v0,
      "selections": v1
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'ba9b4c9a172d4cc274966a954481fb63';
module.exports = node;

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.includeIfAnyIsTrue = exports.onlyIncludeNewUsers = exports.excludeUsersWhoJoinedWithin = undefined;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generate a filter function to exclude users who joined less than
 * X time units ago.
 * @param {Object} userInfo
 * @param {String} userInfo.joined - The ISO string of when the
 *   user joined.
 * @param {Boolean} userInfo.isNewUser - Whether this user has just
 *   signed up.
 * @returns {Function}
 */
var excludeUsersWhoJoinedWithin = exports.excludeUsersWhoJoinedWithin = function excludeUsersWhoJoinedWithin(number) {
  var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'days';

  return function (userInfo) {
    return (0, _moment2.default)().diff((0, _moment2.default)(userInfo.joined), units) > number;
  };
};

/**
 * A filter to only include new users.
 * @param {Object} userInfo
 * @param {String} userInfo.joined - The ISO string of when the
 *   user joined.
 * @param {Boolean} userInfo.isNewUser - Whether this user has just
 *   signed up.
 * @returns {Boolean}
 */
var onlyIncludeNewUsers = exports.onlyIncludeNewUsers = function onlyIncludeNewUsers(userInfo) {
  return !!userInfo.isNewUser;
};

/**
 * A meta filter function to allow for "or" logic. If at least
 * one of the included filters returns true, this filter will
 * return true.
 * @param {Function[]} An array of filter functions
 * @returns {Function}
 */
var includeIfAnyIsTrue = exports.includeIfAnyIsTrue = function includeIfAnyIsTrue(filterFuncs) {
  return function (userInfo) {
    return filterFuncs.some(function (filterFunc) {
      return filterFunc(userInfo);
    });
  };
};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardHeaderSubtitleStyle = exports.cardHeaderTitleStyle = exports.widgetEditButtonHover = exports.widgetEditButtonInactive = exports.dashboardTransparentBackgroundHover = exports.dashboardTransparentBackground = exports.appBarLightColor = exports.dashboardIconActiveColor = exports.dashboardIconInactiveColor = exports.buttonFontWeight = exports.dividerColor = exports.lighterTextColor = exports.textColor = exports.alternateAccentColor = exports.primaryColor = undefined;

var _colors = __webpack_require__(336);

var _colorManipulator = __webpack_require__(121);

var _spacing = __webpack_require__(791);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Logo color: #9d4ba3
// Color tool:
// https://material.io/color/#!/?view.left=0&view.right=0&primary.color=9d4ba3&secondary.color=FFEE58&secondary.text.color=757575
var primaryColor = exports.primaryColor = '#9d4ba3';
var primaryColorDark = '#6c1b74';
var primaryColorLight = '#d07ad5';
var textOnPrimaryColor = '#FFFFFF';

var alternateAccentColor = exports.alternateAccentColor = '#4a90e2';

// const secondaryColor = '#ffee58'
// const secondaryColorDark = '#c9bc1f'
// const secondaryColorLight = '#ffff8b'
// const textOnSecondaryColor = '#616161'

var textColor = exports.textColor = '#212121';
var lighterTextColor = exports.lighterTextColor = 'rgba(33, 33, 33, 0.56)';
var dividerColor = exports.dividerColor = '#BDBDBD';
var disabledColor = (0, _colorManipulator.fade)(_colors.darkBlack, 0.3);
var buttonFontWeight = exports.buttonFontWeight = '600';

// Override-able values here:
// https://github.com/callemall/material-ui/blob/master/src/styles/getMuiTheme.js
exports.default = {
  spacing: _spacing2.default,
  fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  palette: {
    primary1Color: primaryColor,
    primary2Color: primaryColorDark,
    primary3Color: primaryColorLight,
    accent1Color: primaryColorLight,
    accent2Color: primaryColorLight,
    accent3Color: primaryColorLight,
    textColor: textColor,
    alternateTextColor: textOnPrimaryColor,
    canvasColor: _colors.white,
    borderColor: dividerColor,
    disabledColor: disabledColor,
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
  },
  fontIcon: {
    color: textColor,
    hoverColor: textColor
  },
  chip: {
    deleteIconColor: textColor
  },
  flatButton: {
    fontSize: 13,
    fontWeight: buttonFontWeight
  },
  raisedButton: {
    fontSize: 13,
    fontWeight: buttonFontWeight
  },
  textField: {
    underlineColor: dividerColor,
    underlineFocusStyle: textColor
  },
  toggle: {
    thumbOffColor: '#f3d6f5',
    trackOffColor: '#d4add6'
    // Lighter
    // thumbOffColor: '#fff4ff',
    // trackOffColor: '#fae2fb'
  }
};
var dashboardIconInactiveColor = exports.dashboardIconInactiveColor = 'rgba(255, 255, 255, 0.8)';
var dashboardIconActiveColor = exports.dashboardIconActiveColor = _colors.white;
var appBarLightColor = exports.appBarLightColor = '#f2f2f2';

var dashboardTransparentBackground = exports.dashboardTransparentBackground = 'rgba(0, 0, 0, 0.36)';
var dashboardTransparentBackgroundHover = exports.dashboardTransparentBackgroundHover = 'rgba(0, 0, 0, 0.39)';

// Widgets
var widgetEditButtonInactive = exports.widgetEditButtonInactive = 'rgba(255,255,255,.3)';
var widgetEditButtonHover = exports.widgetEditButtonHover = _colors.white;

// Custom card header styling

var cardHeaderTitleStyle = exports.cardHeaderTitleStyle = {
  fontSize: 20,
  fontWeight: 'normal'
};
var cardHeaderSubtitleStyle = exports.cardHeaderSubtitleStyle = {
  fontSize: 14,
  fontWeight: 'normal'
};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
  Configuration
**/

var MAX_DAILY_HEARTS_FROM_TABS = exports.MAX_DAILY_HEARTS_FROM_TABS = 150;

/**
  Strings passed from server-side. Do not change.
**/

var WIDGET_TYPE_BOOKMARKS = exports.WIDGET_TYPE_BOOKMARKS = 'bookmarks';
var WIDGET_TYPE_CLOCK = exports.WIDGET_TYPE_CLOCK = 'clock';
var WIDGET_TYPE_NOTES = exports.WIDGET_TYPE_NOTES = 'notes';
var WIDGET_TYPE_SEARCH = exports.WIDGET_TYPE_SEARCH = 'search';
var WIDGET_TYPE_TODOS = exports.WIDGET_TYPE_TODOS = 'todos';

var USER_BACKGROUND_OPTION_CUSTOM = exports.USER_BACKGROUND_OPTION_CUSTOM = 'custom';
var USER_BACKGROUND_OPTION_COLOR = exports.USER_BACKGROUND_OPTION_COLOR = 'color';
var USER_BACKGROUND_OPTION_PHOTO = exports.USER_BACKGROUND_OPTION_PHOTO = 'photo';
var USER_BACKGROUND_OPTION_DAILY = exports.USER_BACKGROUND_OPTION_DAILY = 'daily';

/**
  localStorage keys. Do not change, or it may
  break storage for existing users.
**/

// tab.user: user attributes persisted server-side
var STORAGE_KEY_USERNAME = exports.STORAGE_KEY_USERNAME = 'tab.user.username';
var STORAGE_BACKGROUND_COLOR = exports.STORAGE_BACKGROUND_COLOR = 'tab.user.background.color';
var STORAGE_BACKGROUND_CUSTOM_IMAGE = exports.STORAGE_BACKGROUND_CUSTOM_IMAGE = 'tab.user.background.customImage';
var STORAGE_BACKGROUND_IMAGE_URL = exports.STORAGE_BACKGROUND_IMAGE_URL = 'tab.user.background.imageURL';
var STORAGE_BACKGROUND_OPTION = exports.STORAGE_BACKGROUND_OPTION = 'tab.user.background.option';

// An ISO timestamp: the time of the first tab opened in the
// most recent day (UTC day) the user was active.
var STORAGE_TABS_LAST_TAB_OPENED_DATE = exports.STORAGE_TABS_LAST_TAB_OPENED_DATE = 'tab.user.lastTabDay.date';

// The count of tabs opened in the most recent day the user was
// active. It could be today (ongoing) or a day in the past.
var STORAGE_TABS_RECENT_DAY_COUNT = exports.STORAGE_TABS_RECENT_DAY_COUNT = 'tab.user.lastTabDay.count';

// tab.clientLocation: general location info, stored client-side only
var STORAGE_LOCATION_COUNTRY_ISO_CODE = exports.STORAGE_LOCATION_COUNTRY_ISO_CODE = 'tab.clientLocation.countryIsoCode';
var STORAGE_LOCATION_IS_IN_EU = exports.STORAGE_LOCATION_IS_IN_EU = 'tab.clientLocation.isInEU';
var STORAGE_LOCATION_QUERY_TIME = exports.STORAGE_LOCATION_QUERY_TIME = 'tab.clientLocation.queryTime';

// tab.referralData: referral data set on homepage
var STORAGE_REFERRAL_DATA_REFERRING_USER = exports.STORAGE_REFERRAL_DATA_REFERRING_USER = 'tab.referralData.referringUser';
var STORAGE_REFERRAL_DATA_REFERRING_CHANNEL = exports.STORAGE_REFERRAL_DATA_REFERRING_CHANNEL = 'tab.referralData.referringChannel';

// tab.consentData: values related to data privacy consent choices,
//   like GDPR
var STORAGE_NEW_CONSENT_DATA_EXISTS = exports.STORAGE_NEW_CONSENT_DATA_EXISTS = 'tab.consentData.newConsentDataExists';

// tab.newUser: values related to the new user experience, such as
//   data we need for unauthenticated users or temporary data we
//   don't want to store server-side. Stored client-side only.
var STORAGE_NEW_USER_HAS_COMPLETED_TOUR = exports.STORAGE_NEW_USER_HAS_COMPLETED_TOUR = 'tab.newUser.hasCompletedTour';
var STORAGE_EXTENSION_INSTALL_ID = exports.STORAGE_EXTENSION_INSTALL_ID = 'tab.newUser.extensionInstallId';
var STORAGE_APPROX_EXTENSION_INSTALL_TIME = exports.STORAGE_APPROX_EXTENSION_INSTALL_TIME = 'tab.newUser.approxInstallTime';
var STORAGE_DISMISSED_AD_EXPLANATION = exports.STORAGE_DISMISSED_AD_EXPLANATION = 'tab.newUser.dismissedAdExplanation';

// tab.experiments: values related to split-testing features
// We may assign other values to localStorage with the tab.experiments.*
// prefix in experiments.js.
var STORAGE_EXPERIMENT_PREFIX = exports.STORAGE_EXPERIMENT_PREFIX = 'tab.experiments';
var STORAGE_EXPERIMENT_ANON_USER = exports.STORAGE_EXPERIMENT_ANON_USER = 'tab.experiments.anonUser';
var STORAGE_EXPERIMENT_VARIOUS_AD_SIZES = exports.STORAGE_EXPERIMENT_VARIOUS_AD_SIZES = 'tab.experiments.variousAdSizes';

/**
  Error codes passed from server-side.
**/

var ERROR_USER_DOES_NOT_EXIST = exports.ERROR_USER_DOES_NOT_EXIST = 'USER_DOES_NOT_EXIST';

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToInviteFriends = exports.goToStats = exports.goToDonate = exports.goToSettings = exports.goToDashboard = exports.goToLogin = exports.goToHome = exports.twitterPageURL = exports.facebookPageURL = exports.externalContactUsURL = exports.externalHelpURL = exports.postUninstallSurveyURL = exports.adblockerWhitelistingURL = exports.jobsURL = exports.teamURL = exports.financialsURL = exports.contactUsURL = exports.termsOfServiceURL = exports.privacyPolicyURL = exports.homeURL = exports.accountURL = exports.inviteFriendsURL = exports.statsURL = exports.donateURL = exports.backgroundSettingsURL = exports.widgetSettingsURL = exports.settingsURL = exports.missingEmailMessageURL = exports.authMessageURL = exports.enterUsernameURL = exports.verifyEmailURL = exports.loginURL = exports.dashboardURL = exports.absoluteUrl = exports.externalRedirect = exports.modifyURLParams = exports.replaceUrl = exports.goTo = undefined;

var _reactRouter = __webpack_require__(220);

var _utils = __webpack_require__(81);

var _qs = __webpack_require__(342);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: replace this with Link navigation via react-router.

var goTo = exports.goTo = function goTo(location) {
  var paramsObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _reactRouter.browserHistory.push({
    pathname: location,
    search: _qs2.default.stringify(paramsObj) ? '?' + _qs2.default.stringify(paramsObj) : null
  });
};

var replaceUrl = exports.replaceUrl = function replaceUrl(location) {
  var paramsObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _reactRouter.browserHistory.replace({
    pathname: location,
    search: _qs2.default.stringify(paramsObj) ? '?' + _qs2.default.stringify(paramsObj) : null
  });
};

var modifyURLParams = exports.modifyURLParams = function modifyURLParams() {
  var paramsObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var newParamsObj = Object.assign({}, (0, _utils.getUrlParameters)(), paramsObj);
  _reactRouter.browserHistory.push({
    pathname: window.location.pathname,
    search: _qs2.default.stringify(newParamsObj) ? '?' + _qs2.default.stringify(newParamsObj) : null
  });
};

var externalRedirect = exports.externalRedirect = function externalRedirect(externalURL) {
  window.location = externalURL;
};

var absoluteUrl = exports.absoluteUrl = function absoluteUrl(path) {
  // If the passed path is already an absolute URL,
  // just return it.
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  var protocol =  true ? "https" : 'https';
  var baseUrl = protocol + '://' + "tab.gladly.io";
  return '' + baseUrl + path;
};

// ROUTES

var dashboardURL = exports.dashboardURL = '/newtab/';

// Auth routes
var loginURL = exports.loginURL = '/newtab/auth/';
var verifyEmailURL = exports.verifyEmailURL = '/newtab/auth/verify-email/';
var enterUsernameURL = exports.enterUsernameURL = '/newtab/auth/username/';
var authMessageURL = exports.authMessageURL = '/newtab/auth/welcome/';
var missingEmailMessageURL = exports.missingEmailMessageURL = '/newtab/auth/missing-email/';

// Settings and profile
var settingsURL = exports.settingsURL = '/newtab/settings/widgets/';
var widgetSettingsURL = exports.widgetSettingsURL = '/newtab/settings/widgets/';
var backgroundSettingsURL = exports.backgroundSettingsURL = '/newtab/settings/background/';
var donateURL = exports.donateURL = '/newtab/profile/donate/';
var statsURL = exports.statsURL = '/newtab/profile/stats/';
var inviteFriendsURL = exports.inviteFriendsURL = '/newtab/profile/invite/';
var accountURL = exports.accountURL = '/newtab/account/';

// Homepage

var homeURL = exports.homeURL = absoluteUrl('/');
var privacyPolicyURL = exports.privacyPolicyURL = absoluteUrl('/privacy/');
var termsOfServiceURL = exports.termsOfServiceURL = absoluteUrl('/terms/');
var contactUsURL = exports.contactUsURL = absoluteUrl('/contact/');
var financialsURL = exports.financialsURL = absoluteUrl('/financials/');
var teamURL = exports.teamURL = absoluteUrl('/team/');
var jobsURL = exports.jobsURL = absoluteUrl('/jobs/');
var adblockerWhitelistingURL = exports.adblockerWhitelistingURL = absoluteUrl('/adblockers/');

// External links

var postUninstallSurveyURL = exports.postUninstallSurveyURL = 'https://goo.gl/forms/XUICFx9psTwCzEIE2';

// Zendesk
var externalHelpURL = exports.externalHelpURL = 'https://gladly.zendesk.com/hc/en-us/categories/201939608-Tab-for-a-Cause';
var externalContactUsURL = exports.externalContactUsURL = 'https://gladly.zendesk.com/hc/en-us/requests/new';

// Social
var facebookPageURL = exports.facebookPageURL = 'https://www.facebook.com/TabForACause';
var twitterPageURL = exports.twitterPageURL = 'https://twitter.com/TabForACause';

// TODO: stop using these and replace the existing uses.
//   They only cause additional complication during testing.
// CONVENIENCE FUNCTIONS

var goToHome = exports.goToHome = function goToHome() {
  goTo(dashboardURL);
};

var goToLogin = exports.goToLogin = function goToLogin() {
  // Use replace by default because likely redirecting when
  // user is not authenticated.
  replaceUrl(loginURL);
};

var goToDashboard = exports.goToDashboard = function goToDashboard() {
  goTo(dashboardURL);
};

var goToSettings = exports.goToSettings = function goToSettings() {
  goTo(settingsURL);
};

var goToDonate = exports.goToDonate = function goToDonate() {
  goTo(donateURL);
};

var goToStats = exports.goToStats = function goToStats() {
  goTo(statsURL);
};

var goToInviteFriends = exports.goToInviteFriends = function goToInviteFriends() {
  goTo(inviteFriendsURL);
};

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _AssignExperimentGroupsComponent = __webpack_require__(1242);

var _AssignExperimentGroupsComponent2 = _interopRequireDefault(_AssignExperimentGroupsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_AssignExperimentGroupsComponent2.default, {
  user: function user() {
    return __webpack_require__(1257);
  }
});

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popover = __webpack_require__(172);

var _Popover2 = _interopRequireDefault(_Popover);

var _default = __webpack_require__(44);

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DashboardPopover = function (_React$Component) {
  _inherits(DashboardPopover, _React$Component);

  function DashboardPopover() {
    _classCallCheck(this, DashboardPopover);

    return _possibleConstructorReturn(this, (DashboardPopover.__proto__ || Object.getPrototypeOf(DashboardPopover)).apply(this, arguments));
  }

  _createClass(DashboardPopover, [{
    key: 'handleRequestClose',
    value: function handleRequestClose() {
      this.props.onRequestClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = Object.assign({}, {
        backgroundColor: _default.dashboardTransparentBackground,
        width: 220,
        padding: 0,
        paddingTop: 0,
        fontSize: 14,
        color: _default2.default.palette.alternateTextColor,
        fontFamily: _default2.default.fontFamily
      }, this.props.style);
      var headerStyle = {
        width: '100%',
        height: 3,
        backgroundColor: _default2.default.palette.primary1Color
      };

      return _react2.default.createElement(
        _Popover2.default,
        {
          open: this.props.open,
          anchorEl: this.props.anchorEl,
          onRequestClose: this.handleRequestClose.bind(this),
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          targetOrigin: { horizontal: 'right', vertical: 'top' },
          style: style,
          useLayerForClickAway: false
          // @material-ui-1-todo: remove this className and the CSS in index.css.
          // This is a workaround for a bug in Popover positioning:
          // https://github.com/mui-org/material-ui/issues/8040#issuecomment-351827522
          , className: 'tooltip-root'
        },
        _react2.default.createElement('div', { style: headerStyle }),
        this.props.children
      );
    }
  }]);

  return DashboardPopover;
}(_react2.default.Component);

DashboardPopover.propTypes = {
  open: _propTypes2.default.bool,
  anchorEl: _propTypes2.default.object,
  onRequestClose: _propTypes2.default.func,
  style: _propTypes2.default.object
};

DashboardPopover.defaultProps = {
  open: false,
  anchorEl: null,
  onRequestClose: function onRequestClose() {},
  style: {}
};

exports.default = DashboardPopover;

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _LogConsentDataComponent = __webpack_require__(1249);

var _LogConsentDataComponent2 = _interopRequireDefault(_LogConsentDataComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_LogConsentDataComponent2.default, {
  user: function user() {
    return __webpack_require__(1262);
  }
});

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _DonateHeartsControlsComponent = __webpack_require__(1268);

var _DonateHeartsControlsComponent2 = _interopRequireDefault(_DonateHeartsControlsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_DonateHeartsControlsComponent2.default, {
  charity: function charity() {
    return __webpack_require__(1271);
  },
  user: function user() {
    return __webpack_require__(1272);
  }
});

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _user = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * Adds a "userId" prop to a child component.
 * @param {Object} options
 * @param {Boolean} options.renderIfNoUser - If true, we will render the
 *   children even if there is no user ID (the user is not signed in).
 * @return {Function} A higher-order component.
 */
var withUserId = function withUserId() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    var CompWithUserId = function (_React$Component) {
      _inherits(CompWithUserId, _React$Component);

      function CompWithUserId(props) {
        _classCallCheck(this, CompWithUserId);

        var _this = _possibleConstructorReturn(this, (CompWithUserId.__proto__ || Object.getPrototypeOf(CompWithUserId)).call(this, props));

        _this.state = {
          userId: null,
          authStateLoaded: false
        };
        return _this;
      }

      _createClass(CompWithUserId, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          // Store unsubscribe function.
          // https://firebase.google.com/docs/reference/js/firebase.auth.Auth#onAuthStateChanged
          this.authListenerUnsubscribe = (0, _user.getCurrentUserListener)().onAuthStateChanged(function (user) {
            if (user && user.uid) {
              _this2.setState({
                userId: user.uid
              });
            }
            _this2.setState({
              authStateLoaded: true
            });
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof this.authListenerUnsubscribe === 'function') {
            this.authListenerUnsubscribe();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var renderIfNoUser = options.renderIfNoUser;
          // Return null if the user is not authenticated but the children require
          // an authenticated user.

          if (!this.state.userId && !renderIfNoUser) {
            return null;
          }
          // Don't render the children until we've retrieved the user.
          if (!this.state.authStateLoaded) {
            return null;
          }
          return _react2.default.createElement(WrappedComponent, _extends({ userId: this.state.userId }, this.props));
        }
      }]);

      return CompWithUserId;
    }(_react2.default.Component);

    CompWithUserId.displayName = 'CompWithUserId(' + getDisplayName(WrappedComponent) + ')';
    return CompWithUserId;
  };
};

exports.default = withUserId;

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _logoWithText = __webpack_require__(1760);

var _logoWithText2 = _interopRequireDefault(_logoWithText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoWithText = function (_React$Component) {
  _inherits(LogoWithText, _React$Component);

  function LogoWithText() {
    _classCallCheck(this, LogoWithText);

    return _possibleConstructorReturn(this, (LogoWithText.__proto__ || Object.getPrototypeOf(LogoWithText)).apply(this, arguments));
  }

  _createClass(LogoWithText, [{
    key: 'render',
    value: function render() {
      var style = Object.assign({}, {
        height: 40
      }, this.props.style);
      return _react2.default.createElement('img', { style: style, src: _logoWithText2.default });
    }
  }]);

  return LogoWithText;
}(_react2.default.Component);

LogoWithText.props = {
  style: _propTypes2.default.object
};

LogoWithText.defaultProps = {
  style: {}
};

exports.default = LogoWithText;

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var _InviteFriendComponent = __webpack_require__(1304);

var _InviteFriendComponent2 = _interopRequireDefault(_InviteFriendComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactRelay.createFragmentContainer)(_InviteFriendComponent2.default, {
  user: function user() {
    return __webpack_require__(1314);
  }
});

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__(120);

var _default = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stat = function (_React$Component) {
  _inherits(Stat, _React$Component);

  function Stat() {
    _classCallCheck(this, Stat);

    return _possibleConstructorReturn(this, (Stat.__proto__ || Object.getPrototypeOf(Stat)).apply(this, arguments));
  }

  _createClass(Stat, [{
    key: 'render',
    value: function render() {
      var containerStyle = Object.assign({}, {
        paddingTop: 50,
        paddingBottom: 50,
        minWidth: 200,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'middle'
      }, this.props.style);
      var statStyle = {
        color: _default.alternateAccentColor,
        display: 'block',
        fontSize: 50,
        textAlign: 'center'
      };
      var statTextStyle = {
        display: 'block',
        textAlign: 'center',
        maxWidth: '70%'
      };
      var extraContentStyle = {
        display: 'block',
        marginTop: 4,
        minHeight: 16,
        alignSelf: 'center',
        textAlign: 'center'
      };
      return _react2.default.createElement(
        _materialUi.Paper,
        { style: containerStyle },
        _react2.default.createElement(
          'span',
          {
            style: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }
          },
          _react2.default.createElement(
            'span',
            { style: statStyle },
            this.props.stat
          ),
          _react2.default.createElement(
            'span',
            { style: statTextStyle },
            this.props.statText
          )
        ),
        _react2.default.createElement(
          'span',
          { style: extraContentStyle },
          this.props.extraContent
        )
      );
    }
  }]);

  return Stat;
}(_react2.default.Component);

Stat.propTypes = {
  stat: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
  statText: _propTypes2.default.string.isRequired,
  extraContent: _propTypes2.default.element,
  style: _propTypes2.default.object
};

Stat.default = {
  style: {}
};

exports.default = Stat;

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import PropTypes from 'prop-types'

var WidgetPieceWrapper = function (_React$Component) {
  _inherits(WidgetPieceWrapper, _React$Component);

  function WidgetPieceWrapper() {
    _classCallCheck(this, WidgetPieceWrapper);

    return _possibleConstructorReturn(this, (WidgetPieceWrapper.__proto__ || Object.getPrototypeOf(WidgetPieceWrapper)).apply(this, arguments));
  }

  _createClass(WidgetPieceWrapper, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        this.props.children
      );
    }
  }]);

  return WidgetPieceWrapper;
}(_react2.default.Component);

WidgetPieceWrapper.propTypes = {};

WidgetPieceWrapper.defaultProps = {};

exports.default = WidgetPieceWrapper;

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRelay = __webpack_require__(16);

var mutation = function mutation() {
  return __webpack_require__(1408);
};

function commit(environment, userId) {
  var onCompleted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var onError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  return (0, _reactRelay.commitMutation)(environment, {
    mutation: mutation,
    variables: {
      input: { userId: userId }
    },
    onCompleted: onCompleted,
    onError: onError
  });
}

exports.default = commit;

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserBackgroundImageURL = exports.getUserBackgroundColor = exports.getUserBackgroundCustomImage = exports.getUserBackgroundOption = exports.setExtensionBackgroundSettings = exports.setBackgroundSettings = undefined;

var _constants = __webpack_require__(46);

var _extensionMessenger = __webpack_require__(1418);

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setBackgroundSettings = exports.setBackgroundSettings = function setBackgroundSettings(backgroundOption, customImage, backgroundColor, imageURL) {
  _localstorageMgr2.default.setItem(_constants.STORAGE_BACKGROUND_OPTION, backgroundOption);
  _localstorageMgr2.default.setItem(_constants.STORAGE_BACKGROUND_CUSTOM_IMAGE, customImage);
  _localstorageMgr2.default.setItem(_constants.STORAGE_BACKGROUND_COLOR, backgroundColor);
  _localstorageMgr2.default.setItem(_constants.STORAGE_BACKGROUND_IMAGE_URL, imageURL);

  setExtensionBackgroundSettings(backgroundOption, customImage, backgroundColor, imageURL);
};

// Call to extension new tab page (parent frame) to update
// its background settings.
var setExtensionBackgroundSettings = exports.setExtensionBackgroundSettings = function setExtensionBackgroundSettings(backgroundOption, customImage, backgroundColor, imageURL) {
  (0, _extensionMessenger.postBackgroundSettings)({
    backgroundOption: backgroundOption,
    customImage: customImage,
    backgroundColor: backgroundColor,
    imageURL: imageURL
  });
};

var getUserBackgroundOption = exports.getUserBackgroundOption = function getUserBackgroundOption() {
  return _localstorageMgr2.default.getItem(_constants.STORAGE_BACKGROUND_OPTION);
};

var getUserBackgroundCustomImage = exports.getUserBackgroundCustomImage = function getUserBackgroundCustomImage() {
  return _localstorageMgr2.default.getItem(_constants.STORAGE_BACKGROUND_CUSTOM_IMAGE);
};

var getUserBackgroundColor = exports.getUserBackgroundColor = function getUserBackgroundColor() {
  return _localstorageMgr2.default.getItem(_constants.STORAGE_BACKGROUND_COLOR);
};

var getUserBackgroundImageURL = exports.getUserBackgroundImageURL = function getUserBackgroundImageURL() {
  return _localstorageMgr2.default.getItem(_constants.STORAGE_BACKGROUND_IMAGE_URL);
};

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function getWidgetConfig(config, settings) {
  var configuration = {};
  var value;
  var field;
  for (var index in settings) {
    field = settings[index].field;
    if (!config || !(field in config)) {
      value = settings[index].defaultValue;
    } else {
      value = config[field];
    }
    configuration[field] = value;
  }

  return configuration;
}

exports.getWidgetConfig = getWidgetConfig;

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var Particle = function () {
    function Particle() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var vel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { x: 0, y: 0 };
        var shrink = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.97;
        var size = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;
        var gravity = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        var color = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var resistance = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1;
        var flick = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
        var alpha = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 1;
        var fade = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 0;

        _classCallCheck(this, Particle);

        this.x = x;
        this.y = y;
        this.vel = vel;
        this.shrink = shrink;
        this.size = size;
        this.gravity = gravity;
        this.color = color;
        this.resistance = resistance;
        this.flick = flick;
        this.alpha = alpha;
        this.fade = fade;
    }

    _createClass(Particle, [{
        key: "getPosition",
        value: function getPosition() {
            return [this.x, this.y];
        }
    }, {
        key: "update",
        value: function update() {
            // apply resistance
            this.vel.x *= this.resistance;
            this.vel.y *= this.resistance;

            // gravity down
            this.vel.y += this.gravity;

            // update position based on speed
            this.x += this.vel.x;
            this.y += this.vel.y;

            // shrink
            this.size *= this.shrink;

            // fade out
            this.alpha -= this.fade;
        }
    }, {
        key: "render",
        value: function render(c) {
            if (!this.exists()) {
                return;
            }

            c.save();

            c.globalCompositeOperation = 'lighter';

            var _ref = [this.x, this.y, this.size],
                x = _ref[0],
                y = _ref[1],
                size = _ref[2];

            var gradient = c.createRadialGradient(x, y, 0.1, x, y, size / 2);
            gradient.addColorStop(0.1, "rgba(255,255,255," + this.alpha + ")");
            gradient.addColorStop(0.8, "hsla(" + this.color + ", 100%, 50%, " + this.alpha + ")");
            gradient.addColorStop(1, "hsla(" + this.color + ", 100%, 50%, 0.1)");

            c.fillStyle = gradient;

            c.beginPath();
            c.arc(x, y, this.flick ? Math.random() * size : size, 0, Math.PI * 2, true);
            c.closePath();
            c.fill();

            c.restore();
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.alpha >= 0.1 && this.size >= 1;
        }
    }]);

    return Particle;
}();

exports.default = Particle;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Fetches the results of an operation (query/mutation/etc)
// and return its results as a Promise.
var fetchQuery = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(operation, variables, cacheConfig, uploadables) {
    var userToken, headers;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _user.getUserToken)();

          case 3:
            userToken = _context.sent;
            headers = {
              'Accept': 'application/json',
              'Content-Type': 'application/json'

              // If the user does not have a token, send a placeholder value.
              // We do this because AWS API Gateway's custom authorizers will
              // reject any request without a token and we want to provide
              // unauthenticated access to our API.
              // "If a specified identify source is missing, null, or empty,
              // API Gateway returns a 401 Unauthorized response without calling
              // the authorizer Lambda function.”
              // https://docs.aws.amazon.com/apigateway/latest/developerguide/configure-api-gateway-lambda-authorization-with-console.html"
            };
            headers['Authorization'] = userToken || 'unauthenticated';

            return _context.abrupt('return', fetch('//' + "tab.gladly.io/graphql/", {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({
                query: operation.text, // GraphQL text from input
                variables: variables
              })
            }).then(function (response) {
              return response.json().then(function (responseJSON) {
                // Temporary fix to force passing errors on to the
                // QueryRenderer.
                // https://github.com/facebook/relay/issues/1913
                if (responseJSON.errors && responseJSON.errors.length > 0) {
                  console.log('relay-env errors', responseJSON.errors);
                  responseJSON.data = null;
                  return responseJSON;
                }
                return responseJSON;
              });
            }));

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);

            console.error(_context.t0);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 9]]);
  }));

  return function fetchQuery(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

// Create a network layer from the fetch function


var _user = __webpack_require__(64);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* global fetch */


var _require = __webpack_require__(48),
    Environment = _require.Environment,
    Network = _require.Network,
    RecordSource = _require.RecordSource,
    Store = _require.Store;

var network = Network.create(fetchQuery);

var source = new RecordSource();
var store = new Store(source);

exports.default = new Environment({
  network: network,
  store: store
});

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global localStorage */

var localStorageMgr = {};

localStorageMgr.setItem = function (key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.log('localStorage not supported. ', e);
  }
};

localStorageMgr.getItem = function (key) {
  try {
    var value = localStorage.getItem(key);
    return value;
  } catch (e) {
    console.log('localStorage not supported. ', e);
    return null;
  }
};

localStorageMgr.removeItem = function (key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.log('localStorage not supported. ', e);
  }
};

exports.default = localStorageMgr;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reloadUser = exports.signInAnonymously = exports.sendVerificationEmail = exports.logout = exports.getUserToken = exports.getCurrentUserListener = exports.getCurrentUser = exports.formatUser = exports.setUsernameInLocalStorage = exports.getUsername = undefined;

var _app = __webpack_require__(246);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(247);

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

var _constants = __webpack_require__(46);

var _navigation = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Only for development.
var shouldMockAuthentication = "true" === 'true' && "production" === 'development';

/**
 * Get the username. This uses localStorage, not our user database,
 * so that we can rely on it during the sign up process.
 * @returns {string} The user's username
 */
var getUsername = exports.getUsername = function getUsername() {
  return _localstorageMgr2.default.getItem(_constants.STORAGE_KEY_USERNAME);
};

/**
 * Set the username in localStorage.
 * @pararms {string} The user's username
 */
var setUsernameInLocalStorage = exports.setUsernameInLocalStorage = function setUsernameInLocalStorage(username) {
  return _localstorageMgr2.default.setItem(_constants.STORAGE_KEY_USERNAME, username);
};

/**
 * Take the user object from our auth service and create
 * the object we'll use in the app.
 * @returns {object} user - The user object for the app.
 * @returns {string} user.id - The user's ID
 * @returns {string} user.email - The user's email
 * @returns {string} user.username - The user's username
 * @returns {boolean} user.isAnonymous - Whether the user is anonymous
 * @returns {boolean} user.emailVerified - Whether the user has verified their email
 */
var formatUser = exports.formatUser = function formatUser(authUserObj) {
  return {
    id: authUserObj.uid,
    email: authUserObj.email,
    username: getUsername(),
    isAnonymous: authUserObj.isAnonymous,
    emailVerified: authUserObj.emailVerified
  };
};

/**
 * Return the raw Firebase user instance.
 * @returns {user} a Firebase User
 */
var getCurrentFirebaseUser = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!shouldMockAuthentication) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', new Promise(function (resolve, reject) {
              var userId = 'abcdefghijklmno';
              var email = 'kevin@example.com';
              var tokenPayload = {
                sub: userId,
                email: 'kevin@example.com',
                email_verified: true
              };
              var jwt = __webpack_require__(671);
              var token = jwt.sign(tokenPayload, 'fakeSecret');
              resolve({
                uid: userId,
                email: email,
                isAnonymous: false,
                emailVerified: true,
                getIdToken: function getIdToken() {
                  return token;
                }
              });
            }));

          case 2:
            return _context.abrupt('return', new Promise(function (resolve, reject) {
              try {
                // https://firebase.google.com/docs/auth/web/manage-users
                _app2.default.auth().onAuthStateChanged(function (authUser) {
                  if (authUser) {
                    resolve(authUser);
                  } else {
                    resolve(null);
                  }
                });
              } catch (e) {
                reject(e);
              }
            }));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getCurrentFirebaseUser() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Get the current user object. Returns null if the user is not
 * logged in.
 * @returns {Promise<({user}|null)>}  A promise that resolves into either
 *   a user obejct or null.
 */
var getCurrentUser = exports.getCurrentUser = function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
    var authUser;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return getCurrentFirebaseUser();

          case 3:
            authUser = _context2.sent;

            if (!authUser) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt('return', formatUser(authUser));

          case 8:
            return _context2.abrupt('return', null);

          case 9:
            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2['catch'](0);
            throw _context2.t0;

          case 14:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 11]]);
  }));

  return function getCurrentUser() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Get the raw Auth object, which is observable with `onAuthStateChanged`.
 * @returns {object} a `firebase.auth` object
 */
var getCurrentUserListener = exports.getCurrentUserListener = function getCurrentUserListener() {
  // For development only: optionally mock a barebones
  // version of the `firebase.auth` object.
  if (shouldMockAuthentication) {
    return {
      onAuthStateChanged: function onAuthStateChanged(callback) {
        getCurrentFirebaseUser().then(function (user) {
          return callback(user);
        });
      }
    };
  }
  return _app2.default.auth();
};

/**
 * Get the user's token.
 * @param {Boolean} forceRefresh - Whether to force Firebase to refresh
 *   the token regardless of expiration status.
 * @returns {(string|null)} The token, if the user is authenticated;
 *   otherwise, null.
 */
var getUserToken = exports.getUserToken = function () {
  var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(forceRefresh) {
    var authUser, token;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return getCurrentFirebaseUser();

          case 3:
            authUser = _context3.sent;

            if (authUser) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt('return', null);

          case 6:
            token = authUser.getIdToken(forceRefresh);

            if (!token) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt('return', token);

          case 11:
            return _context3.abrupt('return', null);

          case 12:
            _context3.next = 17;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3['catch'](0);
            throw _context3.t0;

          case 17:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[0, 14]]);
  }));

  return function getUserToken(_x) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Delete any sensitive localStorage items.
 * @returns {null}
 */
var clearAuthLocalStorageItems = function clearAuthLocalStorageItems() {
  // Currently, removes everything except background settings.
  _localstorageMgr2.default.removeItem(_constants.STORAGE_KEY_USERNAME);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_TABS_LAST_TAB_OPENED_DATE);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_TABS_RECENT_DAY_COUNT);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_LOCATION_COUNTRY_ISO_CODE);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_LOCATION_IS_IN_EU);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_LOCATION_QUERY_TIME);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_REFERRAL_DATA_REFERRING_USER);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_REFERRAL_DATA_REFERRING_CHANNEL);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_NEW_CONSENT_DATA_EXISTS);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_NEW_USER_HAS_COMPLETED_TOUR);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_EXTENSION_INSTALL_ID);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_APPROX_EXTENSION_INSTALL_TIME);
  _localstorageMgr2.default.removeItem(_constants.STORAGE_EXPERIMENT_ANON_USER);
};

/**
 * Log the user out.
 * @returns {Promise<boolean>}  A promise that resolves into a boolean,
 *   whether or not the logout was successful.
 */
var logout = exports.logout = function () {
  var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new Promise(function (resolve, reject) {
              _app2.default.auth().signOut().then(function () {
                // Delete any sensitive localStorage items.
                clearAuthLocalStorageItems();

                // Sign-out successful.
                resolve(true);
              }).catch(function (e) {
                console.log(e);
                resolve(false);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function logout() {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Send a confirmation email to a Firebase user.
 * @param {object} firebaseUser - A Firebase user instance
 * @returns {Promise<boolean>}  A promise that resolves into a boolean,
 *   whether or not the email was sent successfully.
 */
var sendFirebaseVerificationEmail = function () {
  var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(firebaseUser) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new Promise(function (resolve, reject) {
              try {
                // https://firebase.google.com/docs/auth/web/manage-users#send_a_user_a_verification_email
                firebaseUser.sendEmailVerification({
                  // The "continue" URL after verifying.
                  url: (0, _navigation.absoluteUrl)(_navigation.enterUsernameURL)
                }).then(function () {
                  resolve(true);
                }).catch(function (err) {
                  console.error(err);
                  resolve(false);
                });
              } catch (e) {
                reject(e);
              }
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function sendFirebaseVerificationEmail(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Send an email for the current user to verify their email address.
 * @returns {Promise<boolean>}  A promise that resolves into a boolean,
 *   whether or not the email was sent successfully.
 */
var sendVerificationEmail = exports.sendVerificationEmail = function () {
  var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6() {
    var authUser, emailSent;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return getCurrentFirebaseUser();

          case 3:
            authUser = _context6.sent;

            if (authUser) {
              _context6.next = 7;
              break;
            }

            console.error('Could not send confirmation email: no authenticated user.');
            return _context6.abrupt('return', false);

          case 7:
            _context6.next = 9;
            return sendFirebaseVerificationEmail(authUser);

          case 9:
            emailSent = _context6.sent;
            return _context6.abrupt('return', emailSent);

          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6['catch'](0);

            console.error(_context6.t0);
            return _context6.abrupt('return', false);

          case 17:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[0, 13]]);
  }));

  return function sendVerificationEmail() {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * Sign in a user anonymously and return their user object.
 * @returns {Promise<{user}>} A Promise resolving into the
 *   user object.
 */
var signInAnonymously = exports.signInAnonymously = function () {
  var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7() {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new Promise(function (resolve, reject) {
              // Should resolve into a non-null Firebase user credential.
              // https://firebase.google.com/docs/reference/js/firebase.auth.Auth?authuser=0#signInAnonymously
              _app2.default.auth().signInAnonymously().then(function (firebaseUserCredential) {
                // Format the user object and return it.
                var firebaseUser = firebaseUserCredential.user;
                var formattedUser = firebaseUser ? formatUser(firebaseUser) : null;
                resolve(formattedUser);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined);
  }));

  return function signInAnonymously() {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * Reload the Firebase user data from the server.
 * @returns {Promise<undefined>}
 */
var reloadUser = exports.reloadUser = function () {
  var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8() {
    var user;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return getCurrentFirebaseUser();

          case 3:
            user = _context8.sent;
            _context8.next = 9;
            break;

          case 6:
            _context8.prev = 6;
            _context8.t0 = _context8['catch'](0);
            throw _context8.t0;

          case 9:
            if (user) {
              _context8.next = 11;
              break;
            }

            return _context8.abrupt('return');

          case 11:
            _context8.next = 13;
            return user.reload();

          case 13:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined, [[0, 6]]);
  }));

  return function reloadUser() {
    return _ref8.apply(this, arguments);
  };
}();

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInIframe = exports.abbreviateNumber = exports.currencyFormatted = exports.commaFormatted = exports.getReferralData = exports.setReferralData = exports.parseUrlSearchString = exports.getUrlParameters = exports.validateUsername = undefined;

var _localstorageMgr = __webpack_require__(61);

var _localstorageMgr2 = _interopRequireDefault(_localstorageMgr);

var _constants = __webpack_require__(46);

var _xregexp = __webpack_require__(1040);

var _xregexp2 = _interopRequireDefault(_xregexp);

var _qs = __webpack_require__(342);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determine if a username string is valid.
 * @param {string} username - The username
 * @return {boolean} Whether the username is valid.
 */
/* eslint no-useless-escape: 0 */

var validateUsername = exports.validateUsername = function validateUsername(username) {
  if (username.length < 2) {
    return false;
  }
  // Based on:
  // https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_SignUp.html#CognitoUserPools-SignUp-request-Username
  var re = (0, _xregexp2.default)('^[\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+$');
  return re.test(username);
};

// Note: in general, we should probably use react-router's
// location object to get the search value.
var getUrlParameters = exports.getUrlParameters = function getUrlParameters() {
  return parseUrlSearchString(window.location.search);
};

/**
 * Convert a string of URL parameters into an object.
 * @param {String} searchString - The URL parameter string,
 *   such as '?myParam=foo&another=bar'
 * @return {Object} The parsed parameter data
 */
var parseUrlSearchString = exports.parseUrlSearchString = function parseUrlSearchString(searchString) {
  return _qs2.default.parse(searchString, { ignoreQueryPrefix: true });
};

// BEGIN: referral data helpers

var referralParams = [{
  urlParam: 'u',
  fieldName: 'referringUser',
  storageKey: _constants.STORAGE_REFERRAL_DATA_REFERRING_USER
}, {
  urlParam: 'r',
  fieldName: 'referringChannel',
  storageKey: _constants.STORAGE_REFERRAL_DATA_REFERRING_CHANNEL
}];

var setReferralData = exports.setReferralData = function setReferralData(urlParams) {
  referralParams.forEach(function (paramObj) {
    if (urlParams[paramObj.urlParam]) {
      _localstorageMgr2.default.setItem(paramObj.storageKey, urlParams[paramObj.urlParam]);
    }
  });
};

var getReferralData = exports.getReferralData = function getReferralData() {
  var data = {};
  referralParams.forEach(function (paramObj) {
    var fieldData = _localstorageMgr2.default.getItem(paramObj.storageKey);
    if (fieldData) {
      data[paramObj.fieldName] = fieldData;
    }
  });
  return data;
};

// END: referral data helpers

// BEGIN: number helpers

/**
 * Takes a number or numerical string and returns a string with commas
 * between each pair of three non-fractional digits.
 * @param {number|string} amount - A number or numerical string
 * @return {string} The amount with commas where appropriate
 */
var commaFormatted = exports.commaFormatted = function commaFormatted(amount) {
  if (amount === undefined || amount === null) {
    return '0';
  }
  var delimiter = ','; // replace comma if desired
  amount = amount.toString();
  var i = amount;
  var d = null;
  if (amount.indexOf('.') > -1) {
    var a = amount.split('.', 2);
    d = a[1];
    i = parseInt(a[0]);
  }
  if (isNaN(i)) {
    return '';
  }
  var minus = '';
  if (i < 0) {
    minus = '-';
  }
  i = Math.abs(i);
  var n = i.toString();
  a = [];
  while (n.length > 3) {
    var nn = n.substr(n.length - 3);
    a.unshift(nn);
    n = n.substr(0, n.length - 3);
  }
  if (n.length > 0) {
    a.unshift(n);
  }
  n = a.join(delimiter);
  if (d === null) {
    amount = n;
  } else if (d.length < 1) {
    amount = n;
  } else {
    amount = n + '.' + d;
  }
  amount = minus + amount;
  return amount;
};

/**
 * Takes a number or numerical string and returns a string with two decimal places.
 * @param {number|string} amount - A number or numerical string
 * @return {string} The amount with exactly two decimal places (rounded or appended)
 */
var currencyFormatted = exports.currencyFormatted = function currencyFormatted(amount) {
  if (amount === undefined || amount === null) {
    return '0.00';
  }
  var i = parseFloat(amount);
  if (isNaN(i)) {
    i = 0.00;
  }
  var minus = '';
  if (i < 0) {
    minus = '-';
  }
  i = Math.abs(i);
  i = parseInt((i + 0.005) * 100);
  i = i / 100;
  var s = i.toString();
  if (s.indexOf('.') < 0) {
    s += '.00';
  }
  if (s.indexOf('.') === s.length - 2) {
    s += '0';
  }
  s = minus + s;
  return s;
};

/**
 * Abbreviate a number to a string with a power suffix (e.g. 248345 to 248.3K)
 * @param {number} num - A number
 * @param {number} decimalPlaces - The maximum number of decimal places to show
 * @return {string} The abbreviated number
 */
var abbreviateNumber = exports.abbreviateNumber = function abbreviateNumber(num) {
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  // From: https://stackoverflow.com/a/32638472/1332513
  // Alternative, more flexible library if needed:
  //   http://numeraljs.com/
  if (num === undefined || num === null || num === 0) {
    return '0';
  }
  decimalPlaces = !decimalPlaces || decimalPlaces < 0 ? 0 : decimalPlaces;
  var b = num.toPrecision(2).split('e');
  var k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3);
  var c = k < 1 ? num.toFixed(0 + decimalPlaces) : (num / Math.pow(10, k * 3)).toFixed(decimalPlaces);
  var d = c < 0 ? c : Math.abs(c);
  var e = d + ['', 'K', 'M', 'B', 'T'][k];
  return e;
};
// END: number helpers

/**
 * Determine if the page is currently iframed.
 * @return {boolean} Whether the page is in an iframe.
 */
var isInIframe = exports.isInIframe = function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

/***/ })

},[2679]);


// WEBPACK FOOTER //
// static/js/app.1ee8308e.js